webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _defineProperties = __webpack_require__(536);
	
	var _defineProperties2 = _interopRequireDefault(_defineProperties);
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(793);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _router = __webpack_require__(435);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _mainVuex = __webpack_require__(89);
	
	var _mainVuex2 = _interopRequireDefault(_mainVuex);
	
	var _loader = __webpack_require__(427);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _vMask = __webpack_require__(788);
	
	var _vMask2 = _interopRequireDefault(_vMask);
	
	var _vueNumeric = __webpack_require__(972);
	
	var _vueNumeric2 = _interopRequireDefault(_vueNumeric);
	
	var _elementUi = __webpack_require__(591);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	var _i18n2 = __webpack_require__(88);
	
	var _i18n3 = _interopRequireDefault(_i18n2);
	
	__webpack_require__(652);
	
	var _vue2GoogleMaps = __webpack_require__(981);
	
	var VueGoogleMaps = _interopRequireWildcard(_vue2GoogleMaps);
	
	var _ModulePanelTemplate = __webpack_require__(821);
	
	var _ModulePanelTemplate2 = _interopRequireDefault(_ModulePanelTemplate);
	
	var _ModuleTemplate = __webpack_require__(66);
	
	var _ModuleTemplate2 = _interopRequireDefault(_ModuleTemplate);
	
	var _BootstrapAlertErrors = __webpack_require__(823);
	
	var _BootstrapAlertErrors2 = _interopRequireDefault(_BootstrapAlertErrors);
	
	var _SgsRender = __webpack_require__(42);
	
	var _SgsRender2 = _interopRequireDefault(_SgsRender);
	
	var _SgsRenderFile = __webpack_require__(833);
	
	var _SgsRenderFile2 = _interopRequireDefault(_SgsRenderFile);
	
	var _SgsRenderButtonReport = __webpack_require__(347);
	
	var _SgsRenderButtonReport2 = _interopRequireDefault(_SgsRenderButtonReport);
	
	var _SgsRenderButtonForm = __webpack_require__(346);
	
	var _SgsRenderButtonForm2 = _interopRequireDefault(_SgsRenderButtonForm);
	
	var _vueHighcharts = __webpack_require__(791);
	
	var _vueHighcharts2 = _interopRequireDefault(_vueHighcharts);
	
	var _highcharts = __webpack_require__(179);
	
	var _highcharts2 = _interopRequireDefault(_highcharts);
	
	var _exporting = __webpack_require__(657);
	
	var _exporting2 = _interopRequireDefault(_exporting);
	
	var _highcharts3d = __webpack_require__(655);
	
	var _highcharts3d2 = _interopRequireDefault(_highcharts3d);
	
	var _highchartsMore = __webpack_require__(656);
	
	var _highchartsMore2 = _interopRequireDefault(_highchartsMore);
	
	var _solidGauge = __webpack_require__(658);
	
	var _solidGauge2 = _interopRequireDefault(_solidGauge);
	
	var _vueFroalaWysiwyg = __webpack_require__(789);
	
	var _vueFroalaWysiwyg2 = _interopRequireDefault(_vueFroalaWysiwyg);
	
	var _vMoney = __webpack_require__(423);
	
	var _vMoney2 = _interopRequireDefault(_vMoney);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	String.prototype.replaceAll = function (from, to) {
	  var str = this;
	  var pos = str.indexOf(from);
	  while (pos > -1) {
	    str = str.replace(from, to);
	    pos = str.indexOf(from);
	  }
	  return str;
	};
	
	_vue2.default.use(_loader2.default, _mainVuex2.default);
	
	_vue2.default.use(_elementUi2.default, {
	  i18n: function i18n(key) {
	    return _i18n3.default.t(key);
	  }
	});
	
	_vue2.default.use(VueGoogleMaps, {
	  load: {
	    key: 'AIzaSyBvWE_sIwKbWkiuJQOf8gSk9qzpO96fhfY',
	    libraries: 'places'
	  }
	});
	
	_vue2.default.use(_vueNumeric2.default);
	
	_vue2.default.use(_vMask2.default);
	(0, _exporting2.default)(_highcharts2.default);
	(0, _highcharts3d2.default)(_highcharts2.default);
	
	_vue2.default.use(_vueHighcharts2.default, { Highcharts: _highcharts2.default });
	
	_vue2.default.use(__webpack_require__(790));
	window.jQuery = window.$ = __webpack_require__(110);
	
	_vue2.default.component('modulePanel', _ModulePanelTemplate2.default);
	_vue2.default.component('SgsRender', _SgsRender2.default);
	_vue2.default.component('SgsRenderFile', _SgsRenderFile2.default);
	_vue2.default.component('SgsRenderButtonReport', _SgsRenderButtonReport2.default);
	_vue2.default.component('SgsRenderButtonForm', _SgsRenderButtonForm2.default);
	_vue2.default.component('moduleTemplate', _ModuleTemplate2.default);
	_vue2.default.component('BootstrapAlertErrors', _BootstrapAlertErrors2.default);
	
	var EventBus = new _vue2.default();
	
	(0, _defineProperties2.default)(_vue2.default.prototype, {
	  $eventBus: {
	    get: function get() {
	      return EventBus;
	    }
	  }
	});
	
	__webpack_require__(653);
	
	__webpack_require__(610);
	
	__webpack_require__(609);
	__webpack_require__(611);
	
	
	(0, _highchartsMore2.default)(_highcharts2.default);
	(0, _solidGauge2.default)(_highcharts2.default);
	
	_vue2.default.use(_vueFroalaWysiwyg2.default);
	
	_vue2.default.use(_vMoney2.default);
	
	new _vue2.default({
	  router: _router2.default,
	  store: _mainVuex2.default,
	  i18n: _i18n3.default,
	  el: '#app',
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _resolveRules$formatF;
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _i18n = __webpack_require__(88);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = __webpack_require__(1);
	var vue = new _vue2.default();
	
	exports.default = (_resolveRules$formatF = {
	
	  resolveRules: function resolveRules(attr, rules) {
	
	    if (!rules) {
	      throw new Error("SGSUtils > resolveRules > rules undefined");
	    }
	
	    var requiredMessage = 'Por favor, preencha o campo';
	    var requiredFile = 'Por favor, selecione um arquivo';
	    var minSize = 'Tamanho mínimo';
	    var maxSize = 'Tamanho máximo';
	    var maxValue = 'Valor máximo';
	    var requiredNumber = 'Por favor, preencha com um número válido';
	
	    if (_i18n2.default.locale == 'es') {
	
	      requiredMessage = 'Por favor, rellene el campo';
	      requiredFile = 'Por favor, seleccione un archivo';
	      minSize = 'Tamaño mínimo';
	      maxSize = 'Tamaño máximo';
	      maxValue = 'Valor máximo';
	      requiredNumber = 'Por favor, rellene con un número válido';
	    } else if (_i18n2.default.locale == 'en') {
	
	      requiredMessage = 'Please fill in the field';
	      requiredFile = 'Please select a file';
	      minSize = 'Minimum size';
	      maxSize = 'Maximum size';
	      maxValue = 'Maximum value';
	      requiredNumber = 'Please fill in with a valid number';
	    }
	
	    rules[attr.columnName] = [];
	
	    if (attr.required) {
	      if (attr.type == "text" || attr.type == "filterText") {
	        rules[attr.columnName].push({ required: true, message: requiredMessage, trigger: 'blur' });
	      } else if (attr.type == "time") {
	        rules[attr.columnName].push({ required: true, message: requiredMessage, trigger: 'blur' });
	      } else if (attr.type == "cnpj") {
	        rules[attr.columnName].push({ required: true, message: requiredMessage, trigger: 'blur' });
	      } else if (attr.type == "cpf") {
	        rules[attr.columnName].push({ required: true, message: requiredMessage, trigger: 'blur' });
	      } else if (attr.type == "email") {
	        rules[attr.columnName].push({ required: true, message: requiredMessage, trigger: 'blur' });
	      } else if (attr.type == "textArea") {
	        rules[attr.columnName].push({ required: true, message: requiredMessage, trigger: 'blur' });
	      } else if (attr.type == "association") {
	        rules[attr.columnName].push({ required: true, message: requiredMessage, trigger: 'change' });
	      } else if (attr.type == "date" || attr.type == "filterDate") {
	        rules[attr.columnName].push({ required: true, message: requiredMessage });
	      } else if (attr.type == "dateTime") {
	        rules[attr.columnName].push({ required: true, message: requiredMessage });
	      } else if (attr.type == "composition") {
	        rules[attr.columnName].push({ required: true, message: requiredMessage });
	        rules[attr.columnName].push({ type: 'number', message: requiredMessage });
	      } else if (attr.type == "map") {
	        rules[attr.columnName].push({ required: true, message: requiredMessage });
	      } else if (attr.type == "password") {
	        rules[attr.columnName].push({ required: true, message: requiredMessage });
	      } else if (attr.type == "phone") {
	        rules[attr.columnName].push({ required: true, message: requiredMessage });
	      } else if (attr.type == "charges") {
	        rules[attr.columnName].push({ required: true, message: requiredMessage });
	      } else if (attr.type == "dealership") {
	        rules[attr.columnName].push({ required: true, message: requiredMessage });
	      } else if (attr.type == "inputCSV") {
	        rules[attr.columnName].push({ required: true, message: requiredFile });
	      } else if (attr.type == "textEditor") {
	        rules[attr.columnName].push({ required: true, message: requiredMessage });
	      }
	    }
	
	    if (attr.type == "numeric") {
	
	      var numericRule = {
	        validator: function validator(rule, value, callback) {
	
	          if (value && isNaN(value)) {
	            callback(new Error(requiredNumber));
	          }
	
	          if (attr.minValue > 0 && !(attr.minValue <= value)) {
	            callback(new Error(minSize + ' ' + attr.minValue));
	          }
	
	          if (attr.maxValue > 0 && !(value <= attr.maxValue)) {
	            callback(new Error(maxValue + ' ' + attr.maxValue));
	          }
	
	          callback();
	        }
	      };
	
	      rules[attr.columnName].push(numericRule);
	    }
	
	    if (attr.type == "float") {
	
	      var floatRule = {
	        validator: function validator(rule, value, callback) {
	
	          var totalDigits = attr.totalDigits;
	          var decimalDigits = attr.decimalDigits;
	          var max = "".padEnd(totalDigits - decimalDigits, "9");
	          max = max + ".".padEnd(decimalDigits + 1, "9");
	
	          if (value > max) {
	            callback(new Error(maxValue + " " + max));
	          } else {
	            callback();
	          }
	        }
	      };
	
	      rules[attr.columnName].push(floatRule);
	    }
	
	    if (attr.minSize > 0) {
	      rules[attr.columnName].push({
	        min: attr.minSize,
	        message: minSize + ' ' + attr.minSize,
	        trigger: 'blur'
	      });
	    }
	    if (attr.maxSize > 0) {
	      rules[attr.columnName].push({
	        max: attr.maxSize,
	        message: maxSize + ' ' + attr.maxSize,
	        trigger: 'blur'
	      });
	    }
	  },
	
	  formatField: function formatField(value, type) {
	    return this.formatField2({
	      value: value,
	      type: type
	    });
	  },
	
	  formatField2: function formatField2(params) {
	
	    if (!params) {
	      return "";
	    }
	
	    var value = params.value;
	    var type = params.type;
	    var misc = params.misc;
	
	    if (value === undefined) {
	      return "";
	    }
	
	    var ret = '';
	
	    if (type == 'boolean' && misc !== undefined && misc.yes !== undefined && misc.no !== undefined) {
	      ret = value == 'YES' ? misc.yes : misc.no;
	    } else if (type == 'boolean') {
	      ret = value == 'YES' ? 'Sim' : 'Não';
	    } else if (type == 'date') {
	      var date = new Date(value + " 00:00:00");
	      ret = moment(date).format('DD/MM/YYYY');
	    } else if (type == 'dateTime') {
	      var _date = new Date(value);
	      ret = moment(_date).format('DD/MM/YYYY HH:mm');
	    } else if (type == 'time') {
	      if (value) {
	        var time = value.split(":");
	        ret = time[0] + ":" + time[1];
	      } else {
	        ret = value;
	      }
	    } else {
	      ret = value;
	    }
	
	    return ret;
	  },
	
	  getPlaceholder: function getPlaceholder(attr) {
	    return this.getPlaceholder(attr, null);
	  }
	
	}, (0, _defineProperty3.default)(_resolveRules$formatF, 'getPlaceholder', function getPlaceholder(attr, locale) {
	
	  if (attr != undefined && attr.placeholderPt != undefined && attr.placeholderPt != "") {
	
	    var placeholder = attr.placeholderPt;
	
	    if (locale == 'es' && attr.placeholderEs != undefined && attr.placeholderEs != "") {
	      placeholder = attr.placeholderEs;
	    } else if (locale == 'en' && attr.placeholderEn != undefined && attr.placeholderEn != "") {
	      placeholder = attr.placeholderEn;
	    }
	
	    return placeholder;
	  }
	
	  return "";
	}), (0, _defineProperty3.default)(_resolveRules$formatF, 'getLabel', function getLabel(params) {
	
	  if (!params) {
	    return "";
	  }
	
	  var attr = params.attr;
	  var locale = params.locale;
	  var label = params.label ? params.label : "";
	
	  if (attr != undefined && attr.labelPt != undefined && attr.labelPt != "") {
	
	    label = attr.labelPt;
	
	    if (locale == 'es' && attr.labelEs != undefined && attr.labelEs != "") {
	      label = attr.labelEs;
	    } else if (locale == 'en' && attr.labelEn != undefined && attr.labelEn != "") {
	      label = attr.labelEn;
	    }
	
	    return label;
	  }
	
	  return label;
	}), (0, _defineProperty3.default)(_resolveRules$formatF, 'getHint', function getHint(params) {
	
	  if (!params) {
	    return "";
	  }
	
	  var attr = params.attr;
	  var locale = params.locale;
	  var hint = "";
	
	  if (attr != undefined && attr.hintPt != undefined && attr.hintPt != "") {
	
	    hint = attr.hintPt;
	
	    if (locale == 'es' && attr.hintEs != undefined && attr.hintEs != "") {
	      hint = attr.hintEs;
	    } else if (locale == 'en' && attr.hintEn != undefined && attr.hintEn != "") {
	      hint = attr.hintEn;
	    }
	
	    return hint;
	  }
	
	  return hint;
	}), _resolveRules$formatF);

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _stringify = __webpack_require__(56);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _callBusinessRule$res;
	
	var _http = __webpack_require__(35);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _AppConfigService = __webpack_require__(11);
	
	var _AppConfigService2 = _interopRequireDefault(_AppConfigService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_callBusinessRule$res = {
	
	  callBusinessRule: function callBusinessRule(params, payload, businessRuleId) {
	
	    var url = this.resolveFormDesc(params) + "/businessRule/" + businessRuleId;
	
	    var dataToSend = {
	      data: payload
	    };
	
	    return (0, _http2.default)({
	      method: 'post',
	      url: url,
	      data: (0, _stringify2.default)(dataToSend)
	    }).then(function (response) {
	
	      if (response.data.meta.code === 200) {
	        response.data.body.instance["_updated"] = new Date();
	      }
	
	      return response.data;
	    });
	  },
	
	  resolveFormUri: function resolveFormUri(params) {
	
	    var businessAreaId = params.businessAreaId;
	    var systemId = params.systemId;
	    var systemVersion = params.systemVersion;
	    var formId = params.formId;
	
	    return "/f/ba" + "/" + businessAreaId + "/c/" + systemId + "/" + systemVersion + "/ms/" + formId;
	  },
	
	  resolveFormDesc: function resolveFormDesc(params) {
	    return _AppConfigService2.default.apiUrl() + this.resolveFormUri(params);
	  },
	
	  resolveUrlWithOutFilter: function resolveUrlWithOutFilter(params) {
	
	    var url = this.resolveFormDesc(params);
	
	    return url + "/rows";
	  },
	
	  resolveFormDataRows: function resolveFormDataRows(params, filter) {
	
	    var url = this.resolveUrlWithOutFilter(params);
	
	    if (filter) {
	
	      var query = [];
	
	      _.forOwn(filter, function (value, key) {
	        if (value) {
	          query.push(key + "=" + value);
	        }
	      });
	
	      if (query.length > 0) {
	        url = url + "?" + query.join("&");
	      }
	    }
	
	    return _http2.default.get(url).then(function (response) {
	      return response.data.data;
	    });
	  },
	
	  resolveFormDataRow: function resolveFormDataRow(params, id) {
	    return this.resolveFormDataRow(params, id, null);
	  }
	
	}, (0, _defineProperty3.default)(_callBusinessRule$res, 'resolveFormDataRow', function resolveFormDataRow(params, id, resourceType) {
	
	  var url = this.resolveFormDesc(params);
	  url = url + "/rows/" + id;
	
	  if (resourceType) {
	    url = url + "/" + resourceType;
	  }
	
	  return _http2.default.get(url).then(function (response) {
	    return response;
	  });
	}), (0, _defineProperty3.default)(_callBusinessRule$res, 'moduleFormRowSave', function moduleFormRowSave(params, id, payload) {
	
	  var url = this.resolveFormDesc(params);
	
	  url += "/rows";
	
	  if (id) {
	    url += "/" + id;
	  }
	
	  var dataToSend = {
	    data: payload
	  };
	
	  return (0, _http2.default)({
	    method: id ? 'put' : 'post',
	    url: url,
	    data: (0, _stringify2.default)(dataToSend)
	  }).then(function (response) {
	    return response.data;
	  });
	}), (0, _defineProperty3.default)(_callBusinessRule$res, 'generatePDF', function generatePDF(params, payload, businessRuleId) {
	
	  var url = this.resolveFormDesc(params) + "/exportPDF/" + businessRuleId;
	
	  var dataToSend = {
	    data: payload
	  };
	
	  return (0, _http2.default)({
	    method: 'post',
	    url: url,
	    data: (0, _stringify2.default)(dataToSend),
	    responseType: 'arraybuffer'
	  });
	}), (0, _defineProperty3.default)(_callBusinessRule$res, 'moduleFormGenerateReport', function moduleFormGenerateReport(params, payload) {
	  this.moduleFormGenerateReport(params, payload, false);
	}), (0, _defineProperty3.default)(_callBusinessRule$res, 'moduleFormGenerateReport', function moduleFormGenerateReport(params, payload, report2) {
	
	  var url = this.resolveFormDesc(params);
	
	  if (report2) {
	    url += "/report2";
	  } else {
	    url += "/report";
	  }
	
	  var dataToSend = {
	    data: payload
	  };
	
	  return (0, _http2.default)({
	    method: 'post',
	    url: url,
	    data: (0, _stringify2.default)(dataToSend),
	    responseType: 'arraybuffer'
	  }).then(function (response) {
	
	    if (response.headers["content-type"] == "application/octet-stream") {
	      var blob = new Blob([response.data], { type: 'application/pdf' });
	
	      var link = document.createElement('a');
	      document.body.appendChild(link);
	      var _url = window.URL.createObjectURL(blob);
	      link.style = "display: none";
	      link.href = _url;
	      link.download = response.headers['x-filename'];
	      link.click();
	      window.URL.revokeObjectURL(_url);
	
	      return {
	        meta: {
	          code: 200
	        }
	      };
	    } else {
	
	      var binaryString = String.fromCharCode.apply(null, new Uint8Array(response.data));
	      return JSON.parse(binaryString);
	    }
	  });
	}), (0, _defineProperty3.default)(_callBusinessRule$res, 'moduleFormRowDelete', function moduleFormRowDelete(params, id) {
	
	  var url = this.resolveFormDesc(params);
	
	  return _http2.default.delete(url + "/rows/" + id).then(function (response) {
	    return response.data;
	  });
	}), (0, _defineProperty3.default)(_callBusinessRule$res, 'resolveModuleDescription', function resolveModuleDescription(params) {
	
	  return _http2.default.get(this.resolveFormDesc(params)).then(function (response) {
	    return response.data;
	  });
	}), (0, _defineProperty3.default)(_callBusinessRule$res, 'resolveModuleFields', function resolveModuleFields(params) {
	
	  return _http2.default.get(this.resolveFormDesc(params)).then(function (response) {
	    return response.data.fields;
	  });
	}), (0, _defineProperty3.default)(_callBusinessRule$res, 'formatDataValues', function formatDataValues() {
	  return "Teste";
	}), (0, _defineProperty3.default)(_callBusinessRule$res, 'resolveSystemVersion', function resolveSystemVersion(businessAreaId, systemId) {
	
	  var url = _AppConfigService2.default.apiUrl() + "/f/ba" + "/" + businessAreaId + "/c/" + systemId + "/current";
	
	  return _http2.default.get(url).then(function (response) {
	    return response.data.data;
	  });
	}), _callBusinessRule$res);

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(56);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	    buildQuery: function buildQuery(filter) {
	
	        if (filter) {
	
	            var query = [];
	
	            _.forOwn(filter, function (value, key) {
	                if (value) {
	                    query.push(key + "=" + encodeURIComponent(value));
	                }
	            });
	
	            if (query.length > 0) {
	                return "?" + query.join("&");
	            }
	        }
	
	        return null;
	    },
	
	    resolveCurrentDomain: function resolveCurrentDomain() {
	        return document.location.origin;
	    },
	    localStorageSetItem: function localStorageSetItem(label, obj) {
	        window.localStorage.setItem(label, (0, _stringify2.default)(obj));
	    },
	    localStorageGetItem: function localStorageGetItem(label) {
	        var string = window.localStorage.getItem(label);
	        return JSON.parse(string);
	    },
	    buildAppErrorMessage: function buildAppErrorMessage(errorsParam) {
	
	        var errors = [];
	
	        var i = void 0;
	        for (i in errorsParam) {
	            var error = errorsParam[i];
	            errors.push(error.pt);
	        }
	
	        return errors;
	    },
	    buildErrorMessage: function buildErrorMessage(errorsParam) {
	
	        var errors = [];
	
	        var i = void 0;
	        for (i in errorsParam) {
	            var error = errorsParam[i];
	            errors[error.field] = error;
	        }
	
	        return errors;
	    },
	    hasRole: function hasRole(roles, role) {
	
	        if (role) {
	
	            var authority = role.substring(role.length - 7, role.length);
	            authority = 'ROLE_' + authority;
	
	            if (roles) {
	                if (roles.indexOf(authority) >= 0) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    },
	    resolveLabel: function resolveLabel(item) {
	        return item.labelPt;
	    }
	};

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  apiUrl: function apiUrl() {
	
	    return ("/app");
	  }
	};

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(56);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _FieldJsonBuilder = __webpack_require__(403);
	
	var _FieldJsonBuilder2 = _interopRequireDefault(_FieldJsonBuilder);
	
	var _RepositoryService = __webpack_require__(24);
	
	var _RepositoryService2 = _interopRequireDefault(_RepositoryService);
	
	var _AppConfigService = __webpack_require__(11);
	
	var _AppConfigService2 = _interopRequireDefault(_AppConfigService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PATH = _AppConfigService2.default.apiUrl() + '/api/form';
	
	exports.default = {
	
	  generateId: function generateId() {
	    function s4() {
	      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	    }
	    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	  },
	  addRow: function addRow(rows, quantity) {
	    var row = {
	      "cols": []
	    };
	    for (var i = 0; i < quantity; i++) {
	      row.cols.push({ "fields": [] });
	    }
	    rows.push(row);
	  },
	  findFieldIndex: function findFieldIndex(id, fields) {
	    var index = _.findIndex(fields, function (o) {
	      return o.id == id;
	    });
	    if (index != undefined && index >= 0) {
	      return index;
	    }
	  },
	  findField: function findField(id, fields) {
	    var index = this.findFieldIndex(id, fields);
	    if (index != undefined) {
	      return fields[index];
	    }
	    console.error("Field ID [" + id + "] not found in fields", fields);
	    return {};
	  },
	
	  fieldBuildObject: function fieldBuildObject(field, fields) {
	
	    var currentField = this.findField(field.id, fields);
	
	    if (currentField != undefined) {
	      var copy = (0, _assign2.default)({}, currentField);
	      return copy;
	    }
	
	    return _FieldJsonBuilder2.default.build(field);
	  },
	
	  saveFieldDesc: function saveFieldDesc(payload) {
	    var url = PATH + "/updateFieldDesc/" + payload.id;
	    return _RepositoryService2.default.save(url, payload);
	  },
	
	  showColumn: function showColumn(col) {
	    var it = JSON.parse((0, _stringify2.default)(col));
	
	    return it.fields.length > 0;
	  },
	  showRow: function showRow(row) {
	    var _this = this;
	
	    var it = JSON.parse((0, _stringify2.default)(row));
	    var ret = false;
	
	    _.forEach(it.cols, function (col) {
	
	      if (_this.showColumn(col)) {
	        ret = _this.showColumn(col);
	      }
	    });
	
	    return ret;
	  }
	};

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(56);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _AppConfigService = __webpack_require__(11);
	
	var _AppConfigService2 = _interopRequireDefault(_AppConfigService);
	
	var _http = __webpack_require__(35);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _LocalDatabaseService = __webpack_require__(44);
	
	var _LocalDatabaseService2 = _interopRequireDefault(_LocalDatabaseService);
	
	var _UtilsService = __webpack_require__(9);
	
	var _UtilsService2 = _interopRequireDefault(_UtilsService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  searchAutoComplete: function searchAutoComplete(url) {
	
	    return _http2.default.get(url).then(function (response) {
	      return {
	        data: response.data.data,
	        pagination: response.data.pagination
	      };
	    });
	  },
	  search: function search(url) {
	    return _http2.default.get(url).then(function (response) {
	      return response.data;
	    });
	  },
	  loadEntityLocation: function loadEntityLocation(entityLocation) {
	
	    var self = this;
	    var id = entityLocation.name + '_' + entityLocation.id;
	
	    return _LocalDatabaseService2.default.findById(id).then(function (document) {
	
	      if (!document) {
	        return self.load(entityLocation).then(function (response) {
	          return _LocalDatabaseService2.default.save(id, response);
	        });
	      }
	
	      return self.load(entityLocation).then(function (response) {
	        return _LocalDatabaseService2.default.update(document, response);
	      });
	    });
	  },
	  load: function load(entityLocation) {
	
	    var url = _AppConfigService2.default.apiUrl() + entityLocation.location;
	
	    return _http2.default.get(url).then(function (response) {
	      return response.data.data;
	    });
	  },
	  resolveReference: function resolveReference(reference, callback) {
	
	    var url = _AppConfigService2.default.apiUrl() + reference.location;
	
	    _http2.default.get(url).then(function (response) {
	
	      if (response.data.meta.code !== 200) {
	        alert('Ocorreu um erro inesperado!');
	      } else {
	
	        callback(response.data.data);
	      }
	    }, function (response) {});
	  },
	  save: function save(url, form, notLoadEntityLocation) {
	    var self = this;
	
	    return (0, _http2.default)({
	      method: form.id ? 'put' : 'post',
	      url: url,
	      data: (0, _stringify2.default)(form)
	    }).then(function (response) {
	      return response.data;
	    }).then(function (response) {
	      var code = response.meta.code;
	      if (code == 200 || code == 201) {
	
	        if (notLoadEntityLocation) {
	          return response.data;
	        }
	
	        return self.loadEntityLocation(response.data);
	      } else if (code === 400) {
	        throw _UtilsService2.default.buildErrorMessage(response.errors);
	      }
	    });
	  }
	};

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(526)
	
	/* template */
	var __vue_template__ = __webpack_require__(907)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(527)
	
	/* template */
	var __vue_template__ = __webpack_require__(913)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(56);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _AppConfigService = __webpack_require__(11);
	
	var _AppConfigService2 = _interopRequireDefault(_AppConfigService);
	
	var _http = __webpack_require__(35);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _LocalDatabaseService = __webpack_require__(44);
	
	var _LocalDatabaseService2 = _interopRequireDefault(_LocalDatabaseService);
	
	var _UtilsService = __webpack_require__(9);
	
	var _UtilsService2 = _interopRequireDefault(_UtilsService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PATH_API = _AppConfigService2.default.apiUrl() + '/api';
	
	exports.default = {
	
	  apiUrl: function apiUrl(uri, excludeApi) {
	
	    if (uri != undefined) {
	
	      if (excludeApi) {
	        var ret = PATH_API + uri;
	        ret = ret.replace('/api', '');
	        return ret;
	      }
	
	      return PATH_API + uri;
	    }
	
	    return PATH_API;
	  },
	
	  post: function post(payload) {
	
	    var uri = payload.uri;
	    var excludeApi = payload.excludeApi;
	    var data = payload.data;
	
	    var httpOptions = {
	      method: 'post',
	      url: this.apiUrl(uri, excludeApi),
	      data: (0, _stringify2.default)(data)
	    };
	
	    return (0, _http2.default)(httpOptions).then(function (response) {
	      return response.data;
	    });
	  },
	
	  search: function search(payload) {
	    var uri = payload.uri;
	    var excludeApi = payload.excludeApi;
	    var filter = payload.filter;
	
	    var url = this.apiUrl(uri, excludeApi);
	
	    var query = _UtilsService2.default.buildQuery(filter);
	    if (query) {
	      url = url + query;
	    }
	
	    return _http2.default.get(url).then(function (response) {
	      return response.data;
	    });
	  },
	
	  fetch: function fetch(payload) {
	    var context = payload.context;
	    var uri = payload.uri;
	
	    context.showLoader();
	
	    var url = this.apiUrl(uri);
	
	    return _http2.default.get(url).then(function (response) {
	      context.hideLoader();
	      return response.data;
	    });
	  },
	
	  save: function save(payload) {
	    var context = payload.context;
	    var uri = payload.uri;
	    var instance = payload.instance;
	    var showRouter = payload.showRouter;
	    var successRouterPush = payload.successRouterPush;
	    var successMessage = payload.successMessage;
	
	    var _successMessage = context.$t("itemSuccessfullyCreated");
	
	    context.showLoader();
	
	    var httpOptions = {
	      method: 'post',
	      url: this.apiUrl(uri),
	      data: (0, _stringify2.default)(instance)
	    };
	
	    if (instance.id) {
	      _successMessage = context.$t("itemSuccessfullyUpdated");
	      httpOptions.method = "put";
	      httpOptions.url += "/" + instance.id;
	    }
	
	    return (0, _http2.default)(httpOptions).then(function (response) {
	      return response.data;
	    }).then(function (response) {
	
	      var code = response.meta.code;
	
	      if (code == 200 || code == 201) {
	
	        if (successMessage != undefined) {
	          _successMessage = successMessage;
	        }
	
	        context.$notify({
	          title: context.$t("success"),
	          message: _successMessage,
	          type: 'success'
	        });
	
	        if (showRouter != undefined) {
	          context.$router.push(showRouter + "/" + response.data.id);
	        }
	
	        if (successRouterPush != undefined) {
	          context.$router.push(successRouterPush);
	        }
	
	        context.hideLoader();
	
	        return response.data;
	      } else if (code === 400) {
	
	        payload.errors = _UtilsService2.default.buildErrorMessage(response.errors);
	
	        context.hideLoader();
	
	        throw payload.errors;
	      }
	    });
	  },
	
	  delete: function _delete(payload) {
	    var _this = this;
	
	    var context = payload.context;
	    var uri = payload.uri;
	    var successRouterPush = payload.successRouterPush;
	
	    return context.$confirm(context.$t("confirmTheDeletion"), context.$t("warning"), {
	      confirmButtonText: context.$t("yes"),
	      cancelButtonText: context.$t("no"),
	      type: 'warning'
	    }).then(function () {
	
	      return _http2.default.delete(_this.apiUrl(uri)).then(function (response) {
	        return response.data;
	      }).then(function (response) {
	
	        if (response.meta.code == 200) {
	
	          context.$notify({
	            title: context.$t("success"),
	            message: context.$t("itemDeleted"),
	            type: 'success'
	          });
	
	          if (successRouterPush != undefined) {
	            context.$router.push(successRouterPush);
	          }
	        } else {
	
	          var errorMessage = response.errors[0].message;
	
	          if (errorMessage == "") {
	            errorMessage = response.errors[0]["error-code"];
	          }
	
	          context.$alert(errorMessage, 'Erro', {
	            confirmButtonText: context.$t("close"),
	            type: 'error'
	          });
	        }
	      });
	    });
	  },
	  searchAutoComplete: function searchAutoComplete(url) {
	    var self = this;
	
	    return _http2.default.get(url).then(function (response) {
	      return {
	        code: response.data.meta.code,
	        data: response.data.data,
	        pagination: response.data.pagination
	      };
	    });
	  },
	  loadObject: function loadObject(object) {
	
	    var id = object.id;
	
	    return _LocalDatabaseService2.default.findById(id).then(function (document) {
	      if (!document) {
	        return _LocalDatabaseService2.default.save(id, object);
	      }
	
	      return _LocalDatabaseService2.default.update(document, object);
	    });
	  },
	  load: function load(entityLocation) {
	
	    var url = _AppConfigService2.default.apiUrl() + entityLocation.location;
	
	    return _http2.default.get(url).then(function (response) {
	      return response.data.data;
	    });
	  },
	  resolveReference: function resolveReference(reference, callback) {
	
	    var url = _AppConfigService2.default.apiUrl() + reference.location;
	
	    _http2.default.get(url).then(function (response) {
	
	      if (response.data.meta.code !== 200) {
	        alert(context.$t("unexpectedError"));
	      } else {
	
	        callback(response.data.data);
	      }
	    }, function (response) {});
	  },
	  deleteInstance: function deleteInstance(paramUrl) {
	    return _http2.default.delete(paramUrl).then(function (response) {
	      return response.data;
	    });
	  }
	};

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createClient = undefined;
	
	var _promise = __webpack_require__(71);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _lodash = __webpack_require__(766);
	
	var _axios = __webpack_require__(374);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mainVuex = __webpack_require__(89);
	
	var _mainVuex2 = _interopRequireDefault(_mainVuex);
	
	var _i18n = __webpack_require__(88);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var minutesToWait = 10;
	
	var createClient = exports.createClient = function createClient() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	
	  var http = _axios2.default.create((0, _lodash.defaults)({}, options));
	  http.defaults.headers.post['Content-Type'] = 'application/json';
	  http.defaults.headers.put['Content-Type'] = 'application/json';
	  http.defaults.timeout = minutesToWait * 60 * 1000;
	
	  http.interceptors.request.use(function (config) {
	    config.headers['x-user-language'] = _i18n2.default.locale;
	    return config;
	  }, function (error) {
	    return _promise2.default.reject(error);
	  });
	
	  http.interceptors.response.use(function (response) {
	
	    if (response.data && response.data.meta && response.data.meta.code == 500) {
	
	      console.error("Ocorreu um erro de comunicação com o servidor, tente novamente!\n" + response.data.error);
	    }
	
	    return response;
	  }, function (error) {
	
	    var currentUrl = window.location.href;
	
	    if (error && error.response && error.response.status) {
	
	      if (error.response.status == 401) {
	
	        if (currentUrl.indexOf('/auth') < 0) {
	          _mainVuex2.default.dispatch('logout').then(function () {
	            window.location.reload();
	          });
	        }
	      } else if (error.response.status == 403) {
	
	        console.log("Acesso negado!!!");
	        _mainVuex2.default.dispatch('logout').then(function () {
	          window.location.reload();
	        });
	      } else {
	        console.error("Ocorreu um erro de comunicação com o servidor, tente novamente!\n" + error.response.data.message);
	      }
	    } else {
	
	      if (currentUrl.indexOf('/auth') < 0) {
	        console.error("Ocorreu um erro de comunicação com o servidor, tente novamente!\n");
	      }
	    }
	
	    return _promise2.default.reject(error);
	  });
	
	  return http;
	};
	
	exports.default = createClient();

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(482)
	
	/* template */
	var __vue_template__ = __webpack_require__(900)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BusinessAreaUtils = __webpack_require__(86);
	
	var _BusinessAreaUtils2 = _interopRequireDefault(_BusinessAreaUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  addBackground: function addBackground(id) {
	    document.getElementsByTagName("html")[0].classList.add('main-with-background');
	    document.getElementsByTagName("main")[0].style = "background-image: url('" + id + "')";
	  },
	
	  removeBackground: function removeBackground() {
	    document.getElementsByTagName("html")[0].classList.remove('main-with-background');
	  },
	
	  getUrlBusinessAreaImage: function getUrlBusinessAreaImage(id) {
	    return _BusinessAreaUtils2.default.apiUrl() + '/f/businessAreaLogo/' + id;
	  }
	};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pouchdb = __webpack_require__(775);
	
	var _pouchdb2 = _interopRequireDefault(_pouchdb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var db = new _pouchdb2.default('patenddb');
	
	var store = {};
	
	store.save = function (id, document) {
	  document._id = id;
	  return db.put(document).then(function () {
	    return document;
	  }).catch(function (err) {
	    if (err.name === 'conflict') {
	      return document;
	    } else {
	      return null;
	    }
	  });
	};
	
	store.update = function (currentDocument, newDocument) {
	
	  newDocument._id = currentDocument._id;
	  newDocument._rev = currentDocument._rev;
	
	  return db.put(newDocument).then(function () {
	    return newDocument;
	  }).catch(function (err) {
	    return null;
	  });
	};
	
	store.findById = function (id) {
	  return db.get(id.toString()).then(function (response) {
	    return response;
	  }).catch(function (err) {
	    return null;
	  });
	};
	
	exports.default = store;

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(645)
	
	/* script */
	__vue_exports__ = __webpack_require__(488)
	
	/* template */
	var __vue_template__ = __webpack_require__(956)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(473)
	
	/* template */
	var __vue_template__ = __webpack_require__(877)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(477)
	
	/* template */
	var __vue_template__ = __webpack_require__(955)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(491)
	
	/* template */
	var __vue_template__ = __webpack_require__(938)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 69 */,
/* 70 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  prefix: '',
	  suffix: '',
	  thousands: ',',
	  decimal: '.',
	  precision: 2
	};

/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RepositoryService = __webpack_require__(24);
	
	var _RepositoryService2 = _interopRequireDefault(_RepositoryService);
	
	var _AppConfigService = __webpack_require__(11);
	
	var _AppConfigService2 = _interopRequireDefault(_AppConfigService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  apiUrl: function apiUrl() {
	    return _AppConfigService2.default.apiUrl();
	  },
	
	  buildQuery: function buildQuery(url, filter) {
	
	    var query = [];
	
	    if (filter.code) {
	      query.push("code=" + filter.code);
	    }
	    if (filter.status) {
	      query.push("status=" + filter.status);
	    }
	
	    if (filter.openingDate) {
	      var openingDateStart = filter.openingDate[0];
	      if (openingDateStart) {
	        query.push("openingDateStart=" + openingDateStart.toISOString().slice(0, 10) + 'T00:00:00Z');
	      }
	      var openingDateEnd = filter.openingDate[1];
	      if (openingDateEnd) {
	        query.push("openingDateEnd=" + openingDateEnd.toISOString().slice(0, 10) + 'T23:59:59Z');
	      }
	    }
	
	    if (filter.closingDate) {
	      var closingDateStart = filter.closingDate[0];
	      if (closingDateStart) {
	        query.push("closingDateStart=" + closingDateStart.toISOString().slice(0, 10) + 'T00:00:00Z');
	      }
	      var closingDateEnd = filter.closingDate[1];
	      if (closingDateEnd) {
	        query.push("closingDateEnd=" + closingDateEnd.toISOString().slice(0, 10) + 'T23:59:59Z');
	      }
	    }
	
	    if (filter.currentPage) {
	      query.push("currentPage=" + filter.currentPage);
	    }
	    if (filter.itemsPerPage) {
	      query.push("itemsPerPage=" + filter.itemsPerPage);
	    }
	    if (query.length) {
	      url = url + "?" + query.join("&");
	    }
	
	    return url;
	  }
	};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _http = __webpack_require__(35);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _AppConfigService = __webpack_require__(11);
	
	var _AppConfigService2 = _interopRequireDefault(_AppConfigService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  resolveFormDesc: function resolveFormDesc(params) {
	
	    var businessAreaId = params.businessAreaId;
	    var systemId = params.systemId;
	    var systemVersion = params.systemVersion;
	
	    return _AppConfigService2.default.apiUrl() + "/f/ba/" + businessAreaId + "/c/" + systemId + "/" + systemVersion + "/ms/menu/items/load";
	  },
	
	  resolveContractMenu: function resolveContractMenu(params) {
	
	    return _http2.default.get(this.resolveFormDesc(params)).then(function (response) {
	      return response.data;
	    });
	  }
	
	};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueI18n = __webpack_require__(792);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	var _en = __webpack_require__(424);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _en3 = __webpack_require__(594);
	
	var _en4 = _interopRequireDefault(_en3);
	
	var _ptBr = __webpack_require__(426);
	
	var _ptBr2 = _interopRequireDefault(_ptBr);
	
	var _ptBr3 = __webpack_require__(596);
	
	var _ptBr4 = _interopRequireDefault(_ptBr3);
	
	var _es = __webpack_require__(425);
	
	var _es2 = _interopRequireDefault(_es);
	
	var _es3 = __webpack_require__(595);
	
	var _es4 = _interopRequireDefault(_es3);
	
	var _i18nApp = __webpack_require__(401);
	
	var _i18nApp2 = _interopRequireDefault(_i18nApp);
	
	var _UtilsService = __webpack_require__(9);
	
	var _UtilsService2 = _interopRequireDefault(_UtilsService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messages = {
	  en: (0, _extends3.default)({}, _en2.default, _en4.default, _i18nApp2.default.en),
	  pt: (0, _extends3.default)({}, _ptBr2.default, _ptBr4.default, _i18nApp2.default.pt),
	  es: (0, _extends3.default)({}, _es2.default, _es4.default, _i18nApp2.default.es)
	};
	
	_vue2.default.use(_vueI18n2.default);
	
	var userLocale = _UtilsService2.default.localStorageGetItem("USER_LOCALE");
	
	var i18n = new _vueI18n2.default({
	  locale: userLocale ? userLocale : 'pt',
	  messages: messages
	});
	
	exports.default = i18n;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(3);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vuex3 = __webpack_require__(421);
	
	var _vuex4 = _interopRequireDefault(_vuex3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	  modules: _vuex4.default
	});

/***/ }),
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(634)
	
	/* script */
	__vue_exports__ = __webpack_require__(443)
	
	/* template */
	var __vue_template__ = __webpack_require__(927)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4fcc4d27"
	
	module.exports = __vue_exports__


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(640)
	
	/* script */
	__vue_exports__ = __webpack_require__(479)
	
	/* template */
	var __vue_template__ = __webpack_require__(942)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7b83533a"
	
	module.exports = __vue_exports__


/***/ }),
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (el, binding) {
	  if (!binding.value) return;
	  var opt = (0, _assign2.default)(_options2.default, binding.value);
	
	  if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
	    var els = el.getElementsByTagName('input');
	    if (els.length !== 1) {} else {
	      el = els[0];
	    }
	  }
	
	  el.oninput = function () {
	    var positionFromEnd = el.value.length - el.selectionEnd;
	    el.value = (0, _utils.format)(el.value, opt);
	    positionFromEnd = Math.max(positionFromEnd, opt.suffix.length);
	    positionFromEnd = el.value.length - positionFromEnd;
	    positionFromEnd = Math.max(positionFromEnd, opt.prefix.length + 1);
	    (0, _utils.setCursor)(el, positionFromEnd);
	    el.dispatchEvent((0, _utils.event)('change'));
	  };
	
	  el.onfocus = function () {
	    (0, _utils.setCursor)(el, el.value.length - opt.suffix.length);
	  };
	
	  el.oninput();
	  el.dispatchEvent((0, _utils.event)('input'));
	};
	
	var _utils = __webpack_require__(147);
	
	var _assign = __webpack_require__(422);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _options = __webpack_require__(70);
	
	var _options2 = _interopRequireDefault(_options);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.event = exports.setCursor = exports.unformat = exports.format = undefined;
	
	var _options = __webpack_require__(70);
	
	var _options2 = _interopRequireDefault(_options);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function format(input) {
	  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _options2.default;
	
	  if (typeof input === 'number') {
	    input = input.toFixed(fixed(opt.precision));
	  }
	  var negative = input.indexOf('-') >= 0 ? '-' : '';
	
	  var numbers = onlyNumbers(input);
	  var currency = numbersToCurrency(numbers, opt.precision);
	  var parts = toStr(currency).split('.');
	  var integer = parts[0];
	  var decimal = parts[1];
	  integer = addThousandSeparator(integer, opt.thousands);
	  return opt.prefix + negative + joinIntegerAndDecimal(integer, decimal, opt.decimal) + opt.suffix;
	}
	
	function unformat(input, precision) {
	  var negative = input.indexOf('-') >= 0 ? -1 : 1;
	  var numbers = onlyNumbers(input);
	  var currency = numbersToCurrency(numbers, precision);
	  return parseFloat(currency) * negative;
	}
	
	function onlyNumbers(input) {
	  return toStr(input).replace(/\D+/g, '') || '0';
	}
	
	function fixed(precision) {
	  return between(0, precision, 20);
	}
	
	function between(min, n, max) {
	  return Math.max(min, Math.min(n, max));
	}
	
	function numbersToCurrency(numbers, precision) {
	  var exp = Math.pow(10, precision);
	  var float = parseFloat(numbers) / exp;
	  return float.toFixed(fixed(precision));
	}
	
	function addThousandSeparator(integer, separator) {
	  return integer.replace(/(\d)(?=(?:\d{3})+\b)/gm, '$1' + separator);
	}
	
	function currencyToIntegerAndDecimal(float) {
	  return toStr(float).split('.');
	}
	
	function joinIntegerAndDecimal(integer, decimal, separator) {
	  return decimal ? integer + separator + decimal : integer;
	}
	
	function toStr(value) {
	  return value ? value.toString() : '';
	}
	
	function setCursor(el, position) {
	  var setSelectionRange = function setSelectionRange() {
	    el.setSelectionRange(position, position);
	  };
	  if (el === document.activeElement) {
	    setSelectionRange();
	    setTimeout(setSelectionRange, 1);
	  }
	}
	
	function event(name) {
	  var evt = document.createEvent('Event');
	  evt.initEvent(name, true, true);
	  return evt;
	}
	
	exports.format = format;
	exports.unformat = unformat;
	exports.setCursor = setCursor;
	exports.event = event;

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var setShow = exports.setShow = 'CODECASTS_LOADER/setShow';

/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 340 */,
/* 341 */,
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(642)
	
	/* script */
	__vue_exports__ = __webpack_require__(449)
	
	/* template */
	var __vue_template__ = __webpack_require__(950)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(620)
	
	/* script */
	__vue_exports__ = __webpack_require__(451)
	
	/* template */
	var __vue_template__ = __webpack_require__(902)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-272a870c"
	
	module.exports = __vue_exports__


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(651)
	
	/* script */
	__vue_exports__ = __webpack_require__(453)
	
	/* template */
	var __vue_template__ = __webpack_require__(969)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-eff8c14e"
	
	module.exports = __vue_exports__


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(616)
	
	/* script */
	__vue_exports__ = __webpack_require__(465)
	
	/* template */
	var __vue_template__ = __webpack_require__(888)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(613)
	
	/* script */
	__vue_exports__ = __webpack_require__(484)
	
	/* template */
	var __vue_template__ = __webpack_require__(878)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-08ca37b0"
	
	module.exports = __vue_exports__


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(643)
	
	/* script */
	__vue_exports__ = __webpack_require__(487)
	
	/* template */
	var __vue_template__ = __webpack_require__(952)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9490f9c0"
	
	module.exports = __vue_exports__


/***/ }),
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(71);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _objectDestructuringEmpty2 = __webpack_require__(45);
	
	var _objectDestructuringEmpty3 = _interopRequireDefault(_objectDestructuringEmpty2);
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _mutations;
	
	var _ApiService = __webpack_require__(30);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _RepositoryService = __webpack_require__(24);
	
	var _RepositoryService2 = _interopRequireDefault(_RepositoryService);
	
	var _userVuex = __webpack_require__(420);
	
	var _userVuex2 = _interopRequireDefault(_userVuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (0, _extends3.default)({}, _userVuex2.default);
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, "genericMutation", function genericMutation(state, payload) {
	  _.set(state[payload.stateName], payload.attribute, payload.attributeValue);
	}), (0, _defineProperty3.default)(_mutations, "setNewObjectState", function setNewObjectState(state, payload) {
	  var stateObject = {};
	  stateObject[payload.stateName] = payload;
	  (0, _assign2.default)(state, stateObject);
	}), _mutations);
	
	var actions = {
	  genericMutationCommit: function genericMutationCommit(_ref, payload) {
	    var commit = _ref.commit;
	
	    commit("genericMutation", payload);
	  },
	  setNewObjectStateCommit: function setNewObjectStateCommit(_ref2, payload) {
	    var commit = _ref2.commit;
	
	    commit("setNewObjectState", payload);
	  },
	  testConection: function testConection() {
	    return _RepositoryService2.default.searchAutoComplete(PATH);
	  },
	  genericDelete: function genericDelete(_ref3, payload) {
	    (0, _objectDestructuringEmpty3.default)(_ref3);
	
	
	    var context = payload.context;
	    var uri = payload.uri;
	    var successRouterPush = payload.successRouterPush;
	
	    context.$confirm(context.$t('confirmTheDeletion'), context.$t('warning'), {
	      confirmButtonText: context.$t('yes'),
	      cancelButtonText: context.$t('no'),
	      type: 'warning'
	    }).then(function () {
	
	      _RepositoryService2.default.deleteInstance(PATH + uri).then(function (response) {
	
	        if (response.meta.code == 200) {
	
	          context.$notify({
	            title: context.$t('success'),
	            message: 'Item removido.',
	            type: 'success'
	          });
	
	          if (successRouterPush != undefined) {
	            context.$router.push(successRouterPush);
	          }
	        } else {
	
	          var errorMessage = response.errors[0].message;
	
	          if (errorMessage == "") {
	            errorMessage = response.errors[0]["error-code"];
	          }
	
	          context.$alert(errorMessage, 'Erro', {
	            confirmButtonText: 'Fechar',
	            type: 'error'
	          });
	        }
	      });
	    });
	  },
	  setItemsPerPage: function setItemsPerPage(_ref4, payload) {
	    var dispatch = _ref4.dispatch;
	
	
	    return dispatch("genericMutationCommit", {
	      stateName: payload.stateName,
	      attribute: "filter.currentPage",
	      attributeValue: 1
	    }).then(function () {
	
	      return dispatch("genericMutationCommit", {
	        stateName: payload.stateName,
	        attribute: "filter.itemsPerPage",
	        attributeValue: payload.filter.itemsPerPage
	      });
	    }).then(function () {
	      return dispatch("search", payload);
	    });
	  },
	  setPage: function setPage(_ref5, payload) {
	    var dispatch = _ref5.dispatch;
	
	
	    return dispatch("genericMutationCommit", {
	      stateName: payload.stateName,
	      attribute: "filter.currentPage",
	      attributeValue: payload.filter.currentPage
	    }).then(function () {
	      return dispatch('search', payload);
	    });
	  },
	  doSearch: function doSearch(_ref6, payload) {
	    var dispatch = _ref6.dispatch;
	
	
	    return _promise2.default.resolve().then(function () {
	      if (payload.clickFromButton) {
	        return dispatch("genericMutationCommit", {
	          stateName: payload.stateName,
	          attribute: "filter.currentPage",
	          attributeValue: 1
	        });
	      }
	    }).then(function () {
	      return dispatch("genericMutationCommit", {
	        stateName: payload.stateName,
	        attribute: "submitted",
	        attributeValue: true
	      });
	    }).then(function () {
	      return dispatch("genericMutationCommit", {
	        stateName: payload.stateName,
	        attribute: "filter",
	        attributeValue: (0, _assign2.default)({}, state[payload.stateName].filter, payload.filter)
	      });
	    }).then(function () {
	      return dispatch("search", payload);
	    });
	  },
	  search: function search(_ref7, payload) {
	    var dispatch = _ref7.dispatch,
	        getters = _ref7.getters;
	
	
	    dispatch("showLoader");
	
	    return _ApiService2.default.search(getters.retrieveState(payload.stateName)).then(function (response) {
	
	      dispatch("genericMutationCommit", {
	        stateName: payload.stateName,
	        attribute: "pagination",
	        attributeValue: response.pagination
	      });
	
	      return dispatch("genericMutationCommit", {
	        stateName: payload.stateName,
	        attribute: "list",
	        attributeValue: response.data
	      });
	    }).then(function () {
	      return dispatch('hideLoader');
	    });
	  },
	  fetch: function fetch(_ref8, payload) {
	    (0, _objectDestructuringEmpty3.default)(_ref8);
	
	    return _ApiService2.default.fetch(payload);
	  },
	  delete: function _delete(_ref9, payload) {
	    (0, _objectDestructuringEmpty3.default)(_ref9);
	
	    return _ApiService2.default.delete(payload);
	  },
	  save: function save(_ref10, payload) {
	    (0, _objectDestructuringEmpty3.default)(_ref10);
	
	    _ApiService2.default.save(payload);
	  }
	};
	
	var getters = {
	  retrieveState: function retrieveState(state) {
	    return function (stateName) {
	      var tr = state[stateName];
	      if (tr === undefined) {
	        return undefined;
	      }
	      return (0, _assign2.default)({}, tr);
	    };
	  },
	  list: function list(state) {
	    return function (payload) {
	      var stateFound = state[payload.stateName];
	      return stateFound !== undefined ? stateFound.list : [];
	    };
	  },
	  pagination: function pagination(state) {
	    return function (payload) {
	      if (payload.stateName !== undefined && payload.stateName !== '') {
	        if (state[payload.stateName] !== undefined) {
	          return state[payload.stateName].pagination;
	        }
	      }
	      return {};
	    };
	  },
	  apiUrl: function apiUrl() {
	    return _ApiService2.default.apiUrl();
	  },
	  showBottomPagination: function showBottomPagination(state) {
	    return function (payload) {
	      var pagination = state[payload.stateName].pagination;
	      return pagination.totalPage > 1;
	    };
	  }
	};
	
	exports.default = {
	  state: state,
	  mutations: mutations,
	  actions: actions,
	  getters: getters
	};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.mutationsTypes = undefined;
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _objectDestructuringEmpty2 = __webpack_require__(45);
	
	var _objectDestructuringEmpty3 = _interopRequireDefault(_objectDestructuringEmpty2);
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _AuthService = __webpack_require__(437);
	
	var _AuthService2 = _interopRequireDefault(_AuthService);
	
	var _UtilsService = __webpack_require__(9);
	
	var _UtilsService2 = _interopRequireDefault(_UtilsService);
	
	var _http = __webpack_require__(35);
	
	var _http2 = _interopRequireDefault(_http);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mutationsTypes = exports.mutationsTypes = {
	    LOGIN: 'auth/LOGIN',
	    LOGOUT: 'auth/LOGOUT',
	    MENU_MAIN_ACTIVE: 'auth/MENU_MAIN_ACTIVE',
	    MENU_MAIN: 'auth/MENU_MAIN',
	    SHOW_BUSINESS_LINE: 'auth/SHOW_BUSINESS_LINE',
	    SHOW_CONTRACTS: 'auth/SHOW_CONTRACTS',
	    CHANGE_PASSWORD_EXPIRED: 'auth/CHANGE_PASSWORD_EXPIRED'
	};
	
	var state = {
	    user: {},
	    logged: false,
	    menus: {
	        main: [{
	            menuItem: 'exampleItem',
	            active: false,
	            role: 'ROLE_EXAMPLE'
	        }]
	    }
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, mutationsTypes.LOGIN, function (state, payload) {
	    state.user = payload;
	    state.logged = true;
	}), (0, _defineProperty3.default)(_mutations, mutationsTypes.USER_DATA, function (state, payload) {
	    state.user.name = payload.name;
	}), (0, _defineProperty3.default)(_mutations, mutationsTypes.LOGOUT, function (state) {
	    state.user = '';
	    state.logged = false;
	}), (0, _defineProperty3.default)(_mutations, mutationsTypes.MENU_MAIN_ACTIVE, function (state, payload) {
	    state.menus.main[payload.index].active = payload.active;
	}), (0, _defineProperty3.default)(_mutations, mutationsTypes.MENU_MAIN, function (state, payload) {
	    state.menus.main = payload;
	}), (0, _defineProperty3.default)(_mutations, mutationsTypes.CHANGE_PASSWORD_EXPIRED, function (state, payload) {
	    state.user.passwordExpired = payload.passwordExpired;
	}), _mutations);
	
	var actions = {
	
	    login: function login(_ref, payload) {
	        var dispatch = _ref.dispatch;
	
	
	        return _AuthService2.default.login(payload.username, payload.password).then(function (user) {
	
	            var newUser = {};
	
	            newUser.access_token = user.access_token;
	            newUser.businessLines = user.businessLines;
	            newUser.name = user.name;
	            newUser.phone = user.phone;
	            newUser.roles = user.roles;
	            newUser.username = user.username;
	
	            _UtilsService2.default.localStorageSetItem(mutationsTypes.LOGIN, newUser);
	            dispatch('buildUser', newUser);
	            return newUser;
	        });
	    },
	
	    logout: function logout(_ref2) {
	        var commit = _ref2.commit;
	
	        _UtilsService2.default.localStorageSetItem(mutationsTypes.LOGIN, '');
	        commit(mutationsTypes.LOGOUT);
	        _http2.default.defaults.headers.common['Authorization'] = '';
	    },
	
	    refreshAuthUser: function refreshAuthUser(_ref3) {
	        var dispatch = _ref3.dispatch;
	
	
	        var userFromLocalStorage = _UtilsService2.default.localStorageGetItem(mutationsTypes.LOGIN);
	
	        if (!state.logged && userFromLocalStorage && userFromLocalStorage !== '') {
	            dispatch('buildUser', userFromLocalStorage);
	        }
	    },
	
	    buildMenuMain: function buildMenuMain(_ref4) {
	        var commit = _ref4.commit,
	            dispatch = _ref4.dispatch,
	            state = _ref4.state;
	
	        var _loop = function _loop(i) {
	            dispatch('userHasRole', state.menus.main[i].role).then(function (response) {
	                commit(mutationsTypes.MENU_MAIN_ACTIVE, { index: i, active: response });
	            });
	        };
	
	        for (var i = 0; i < state.menus.main.length; i++) {
	            _loop(i);
	        }
	    },
	    userHasRole: function userHasRole(_ref5, payload) {
	        (0, _objectDestructuringEmpty3.default)(_ref5);
	
	
	        return _UtilsService2.default.hasRole(state.user.roles, payload);
	    },
	    buildUser: function buildUser(_ref6, user) {
	        var commit = _ref6.commit,
	            dispatch = _ref6.dispatch;
	
	
	        commit(mutationsTypes.LOGIN, user);
	        _http2.default.defaults.headers.common['Authorization'] = 'Bearer ' + user.access_token;
	        dispatch('buildMenuMain');
	    },
	    updatePasswordExpired: function updatePasswordExpired(_ref7, payload) {
	        var commit = _ref7.commit;
	
	        commit(mutationsTypes.CHANGE_PASSWORD_EXPIRED, payload);
	    },
	
	
	    changePassword: function changePassword(_ref8, payload) {
	        (0, _objectDestructuringEmpty3.default)(_ref8);
	
	        return _AuthService2.default.changePassword(payload);
	    },
	
	    retrievePassword: function retrievePassword(_ref9, payload) {
	        (0, _objectDestructuringEmpty3.default)(_ref9);
	
	        return _AuthService2.default.retrievePassword(payload);
	    },
	
	    changePasswordByToken: function changePasswordByToken(_ref10, payload) {
	        (0, _objectDestructuringEmpty3.default)(_ref10);
	
	        return _AuthService2.default.changePasswordByToken(payload);
	    },
	
	    changeUserContractVersion: function changeUserContractVersion(_ref11, payload) {
	        var dispatch = _ref11.dispatch;
	
	
	        var userWithNewContractVersion = (0, _assign2.default)({}, state.user);
	
	        var businessAreaIndex = _.findIndex(userWithNewContractVersion.businessLines, { 'id': payload.businessAreaId });
	        var contractIndex = _.findIndex(userWithNewContractVersion.businessLines[businessAreaIndex].contracts, { 'id': payload.contractId });
	
	        userWithNewContractVersion.businessLines[businessAreaIndex].contracts[contractIndex].version = payload.version;
	
	        _UtilsService2.default.localStorageSetItem(mutationsTypes.LOGIN, userWithNewContractVersion);
	        dispatch('buildUser', userWithNewContractVersion);
	    }
	};
	
	var getters = {
	
	    isLogged: function isLogged() {
	        return state.logged;
	    },
	
	    passwordExpired: function passwordExpired() {
	        if (state.user.passwordExpired !== null) {
	            return state.user.passwordExpired;
	        }
	        return false;
	    },
	
	    loggedUser: function loggedUser(state) {
	        return state.logged ? state.user : {};
	    },
	
	    authMenuMainExample: function authMenuMainExample() {
	        return findItemMenuMain(state.menus.main, 'exampleItem').active;
	    },
	
	    userLoggedRoles: function userLoggedRoles() {
	        return state.logged ? state.user.roles : null;
	    }
	};
	
	var findItemMenuMain = function findItemMenuMain(list, itemFind) {
	    return list.filter(function (item) {
	        return item.menuItem == itemFind;
	    })[0];
	};
	
	exports.default = {
	    state: state,
	    mutations: mutations,
	    actions: actions,
	    getters: getters
	};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var login = {
	    en: {
	        loginDescription: "Wherever you are in the world, in whatever industry, you can rely on our international teams of experts to provide you with specialized business solutions to make your business faster, simpler and more efficient.",
	        retrievePassword: "Recover Password",
	        forgotMyPassword: "Forgot my password",
	        enterYourUsername: "Enter your username:",
	        textEmailSent: "A message has been sent to your email with instructions to reset your password.",
	        inputNewPassword: "Enter the new password"
	    },
	    pt: {
	        loginDescription: "Onde quer que esteja no mundo, seja qual for o seu setor de atuação, você pode confiar em nossas equipes internacionais de especialistas.",
	        retrievePassword: "Recuperar senha",
	        forgotMyPassword: "Esqueci minha senha",
	        enterYourUsername: "Informe seu nome de usuário:",
	        textEmailSent: "Foi enviado para o seu e-mail uma mensagem com instruções para redefinir a sua senha.",
	        inputNewPassword: "Informe a nova senha"
	    },
	    es: {
	        loginDescription: "En cualquier parte del mundo y en cualquier sector, puede confiar en nuestros equipos internacionales de expertos, que le ofrecerán soluciones comerciales especializadas para lograr una mayor rapidez, sencillez y eficacia en sus negocios.",
	        retrievePassword: "Recuperar contraseña",
	        forgotMyPassword: "Olvide mi contraseña",
	        enterYourUsername: "Ingrese su nombre de usuario:",
	        textEmailSent: "Se ha enviado un mensaje a su correo electrónico con instrucciones para restablecer su contraseña.",
	        inputNewPassword: "Introduce la nueva contraseña"
	    }
	};
	
	exports.default = (0, _extends3.default)({}, login);

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(397);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Login = __webpack_require__(796);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _ForgetPassword = __webpack_require__(795);
	
	var _ForgetPassword2 = _interopRequireDefault(_ForgetPassword);
	
	var _ChangePassword = __webpack_require__(794);
	
	var _ChangePassword2 = _interopRequireDefault(_ChangePassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{ path: '/auth', component: _Login2.default, authenticated: false }, { path: '/forgetPassword', component: _ForgetPassword2.default, authenticated: false }, { path: '/changePassword', component: _ChangePassword2.default, authenticated: false }];

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mutationsTypes = undefined;
	
	var _objectDestructuringEmpty2 = __webpack_require__(45);
	
	var _objectDestructuringEmpty3 = _interopRequireDefault(_objectDestructuringEmpty2);
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _mutations;
	
	var _RepositoryService = __webpack_require__(24);
	
	var _RepositoryService2 = _interopRequireDefault(_RepositoryService);
	
	var _BusinessAreaUtils = __webpack_require__(86);
	
	var _BusinessAreaUtils2 = _interopRequireDefault(_BusinessAreaUtils);
	
	var _AppConfigService = __webpack_require__(11);
	
	var _AppConfigService2 = _interopRequireDefault(_AppConfigService);
	
	var _LocalDatabaseService = __webpack_require__(44);
	
	var _LocalDatabaseService2 = _interopRequireDefault(_LocalDatabaseService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PATH = _AppConfigService2.default.apiUrl() + '/f/ba';
	
	var state = {
	  list: []
	};
	
	var mutationsTypes = exports.mutationsTypes = {
	  LIST: 'businessArea/LIST',
	  PAGINATION: 'businessArea/PAGINATION',
	  UPDATE_FILTER: 'businessArea/UPDATE_FILTER',
	  UPDATE_FILTER_CURRENT_PAGE: 'businessArea/UPDATE_FILTER_CURRENT_PAGE',
	  UPDATE_FILTER_ITEMS_PER_PAGE: 'businessArea/UPDATE_FILTER_ITEMS_PER_PAGE'
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, mutationsTypes.LIST, function (state, payload) {
	  state.list = payload;
	}), (0, _defineProperty3.default)(_mutations, mutationsTypes.PAGINATION, function (state, payload) {
	  state.pagination = payload;
	}), (0, _defineProperty3.default)(_mutations, mutationsTypes.UPDATE_FILTER, function (state, payload) {
	  state.filter = (0, _assign2.default)({}, state.filter, payload);
	}), (0, _defineProperty3.default)(_mutations, mutationsTypes.UPDATE_FILTER_CURRENT_PAGE, function (state, payload) {
	  state.filter.currentPage = payload;
	}), (0, _defineProperty3.default)(_mutations, mutationsTypes.UPDATE_FILTER_ITEMS_PER_PAGE, function (state, payload) {
	  state.filter.itemsPerPage = payload;
	}), _mutations);
	
	var actions = {
	
	  businessAreaSetList: function businessAreaSetList(_ref, payload) {
	    var commit = _ref.commit;
	
	    commit(mutationsTypes.LIST, payload);
	  },
	
	  businessAreaSetPagination: function businessAreaSetPagination(_ref2, payload) {
	    var commit = _ref2.commit;
	
	    commit(mutationsTypes.PAGINATION, payload);
	  },
	
	  businessAreaSetItemsPerPage: function businessAreaSetItemsPerPage(_ref3, payload) {
	    var dispatch = _ref3.dispatch,
	        commit = _ref3.commit;
	
	    commit(mutationsTypes.UPDATE_FILTER_CURRENT_PAGE, 1);
	    commit(mutationsTypes.UPDATE_FILTER_ITEMS_PER_PAGE, payload);
	    dispatch("businessAreaSearch");
	  },
	  businessAreaSetPage: function businessAreaSetPage(_ref4, payload) {
	    var dispatch = _ref4.dispatch,
	        commit = _ref4.commit;
	
	    commit(mutationsTypes.UPDATE_FILTER_CURRENT_PAGE, payload);
	    dispatch('businessAreaSearch');
	  },
	  businessAreaDoSearch: function businessAreaDoSearch(_ref5, payload) {
	    var dispatch = _ref5.dispatch,
	        commit = _ref5.commit;
	
	    dispatch("businessAreaSearch");
	  },
	  businessAreaSearch: function businessAreaSearch(_ref6) {
	    var dispatch = _ref6.dispatch,
	        state = _ref6.state;
	
	    dispatch("showLoader");
	
	    var url = PATH;
	
	    _RepositoryService2.default.search(url).then(function (response) {
	      dispatch('businessAreaSetList', response);
	      dispatch('hideLoader');
	    });
	  },
	  businessAreaSave: function businessAreaSave(_ref7, payload) {
	    (0, _objectDestructuringEmpty3.default)(_ref7);
	
	    return _RepositoryService2.default.save(PATH, payload, true);
	  },
	  businessAreaGetInstance: function businessAreaGetInstance(_ref8, payload) {
	    (0, _objectDestructuringEmpty3.default)(_ref8);
	
	    return _LocalDatabaseService2.default.findById('BusinessArea_' + payload);
	  }
	};
	
	var getters = {
	  businessAreaFilter: function businessAreaFilter(state) {
	    return (0, _assign2.default)({}, state.filter);
	  },
	  businessAreaList: function businessAreaList() {
	    return state.list;
	  },
	  businessAreaPagination: function businessAreaPagination() {
	    return state.pagination;
	  }
	};
	
	exports.default = {
	  state: state,
	  mutations: mutations,
	  actions: actions,
	  getters: getters
	};

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(400);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _BusinessArea = __webpack_require__(797);
	
	var _BusinessArea2 = _interopRequireDefault(_BusinessArea);
	
	var _BusinessAreaList = __webpack_require__(798);
	
	var _BusinessAreaList2 = _interopRequireDefault(_BusinessAreaList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	    path: '/businessArea', component: _BusinessArea2.default,
	    children: [{ path: '', component: _BusinessAreaList2.default, name: 'BusinessAreaList' }]
	}];

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _i18nUser = __webpack_require__(417);
	
	var _i18nUser2 = _interopRequireDefault(_i18nUser);
	
	var _i18nModule = __webpack_require__(405);
	
	var _i18nModule2 = _interopRequireDefault(_i18nModule);
	
	var _i18nLogin = __webpack_require__(395);
	
	var _i18nLogin2 = _interopRequireDefault(_i18nLogin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var app = {
	    en: (0, _extends3.default)({
	        businessLine: "Business Line",
	        contracts: "Contracts",
	        updated: "updated",
	        created: "created",
	        forms: "Forms",
	        file: 'Upload file',
	        filters: "Filters",
	        sgsHome: "SGS Home",
	        sgsAroundTheWorld: "SGS around the world",
	        latitude: "Latitude",
	        longitude: "Longitude",
	        charges: "Billet charges",
	        dealership: "Billet dealership",
	        yourPasswordIsExpired: 'Your password is expired, please change your password to gain access to the system!',
	        newPasswordCanNotBeEqualToACurrentPassword: "New password can not be equal to a current password!",
	        newPasswordAndRepeatPasswordAreDifferentValues: 'New password and repeat password are different values!',
	        savedPasswordWithSuccess: "Saved password with success",
	        passwordUpdatedWithSuccess: "Password updated with success",
	        cancel: "Cancel",
	        continue: "Continue",
	        back: "Back"
	
	    }, _i18nUser2.default.en, _i18nModule2.default.en, _i18nLogin2.default.en),
	    pt: (0, _extends3.default)({
	        businessLine: "Business Line",
	        contracts: "Contratos",
	        updated: "atualizado",
	        created: "criado",
	        forms: "Forms",
	        file: 'Anexar',
	        filters: "Filtros",
	        sgsHome: "SGS Home",
	        sgsAroundTheWorld: "SGS ao redor do mundo",
	        latitude: "Latitude",
	        longitude: "Longitude",
	        charges: "Boleto de cobranças",
	        dealership: "Boleto de concessionária",
	        yourPasswordIsExpired: 'Sua senha está expirada, por favor mude a senha para ter acesso ao sistema!',
	        newPasswordCanNotBeEqualToACurrentPassword: "Nova senha não pode ser igual a senha atual!",
	        newPasswordAndRepeatPasswordAreDifferentValues: 'Nova senha e repetir nova senha são valores diferentes!',
	        savedPasswordWithSuccess: "Senha salva com sucesso",
	        passwordUpdatedWithSuccess: "Senha alterada com sucesso",
	        cancel: "Cancelar",
	        continue: "Continuar",
	        back: "Voltar"
	
	    }, _i18nUser2.default.pt, _i18nModule2.default.pt, _i18nLogin2.default.pt),
	    es: (0, _extends3.default)({
	        businessLine: "Business Line",
	        contracts: "Contratos",
	        updated: "actualizado",
	        created: "creado",
	        forms: "Forms",
	        file: 'Anexar',
	        filters: "Filtros",
	        sgsHome: "SGS Home",
	        sgsAroundTheWorld: "SGS en todo el mundo",
	        latitude: "Latitud",
	        longitude: "Longitud",
	        charges: "Billete de conbranza",
	        dealership: "Billete de la concessionaria",
	        yourPasswordIsExpired: 'Su contraseña ha caducado. ¡Cambie su contraseña para acceder al sistema!',
	        newPasswordCanNotBeEqualToACurrentPassword: '¡Nueva contraseña no puede ser igual a contraseña actual!',
	        newPasswordAndRepeatPasswordAreDifferentValues: '¡Nueva contraseña y contraseña de repetición son valores diferentes!',
	        savedPasswordWithSuccess: "Contraseña guardada con éxito",
	        passwordUpdatedWithSuccess: "Contraseña alterada con éxito",
	        cancel: "Cancelar",
	        continue: "Continuar",
	        back: "Volar"
	
	    }, _i18nUser2.default.es, _i18nModule2.default.es, _i18nLogin2.default.es)
	};
	
	exports.default = (0, _extends3.default)({}, app);

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(412);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  build: function build(field) {
	
	    var type = field.type;
	
	    if (type == 'header') {
	      return this.header(field);
	    } else if (type == 'text') {
	      return this.text(field);
	    } else if (type == 'numeric') {
	      return this.numeric(field);
	    } else if (type == 'date') {
	      return this.date(field);
	    } else if (type == 'dateTime') {
	      return this.dateTime(field);
	    } else if (type == 'time') {
	      return this.time(field);
	    } else if (type == 'textArea') {
	      return this.textArea(field);
	    } else if (type == 'cnpj') {
	      return this.cnpj(field);
	    } else if (type == 'cpf') {
	      return this.cpf(field);
	    } else if (type == 'currency') {
	      return this.currency(field);
	    } else if (type == 'email') {
	      return this.email(field);
	    }
	
	    return {};
	  },
	
	  commons: function commons(field) {
	    return {
	      id: field.id,
	      type: field.type,
	      name: '',
	      columnName: '',
	      persistent: true
	    };
	  },
	
	  commonsLabel: function commonsLabel() {
	    return {
	      labelPt: '',
	      labelEs: '',
	      labelEn: ''
	    };
	  },
	
	  commonsPlaceholder: function commonsPlaceholder() {
	    return {
	      placeholderPt: '',
	      placeholderEs: '',
	      placeholderEn: ''
	    };
	  },
	
	  buildPrefix: function buildPrefix() {
	    return {
	      prefix: ''
	    };
	  },
	
	  buildSufix: function buildSufix() {
	    return {
	      sufix: ''
	    };
	  },
	
	  buildMask: function buildMask() {
	    return {
	      mask: ''
	    };
	  },
	
	  buildRequired: function buildRequired() {
	    return {
	      required: true
	    };
	  },
	
	  buildMinSize: function buildMinSize() {
	    return {
	      minSize: 0
	    };
	  },
	
	  buildMaxSize: function buildMaxSize() {
	    return {
	      maxSize: 0
	    };
	  },
	
	  buildRegex: function buildRegex() {
	    return {
	      regex: ''
	    };
	  },
	
	  buildMinValue: function buildMinValue() {
	    return {
	      minValue: 0
	    };
	  },
	
	  buildMaxValue: function buildMaxValue() {
	    return {
	      maxValue: 0
	    };
	  },
	
	  header: function header(field) {
	    var obj = (0, _assign2.default)({}, this.commons(field));
	    obj = (0, _assign2.default)(obj, this.commonsLabel());
	    return obj;
	  },
	
	  text: function text(field) {
	    var obj = (0, _assign2.default)({}, this.commons(field));
	    obj = (0, _assign2.default)(obj, this.commonsLabel());
	    obj = (0, _assign2.default)(obj, this.commonsPlaceholder());
	    obj = (0, _assign2.default)(obj, this.buildPrefix());
	    obj = (0, _assign2.default)(obj, this.buildSufix());
	    obj = (0, _assign2.default)(obj, this.buildMask());
	    obj = (0, _assign2.default)(obj, this.buildRequired());
	    obj = (0, _assign2.default)(obj, this.buildMinSize());
	    obj = (0, _assign2.default)(obj, this.buildMaxSize());
	    obj = (0, _assign2.default)(obj, this.buildRegex());
	    return obj;
	  },
	
	  numeric: function numeric(field) {
	    var obj = (0, _assign2.default)({}, this.commons(field));
	    obj = (0, _assign2.default)(obj, this.commonsLabel());
	    obj = (0, _assign2.default)(obj, this.buildPrefix());
	    obj = (0, _assign2.default)(obj, this.buildSufix());
	    obj = (0, _assign2.default)(obj, this.buildRequired());
	    obj = (0, _assign2.default)(obj, this.buildMinValue());
	    obj = (0, _assign2.default)(obj, this.buildMaxValue());
	    return obj;
	  },
	
	  date: function date(field) {
	    var obj = (0, _assign2.default)({}, this.commons(field));
	    obj = (0, _assign2.default)(obj, this.commonsLabel());
	    obj = (0, _assign2.default)(obj, this.commonsPlaceholder());
	    obj = (0, _assign2.default)(obj, this.buildRequired());
	    obj = (0, _assign2.default)(obj, this.buildRegex());
	    return obj;
	  },
	
	  dateTime: function dateTime(field) {
	    var obj = (0, _assign2.default)({}, this.commons(field));
	    obj = (0, _assign2.default)(obj, this.commonsLabel());
	    obj = (0, _assign2.default)(obj, this.commonsPlaceholder());
	    obj = (0, _assign2.default)(obj, this.buildRequired());
	    return obj;
	  },
	
	  time: function time(field) {
	    var obj = (0, _assign2.default)({}, this.commons(field));
	    obj = (0, _assign2.default)(obj, this.commonsLabel());
	    obj = (0, _assign2.default)(obj, this.commonsPlaceholder());
	    obj = (0, _assign2.default)(obj, this.buildRequired());
	    return obj;
	  },
	
	  textArea: function textArea(field) {
	    var obj = (0, _assign2.default)({}, this.commons(field));
	    obj = (0, _assign2.default)(obj, this.commonsLabel());
	    obj = (0, _assign2.default)(obj, this.commonsPlaceholder());
	    obj = (0, _assign2.default)(obj, this.buildRequired());
	    obj = (0, _assign2.default)(obj, this.buildMinSize());
	    obj = (0, _assign2.default)(obj, this.buildMaxSize());
	    return obj;
	  },
	
	  cnpj: function cnpj(field) {
	    var obj = (0, _assign2.default)({}, this.commons(field));
	    obj = (0, _assign2.default)(obj, this.commonsLabel());
	    obj = (0, _assign2.default)(obj, this.commonsPlaceholder());
	    obj = (0, _assign2.default)(obj, this.buildMask());
	    obj = (0, _assign2.default)(obj, this.buildRequired());
	    return obj;
	  },
	
	  cpf: function cpf(field) {
	    var obj = (0, _assign2.default)({}, this.commons(field));
	    obj = (0, _assign2.default)(obj, this.commonsLabel());
	    obj = (0, _assign2.default)(obj, this.commonsPlaceholder());
	    obj = (0, _assign2.default)(obj, this.buildMask());
	    obj = (0, _assign2.default)(obj, this.buildRequired());
	    return obj;
	  },
	
	  currency: function currency(field) {
	    var obj = (0, _assign2.default)({}, this.commons(field));
	    obj = (0, _assign2.default)(obj, this.commonsLabel());
	    obj = (0, _assign2.default)(obj, this.commonsPlaceholder());
	    obj = (0, _assign2.default)(obj, this.buildPrefix());
	    obj = (0, _assign2.default)(obj, this.buildMask());
	    obj = (0, _assign2.default)(obj, this.buildRequired());
	    obj = (0, _assign2.default)(obj, this.buildMinValue());
	    obj = (0, _assign2.default)(obj, this.buildMaxValue());
	    return obj;
	  },
	
	  email: function email(field) {
	    var obj = (0, _assign2.default)({}, this.commons(field));
	    obj = (0, _assign2.default)(obj, this.commonsLabel());
	    obj = (0, _assign2.default)(obj, this.commonsPlaceholder());
	    obj = (0, _assign2.default)(obj, this.buildPrefix());
	    obj = (0, _assign2.default)(obj, this.buildRequired());
	    obj = (0, _assign2.default)(obj, this.buildRegex());
	    return obj;
	  }
	};

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mutationsTypes = undefined;
	
	var _objectDestructuringEmpty2 = __webpack_require__(45);
	
	var _objectDestructuringEmpty3 = _interopRequireDefault(_objectDestructuringEmpty2);
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _mutations;
	
	var _RepositoryService = __webpack_require__(24);
	
	var _RepositoryService2 = _interopRequireDefault(_RepositoryService);
	
	var _AppConfigService = __webpack_require__(11);
	
	var _AppConfigService2 = _interopRequireDefault(_AppConfigService);
	
	var _LocalDatabaseService = __webpack_require__(44);
	
	var _LocalDatabaseService2 = _interopRequireDefault(_LocalDatabaseService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PATH = _AppConfigService2.default.apiUrl() + '/f/ba/402882745af64dab015af64e419b0000/c/402882745af64dab015af64f87ed0002/14/ms/402882745af64dab015af64fcfa60003';
	
	var state = {
	  list: []
	};
	
	var mutationsTypes = exports.mutationsTypes = {
	  LIST: 'module/LIST',
	  PAGINATION: 'module/PAGINATION',
	  UPDATE_FILTER: 'module/UPDATE_FILTER',
	  UPDATE_FILTER_CURRENT_PAGE: 'module/UPDATE_FILTER_CURRENT_PAGE',
	  UPDATE_FILTER_ITEMS_PER_PAGE: 'module/UPDATE_FILTER_ITEMS_PER_PAGE'
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, mutationsTypes.LIST, function (state, payload) {
	  state.list = payload;
	}), (0, _defineProperty3.default)(_mutations, mutationsTypes.PAGINATION, function (state, payload) {
	  state.pagination = payload;
	}), (0, _defineProperty3.default)(_mutations, mutationsTypes.UPDATE_FILTER, function (state, payload) {
	  state.filter = (0, _assign2.default)({}, state.filter, payload);
	}), (0, _defineProperty3.default)(_mutations, mutationsTypes.UPDATE_FILTER_CURRENT_PAGE, function (state, payload) {
	  state.filter.currentPage = payload;
	}), (0, _defineProperty3.default)(_mutations, mutationsTypes.UPDATE_FILTER_ITEMS_PER_PAGE, function (state, payload) {
	  state.filter.itemsPerPage = payload;
	}), _mutations);
	
	var actions = {
	
	  moduleSetList: function moduleSetList(_ref, payload) {
	    var commit = _ref.commit;
	
	    commit(mutationsTypes.LIST, payload);
	  },
	
	  moduleSetPagination: function moduleSetPagination(_ref2, payload) {
	    var commit = _ref2.commit;
	
	    commit(mutationsTypes.PAGINATION, payload);
	  },
	
	  moduleSetItemsPerPage: function moduleSetItemsPerPage(_ref3, payload) {
	    var dispatch = _ref3.dispatch,
	        commit = _ref3.commit;
	
	    commit(mutationsTypes.UPDATE_FILTER_CURRENT_PAGE, 1);
	    commit(mutationsTypes.UPDATE_FILTER_ITEMS_PER_PAGE, payload);
	    dispatch("moduleSearch");
	  },
	  moduleSetPage: function moduleSetPage(_ref4, payload) {
	    var dispatch = _ref4.dispatch,
	        commit = _ref4.commit;
	
	    commit(mutationsTypes.UPDATE_FILTER_CURRENT_PAGE, payload);
	    dispatch('moduleSearch');
	  },
	  moduleDoSearch: function moduleDoSearch(_ref5, payload) {
	    var dispatch = _ref5.dispatch;
	
	    dispatch("moduleSearch", payload);
	  },
	  moduleSearch: function moduleSearch(_ref6, id) {
	    var dispatch = _ref6.dispatch;
	
	    dispatch("showLoader");
	
	    var url = PATH;
	
	    _RepositoryService2.default.search(url).then(function (response) {
	      dispatch('moduleSetList', response.fields);
	      dispatch('hideLoader');
	    });
	  },
	  moduleSave: function moduleSave(_ref7, payload) {
	    (0, _objectDestructuringEmpty3.default)(_ref7);
	
	    return _RepositoryService2.default.save(PATH, payload, true);
	  },
	  moduleGetInstance: function moduleGetInstance(_ref8, payload) {
	    (0, _objectDestructuringEmpty3.default)(_ref8);
	
	    return _LocalDatabaseService2.default.findById('Module_' + payload);
	  }
	};
	
	var getters = {
	  moduleFilter: function moduleFilter(state) {
	    return (0, _assign2.default)({}, state.filter);
	  },
	  moduleList: function moduleList() {
	    return state.list;
	  },
	  modulePagination: function modulePagination() {
	    return state.pagination;
	  }
	};
	
	exports.default = {
	  state: state,
	  mutations: mutations,
	  actions: actions,
	  getters: getters
	};

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = {
	  en: {
	    generateReport: "Generate report"
	  },
	  pt: {
	    generateReport: "Gerar relatório "
	
	  },
	  es: {
	    generateReport: " Generar el informe"
	
	  }
	};
	
	exports.default = (0, _extends3.default)({}, _module);

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(407);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Module = __webpack_require__(799);
	
	var _Module2 = _interopRequireDefault(_Module);
	
	var _ModuleList = __webpack_require__(343);
	
	var _ModuleList2 = _interopRequireDefault(_ModuleList);
	
	var _ModuleForm = __webpack_require__(342);
	
	var _ModuleForm2 = _interopRequireDefault(_ModuleForm);
	
	var _ModuleShow = __webpack_require__(344);
	
	var _ModuleShow2 = _interopRequireDefault(_ModuleShow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	    path: '/businessArea/:businessAreaId/:systemId/:systemVersion/:formId', component: _Module2.default,
	    children: [{ path: '', component: _ModuleList2.default, name: 'ModuleList' }, { path: 'create', component: _ModuleForm2.default, name: 'ModuleCreate' }, { path: 'edit/:id', component: _ModuleForm2.default, name: 'ModuleEdit' }, { path: 'show/:id', component: _ModuleShow2.default, name: 'ModuleShow' }]
	}];

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RepositoryService = __webpack_require__(24);
	
	var _RepositoryService2 = _interopRequireDefault(_RepositoryService);
	
	var _AppConfigService = __webpack_require__(11);
	
	var _AppConfigService2 = _interopRequireDefault(_AppConfigService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  apiUrl: function apiUrl() {
	    return _AppConfigService2.default.apiUrl();
	  },
	
	  buildQuery: function buildQuery(url, filter) {
	
	    var query = [];
	
	    if (filter.code) {
	      query.push("code=" + filter.code);
	    }
	    if (filter.status) {
	      query.push("status=" + filter.status);
	    }
	
	    if (filter.openingDate) {
	      var openingDateStart = filter.openingDate[0];
	      if (openingDateStart) {
	        query.push("openingDateStart=" + openingDateStart.toISOString().slice(0, 10) + 'T00:00:00Z');
	      }
	      var openingDateEnd = filter.openingDate[1];
	      if (openingDateEnd) {
	        query.push("openingDateEnd=" + openingDateEnd.toISOString().slice(0, 10) + 'T23:59:59Z');
	      }
	    }
	
	    if (filter.closingDate) {
	      var closingDateStart = filter.closingDate[0];
	      if (closingDateStart) {
	        query.push("closingDateStart=" + closingDateStart.toISOString().slice(0, 10) + 'T00:00:00Z');
	      }
	      var closingDateEnd = filter.closingDate[1];
	      if (closingDateEnd) {
	        query.push("closingDateEnd=" + closingDateEnd.toISOString().slice(0, 10) + 'T23:59:59Z');
	      }
	    }
	
	    if (filter.currentPage) {
	      query.push("currentPage=" + filter.currentPage);
	    }
	    if (filter.itemsPerPage) {
	      query.push("itemsPerPage=" + filter.itemsPerPage);
	    }
	    if (query.length) {
	      url = url + "?" + query.join("&");
	    }
	
	    return url;
	  }
	};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mutationsTypes = undefined;
	
	var _objectDestructuringEmpty2 = __webpack_require__(45);
	
	var _objectDestructuringEmpty3 = _interopRequireDefault(_objectDestructuringEmpty2);
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _mutations;
	
	var _RepositoryService = __webpack_require__(24);
	
	var _RepositoryService2 = _interopRequireDefault(_RepositoryService);
	
	var _AppConfigService = __webpack_require__(11);
	
	var _AppConfigService2 = _interopRequireDefault(_AppConfigService);
	
	var _LocalDatabaseService = __webpack_require__(44);
	
	var _LocalDatabaseService2 = _interopRequireDefault(_LocalDatabaseService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PATH = _AppConfigService2.default.apiUrl() + '/f/ba';
	
	var state = {
	  list: []
	};
	
	var mutationsTypes = exports.mutationsTypes = {
	  LIST: 'modules/LIST',
	  PAGINATION: 'modules/PAGINATION',
	  UPDATE_FILTER: 'modules/UPDATE_FILTER',
	  UPDATE_FILTER_CURRENT_PAGE: 'modules/UPDATE_FILTER_CURRENT_PAGE',
	  UPDATE_FILTER_ITEMS_PER_PAGE: 'modules/UPDATE_FILTER_ITEMS_PER_PAGE'
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, mutationsTypes.LIST, function (state, payload) {
	  state.list = payload;
	}), (0, _defineProperty3.default)(_mutations, mutationsTypes.PAGINATION, function (state, payload) {
	  state.pagination = payload;
	}), (0, _defineProperty3.default)(_mutations, mutationsTypes.UPDATE_FILTER, function (state, payload) {
	  state.filter = (0, _assign2.default)({}, state.filter, payload);
	}), (0, _defineProperty3.default)(_mutations, mutationsTypes.UPDATE_FILTER_CURRENT_PAGE, function (state, payload) {
	  state.filter.currentPage = payload;
	}), (0, _defineProperty3.default)(_mutations, mutationsTypes.UPDATE_FILTER_ITEMS_PER_PAGE, function (state, payload) {
	  state.filter.itemsPerPage = payload;
	}), _mutations);
	
	var actions = {
	
	  modulesSetList: function modulesSetList(_ref, payload) {
	    var commit = _ref.commit;
	
	    commit(mutationsTypes.LIST, payload);
	  },
	
	  modulesSetPagination: function modulesSetPagination(_ref2, payload) {
	    var commit = _ref2.commit;
	
	    commit(mutationsTypes.PAGINATION, payload);
	  },
	
	  modulesSetItemsPerPage: function modulesSetItemsPerPage(_ref3, payload) {
	    var dispatch = _ref3.dispatch,
	        commit = _ref3.commit;
	
	    commit(mutationsTypes.UPDATE_FILTER_CURRENT_PAGE, 1);
	    commit(mutationsTypes.UPDATE_FILTER_ITEMS_PER_PAGE, payload);
	    dispatch("modulesSearch");
	  },
	  modulesSetPage: function modulesSetPage(_ref4, payload) {
	    var dispatch = _ref4.dispatch,
	        commit = _ref4.commit;
	
	    commit(mutationsTypes.UPDATE_FILTER_CURRENT_PAGE, payload);
	    dispatch('modulesSearch');
	  },
	  modulesDoSearch: function modulesDoSearch(_ref5, payload) {
	    var dispatch = _ref5.dispatch;
	
	    dispatch("modulesSearch", payload);
	  },
	  modulesSearch: function modulesSearch(_ref6, payload) {
	    var dispatch = _ref6.dispatch;
	
	    dispatch("showLoader");
	
	    var url = PATH;
	
	    var businessAreaId = payload.businessAreaId;
	    var systemId = payload.systemId;
	    var systemVersion = payload.systemVersion;
	
	    url = url + "/" + businessAreaId + "/c/" + systemId + "/" + systemVersion + "/ms";
	
	    _RepositoryService2.default.search(url).then(function (response) {
	      dispatch('modulesSetList', response);
	      dispatch('hideLoader');
	    });
	  },
	  modulesSave: function modulesSave(_ref7, payload) {
	    (0, _objectDestructuringEmpty3.default)(_ref7);
	
	    return _RepositoryService2.default.save(PATH, payload, true);
	  },
	  modulesGetInstance: function modulesGetInstance(_ref8, payload) {
	    (0, _objectDestructuringEmpty3.default)(_ref8);
	
	    return _LocalDatabaseService2.default.findById('Modules_' + payload);
	  }
	};
	
	var getters = {
	  modulesFilter: function modulesFilter(state) {
	    return (0, _assign2.default)({}, state.filter);
	  },
	  modulesList: function modulesList() {
	    return state.list;
	  },
	  modulesPagination: function modulesPagination() {
	    return state.pagination;
	  }
	};
	
	exports.default = {
	  state: state,
	  mutations: mutations,
	  actions: actions,
	  getters: getters
	};

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(411);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Modules = __webpack_require__(805);
	
	var _Modules2 = _interopRequireDefault(_Modules);
	
	var _ModulesList = __webpack_require__(806);
	
	var _ModulesList2 = _interopRequireDefault(_ModulesList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	    path: '/businessArea/:businessAreaId/:systemId/:systemVersion', component: _Modules2.default,
	    children: [{ path: '', component: _ModulesList2.default, name: 'ModulesList' }]
	}];

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(149);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _auth = __webpack_require__(396);
	
	var _businessArea = __webpack_require__(399);
	
	var _systems = __webpack_require__(415);
	
	var _modules = __webpack_require__(410);
	
	var _module2 = __webpack_require__(406);
	
	var _user = __webpack_require__(418);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [].concat((0, _toConsumableArray3.default)(_auth.routes), (0, _toConsumableArray3.default)(_businessArea.routes), (0, _toConsumableArray3.default)(_systems.routes), (0, _toConsumableArray3.default)(_modules.routes), (0, _toConsumableArray3.default)(_module2.routes), (0, _toConsumableArray3.default)(_user.routes));

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AppConfigService = __webpack_require__(11);
	
	var _AppConfigService2 = _interopRequireDefault(_AppConfigService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  apiUrl: function apiUrl() {
	    return _AppConfigService2.default.apiUrl();
	  },
	
	  buildQuery: function buildQuery(url, filter) {
	
	    var query = [];
	
	    if (filter.code) {
	      query.push("code=" + filter.code);
	    }
	    if (filter.status) {
	      query.push("status=" + filter.status);
	    }
	
	    if (filter.openingDate) {
	      var openingDateStart = filter.openingDate[0];
	      if (openingDateStart) {
	        query.push("openingDateStart=" + openingDateStart.toISOString().slice(0, 10) + 'T00:00:00Z');
	      }
	      var openingDateEnd = filter.openingDate[1];
	      if (openingDateEnd) {
	        query.push("openingDateEnd=" + openingDateEnd.toISOString().slice(0, 10) + 'T23:59:59Z');
	      }
	    }
	
	    if (filter.closingDate) {
	      var closingDateStart = filter.closingDate[0];
	      if (closingDateStart) {
	        query.push("closingDateStart=" + closingDateStart.toISOString().slice(0, 10) + 'T00:00:00Z');
	      }
	      var closingDateEnd = filter.closingDate[1];
	      if (closingDateEnd) {
	        query.push("closingDateEnd=" + closingDateEnd.toISOString().slice(0, 10) + 'T23:59:59Z');
	      }
	    }
	
	    if (filter.currentPage) {
	      query.push("currentPage=" + filter.currentPage);
	    }
	    if (filter.itemsPerPage) {
	      query.push("itemsPerPage=" + filter.itemsPerPage);
	    }
	    if (query.length) {
	      url = url + "?" + query.join("&");
	    }
	
	    return url;
	  }
	};

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mutationsTypes = undefined;
	
	var _objectDestructuringEmpty2 = __webpack_require__(45);
	
	var _objectDestructuringEmpty3 = _interopRequireDefault(_objectDestructuringEmpty2);
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _mutations;
	
	var _RepositoryService = __webpack_require__(24);
	
	var _RepositoryService2 = _interopRequireDefault(_RepositoryService);
	
	var _AppConfigService = __webpack_require__(11);
	
	var _AppConfigService2 = _interopRequireDefault(_AppConfigService);
	
	var _LocalDatabaseService = __webpack_require__(44);
	
	var _LocalDatabaseService2 = _interopRequireDefault(_LocalDatabaseService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PATH = _AppConfigService2.default.apiUrl() + '/f/ba';
	
	var state = {
	  list: []
	};
	
	var mutationsTypes = exports.mutationsTypes = {
	  LIST: 'systems/LIST',
	  PAGINATION: 'systems/PAGINATION',
	  UPDATE_FILTER: 'systems/UPDATE_FILTER',
	  UPDATE_FILTER_CURRENT_PAGE: 'systems/UPDATE_FILTER_CURRENT_PAGE',
	  UPDATE_FILTER_ITEMS_PER_PAGE: 'systems/UPDATE_FILTER_ITEMS_PER_PAGE'
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, mutationsTypes.LIST, function (state, payload) {
	  state.list = payload;
	}), (0, _defineProperty3.default)(_mutations, mutationsTypes.PAGINATION, function (state, payload) {
	  state.pagination = payload;
	}), (0, _defineProperty3.default)(_mutations, mutationsTypes.UPDATE_FILTER, function (state, payload) {
	  state.filter = (0, _assign2.default)({}, state.filter, payload);
	}), (0, _defineProperty3.default)(_mutations, mutationsTypes.UPDATE_FILTER_CURRENT_PAGE, function (state, payload) {
	  state.filter.currentPage = payload;
	}), (0, _defineProperty3.default)(_mutations, mutationsTypes.UPDATE_FILTER_ITEMS_PER_PAGE, function (state, payload) {
	  state.filter.itemsPerPage = payload;
	}), _mutations);
	
	var actions = {
	
	  systemsSetList: function systemsSetList(_ref, payload) {
	    var commit = _ref.commit;
	
	    commit(mutationsTypes.LIST, payload);
	  },
	
	  systemsSetPagination: function systemsSetPagination(_ref2, payload) {
	    var commit = _ref2.commit;
	
	    commit(mutationsTypes.PAGINATION, payload);
	  },
	
	  systemsSetItemsPerPage: function systemsSetItemsPerPage(_ref3, payload) {
	    var dispatch = _ref3.dispatch,
	        commit = _ref3.commit;
	
	    commit(mutationsTypes.UPDATE_FILTER_CURRENT_PAGE, 1);
	    commit(mutationsTypes.UPDATE_FILTER_ITEMS_PER_PAGE, payload);
	    dispatch("systemsSearch");
	  },
	  systemsSetPage: function systemsSetPage(_ref4, payload) {
	    var dispatch = _ref4.dispatch,
	        commit = _ref4.commit;
	
	    commit(mutationsTypes.UPDATE_FILTER_CURRENT_PAGE, payload);
	    dispatch('systemsSearch');
	  },
	  systemsDoSearch: function systemsDoSearch(_ref5, payload) {
	    var dispatch = _ref5.dispatch;
	
	    dispatch("systemsSearch", payload);
	  },
	  systemsSearch: function systemsSearch(_ref6, id) {
	    var dispatch = _ref6.dispatch;
	
	    dispatch("showLoader");
	
	    var url = PATH + '/' + id + '/c';
	
	    _RepositoryService2.default.search(url).then(function (response) {
	      dispatch('systemsSetList', response);
	      dispatch('hideLoader');
	    });
	  },
	  systemsSave: function systemsSave(_ref7, payload) {
	    (0, _objectDestructuringEmpty3.default)(_ref7);
	
	    return _RepositoryService2.default.save(PATH, payload, true);
	  },
	  systemsGetInstance: function systemsGetInstance(_ref8, payload) {
	    (0, _objectDestructuringEmpty3.default)(_ref8);
	
	    return _LocalDatabaseService2.default.findById('Systems_' + payload);
	  }
	};
	
	var getters = {
	  systemsFilter: function systemsFilter(state) {
	    return (0, _assign2.default)({}, state.filter);
	  },
	  systemsList: function systemsList() {
	    return state.list;
	  },
	  systemsPagination: function systemsPagination() {
	    return state.pagination;
	  }
	};
	
	exports.default = {
	  state: state,
	  mutations: mutations,
	  actions: actions,
	  getters: getters
	};

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(416);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Systems = __webpack_require__(807);
	
	var _Systems2 = _interopRequireDefault(_Systems);
	
	var _SystemsList = __webpack_require__(808);
	
	var _SystemsList2 = _interopRequireDefault(_SystemsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	    path: '/businessArea/:businessAreaId', component: _Systems2.default,
	    children: [{ path: '', component: _SystemsList2.default, name: 'SystemsList' }]
	}];

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var user = {
	  en: {
	    updatePermission: "Update permission."
	  },
	  pt: {
	    updatePermission: "Permissão atualizada."
	
	  },
	  es: {
	    updatePermission: "Permiso de actualización."
	
	  }
	};
	
	exports.default = (0, _extends3.default)({}, user);

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(419);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Profile = __webpack_require__(810);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _UserProfile = __webpack_require__(811);
	
	var _UserProfile2 = _interopRequireDefault(_UserProfile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	  path: '/user', component: _Profile2.default,
	  children: [{ path: 'profile', component: _UserProfile2.default, name: 'UserProfile' }]
	}];

/***/ }),
/* 420 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var users = {
	  stateName: "users",
	  uri: '/users',
	  filter: {
	    itemsPerPage: 25,
	    currentPage: 1,
	    username: '',
	    name: ''
	  },
	  list: [],
	  pagination: {},
	  submitted: false,
	  clickFromButton: false
	};
	
	exports.default = {
	  users: users
	};

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _authVuex = __webpack_require__(394);
	
	var _authVuex2 = _interopRequireDefault(_authVuex);
	
	var _AppVuex = __webpack_require__(393);
	
	var _AppVuex2 = _interopRequireDefault(_AppVuex);
	
	var _BusinessAreaVuex = __webpack_require__(398);
	
	var _BusinessAreaVuex2 = _interopRequireDefault(_BusinessAreaVuex);
	
	var _SystemsVuex = __webpack_require__(414);
	
	var _SystemsVuex2 = _interopRequireDefault(_SystemsVuex);
	
	var _ModulesVuex = __webpack_require__(409);
	
	var _ModulesVuex2 = _interopRequireDefault(_ModulesVuex);
	
	var _ModuleVuex = __webpack_require__(404);
	
	var _ModuleVuex2 = _interopRequireDefault(_ModuleVuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  Auth: _authVuex2.default,
	  App: _AppVuex2.default,
	
	  BusinessArea: _BusinessAreaVuex2.default,
	  Systems: _SystemsVuex2.default,
	  Modules: _ModulesVuex2.default,
	  Module: _ModuleVuex2.default
	};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(90);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = function (defaults, extras) {
	  defaults = defaults || {};
	  extras = extras || {};
	  return (0, _keys2.default)(defaults).concat((0, _keys2.default)(extras)).reduce(function (acc, val) {
	    acc[val] = extras[val] === undefined ? defaults[val] : extras[val];
	    return acc;
	  }, {});
	};
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.options = exports.VMoney = exports.Money = undefined;
	
	var _keys = __webpack_require__(90);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _component = __webpack_require__(822);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _directive = __webpack_require__(146);
	
	var _directive2 = _interopRequireDefault(_directive);
	
	var _options = __webpack_require__(70);
	
	var _options2 = _interopRequireDefault(_options);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Money = _component2.default;
	exports.VMoney = _directive2.default;
	exports.options = _options2.default;
	
	
	function install(Vue, globalOptions) {
	  if (globalOptions) {
	    (0, _keys2.default)(globalOptions).map(function (key) {
	      _options2.default[key] = globalOptions[key];
	    });
	  }
	  Vue.directive('money', _directive2.default);
	  Vue.component('money', _component2.default);
	}
	
	exports.default = install;
	
	if (typeof window !== 'undefined' && window.Vue) {
	  window.Vue.use(install);
	}

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var en = {
	  language: "Language",
	  english: "English",
	  portuguese: "Portuguese",
	  spanish: "Spanish",
	  logout: "Logout",
	  loginPage: "Login",
	  login: "Login",
	  welcome: "Welcome",
	  save: "Save",
	  backToSearch: "Back to search",
	  backToDetails: "Back to details",
	  delete: "Delete",
	  update: "Update",
	  edit: "Edit",
	  new: "New",
	  newA: "New",
	  search: "Search",
	  total: "Total",
	  itensFound: "items found",
	  registersPerPage: "registers per page",
	  ofPages: "of {0} pages",
	  yes: "Yes",
	  no: "No",
	  select: "Select",
	  name: "Name",
	  code: "Code",
	  close: "Close",
	  date: "Date",
	  user: "User",
	  details: "Details",
	  email: "E-mail",
	  column: "Column",
	  warning: "Warning",
	  menu: "Menu",
	  form: "Form",
	  itemSuccessfullyCreated: "Item successfully created",
	  itemSuccessfullyUpdated: "Item successfully updated",
	  confirmTheDeletion: "Do you confirm the deletion?",
	  itemDeleted: "Item deleted.",
	  error: "Error",
	  unexpectedError: "Unexpected error!",
	  anUnexpectedErrorOccurred: "An unexpected error occurred:",
	  theUrlAccessedDoesNotBelongToAnyTenant: "The url accessed does not belong to any Tenant",
	  success: "Success",
	  value: "Value",
	  label: "Label",
	  maximumSize: "Maximum size",
	  maximumValue: "Maximum value",
	  minimumSize: "Minimum size",
	  minimumValue: "Minimum value",
	  required: "Required",
	  suffix: "Suffix",
	  users: "Users",
	  backToList: "Back to list",
	  phone: "Phone",
	  enabled: "Enabled?",
	  noItemsFound: "No items found",
	  item: "Item",
	  contactUs: "Contact us",
	  cpf: "CPF",
	  cnpj: "CNPJ",
	  invalid: "invalid",
	  pleaseFillInTheField: "Please, fill in the field",
	  bothFieldsAreRequired: "Both fields are required!",
	  profile: "Profile",
	  changePassword: "Change password",
	  currentPassword: "Current password",
	  newPassword: "New password",
	  repeatNewPassword: "Repeat new password",
	  passwordExpired: 'Password expired',
	
	  username: "Username",
	  password: "Password",
	  documentNumber: "Document number",
	  actions: 'Actions',
	  chooseAFile: 'Choose a file.',
	  version: 'Version',
	  sgs_render_file_error_upload: "An error occurred, the file was not uploaded"
	};
	
	exports.default = (0, _extends3.default)({}, en);

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var es = {
	  language: "Idioma",
	  english: "Inglés",
	  portuguese: "Portugués",
	  spanish: "Español",
	  logout: "Salir",
	  login: "Login",
	  loginPage: "Accesso",
	  welcome: "Bienvenido",
	  save: "Salvar",
	  backToSearch: "Volver a la búsqueda",
	  backToDetails: "Volver a los detalles",
	  delete: "Borrar",
	  update: "Actualizar",
	  edit: "Editar",
	  new: "Nuevo",
	  newA: "Nuevo (a)",
	  search: "Buscar",
	  total: "Total",
	  itensFound: "artículos encontrados",
	  registersPerPage: "registros por página",
	  ofPages: "de {0} páginas",
	  yes: "Sí",
	  no: "No",
	  select: "Seleccionar",
	  name: "Nombre",
	  code: "Código",
	  close: "Cerrar",
	  date: "Fecha",
	  user: "Usuario",
	  details: "Detalles",
	  email: "Email",
	  column: "Columna",
	  warning: "Aviso",
	  menu: "Menú",
	  form: "Form",
	  itemSuccessfullyCreated: "Elemento creado correctamente",
	  itemSuccessfullyUpdated: "Elemento actualizado correctamente",
	  confirmTheDeletion: "¿Confirma la eliminación?",
	  itemDeleted: "Elemento eliminado.",
	  error: "Error",
	  unexpectedError: "¡Error inesperado!",
	  anUnexpectedErrorOccurred: "Ocurrió un error inesperado:",
	  theUrlAccessedDoesNotBelongToAnyTenant: "The URL accessed does not belong to any Tenant",
	  success: "Éxito",
	  value: "Value",
	  label: "Label",
	  maximumSize: "Tamaño máximo",
	  maximumValue: "Valor máximo",
	  minimumSize: "Tamaño mínimo",
	  minimumValue: "Valor mínimo",
	  required: "Necesario",
	  suffix: "Sufijo",
	  users: "Usuarios",
	  backToList: "Volver a la lista",
	  phone: "Teléfono",
	  enabled: "¿Autorizado?",
	  noItemsFound: "No se encontraron artículos",
	  item: "Item",
	  contactUs: "Contacto",
	  cpf: "CPF",
	  cnpj: "CNPJ",
	  invalid: "inválido",
	  pleaseFillInTheField: "Por favor, rellene el campo",
	  bothFieldsAreRequired: "¡Ambos los campos son obligatorio!",
	  profile: "Perfil",
	  changePassword: "Cambiar la contraseña",
	  currentPassword: "Contraseña actual",
	  newPassword: "Nueva contraseña",
	  repeatNewPassword: "Repita la nueva contraseña",
	  passwordExpired: 'Contraseña expirada',
	
	  username: "Nombre de usuario",
	  password: "Contraseña",
	  documentNumber: "Número de documento",
	  actions: 'Acciones',
	  chooseAFile: 'Elige un archivo.',
	  version: 'Versión',
	  sgs_render_file_error_upload: "Ocurrió un error, el archivo no fue subido"
	};
	
	exports.default = (0, _extends3.default)({}, es);

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ptBR = {
	  language: "Idioma",
	  english: "Inglês",
	  portuguese: "Português",
	  spanish: "Espanhol",
	  logout: "Sair",
	  login: "Login",
	  loginPage: "Entrar",
	  welcome: "Bem vindo",
	  save: "Salvar",
	  backToSearch: "Voltar para pesquisa",
	  backToDetails: "Voltar para detalhes",
	  delete: "Excluir",
	  update: "Atualizar",
	  edit: "Editar",
	  new: "Novo",
	  newA: "Novo (a)",
	  search: "Pesquisar",
	  total: "Total",
	  itensFound: "itens encontrados",
	  registersPerPage: "registros por página",
	  ofPages: "de {0} páginas",
	  yes: "Sim",
	  no: "Não",
	  select: "Selecione",
	  name: "Nome",
	  code: "Código",
	  close: "Fechar",
	  date: "Data",
	  user: "Usuário",
	  details: "Detalhes",
	  email: "E-mail",
	  column: "Coluna",
	  warning: "Aviso",
	  menu: "Menu",
	  form: "Form",
	  itemSuccessfullyCreated: "Item criado com sucesso",
	  itemSuccessfullyUpdated: "Item atualizado com sucesso",
	  confirmTheDeletion: "Confirma a exclusão?",
	  itemDeleted: "Item removido.",
	  error: "Erro",
	  unexpectedError: "Erro inesperado!",
	  anUnexpectedErrorOccurred: "Ocorreu um erro inesperado:",
	  ServerNotAvailable: "Servidor não disponivel!",
	  theUrlAccessedDoesNotBelongToAnyTenant: "A url acessada não pertence a nenhum Tenant",
	  success: "Sucesso",
	  value: "Value",
	  label: "Label",
	  maximumSize: "Tamanho máximo",
	  maximumValue: "Valor máximo",
	  minimumSize: "Tamanho mínimo",
	  minimumValue: "Valor mínimo",
	  required: "Requerido",
	  suffix: "Sufixo",
	  users: "Usuários",
	  backToList: "Voltar para lista",
	  phone: "Telefone",
	  enabled: "Habilitado?",
	  noItemsFound: "Nenhum item encontrado",
	  item: "Item",
	  contactUs: "Fale conosco",
	  cpf: "CPF",
	  cnpj: "CNPJ",
	  invalid: "inválido",
	  pleaseFillInTheField: "Por favor, preencha o campo",
	  bothFieldsAreRequired: "Os dois campos são obrigatórios!",
	  profile: "Perfil",
	  changePassword: "Troca de senha",
	  currentPassword: "Senha atual",
	  newPassword: "Nova senha",
	  repeatNewPassword: "Repita a nova senha",
	  passwordExpired: 'Senha expirada',
	
	  username: "Nome de usuário",
	  password: "Senha",
	  documentNumber: "Número de documento",
	  actions: 'Ações',
	  chooseAFile: 'Escolha um arquivo.',
	  version: 'Versão',
	  sgs_render_file_error_upload: "Ocorreu um erro, o arquivo não foi enviado"
	};
	
	exports.default = (0, _extends3.default)({}, ptBR);

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loaderFactory = __webpack_require__(428);
	
	var _loaderFactory2 = _interopRequireDefault(_loaderFactory);
	
	var _registerStore = __webpack_require__(429);
	
	var _registerStore2 = _interopRequireDefault(_registerStore);
	
	var _pageLoader = __webpack_require__(868);
	
	var _pageLoader2 = _interopRequireDefault(_pageLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var install = function install(Vue, store) {
	  Vue.component('PageLoader', _pageLoader2.default);
	
	  (0, _registerStore2.default)(store);
	  Object.defineProperty(Vue.prototype, '$loader', {
	    get: function get() {
	      return (0, _loaderFactory2.default)(this);
	    }
	  });
	};
	
	exports.default = { install: install };

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var loaderFactory = function loaderFactory(context) {
	  return {
	    show: function show() {
	      context.$store.dispatch('showLoader');
	    },
	    hide: function hide() {
	      context.$store.dispatch('hideLoader');
	    }
	  };
	};
	
	exports.default = loaderFactory;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(431);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var registerStore = function registerStore(store) {
	  store.registerModule('CODECASTS_LOADER', (0, _extends3.default)({}, _vuex2.default));
	};
	exports.default = registerStore;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hideLoader = exports.showLoader = undefined;
	
	var _mutationsType = __webpack_require__(148);
	
	var types = _interopRequireWildcard(_mutationsType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var showLoader = exports.showLoader = function showLoader(context) {
	  context.commit(types.setShow, true);
	};
	
	var hideLoader = exports.hideLoader = function hideLoader(context) {
	  setTimeout(function () {
	    context.commit(types.setShow, false);
	  }, 500);
	};

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mutations = __webpack_require__(432);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _actions = __webpack_require__(430);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _state = __webpack_require__(433);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = { mutations: _mutations2.default, actions: actions, state: _state2.default };

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationsType = __webpack_require__(148);
	
	var types = _interopRequireWildcard(_mutationsType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _defineProperty3.default)({}, types.setShow, function (state, value) {
	  state.show = value;
	});

/***/ }),
/* 433 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  show: false
	
	};

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mainVuex = __webpack_require__(89);
	
	var _mainVuex2 = _interopRequireDefault(_mainVuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isOpenRoute = function isOpenRoute(route) {
	
	  var openRouteList = ["/auth", "/forgetPassword", "/changePassword"];
	
	  return openRouteList.indexOf(route.path) > -1;
	};
	
	var isLogged = function isLogged() {
	  if (!_mainVuex2.default.getters.isLogged) {
	    _mainVuex2.default.dispatch('refreshAuthUser');
	  }
	  return _mainVuex2.default.getters.isLogged;
	};
	
	var passwordExpired = function passwordExpired() {
	  return _mainVuex2.default.getters.passwordExpired;
	};
	
	exports.default = function (to, from, next) {
	  if (!isLogged() && !isOpenRoute(to)) {
	    next('/auth');
	  } else if (isLogged() && isOpenRoute(to)) {
	    next('/');
	  } else {
	
	    var role = to.meta.role;
	
	    if (passwordExpired() && to.path !== '/user/profile') {
	      next('/user/profile');
	    } else {
	
	      if (!role) {
	        if (to.name === null) {
	          next('/businessArea');
	        } else {
	          next();
	        }
	      } else {
	
	        _mainVuex2.default.dispatch('userHasRole', role).then(function (response) {
	          if (response) {
	            next();
	          } else {
	            next('/');
	          }
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(973);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routes = __webpack_require__(436);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _beforeEach = __webpack_require__(434);
	
	var _beforeEach2 = _interopRequireDefault(_beforeEach);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	  routes: _routes2.default, linkActiveClass: 'active'
	});
	
	router.beforeEach(_beforeEach2.default);
	
	exports.default = router;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(149);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _app = __webpack_require__(402);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [].concat((0, _toConsumableArray3.default)(_app.routes));

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(71);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _http = __webpack_require__(35);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _AppConfigService = __webpack_require__(11);
	
	var _AppConfigService2 = _interopRequireDefault(_AppConfigService);
	
	var _UtilsService = __webpack_require__(9);
	
	var _UtilsService2 = _interopRequireDefault(_UtilsService);
	
	var _ApiService = __webpack_require__(30);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    login: function login(username, password) {
	
	        var LOGIN_URL = _AppConfigService2.default.apiUrl() + '/api/login';
	
	        return _http2.default.post(LOGIN_URL, {
	            credentials: {
	                username: username
	            },
	            password: password
	        }).then(function (response) {
	            return response.data;
	        }).then(function (user) {
	
	            if (user.username !== "admin") {
	
	                _http2.default.defaults.headers.common['Authorization'] = 'Bearer ' + user.access_token;
	
	                return _http2.default.get(_AppConfigService2.default.apiUrl() + '/api/users/username/' + user.username).then(function (response) {
	
	                    var userReturned = response.data.data;
	
	                    user.name = userReturned.name;
	                    user.email = userReturned.email;
	                    user.phone = userReturned.phone;
	                    user.passwordExpired = userReturned.passwordExpired;
	                    user.enabled = userReturned.enabled;
	
	                    return user;
	                });
	            }
	
	            user.name = "";
	            return user;
	        }).then(function (user) {
	            return _ApiService2.default.search({
	                excludeApi: true,
	                uri: "/f/ba"
	            }).then(function (response) {
	
	                user.businessLines = [];
	
	                _.orderBy(response, [function (businessLine) {
	                    return businessLine.labelPt.toLowerCase();
	                }], ['asc']).map(function (businessLine) {
	
	                    if (_UtilsService2.default.hasRole(user.roles, businessLine.id)) {
	
	                        var businessLineRow = (0, _assign2.default)({}, businessLine);
	                        businessLineRow.contracts = [];
	
	                        _.orderBy(businessLine.contracts, [function (contract) {
	                            return contract.labelPt.toLowerCase();
	                        }], ['asc']).map(function (contract) {
	                            if (_UtilsService2.default.hasRole(user.roles, contract.id)) {
	                                businessLineRow.contracts.push(contract);
	                            }
	                        });
	
	                        user.businessLines.push(businessLineRow);
	                    }
	                });
	
	                return user;
	            });
	        }).catch(function (error) {
	            throw error;
	        });
	    },
	    logout: function logout() {
	
	        var LOGOUT_URL = _AppConfigService2.default.apiUrl() + '/api/logout';
	
	        return _http2.default.post(LOGOUT_URL).then(function (response) {
	
	            console.log("LOGOUT", response);
	
	            return response.data;
	        }).catch(function (error) {
	
	            console.log("LOGOUT ERROR", error);
	
	            return error;
	        });
	    },
	    changePassword: function changePassword(payload) {
	
	        var URL = _AppConfigService2.default.apiUrl() + '/api/users/changePassword';
	
	        var successMessage = payload.successMessage;
	
	        return _http2.default.put(URL, payload).then(function (response) {
	            return response.data;
	        });
	    },
	    retrievePassword: function retrievePassword(payload) {
	
	        var URL = _AppConfigService2.default.apiUrl() + '/api/forgetPassword/retrievePassword';
	
	        return _http2.default.post(URL, payload).then(function (response) {
	            return response.data;
	        });
	    },
	    changePasswordByToken: function changePasswordByToken(payload) {
	
	        var URL = _AppConfigService2.default.apiUrl() + '/api/forgetPassword/changePassword';
	
	        return _http2.default.post(URL, payload).then(function (response) {
	            return response.data;
	        });
	    },
	    loginFake: function loginFake(username, password) {
	        return new _promise2.default(function (resolve) {
	            resolve({
	                username: username,
	                roles: []
	            });
	        });
	    }
	};

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(661);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	__webpack_require__(654);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: {
	        events: {
	            default: function _default() {
	                return [];
	            }
	        },
	
	        eventSources: {
	            default: function _default() {
	                return [];
	            }
	        },
	
	        editable: {
	            default: function _default() {
	                return true;
	            }
	        },
	
	        selectable: {
	            default: function _default() {
	                return true;
	            }
	        },
	
	        selectHelper: {
	            default: function _default() {
	                return true;
	            }
	        },
	
	        header: {
	            default: function _default() {
	                return {
	                    left: 'prev,next today',
	                    center: 'title',
	                    right: 'month,agendaWeek,agendaDay'
	                };
	            }
	        },
	
	        defaultView: {
	            default: function _default() {
	                return 'agendaWeek';
	            }
	        },
	
	        sync: {
	            default: function _default() {
	                return false;
	            }
	        },
	
	        config: {
	            type: Object,
	            default: function _default() {
	                return {};
	            }
	        }
	    },
	
	    computed: {
	        defaultConfig: function defaultConfig() {
	            var self = this;
	            return {
	                header: this.header,
	                defaultView: this.defaultView,
	                editable: this.editable,
	                selectable: this.selectable,
	                selectHelper: this.selectHelper,
	                aspectRatio: 2,
	                timeFormat: 'HH:mm',
	                events: this.events,
	                eventSources: this.eventSources,
	
	                eventRender: function eventRender() {
	                    if (this.sync) {
	                        self.events = cal.fullCalendar('clientEvents');
	                    }
	
	                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                        args[_key] = arguments[_key];
	                    }
	
	                    self.$emit.apply(self, ['event-render'].concat(args));
	                },
	                eventDestroy: function eventDestroy(event) {
	                    if (this.sync) {
	                        self.events = cal.fullCalendar('clientEvents');
	                    }
	                },
	                eventClick: function eventClick() {
	                    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	                        args[_key2] = arguments[_key2];
	                    }
	
	                    self.$emit.apply(self, ['event-selected'].concat(args));
	                },
	                eventDrop: function eventDrop() {
	                    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	                        args[_key3] = arguments[_key3];
	                    }
	
	                    self.$emit.apply(self, ['event-drop'].concat(args));
	                },
	                eventResize: function eventResize() {
	                    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	                        args[_key4] = arguments[_key4];
	                    }
	
	                    self.$emit.apply(self, ['event-resize'].concat(args));
	                },
	                dayClick: function dayClick() {
	                    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	                        args[_key5] = arguments[_key5];
	                    }
	
	                    self.$emit.apply(self, ['day-click'].concat(args));
	                },
	                select: function select(start, end, jsEvent) {
	                    self.$emit('event-created', {
	                        start: start,
	                        end: end,
	                        allDay: !start.hasTime() && !end.hasTime()
	                    });
	                }
	            };
	        }
	    },
	
	    mounted: function mounted() {
	        var _this = this;
	
	        var cal = $(this.$el),
	            self = this;
	
	        this.$on('remove-event', function (event) {
	            if (event && event.hasOwnProperty('id')) {
	                $(_this.$el).fullCalendar('removeEvents', event.id);
	            } else {
	                $(_this.$el).fullCalendar('removeEvents', event);
	            }
	        });
	
	        this.$on('rerender-events', function () {
	            $(_this.$el).fullCalendar('rerenderEvents');
	        });
	
	        this.$on('refetch-events', function () {
	            $(_this.$el).fullCalendar('refetchEvents');
	        });
	
	        this.$on('render-event', function (event) {
	            $(_this.$el).fullCalendar('renderEvent', event);
	        });
	
	        this.$on('reload-events', function () {
	            $(_this.$el).fullCalendar('removeEvents');
	            $(_this.$el).fullCalendar('addEventSource', _this.events);
	        });
	
	        this.$on('rebuild-sources', function () {
	            $(_this.$el).fullCalendar('removeEvents');
	            _this.eventSources.map(function (event) {
	                $(_this.$el).fullCalendar('addEventSource', event);
	            });
	        });
	
	        cal.fullCalendar((0, _lodash2.default)(this.config, this.defaultConfig));
	    },
	
	
	    methods: {
	        fireMethod: function fireMethod() {
	            var _$;
	
	            (_$ = $(this.$el)).fullCalendar.apply(_$, arguments);
	        }
	    },
	
	    watch: {
	        events: {
	            deep: true,
	            handler: function handler(val) {
	                $(this.$el).fullCalendar('removeEvents');
	                $(this.$el).fullCalendar('addEventSource', this.events);
	            }
	        },
	        eventSources: {
	            deep: true,
	            handler: function handler(val) {
	                this.$emit('rebuild-sources');
	            }
	        }
	    },
	
	    beforeDestroy: function beforeDestroy() {
	        this.$off('remove-event');
	        this.$off('rerender-events');
	        this.$off('refetch-events');
	        this.$off('render-event');
	        this.$off('reload-events');
	        this.$off('rebuild-sources');
	    }
	};

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _main = __webpack_require__(816);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _Footer = __webpack_require__(812);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ModuleUtils = __webpack_require__(7);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { RootHeader: _main2.default, AppFooter: _Footer2.default },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['testConection', 'changeUserContractVersion']), {
	    checkVersion: function checkVersion() {
	      var _this = this;
	
	      var self = this;
	
	      if (["ModuleList", "ModuleCreate", "ModuleEdit", "ModuleShow"].indexOf(self.$route.name) >= 0) {
	        var businessAreaId = this.$route.params.businessAreaId;
	        var systemId = this.$route.params.systemId;
	
	        _ModuleUtils2.default.resolveSystemVersion(businessAreaId, systemId).then(function (response) {
	          if (_this.$route.params.systemVersion != response.id) {
	            var payload = {};
	
	            payload.businessAreaId = businessAreaId;
	            payload.contractId = systemId;
	            payload.version = response.id;
	
	            _this.changeUserContractVersion(payload);
	
	            alert('Uma nova versão do sistema ' + response.name + ' está disponível, caso você queira utilizar essa nova versão, por gentileza efetue o login novamente no sistema.');
	          }
	        });
	      }
	
	      setTimeout(function () {
	        self.checkVersion();
	      }, 600 * 1000);
	    }
	  }),
	  mounted: function mounted() {}
	};

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _LoginTemplate = __webpack_require__(136);
	
	var _LoginTemplate2 = _interopRequireDefault(_LoginTemplate);
	
	var _UtilsService = __webpack_require__(9);
	
	var _UtilsService2 = _interopRequireDefault(_UtilsService);
	
	var _vuePasswordStrengthMeter = __webpack_require__(348);
	
	var _vuePasswordStrengthMeter2 = _interopRequireDefault(_vuePasswordStrengthMeter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: {
	        LoginTemplate: _LoginTemplate2.default,
	        Password: _vuePasswordStrengthMeter2.default
	    },
	    data: function data() {
	        return {
	            lang: 'pt',
	            token: '',
	            username: '',
	            password: '',
	            repeatPassword: '',
	            error: '',
	            errors: []
	        };
	    },
	    mounted: function mounted() {
	
	        this.token = this.$route.query.token;
	
	        if (!this.token) {
	            this.backToLogin();
	        }
	
	        if (this.$route.query.lang === "en") {
	            this.lang = "en";
	        } else if (this.$route.query.lang === "es") {
	            this.lang = "es";
	        }
	
	        _UtilsService2.default.localStorageSetItem("USER_LOCALE", this.lang);
	        this.$i18n.locale = this.lang;
	    },
	
	    computed: {
	        isValidToSubmit: function isValidToSubmit() {
	            return this.username && this.password && this.repeatPassword;
	        }
	    },
	    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['changePasswordByToken']), {
	        backToLogin: function backToLogin() {
	
	            this.$router.push({ path: '/auth' });
	        },
	        doChangePassword: function doChangePassword() {
	            var _this = this;
	
	            var self = this;
	
	            self.error = "";
	            self.errors = [];
	
	            if (self.password !== self.repeatPassword) {
	
	                self.error = this.$t('newPasswordAndRepeatPasswordAreDifferentValues');
	            } else {
	
	                self.$loader.show();
	
	                this.changePasswordByToken({
	                    username: self.username,
	                    password: self.password,
	                    token: self.token
	                }).then(function (response) {
	
	                    var code = response.meta.code;
	                    self.$loader.hide();
	
	                    if (code === 200) {
	
	                        _this.$notify({
	                            title: _this.$t("success"),
	                            message: _this.$t("passwordUpdatedWithSuccess"),
	                            type: 'success'
	                        });
	
	                        _this.backToLogin();
	                    } else if (code === 400) {
	
	                        self.errors = _UtilsService2.default.buildErrorMessage(response.errors);
	
	                        console.log(response.errors);
	                        console.log(self.errors);
	                    }
	                }).catch(function (err) {
	
	                    console.log("Error!");
	                    console.log(err);
	
	                    self.error = "ERRO";
	                    self.$loader.hide();
	                });
	            }
	        }
	    })
	};

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _LoginTemplate = __webpack_require__(136);
	
	var _LoginTemplate2 = _interopRequireDefault(_LoginTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: {
	        LoginTemplate: _LoginTemplate2.default
	    },
	    data: function data() {
	        return {
	            username: '',
	            error: '',
	            showForm: true
	        };
	    },
	
	    computed: {
	        isValidToSubmit: function isValidToSubmit() {
	
	            var self = this;
	            return self.username;
	        }
	    },
	    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['retrievePassword']), {
	        backToLogin: function backToLogin() {
	
	            this.$router.push({ path: '/auth' });
	        },
	        doRetrievePassword: function doRetrievePassword() {
	            var _this = this;
	
	            var self = this;
	            self.$loader.show();
	            self.error = '';
	
	            this.retrievePassword({
	                username: self.username,
	                language: self.$i18n.locale
	            }).then(function (response) {
	
	                self.$loader.hide();
	                _this.showForm = false;
	            }).catch(function (err) {
	
	                console.log("Error!");
	                console.log(err);
	
	                self.error = "Erro inesperado";
	
	                self.$loader.hide();
	            });
	        }
	    })
	};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _utils = __webpack_require__(43);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _LoginTemplate = __webpack_require__(136);
	
	var _LoginTemplate2 = _interopRequireDefault(_LoginTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: {
	        LoginTemplate: _LoginTemplate2.default
	    },
	    data: function data() {
	        return {
	            loginField: '',
	            username: '',
	            password: '',
	            error: ''
	        };
	    },
	
	    computed: {
	        isValidToSubmit: function isValidToSubmit() {
	            var self = this;
	            return self.username && self.password;
	        },
	        loginPlaceholder: function loginPlaceholder() {
	            return this.$t("login");
	        }
	    },
	    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['login']), {
	        doLogin: function doLogin() {
	
	            var self = this;
	            self.$loader.show();
	            self.error = '';
	
	            this.login({
	                username: self.username,
	                password: self.password
	            }).then(function (response) {
	
	                self.$loader.hide();
	                self.$router.push({ path: "/" });
	            }).catch(function (err) {
	
	                console.log("Error!");
	                console.log(err);
	
	                self.error = self.loginPlaceholder + '/Senha inválida';
	                self.$loader.hide();
	            });
	        }
	    })
	};

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _utils = __webpack_require__(43);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    mounted: function mounted() {
	        document.getElementsByTagName("html")[0].classList.add('main-with-background');
	    },
	    destroyed: function destroyed() {
	        _utils2.default.removeBackground();
	    }
	};

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModuleTemplate = __webpack_require__(66);
	
	var _ModuleTemplate2 = _interopRequireDefault(_ModuleTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['appendToTitle', 'subtitle'],
	  data: function data() {
	    return {
	      title: 'Business Lines'
	    };
	  },
	
	  methods: {
	    resolveTitle: function resolveTitle() {
	      if (this.appendToTitle) {
	        return this.title + " - " + this.appendToTitle;
	      } else {
	        return this.title;
	      }
	    }
	  },
	  components: {
	    ModuleTemplate: _ModuleTemplate2.default
	  }
	};

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _BusinessAreaUtils = __webpack_require__(86);
	
	var _BusinessAreaUtils2 = _interopRequireDefault(_BusinessAreaUtils);
	
	var _utils = __webpack_require__(43);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _ApiService = __webpack_require__(30);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _RenderImagem = __webpack_require__(137);
	
	var _RenderImagem2 = _interopRequireDefault(_RenderImagem);
	
	var _UtilsService = __webpack_require__(9);
	
	var _UtilsService2 = _interopRequireDefault(_UtilsService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    RenderImagem: _RenderImagem2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['loggedUser'])),
	  methods: {
	    getLogo: function getLogo(id) {
	      return _utils2.default.getUrlBusinessAreaImage(id);
	    }
	  },
	  mounted: function mounted() {
	    if (this.loggedUser.businessLines.length === 1) {
	      this.$router.push('/businessArea/' + this.loggedUser.businessLines[0].id);
	    }
	  }
	};

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ModuleWrapper = __webpack_require__(804);
	
	var _ModuleWrapper2 = _interopRequireDefault(_ModuleWrapper);
	
	var _AutoComplete = __webpack_require__(827);
	
	var _AutoComplete2 = _interopRequireDefault(_AutoComplete);
	
	var _ModuleUtils = __webpack_require__(7);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Module',
	  data: function data() {
	    return {
	      autoComplete: null,
	      exportPdfViewer: false,
	      exportPdfViewerData: "",
	      showDialogForm: {
	        showDialogWithForm: false,
	        formIdModal: '',
	        parentIdModal: ''
	      }
	    };
	  },
	  components: {
	    ModuleWrapper: _ModuleWrapper2.default,
	    AutoComplete: _AutoComplete2.default
	  },
	  computed: {
	    businessAreaId: function businessAreaId() {
	      return this.$route.params.businessAreaId;
	    },
	    systemId: function systemId() {
	      return this.$route.params.systemId;
	    },
	    systemVersion: function systemVersion() {
	      return this.$route.params.systemVersion;
	    },
	    formId: function formId() {
	      return this.$route.params.formId;
	    },
	    exportPdfViewerHeight: function exportPdfViewerHeight() {
	      return window.innerHeight - 100;
	    }
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['showLoader', 'hideLoader']), {
	    handleResize: function handleResize(event) {
	      this.fullHeight = document.documentElement.clientHeight;
	    },
	
	    eventAutoComplete: function eventAutoComplete(payload) {
	      this.autoComplete = payload;
	    },
	    autoCompleteClose: function autoCompleteClose() {
	      this.autoComplete = null;
	    }
	  }),
	  created: function created() {
	    var _this = this;
	
	    this.$eventBus.$on('auto-complete', function (payload) {
	      _this.eventAutoComplete(payload);
	    });
	
	    this.$eventBus.$on('generate-report', function (reportData) {
	
	      var formIdentifier = (0, _assign2.default)({}, reportData.formIdentifier);
	      formIdentifier.formId = reportData.formId;
	
	      _this.showLoader();
	
	      _ModuleUtils2.default.moduleFormGenerateReport(formIdentifier, reportData.instance, true).then(function (response) {
	
	        _this.hideLoader();
	
	        if (response.body) {
	          _this.notificationError = response.body.notificationError;
	          _this.notificationSuccess = response.body.notificationSuccess;
	        }
	
	        if (response.meta.code == 400) {
	
	          _.forOwn(response.body.instance, function (value, key) {
	            _this.$set(_this.instance, key, value);
	          });
	        } else if (response.meta.code == 500) {
	
	          _this.$notify({
	            title: 'Error',
	            message: _this.$t('anUnexpectedErrorOccurred') + ' ' + response.error,
	            type: 'error'
	          });
	        }
	      });
	    });
	
	    this.$eventBus.$on('show-dialog-form', function (formIdModal, parentIdModal) {
	      _this.showDialogForm.formIdModal = formIdModal;
	      _this.showDialogForm.parentIdModal = parentIdModal;
	      _this.showDialogForm.showDialogWithForm = true;
	    });
	
	    this.$eventBus.$on('export-pdf', function (businessRuleId, instance) {
	
	      _this.showLoader();
	
	      var formIdentifier = {
	        businessAreaId: _this.businessAreaId,
	        systemId: _this.systemId,
	        systemVersion: _this.systemVersion,
	        formId: _this.formId
	      };
	
	      _ModuleUtils2.default.generatePDF(formIdentifier, instance, businessRuleId).then(function (response) {
	
	        _this.exportPdfViewerData = "";
	        _this.hideLoader();
	
	        if (response.headers["content-type"] == "application/pdf") {
	
	          var blob = new Blob([response.data], {
	            type: 'application/pdf'
	          });
	          _this.exportPdfViewerData = window.URL.createObjectURL(blob);
	          _this.exportPdfViewer = true;
	        } else {
	
	          var binaryString = String.fromCharCode.apply(null, new Uint8Array(response.data));
	
	          response = JSON.parse(binaryString);
	
	          if (response.body) {
	            _this.notificationError = response.body.notificationError;
	            _this.notificationSuccess = response.body.notificationSuccess;
	          }
	
	          if (response.meta.code == 400) {
	
	            _.forOwn(response.body.instance, function (value, key) {
	              _this.$set(_this.instance, key, value);
	            });
	          } else if (response.meta.code == 500) {
	
	            _this.$notify({
	              title: 'Error',
	              message: _this.$t('anUnexpectedErrorOccurred') + ' ' + response.error,
	              type: 'error'
	            });
	          }
	        }
	      });
	    });
	
	    this.$eventBus.$on('notification-error', function (message) {
	
	      if (_this.$i18n && message) {
	
	        var label = message.pt;
	
	        if (_this.$i18n.locale == 'es' && message.es) {
	          label = message.es;
	        } else if (_this.$i18n.locale == 'en' && message.en) {
	          label = message.en;
	        }
	
	        if (label) {
	          _this.$alert(label, _this.$t('error') + "!", {
	            confirmButtonText: 'OK',
	            type: 'error'
	          });
	        }
	      }
	    });
	
	    this.$eventBus.$on('notification-success', function (message) {
	
	      if (_this.$i18n && message) {
	
	        var label = message.pt;
	
	        if (_this.$i18n.locale == 'es' && message.es) {
	          label = message.es;
	        } else if (_this.$i18n.locale == 'en' && message.en) {
	          label = message.en;
	        }
	
	        if (label) {
	          _this.$notify({
	            title: _this.$t('success'),
	            message: label,
	            type: 'success'
	          });
	        }
	      }
	    });
	  }
	};

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(3);
	
	var _ModuleUtils = __webpack_require__(7);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	var _SgsRenderNotificationSuccess = __webpack_require__(28);
	
	var _SgsRenderNotificationSuccess2 = _interopRequireDefault(_SgsRenderNotificationSuccess);
	
	var _SgsRenderNotificationError = __webpack_require__(27);
	
	var _SgsRenderNotificationError2 = _interopRequireDefault(_SgsRenderNotificationError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['title', 'formIdentifier', 'customTemplate', 'parentId'],
	  components: {
	    SgsRenderNotificationSuccess: _SgsRenderNotificationSuccess2.default,
	    SgsRenderNotificationError: _SgsRenderNotificationError2.default
	  },
	  data: function data() {
	    return {
	      currentView: '',
	      template: '',
	      script: null,
	      params: {},
	      instance: null,
	      notificationError: null,
	      notificationSuccess: null
	    };
	  },
	  computed: {},
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['showLoader', 'hideLoader']), {
	    callBusinessRule: function callBusinessRule(instance, businessRuleId) {
	      var _this = this;
	
	      this.showLoader();
	
	      _ModuleUtils2.default.callBusinessRule(this.formIdentifier, instance, businessRuleId).then(function (response) {
	        _this.hideLoader();
	
	        _.forOwn(response.body.instance, function (value, key) {
	          _this.$set(instance, key, value);
	        });
	
	        _this.notificationError = response.body.notificationError;
	        _this.notificationSuccess = response.body.notificationSuccess;
	      });
	    },
	    actionLinkSelected: function actionLinkSelected(formId, dataRow) {
	      this.$emit('actionLinkSelected', formId, dataRow);
	    }
	  }),
	  mounted: function mounted() {
	    if (this.customTemplate) {
	
	      this.params.urlAttachment = _ModuleUtils2.default.resolveFormDesc(this.formIdentifier) + "/attachment";
	      this.params.parentId = this.parentId;
	      this.params.moment = __webpack_require__(1);
	      this.params.formIdentifier = this.formIdentifier;
	      this.params.userLanguage = this.$i18n.locale;
	
	      var vueJson = eval('(' + this.customTemplate.script + ')');
	      vueJson.template = this.customTemplate.template;
	
	      var customDynamicComponentName = "customDynamicComponent_" + this.formIdentifier.formId;
	
	      _vue2.default.component(customDynamicComponentName, vueJson);
	      this.currentView = customDynamicComponentName;
	    }
	  }
	};

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ModuleUtils = __webpack_require__(7);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	var _SgsRender = __webpack_require__(42);
	
	var _SgsRender2 = _interopRequireDefault(_SgsRender);
	
	var _SgsRenderCollapse = __webpack_require__(54);
	
	var _SgsRenderCollapse2 = _interopRequireDefault(_SgsRenderCollapse);
	
	var _SgsRenderErrorList = __webpack_require__(68);
	
	var _SgsRenderErrorList2 = _interopRequireDefault(_SgsRenderErrorList);
	
	var _FormBuilderUtils = __webpack_require__(18);
	
	var _FormBuilderUtils2 = _interopRequireDefault(_FormBuilderUtils);
	
	var _vuex = __webpack_require__(3);
	
	var _UtilsService = __webpack_require__(9);
	
	var _UtilsService2 = _interopRequireDefault(_UtilsService);
	
	var _SgsRenderNotificationSuccess = __webpack_require__(28);
	
	var _SgsRenderNotificationSuccess2 = _interopRequireDefault(_SgsRenderNotificationSuccess);
	
	var _SgsRenderNotificationError = __webpack_require__(27);
	
	var _SgsRenderNotificationError2 = _interopRequireDefault(_SgsRenderNotificationError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['rows', 'fields', 'formIdentifier', 'id', 'parentId', 'parentColumnName', 'title', 'businessRulesBeforeOtherView'],
	  components: {
	    SgsRender: _SgsRender2.default,
	    SgsRenderErrorList: _SgsRenderErrorList2.default,
	    SgsRenderCollapse: _SgsRenderCollapse2.default,
	    SgsRenderNotificationSuccess: _SgsRenderNotificationSuccess2.default,
	    SgsRenderNotificationError: _SgsRenderNotificationError2.default
	  },
	  data: function data() {
	    return {
	      instance: {},
	      errors: [],
	      rules: {},
	      rowsToShow: [],
	      notificationError: null,
	      notificationSuccess: null
	    };
	  },
	
	  computed: {
	    messageCreateOrUpdate: function messageCreateOrUpdate() {
	      return this.instance.id ? this.$t('updated') : this.$t('created');
	    }
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['showLoader', 'hideLoader']), {
	    getField: function getField(id) {
	      return _FormBuilderUtils2.default.findField(id, this.fields);
	    },
	    getColumnName: function getColumnName(id) {
	
	      var el = this.getField(id);
	      if (el != undefined) {
	
	        if (el.type == "errorList") {
	          return el.property;
	        }
	
	        return el.columnName;
	      }
	
	      return "";
	    },
	    updateField: function updateField(fieldName, fieldValue) {
	      this.$set(this.instance, fieldName, fieldValue);
	    },
	    callBusinessRule: function callBusinessRule(businessRuleId) {
	      var _this = this;
	
	      this.showLoader();
	
	      _ModuleUtils2.default.callBusinessRule(this.formIdentifier, this.instance, businessRuleId).then(function (response) {
	
	        _this.hideLoader();
	
	        _.forOwn(response.body.instance, function (value, key) {
	          _this.$set(_this.instance, key, value);
	        });
	
	        _this.notificationError = response.body.notificationError;
	        _this.notificationSuccess = response.body.notificationSuccess;
	      });
	    },
	    actionLinkSelected: function actionLinkSelected(formId, dataRow) {
	      this.$emit('actionLinkSelected', formId, dataRow);
	    }
	  }),
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.showLoader();
	
	    if (this.rows !== undefined && this.fields !== undefined) {
	
	      var collapseField = null;
	
	      this.rows.map(function (row) {
	
	        var newRow = { "cols": [] };
	        var eARowDoCollapse = false;
	
	        row.cols.map(function (col) {
	
	          if (col.fields.length > 0) {
	
	            var newCol = {
	              "width": col.width,
	              "fields": []
	            };
	
	            col.fields.map(function (field) {
	
	              var fieldFound = _this2.getField(field.id);
	
	              if (fieldFound.id) {
	
	                newCol.fields.push(fieldFound);
	
	                if (fieldFound.type == 'collapse') {
	                  eARowDoCollapse = true;
	                  collapseField = fieldFound;
	                  collapseField.rows = [];
	                }
	              }
	            });
	
	            if (newCol.fields.length > 0) {
	              newRow.cols.push(newCol);
	            }
	          }
	        });
	
	        if (newRow.cols.length > 0) {
	
	          if (collapseField) {
	
	            if (eARowDoCollapse) {
	              _this2.rowsToShow.push(newRow);
	            } else {
	              collapseField.rows.push(newRow);
	            }
	          } else {
	            _this2.rowsToShow.push(newRow);
	          }
	        } else {
	          collapseField = null;
	        }
	      });
	    }
	
	    this.fields.map(function (it) {
	      if (it.columnName && it.type !== 'dashboard') {
	        _this2.$set(_this2.instance, it.columnName, "");
	      }
	    });
	
	    if (this.parentId != undefined) {
	      this.$set(this.instance, 'parentId', this.parentId);
	    }
	
	    if (this.businessRulesBeforeOtherView) {
	      this.callBusinessRule(this.businessRulesBeforeOtherView);
	    }
	
	    this.hideLoader();
	  }
	};

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ModuleUtils = __webpack_require__(7);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	var _SgsRender = __webpack_require__(42);
	
	var _SgsRender2 = _interopRequireDefault(_SgsRender);
	
	var _SgsRenderCollapse = __webpack_require__(54);
	
	var _SgsRenderCollapse2 = _interopRequireDefault(_SgsRenderCollapse);
	
	var _SgsRenderErrorList = __webpack_require__(68);
	
	var _SgsRenderErrorList2 = _interopRequireDefault(_SgsRenderErrorList);
	
	var _SgsRenderNotificationSuccess = __webpack_require__(28);
	
	var _SgsRenderNotificationSuccess2 = _interopRequireDefault(_SgsRenderNotificationSuccess);
	
	var _SgsRenderNotificationError = __webpack_require__(27);
	
	var _SgsRenderNotificationError2 = _interopRequireDefault(_SgsRenderNotificationError);
	
	var _FormBuilderUtils = __webpack_require__(18);
	
	var _FormBuilderUtils2 = _interopRequireDefault(_FormBuilderUtils);
	
	var _vuex = __webpack_require__(3);
	
	var _UtilsService = __webpack_require__(9);
	
	var _UtilsService2 = _interopRequireDefault(_UtilsService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['rows', 'fields', 'formIdentifier', 'id', 'parentId', 'parentColumnName', 'title', 'businessRulesBeforeCrudViewCreate', 'businessRulesBeforeCrudViewEdit'],
	  components: {
	    SgsRender: _SgsRender2.default,
	    SgsRenderErrorList: _SgsRenderErrorList2.default,
	    SgsRenderCollapse: _SgsRenderCollapse2.default,
	    SgsRenderNotificationSuccess: _SgsRenderNotificationSuccess2.default,
	    SgsRenderNotificationError: _SgsRenderNotificationError2.default
	  },
	  data: function data() {
	    return {
	      instance: {},
	      errors: [],
	      rules: {},
	      rowsToShow: [],
	      notificationError: null,
	      notificationSuccess: null
	    };
	  },
	
	  computed: {
	    messageCreateOrUpdate: function messageCreateOrUpdate() {
	      return this.instance.id ? this.$t('updated') : this.$t('created');
	    }
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['showLoader', 'hideLoader']), {
	    doSave: function doSave() {
	      var _this = this;
	
	      this.$refs["instance"].validate(function (valid) {
	        if (valid) {
	          _this.showLoader();
	
	          _ModuleUtils2.default.moduleFormRowSave(_this.formIdentifier, _this.id, _this.instance).then(function (response) {
	
	            _this.hideLoader();
	
	            _this.notificationError = response.body.notificationError;
	            _this.notificationSuccess = response.body.notificationSuccess;
	
	            if (response.meta.code == 200 || response.meta.code == 201) {
	
	              _this.$notify({
	                title: _this.$t('success'),
	                message: _this.$t('item') + ' ' + _this.messageCreateOrUpdate + '.',
	                type: 'success'
	              });
	
	              _this.backToShow(response.body.instance.id);
	            } else if (response.meta.code == 400) {
	
	              _.forOwn(response.body.instance, function (value, key) {
	                _this.$set(_this.instance, key, value);
	              });
	            } else if (response.meta.code == 500) {
	
	              _this.$notify({
	                title: 'Error',
	                message: _this.$t('anUnexpectedErrorOccurred') + ' ' + response.error,
	                type: 'error'
	              });
	            }
	          });
	        } else {
	          console.log('error submit!!');
	        }
	      });
	    },
	    backToSearch: function backToSearch() {
	      this.$emit('changeModuleActive', 'list');
	    },
	    backToShow: function backToShow(id) {
	      this.$emit('changeModuleActive', 'show', id ? id : this.id);
	    },
	    getField: function getField(id) {
	      var el = _FormBuilderUtils2.default.findField(id, this.fields);
	      return el;
	    },
	    getColumnName: function getColumnName(id) {
	
	      var el = this.getField(id);
	      if (el != undefined) {
	
	        if (el.type == "errorList") {
	          return el.property;
	        }
	
	        return el.columnName;
	      }
	
	      return "";
	    },
	    updateField: function updateField(fieldName, fieldValue) {
	      this.$set(this.instance, fieldName, fieldValue);
	    },
	    callBusinessRule: function callBusinessRule(businessRuleId) {
	      var _this2 = this;
	
	      this.showLoader();
	
	      _ModuleUtils2.default.callBusinessRule(this.formIdentifier, this.instance, businessRuleId).then(function (response) {
	
	        _this2.hideLoader();
	
	        _.forOwn(response.body.instance, function (value, key) {
	          _this2.$set(_this2.instance, key, value);
	        });
	
	        _this2.notificationError = response.body.notificationError;
	        _this2.notificationSuccess = response.body.notificationSuccess;
	      });
	    },
	    actionLinkSelected: function actionLinkSelected(formId, dataRow) {
	      this.$emit('actionLinkSelected', formId, dataRow);
	    }
	  }),
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.showLoader();
	
	    if (this.rows !== undefined && this.fields !== undefined) {
	
	      var collapseField = null;
	
	      this.rows.map(function (row) {
	
	        var newRow = { "cols": [] };
	        var eARowDoCollapse = false;
	
	        row.cols.map(function (col) {
	
	          if (col.fields.length > 0) {
	
	            var newCol = {
	              "width": col.width,
	              "fields": []
	            };
	
	            col.fields.map(function (field) {
	
	              var fieldFound = _this3.getField(field.id);
	
	              if (fieldFound.id) {
	
	                newCol.fields.push(fieldFound);
	
	                if (fieldFound.type == 'collapse') {
	                  eARowDoCollapse = true;
	                  collapseField = fieldFound;
	                  collapseField.rows = [];
	                }
	              }
	            });
	
	            if (newCol.fields.length > 0) {
	              newRow.cols.push(newCol);
	            }
	          }
	        });
	
	        if (newRow.cols.length > 0) {
	
	          if (collapseField) {
	
	            if (eARowDoCollapse) {
	              _this3.rowsToShow.push(newRow);
	            } else {
	              collapseField.rows.push(newRow);
	            }
	          } else {
	            _this3.rowsToShow.push(newRow);
	          }
	        } else {
	          collapseField = null;
	        }
	      });
	    }
	
	    this.fields.map(function (it) {
	      if (it.columnName && it.type !== 'dashboard') {
	        _this3.$set(_this3.instance, it.columnName, "");
	      }
	    });
	
	    if (this.parentId != undefined) {
	      this.$set(this.instance, this.parentColumnName, this.parentId);
	    }
	
	    if (this.id != undefined) {
	      _ModuleUtils2.default.resolveFormDataRow(this.formIdentifier, this.id, 'form').then(function (response) {
	
	        _.forOwn(response.data.body.instance, function (value, key) {
	          _this3.$set(_this3.instance, key, value);
	        });
	      }).then(function () {
	
	        if (_this3.businessRulesBeforeCrudViewEdit) {
	          _this3.callBusinessRule(_this3.businessRulesBeforeCrudViewEdit);
	        }
	      });
	    } else if (this.businessRulesBeforeCrudViewCreate) {
	      this.callBusinessRule(this.businessRulesBeforeCrudViewCreate);
	    }
	
	    this.hideLoader();
	  }
	};

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ModuleUtils = __webpack_require__(7);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	var _SgsRender = __webpack_require__(42);
	
	var _SgsRender2 = _interopRequireDefault(_SgsRender);
	
	var _SgsRenderCollapse = __webpack_require__(54);
	
	var _SgsRenderCollapse2 = _interopRequireDefault(_SgsRenderCollapse);
	
	var _SgsRenderErrorList = __webpack_require__(68);
	
	var _SgsRenderErrorList2 = _interopRequireDefault(_SgsRenderErrorList);
	
	var _FormBuilderUtils = __webpack_require__(18);
	
	var _FormBuilderUtils2 = _interopRequireDefault(_FormBuilderUtils);
	
	var _vuex = __webpack_require__(3);
	
	var _UtilsService = __webpack_require__(9);
	
	var _UtilsService2 = _interopRequireDefault(_UtilsService);
	
	var _SgsRenderNotificationSuccess = __webpack_require__(28);
	
	var _SgsRenderNotificationSuccess2 = _interopRequireDefault(_SgsRenderNotificationSuccess);
	
	var _SgsRenderNotificationError = __webpack_require__(27);
	
	var _SgsRenderNotificationError2 = _interopRequireDefault(_SgsRenderNotificationError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['rows', 'fields', 'formIdentifier', 'id', 'parentId', 'parentColumnName', 'title', 'businessRulesBeforeOtherView'],
	  components: {
	    SgsRender: _SgsRender2.default,
	    SgsRenderErrorList: _SgsRenderErrorList2.default,
	    SgsRenderCollapse: _SgsRenderCollapse2.default,
	    SgsRenderNotificationSuccess: _SgsRenderNotificationSuccess2.default,
	    SgsRenderNotificationError: _SgsRenderNotificationError2.default
	  },
	  data: function data() {
	    return {
	      instance: {},
	      errors: [],
	      rules: {},
	      rowsToShow: [],
	      notificationError: null,
	      notificationSuccess: null
	    };
	  },
	
	  computed: {
	    messageCreateOrUpdate: function messageCreateOrUpdate() {
	      return this.instance.id ? this.$t('updated') : this.$t('created');
	    }
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['showLoader', 'hideLoader']), {
	    getField: function getField(id) {
	      return _FormBuilderUtils2.default.findField(id, this.fields);
	    },
	    getColumnName: function getColumnName(id) {
	
	      var el = this.getField(id);
	      if (el != undefined) {
	
	        if (el.type == "errorList") {
	          return el.property;
	        }
	
	        return el.columnName;
	      }
	
	      return "";
	    },
	    updateField: function updateField(fieldName, fieldValue) {
	      this.$set(this.instance, fieldName, fieldValue);
	    },
	    callBusinessRule: function callBusinessRule(businessRuleId) {
	      var _this = this;
	
	      this.showLoader();
	
	      _ModuleUtils2.default.callBusinessRule(this.formIdentifier, this.instance, businessRuleId).then(function (response) {
	
	        _this.hideLoader();
	
	        _.forOwn(response.body.instance, function (value, key) {
	          _this.$set(_this.instance, key, value);
	        });
	
	        _this.notificationError = response.body.notificationError;
	        _this.notificationSuccess = response.body.notificationSuccess;
	      });
	    },
	    actionLinkSelected: function actionLinkSelected(formId, dataRow) {
	      this.$emit('actionLinkSelected', formId, dataRow);
	    }
	  }),
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.showLoader();
	
	    if (this.rows !== undefined && this.fields !== undefined) {
	
	      var collapseField = null;
	
	      this.rows.map(function (row) {
	
	        var newRow = { "cols": [] };
	        var eARowDoCollapse = false;
	
	        row.cols.map(function (col) {
	
	          if (col.fields.length > 0) {
	
	            var newCol = {
	              "width": col.width,
	              "fields": []
	            };
	
	            col.fields.map(function (field) {
	
	              var fieldFound = _this2.getField(field.id);
	
	              if (fieldFound.id) {
	
	                newCol.fields.push(fieldFound);
	
	                if (fieldFound.type == 'collapse') {
	                  eARowDoCollapse = true;
	                  collapseField = fieldFound;
	                  collapseField.rows = [];
	                }
	              }
	            });
	
	            if (newCol.fields.length > 0) {
	              newRow.cols.push(newCol);
	            }
	          }
	        });
	
	        if (newRow.cols.length > 0) {
	
	          if (collapseField) {
	
	            if (eARowDoCollapse) {
	              _this2.rowsToShow.push(newRow);
	            } else {
	              collapseField.rows.push(newRow);
	            }
	          } else {
	            _this2.rowsToShow.push(newRow);
	          }
	        } else {
	          collapseField = null;
	        }
	      });
	    }
	
	    this.fields.map(function (it) {
	      if (it.columnName && it.type !== 'dashboard') {
	        _this2.$set(_this2.instance, it.columnName, "");
	      }
	    });
	
	    if (this.parentId != undefined) {
	      this.$set(this.instance, 'parentId', this.parentId);
	    }
	
	    if (this.businessRulesBeforeOtherView) {
	      this.callBusinessRule(this.businessRulesBeforeOtherView);
	    }
	
	    this.hideLoader();
	  }
	};

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _promise = __webpack_require__(71);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _ModuleUtils = __webpack_require__(7);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	var _FormBuilderUtils = __webpack_require__(18);
	
	var _FormBuilderUtils2 = _interopRequireDefault(_FormBuilderUtils);
	
	var _SgsRender = __webpack_require__(42);
	
	var _SgsRender2 = _interopRequireDefault(_SgsRender);
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	var _Pagination = __webpack_require__(825);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _SgsRenderNotificationSuccess = __webpack_require__(28);
	
	var _SgsRenderNotificationSuccess2 = _interopRequireDefault(_SgsRenderNotificationSuccess);
	
	var _SgsRenderNotificationError = __webpack_require__(27);
	
	var _SgsRenderNotificationError2 = _interopRequireDefault(_SgsRenderNotificationError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ModuleList',
	  components: {
	    SgsRender: _SgsRender2.default,
	    Pagination: _Pagination2.default,
	    SgsRenderNotificationSuccess: _SgsRenderNotificationSuccess2.default,
	    SgsRenderNotificationError: _SgsRenderNotificationError2.default
	  },
	  props: ['fields', 'formIdentifier', 'parentId', 'parentColumnName', 'title', 'filter', 'showCreateButton', 'showEditIcon', 'showShowIcon', 'businessRulesBeforeCrudViewList'],
	  data: function data() {
	    return {
	      rules: {},
	      state: {
	        stateName: "",
	        uri: "",
	        filter: {
	          itemsPerPage: 25,
	          _showFilter: true
	        },
	        list: [],
	        pagination: {},
	        submitted: false,
	        clickFromButton: false,
	        excludeApi: true
	      },
	      localList: [],
	      notificationError: null,
	      notificationSuccess: null,
	      formIdentifierModal: {}
	    };
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['retrieveState', 'list', 'pagination', 'showBottomPagination']), {
	    _fields: function _fields() {
	
	      var ret = [];
	
	      if (this.fields) {
	        _.orderBy(this.fields, ['name'], ['asc']).map(function (it) {
	          ret.push(it);
	        });
	      }
	
	      return ret;
	    },
	    _resultDesign: function _resultDesign() {
	      var _this = this;
	
	      var ret = [];
	
	      if (this.filter && this.filter.resultDesign && this.filter.resultDesign.length) {
	        _.orderBy(this.filter.resultDesign, ['position'], ['asc']).map(function (it) {
	
	          var visible = true;
	
	          if (_this.$i18n.locale == 'pt' && it.visibleToPt != undefined) {
	            visible = it.visibleToPt;
	          } else if (_this.$i18n.locale == 'es' && it.visibleToEs != undefined) {
	            visible = it.visibleToEs;
	          } else if (_this.$i18n.locale == 'en' && it.visibleToEn != undefined) {
	            visible = it.visibleToEn;
	          }
	
	          if (visible) {
	            ret.push(_.find(_this._fields, { 'id': it.id }));
	          }
	        });
	      } else {
	        var itemsToExcluded = ['textArea', 'header', 'collapse', 'password', 'file', 'hidden', 'image', 'grid', 'inputCSV', 'textEditor'];
	
	        this._fields.map(function (it) {
	
	          if (ret.length < 5 && it.persistent && !(itemsToExcluded.indexOf(it.type) > -1)) {
	            ret.push(it);
	          }
	        });
	      }
	
	      return ret;
	    },
	    _resultActions: function _resultActions() {
	      if (this.filter && this.filter.resultActions) {
	        return this.filter.resultActions;
	      }
	      return [];
	    },
	    widthIcons: function widthIcons() {
	      var iconWidth = 40;
	      var width = this._resultActions.length * iconWidth;
	      if (this.showEditIcon) {
	        width += iconWidth;
	      }
	      if (this.showShowIcon) {
	        width += iconWidth;
	      }
	      return width + "px";
	    },
	    filterRows: function filterRows() {
	      if (this.filter && this.filter.filterDesign) {
	        return this.filter.filterDesign.rows;
	      }
	      return [];
	    },
	    filterFields: function filterFields() {
	      if (this.filter && this.filter.filterDesign) {
	        return this.filter.filterDesign.fields;
	      }
	      return [];
	    }
	  }),
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.loadState().then(function (response) {
	
	      if (_this2.filterFields.length > 0) {
	        _this2.filterFields.map(function (item) {
	          _this2.$set(_this2.state.filter, item.columnName, '');
	        });
	      }
	
	      if (_this2.businessRulesBeforeCrudViewList) {
	        _this2.callBusinessRule(_this2.businessRulesBeforeCrudViewList, _this2.state.filter);
	      }
	    });
	  },
	  watch: {
	    'formIdentifier': function formIdentifier(newValue, oldValue) {
	      if (!(newValue.formId == oldValue.formId)) {
	        this.loadState();
	      }
	    },
	    'state.filter._showFilter': function stateFilter_showFilter(newValue, oldValue) {
	      this._doSearch();
	    },
	    'filter': function filter(newValue) {
	      var _this3 = this;
	
	      if (newValue && newValue.filterDesign) {
	        newValue.filterDesign.fields.map(function (item) {
	          _this3.$set(_this3.state.filter, item.columnName, '');
	        });
	        if (this.businessRulesBeforeCrudViewList) {
	          this.callBusinessRule(this.businessRulesBeforeCrudViewList, this.state.filter);
	        }
	      }
	    }
	
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['showLoader', 'hideLoader', 'doSearch', 'setPage', 'setItemsPerPage', 'setNewObjectStateCommit']), {
	    loadState: function loadState() {
	      var _this4 = this;
	
	      this.localList = [];
	      var stateName = this.formIdentifier.formId;
	
	      if (this.parentId) {
	        stateName = stateName + '_' + this.parentId;
	        this.$set(this.state.filter, 'parentId', this.parentId);
	      }
	
	      return _promise2.default.resolve().then(function () {
	        if (_this4.retrieveState(stateName) === undefined) {
	          _promise2.default.resolve().then(function () {
	            _this4.state.stateName = stateName;
	            _this4.state.uri = _ModuleUtils2.default.resolveFormUri(_this4.formIdentifier) + "/rows";
	            if (_this4.filterRows.length === 0) {
	              _this4.state.filter._showFilter = false;
	            }
	          }).then(function () {
	            _this4.setNewObjectStateCommit((0, _assign2.default)({}, _this4.state));
	          });
	        } else {
	          _promise2.default.resolve().then(function () {
	
	            return _this4.retrieveState(stateName);
	          }).then(function (response) {
	
	            _this4.state = response;
	          }).then(function () {
	
	            if (_this4.state.filter.currentPage > 1) {
	              _this4._setPage(_this4.state.filter.currentPage);
	            } else {
	
	              if (_this4.state.submitted) {
	                _this4._doSearch();
	              }
	            }
	          });
	        }
	      });
	    },
	    create: function create() {
	      this.$emit('changeModuleActive', 'form');
	    },
	    edit: function edit(row) {
	      this.$emit('changeModuleActive', 'form', row.id);
	    },
	    show: function show(row) {
	      this.$emit('changeModuleActive', 'show', row.id);
	    },
	    _doSearch: function _doSearch() {
	      var _this5 = this;
	
	      this.state.clickFromButton = true;
	
	      if (this.state.filter._showFilter) {
	        this.$refs["instance"].validate(function (valid) {
	          if (valid) {
	            _this5.state.filter.currentPage = 1;
	            _this5.doSearch(_this5.state).then(function () {
	              _this5.resolveLocalList();
	            });
	          } else {
	            console.log('error submit!!');
	          }
	        });
	      } else {
	        this.state.filter.currentPage = 1;
	        this.doSearch(this.state).then(function () {
	          _this5.resolveLocalList();
	        });
	      }
	    },
	    resolveLocalList: function resolveLocalList() {
	      this.localList = this.list(this.state);
	    },
	    getField: function getField(id, list) {
	      return _FormBuilderUtils2.default.findField(id, list);
	    },
	    getFilterField: function getFilterField(id) {
	      return this.getField(id, this.filterFields);
	    },
	    getFormField: function getFormField(id) {
	      return this.getField(id, this._fields);
	    },
	    getFormFieldLabel: function getFormFieldLabel(field) {
	
	      if (field == undefined) {
	        return "";
	      }
	
	      var labelPt = field.labelPt;
	      var labelEs = field.labelEs;
	      var labelEn = field.labelEn;
	
	      if (this.$i18n.locale == 'es' && field.labelEs) {
	        return field.labelEs;
	      } else if (this.$i18n.locale == 'en' && field.labelEn) {
	        return field.labelEn;
	      }
	
	      return field.labelPt;
	    },
	    getTableHeaderLabel: function getTableHeaderLabel(id) {
	      var field = this.getField(id, this._fields);
	
	      var labelPt = field.labelPt;
	      var labelEs = field.labelEs;
	      var labelEn = field.labelEn;
	
	      if (this.state.filter._config) {
	        var newHeader = this.state.filter._config[field.columnName];
	        if (newHeader) {
	
	          if (newHeader.labelPt) {
	            labelPt = newHeader.labelPt;
	          }
	          if (newHeader.labelPt) {
	            labelEs = newHeader.labelEs;
	          }
	          if (newHeader.labelPt) {
	            labelEn = newHeader.labelEn;
	          }
	        }
	      }
	
	      if (this.$i18n.locale == 'es' && field.labelEs) {
	        return field.labelEs;
	      } else if (this.$i18n.locale == 'en' && field.labelEn) {
	        return field.labelEn;
	      }
	
	      return field.labelPt;
	    },
	    updateField: function updateField(fieldName, fieldValue) {
	      this.$set(this.state.filter, fieldName, fieldValue);
	    },
	    getColumnName: function getColumnName(id) {
	
	      var el = this.getFilterField(id);
	      if (el != undefined) {
	        return el.columnName;
	      }
	
	      return "";
	    },
	    formatField: function formatField(value, type) {
	      return _SgsUtils2.default.formatField(value, type);
	    },
	    _setItemsPerPage: function _setItemsPerPage(val) {
	      var _this6 = this;
	
	      this.state.filter.itemsPerPage = val;
	      this.setItemsPerPage(this.state).then(function () {
	        _this6.resolveLocalList();
	      });
	    },
	    _setPage: function _setPage(val) {
	      var _this7 = this;
	
	      this.state.filter.currentPage = val;
	      this.setPage(this.state).then(function () {
	        _this7.resolveLocalList();
	      });
	    },
	    callBusinessRule: function callBusinessRule(businessRuleId, instance) {
	      var _this8 = this;
	
	      this.showLoader();
	
	      _ModuleUtils2.default.callBusinessRule(this.formIdentifier, instance, businessRuleId).then(function (response) {
	        _this8.hideLoader();
	
	        _.forOwn(response.body.instance, function (value, key) {
	          _this8.$set(instance, key, value);
	        });
	
	        _this8.notificationError = response.body.notificationError;
	        _this8.notificationSuccess = response.body.notificationSuccess;
	      });
	    },
	    callBusinessRuleFilter: function callBusinessRuleFilter(businessRuleId) {
	      this.callBusinessRule(businessRuleId, this.state.filter);
	    },
	    actionButton: function actionButton(button, fieldsDataRow) {
	      if (button.type === 'ACTION' || !button.type) {
	        this.callBusinessRule(button.businessRules.id, fieldsDataRow);
	      } else if (button.type === 'REPORT') {
	        this.doGenerateReport(fieldsDataRow, button.form.id);
	      } else if (button.type === 'LINK') {
	        this.$emit('actionLinkSelected', button.form.id, fieldsDataRow);
	      }
	    },
	    returnNewFormIdentifier: function returnNewFormIdentifier(formId) {
	      var formIdentifier = (0, _assign2.default)({}, this.formIdentifier);
	      formIdentifier.formId = formId;
	
	      return formIdentifier;
	    },
	    doGenerateReport: function doGenerateReport(fieldsDataRow, formId) {
	      var _this9 = this;
	
	      this.$refs["instance"].validate(function (valid) {
	        if (valid) {
	
	          _this9.showLoader();
	
	          _ModuleUtils2.default.moduleFormGenerateReport(_this9.returnNewFormIdentifier(formId), fieldsDataRow, true).then(function (response) {
	
	            _this9.hideLoader();
	
	            if (response.body) {
	              _this9.notificationError = response.body.notificationError;
	              _this9.notificationSuccess = response.body.notificationSuccess;
	            }
	
	            if (response.meta.code == 400) {
	
	              _.forOwn(response.body.instance, function (value, key) {
	                _this9.$set(_this9.instance, key, value);
	              });
	            } else if (response.meta.code == 500) {
	
	              _this9.$notify({
	                title: 'Error',
	                message: _this9.$t('anUnexpectedErrorOccurred') + ' ' + response.error,
	                type: 'error'
	              });
	            }
	          });
	        } else {
	          console.log('error submit!!');
	        }
	      });
	    },
	    renderIcon: function renderIcon(icon) {
	      return "glyphicon glyphicon-" + icon;
	    },
	    returnBackgroundColor: function returnBackgroundColor(backgroundColor) {
	      if (backgroundColor) {
	        return "background-color: " + backgroundColor + "; color: white;";
	      }
	      return "";
	    },
	    getAttrConfig: function getAttrConfig(instance, columnName) {
	      if (instance != undefined && instance._config != undefined && columnName != undefined) {
	        return instance._config[columnName];
	      }
	    }
	  })
	};

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ModuleUtils = __webpack_require__(7);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	var _SgsRender = __webpack_require__(42);
	
	var _SgsRender2 = _interopRequireDefault(_SgsRender);
	
	var _SgsRenderCollapse = __webpack_require__(54);
	
	var _SgsRenderCollapse2 = _interopRequireDefault(_SgsRenderCollapse);
	
	var _SgsRenderErrorList = __webpack_require__(68);
	
	var _SgsRenderErrorList2 = _interopRequireDefault(_SgsRenderErrorList);
	
	var _FormBuilderUtils = __webpack_require__(18);
	
	var _FormBuilderUtils2 = _interopRequireDefault(_FormBuilderUtils);
	
	var _vuex = __webpack_require__(3);
	
	var _UtilsService = __webpack_require__(9);
	
	var _UtilsService2 = _interopRequireDefault(_UtilsService);
	
	var _SgsRenderNotificationSuccess = __webpack_require__(28);
	
	var _SgsRenderNotificationSuccess2 = _interopRequireDefault(_SgsRenderNotificationSuccess);
	
	var _SgsRenderNotificationError = __webpack_require__(27);
	
	var _SgsRenderNotificationError2 = _interopRequireDefault(_SgsRenderNotificationError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['rows', 'fields', 'formIdentifier', 'id', 'parentId', 'parentColumnName', 'title', 'businessRulesBeforeOtherView'],
	  components: {
	    SgsRender: _SgsRender2.default,
	    SgsRenderErrorList: _SgsRenderErrorList2.default,
	    SgsRenderCollapse: _SgsRenderCollapse2.default,
	    SgsRenderNotificationSuccess: _SgsRenderNotificationSuccess2.default,
	    SgsRenderNotificationError: _SgsRenderNotificationError2.default
	  },
	  data: function data() {
	    return {
	      instance: {},
	      errors: [],
	      rules: {},
	      rowsToShow: [],
	      notificationError: null,
	      notificationSuccess: null
	    };
	  },
	
	  computed: {
	    messageCreateOrUpdate: function messageCreateOrUpdate() {
	      return this.instance.id ? this.$t('updated') : this.$t('created');
	    }
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['showLoader', 'hideLoader']), {
	    doGenerateReport: function doGenerateReport() {
	      var _this = this;
	
	      this.$refs["instance"].validate(function (valid) {
	        if (valid) {
	
	          _this.showLoader();
	
	          _ModuleUtils2.default.moduleFormGenerateReport(_this.formIdentifier, _this.instance).then(function (response) {
	
	            _this.hideLoader();
	
	            if (response.body) {
	              _this.notificationError = response.body.notificationError;
	              _this.notificationSuccess = response.body.notificationSuccess;
	            }
	
	            if (response.meta.code == 400) {
	
	              _.forOwn(response.body.instance, function (value, key) {
	                _this.$set(_this.instance, key, value);
	              });
	            } else if (response.meta.code == 500) {
	
	              _this.$notify({
	                title: 'Error',
	                message: _this.$t('anUnexpectedErrorOccurred') + ' ' + response.error,
	                type: 'error'
	              });
	            }
	          });
	        } else {
	          console.log('error submit!!');
	        }
	      });
	    },
	    getField: function getField(id) {
	      var el = _FormBuilderUtils2.default.findField(id, this.fields);
	      return el;
	    },
	    getColumnName: function getColumnName(id) {
	
	      var el = this.getField(id);
	      if (el != undefined) {
	
	        if (el.type == "errorList") {
	          return el.property;
	        }
	
	        return el.columnName;
	      }
	
	      return "";
	    },
	    updateField: function updateField(fieldName, fieldValue) {
	      this.$set(this.instance, fieldName, fieldValue);
	    },
	    callBusinessRule: function callBusinessRule(businessRuleId) {
	      var _this2 = this;
	
	      this.showLoader();
	
	      _ModuleUtils2.default.callBusinessRule(this.formIdentifier, this.instance, businessRuleId).then(function (response) {
	
	        _this2.hideLoader();
	
	        _.forOwn(response.body.instance, function (value, key) {
	          _this2.$set(_this2.instance, key, value);
	        });
	
	        _this2.notificationError = response.body.notificationError;
	        _this2.notificationSuccess = response.body.notificationSuccess;
	      });
	    },
	    actionLinkSelected: function actionLinkSelected(formId, dataRow) {
	      this.$emit('actionLinkSelected', formId, dataRow);
	    }
	  }),
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.showLoader();
	
	    if (this.rows !== undefined && this.fields !== undefined) {
	
	      var collapseField = null;
	
	      this.rows.map(function (row) {
	
	        var newRow = { "cols": [] };
	        var eARowDoCollapse = false;
	
	        row.cols.map(function (col) {
	
	          if (col.fields.length > 0) {
	
	            var newCol = {
	              "width": col.width,
	              "fields": []
	            };
	
	            col.fields.map(function (field) {
	
	              var fieldFound = _this3.getField(field.id);
	
	              if (fieldFound.id) {
	
	                newCol.fields.push(fieldFound);
	
	                if (fieldFound.type == 'collapse') {
	                  eARowDoCollapse = true;
	                  collapseField = fieldFound;
	                  collapseField.rows = [];
	                }
	              }
	            });
	
	            if (newCol.fields.length > 0) {
	              newRow.cols.push(newCol);
	            }
	          }
	        });
	
	        if (newRow.cols.length > 0) {
	
	          if (collapseField) {
	
	            if (eARowDoCollapse) {
	              _this3.rowsToShow.push(newRow);
	            } else {
	              collapseField.rows.push(newRow);
	            }
	          } else {
	            _this3.rowsToShow.push(newRow);
	          }
	        } else {
	          collapseField = null;
	        }
	      });
	    }
	
	    this.fields.map(function (it) {
	      if (it.columnName && it.type !== 'dashboard') {
	        _this3.$set(_this3.instance, it.columnName, "");
	      }
	    });
	
	    if (this.parentId != undefined) {
	      this.$set(this.instance, 'parentId', this.parentId);
	    }
	
	    if (this.businessRulesBeforeOtherView) {
	      this.callBusinessRule(this.businessRulesBeforeOtherView);
	    }
	
	    this.hideLoader();
	  }
	};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ModuleUtils = __webpack_require__(7);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	var _SgsRender = __webpack_require__(42);
	
	var _SgsRender2 = _interopRequireDefault(_SgsRender);
	
	var _SgsRenderCollapse = __webpack_require__(54);
	
	var _SgsRenderCollapse2 = _interopRequireDefault(_SgsRenderCollapse);
	
	var _SgsRenderNotificationSuccess = __webpack_require__(28);
	
	var _SgsRenderNotificationSuccess2 = _interopRequireDefault(_SgsRenderNotificationSuccess);
	
	var _SgsRenderNotificationError = __webpack_require__(27);
	
	var _SgsRenderNotificationError2 = _interopRequireDefault(_SgsRenderNotificationError);
	
	var _FormBuilderUtils = __webpack_require__(18);
	
	var _FormBuilderUtils2 = _interopRequireDefault(_FormBuilderUtils);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['rows', 'fields', 'formIdentifier', 'id', 'parentId', 'parentColumnName', 'title', 'showEditButton', 'showDeleteButton', 'showCreateButton', 'businessRulesBeforeCrudViewShow'],
	  components: {
	    SgsRender: _SgsRender2.default,
	    SgsRenderCollapse: _SgsRenderCollapse2.default,
	    SgsRenderNotificationSuccess: _SgsRenderNotificationSuccess2.default,
	    SgsRenderNotificationError: _SgsRenderNotificationError2.default
	  },
	  data: function data() {
	    return {
	      instance: {},
	      rowsToShow: [],
	      notificationError: null,
	      notificationSuccess: null
	    };
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['showLoader', 'hideLoader']), {
	    back: function back() {
	      this.$emit('changeModuleActive', 'list');
	    },
	    edit: function edit() {
	      this.$emit('changeModuleActive', 'form', this.id);
	    },
	    create: function create() {
	      this.$emit('changeModuleActive', 'form');
	    },
	    getField: function getField(id) {
	      return _FormBuilderUtils2.default.findField(id, this.fields);
	    },
	    getFieldValue: function getFieldValue(id) {
	
	      var el = this.getField(id);
	      if (el == undefined) {
	        return "not found TODO";
	      }
	
	      return this.instance[el.columnName];
	    },
	    doDelete: function doDelete() {
	      var _this = this;
	
	      this.$confirm(this.$t('confirmTheDeletion'), this.$t('warning'), {
	        confirmButtonText: this.$t('yes'),
	        cancelButtonText: this.$t('no'),
	        type: 'warning'
	      }).then(function () {
	
	        _this.showLoader();
	
	        _ModuleUtils2.default.moduleFormRowDelete(_this.formIdentifier, _this.id).then(function (response) {
	
	          _this.hideLoader();
	
	          _this.notificationError = response.body.notificationError;
	          _this.notificationSuccess = response.body.notificationSuccess;
	
	          if (response.meta.code == 200) {
	
	            _this.$notify({
	              title: _this.$t('success'),
	              message: _this.$t('itemDeleted'),
	              type: 'success'
	            });
	
	            _this.back();
	          } else if (response.meta.code == 400) {
	
	            _this.$alert(response.body.error.message, 'Erro', {
	              confirmButtonText: _this.$t('close'),
	              type: 'error'
	            });
	          } else {
	            console.log("error on delete: ", response);
	          }
	        });
	      });
	    },
	    callBusinessRule: function callBusinessRule(businessRuleId) {
	      var _this2 = this;
	
	      this.showLoader();
	
	      _ModuleUtils2.default.callBusinessRule(this.formIdentifier, this.instance, businessRuleId).then(function (response) {
	
	        _this2.hideLoader();
	
	        _.forOwn(response.body.instance, function (value, key) {
	          _this2.$set(_this2.instance, key, value);
	        });
	
	        _this2.notificationError = response.body.notificationError;
	        _this2.notificationSuccess = response.body.notificationSuccess;
	      });
	    },
	    actionLinkSelected: function actionLinkSelected(formId, dataRow) {
	      this.$emit('actionLinkSelected', formId, dataRow);
	    }
	  }),
	  mounted: function mounted() {
	    var _this3 = this;
	
	    if (this.rows !== undefined && this.fields !== undefined) {
	
	      var collapseField = null;
	
	      this.rows.map(function (row) {
	
	        var newRow = { "cols": [] };
	        var eARowDoCollapse = false;
	
	        row.cols.map(function (col) {
	
	          if (col.fields.length > 0) {
	
	            var newCol = {
	              "width": col.width,
	              "fields": []
	            };
	
	            col.fields.map(function (field) {
	
	              var fieldFound = _this3.getField(field.id);
	
	              if (fieldFound.id) {
	
	                newCol.fields.push(fieldFound);
	
	                if (fieldFound.type == 'collapse') {
	                  eARowDoCollapse = true;
	                  collapseField = fieldFound;
	                  collapseField.rows = [];
	                }
	              }
	            });
	
	            if (newCol.fields.length > 0) {
	              newRow.cols.push(newCol);
	            }
	          }
	        });
	
	        if (newRow.cols.length > 0) {
	
	          if (collapseField) {
	
	            if (eARowDoCollapse) {
	              _this3.rowsToShow.push(newRow);
	            } else {
	              collapseField.rows.push(newRow);
	            }
	          } else {
	            _this3.rowsToShow.push(newRow);
	          }
	        } else {
	          collapseField = null;
	        }
	      });
	    }
	
	    this.fields.map(function (it) {
	      if (it.columnName && it.type !== 'dashboard') {
	        _this3.$set(_this3.instance, it.columnName, "");
	      }
	    });
	
	    _ModuleUtils2.default.resolveFormDataRow(this.formIdentifier, this.id, "show").then(function (response) {
	      _.forOwn(response.data.body.instance, function (value, key) {
	        _this3.$set(_this3.instance, key, value);
	      });
	    }).then(function () {
	      if (_this3.businessRulesBeforeCrudViewShow) {
	        _this3.callBusinessRule(_this3.businessRulesBeforeCrudViewShow);
	      }
	    });
	  }
	};

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(90);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _ModuleUtils = __webpack_require__(7);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	var _ModuleList = __webpack_require__(343);
	
	var _ModuleList2 = _interopRequireDefault(_ModuleList);
	
	var _ModuleForm = __webpack_require__(342);
	
	var _ModuleForm2 = _interopRequireDefault(_ModuleForm);
	
	var _ModuleShow = __webpack_require__(344);
	
	var _ModuleShow2 = _interopRequireDefault(_ModuleShow);
	
	var _ModuleCustom = __webpack_require__(800);
	
	var _ModuleCustom2 = _interopRequireDefault(_ModuleCustom);
	
	var _ModuleDashboard = __webpack_require__(801);
	
	var _ModuleDashboard2 = _interopRequireDefault(_ModuleDashboard);
	
	var _ModuleFree = __webpack_require__(802);
	
	var _ModuleFree2 = _interopRequireDefault(_ModuleFree);
	
	var _ModuleReport = __webpack_require__(803);
	
	var _ModuleReport2 = _interopRequireDefault(_ModuleReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'sgs-module-wrapper',
	  props: ['businessAreaId', 'systemId', 'systemVersion', 'formId', 'parentId'],
	  data: function data() {
	    return {
	      form: {},
	      moduleType: '',
	      moduleActive: 'list',
	      moduleActiveDataId: '',
	      moduleChild: [],
	      moduleFilter: [],
	      createView: true,
	      deleteButton: true,
	      editView: true,
	      showView: true,
	      customTemplate: '',
	      showDialogWithForm: false,
	      formIdModal: '',
	      parentIdModal: ''
	    };
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userLoggedRoles']), {
	    title: function title() {
	      if (this.form) {
	
	        var title = this.form.labelPt;
	
	        if (this.$i18n.locale == 'es' && this.form.labelEs) {
	          title = this.form.labelEs;
	        } else if (this.$i18n.locale == 'en' && this.form.labelEn) {
	          title = this.form.labelEn;
	        }
	
	        return title;
	      }
	    },
	    _moduleChild: function _moduleChild() {
	      return _.sortBy(this.moduleChild, ['labelPt']);
	    }
	  }),
	  mounted: function mounted() {
	    this.resolveModuleDescription();
	  },
	
	  components: {
	    ModuleList: _ModuleList2.default, ModuleForm: _ModuleForm2.default,
	    ModuleShow: _ModuleShow2.default, ModuleCustom: _ModuleCustom2.default,
	    ModuleDashboard: _ModuleDashboard2.default, ModuleReport: _ModuleReport2.default,
	    ModuleFree: _ModuleFree2.default
	  },
	  watch: {
	    'formId': function formId() {
	      this.resolveModuleDescription();
	    }
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['userHasRole']), {
	    formIdentifier: function formIdentifier() {
	      return {
	        businessAreaId: this.businessAreaId,
	        systemId: this.systemId,
	        systemVersion: this.systemVersion,
	        formId: this.formId
	      };
	    },
	    resolveModuleDescription: function resolveModuleDescription() {
	      var _this = this;
	
	      this.moduleType = '';
	      this.moduleActive = 'list';
	      this.moduleActiveDataId = '';
	      this.moduleChild = [];
	      this.moduleFilter = [];
	      this.createView = true;
	      this.deleteButton = true;
	      this.editView = true;
	      this.showView = true;
	      this.customTemplate = '';
	
	      _ModuleUtils2.default.resolveModuleDescription(this.formIdentifier()).then(function (response) {
	
	        _this.form = response;
	
	        if (_this.form) {
	
	          _this.moduleType = _this.form.type;
	
	          if (_this.form.type == 'CRUD') {
	            if (_this.form.fieldDesc) {
	              _this.form.children.map(function (it) {
	                if (it.availableInWeb) {
	                  _this.userHasRole(it.id).then(function (response) {
	                    if (response) {
	                      _this.moduleChild.push(it);
	                    }
	                  });
	                }
	              });
	
	              _this.moduleFilter = _this.form.fieldDesc.filter;
	              _this.createView = _this.form.createView;
	              _this.deleteButton = _this.form.deleteButton;
	              _this.editView = _this.form.editView;
	              _this.showView = _this.form.showView;
	            }
	          } else if (_this.moduleType == 'CUSTOM') {
	            _this.customTemplate = _this.form.customTemplate;
	          }
	        }
	      });
	    },
	    changeModuleActive: function changeModuleActive(moduleName, id) {
	      this.moduleActive = moduleName;
	      this.moduleActiveDataId = id;
	    },
	    rows: function rows() {
	      if (this.form && this.form.fieldDesc) {
	        return this.form.fieldDesc.rows;
	      }
	      return [];
	    },
	    fields: function fields() {
	      if (this.form && this.form.fieldDesc && (0, _keys2.default)(this.form.fieldDesc).length > 0) {
	        return this.form.fieldDesc.fields;
	      }
	      return [];
	    },
	    filter: function filter() {
	      if (this.form && this.form.fieldDesc && this.form.fieldDesc.filter) {
	        return this.form.fieldDesc.filter;
	      }
	      return [];
	    },
	    children: function children() {
	      if (this.form && this.form.fieldDesc) {
	        return this.form.children;
	      }
	      return [];
	    },
	    parentColumnName: function parentColumnName() {
	      if (this.form && this.form.parentColumnName) {
	        return this.form.parentColumnName;
	      }
	      return '';
	    },
	    showChildrenTabs: function showChildrenTabs() {
	      return this.children().length > 0;
	    },
	    actionLinkSelected: function actionLinkSelected(formId, dataRow) {
	
	      this.showDialogWithForm = true;
	      this.formIdModal = formId;
	      this.parentIdModal = dataRow.id;
	    },
	    childTitle: function childTitle(child) {
	
	      var title = child.labelPt;
	
	      if (this.$i18n.locale == 'es' && child.labelEs) {
	        title = child.labelEs;
	      } else if (this.$i18n.locale == 'en' && child.labelEn) {
	        title = child.labelEn;
	      }
	
	      return title;
	    }
	  })
	};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ModuleTemplate = __webpack_require__(66);
	
	var _ModuleTemplate2 = _interopRequireDefault(_ModuleTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: ['appendToTitle', 'subtitle'],
	    data: function data() {
	        return {
	            title: ''
	        };
	    },
	
	    methods: {
	        resolveTitle: function resolveTitle() {
	            if (this.appendToTitle) {
	                return this.title + " - " + this.appendToTitle;
	            } else {
	                return this.title;
	            }
	        }
	    },
	    components: {
	        ModuleTemplate: _ModuleTemplate2.default
	    }
	};

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _ModulesUtils = __webpack_require__(408);
	
	var _ModulesUtils2 = _interopRequireDefault(_ModulesUtils);
	
	var _utils = __webpack_require__(43);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  data: function data() {
	    return {
	      filter: {},
	      checked: true
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    list: 'modulesList'
	  })),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['modulesDoSearch']), {
	    getLogo: function getLogo() {
	      return _ModulesUtils2.default.apiUrl() + '/f/systemBackground/' + this.$route.params.systemId;
	    }
	  }),
	  mounted: function mounted() {
	    _utils2.default.addBackground(this.getLogo());
	    this.modulesDoSearch(this.$route.params);
	  },
	  destroyed: function destroyed() {
	    _utils2.default.removeBackground();
	  }
	};

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ModuleTemplate = __webpack_require__(66);
	
	var _ModuleTemplate2 = _interopRequireDefault(_ModuleTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'Systems',
	    props: ['appendToTitle', 'subtitle'],
	    data: function data() {
	        return {
	            title: 'Contratos'
	        };
	    },
	
	    methods: {
	        resolveTitle: function resolveTitle() {
	            if (this.appendToTitle) {
	                return this.title + " - " + this.appendToTitle;
	            } else {
	                return this.title;
	            }
	        }
	    },
	    components: {
	        ModuleTemplate: _ModuleTemplate2.default
	    }
	};

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _SystemsUtils = __webpack_require__(413);
	
	var _SystemsUtils2 = _interopRequireDefault(_SystemsUtils);
	
	var _utils = __webpack_require__(43);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _RenderImagem = __webpack_require__(137);
	
	var _RenderImagem2 = _interopRequireDefault(_RenderImagem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    RenderImagem: _RenderImagem2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['loggedUser']), {
	    businessLineContracts: function businessLineContracts() {
	      var businessLine = _.find(this.loggedUser.businessLines, { 'id': this.$route.params.businessAreaId });
	      if (businessLine !== undefined) {
	        return businessLine.contracts;
	      }
	      return [];
	    }
	  }),
	  methods: {
	    getRandomImage: function getRandomImage() {
	      return 'static/img/ex/img-' + Math.floor(Math.random() * 13) + '.jpg';
	    },
	    getLogo: function getLogo(id) {
	      return _SystemsUtils2.default.apiUrl() + '/f/systemLogo/' + id;
	    }
	  },
	  mounted: function mounted() {
	
	    if (this.businessLineContracts.length === 1) {
	      this.$router.push({
	        name: 'ModulesList',
	        params: {
	          systemId: this.businessLineContracts[0].id,
	          systemVersion: this.businessLineContracts[0].version
	        }
	      });
	    } else {
	      _utils2.default.addBackground(_utils2.default.getUrlBusinessAreaImage(this.$route.params.businessAreaId));
	    }
	  },
	  destroyed: function destroyed() {
	    _utils2.default.removeBackground();
	  }
	};

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _UtilsService = __webpack_require__(9);
	
	var _UtilsService2 = _interopRequireDefault(_UtilsService);
	
	var _vuePasswordStrengthMeter = __webpack_require__(348);
	
	var _vuePasswordStrengthMeter2 = _interopRequireDefault(_vuePasswordStrengthMeter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Password: _vuePasswordStrengthMeter2.default
	  },
	  props: ["value", "instance"],
	  data: function data() {
	    return {
	      payload: {
	        currentPassword: '',
	        newPassword: '',
	        repeatNewPassword: '',
	        user: {}
	      },
	      errors: [],
	      context: null,
	      successMessage: '',
	      rules: {
	        "currentPassword": [],
	        "newPassword": [],
	        "repeatNewPassword": []
	      }
	    };
	  },
	
	  watch: {
	    "value": function value(newValue, oldValue) {
	      if (newValue) {
	        this.payload.user = this.instance;
	      }
	    }
	  },
	  computed: {
	    _value: {
	      get: function get() {
	        return this.value;
	      },
	      set: function set(newValue) {
	        this.$emit('input', newValue);
	      }
	    }
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['changePassword', 'updatePasswordExpired', 'showLoader', 'hideLoader']), {
	    resetData: function resetData() {
	      (0, _assign2.default)(this.$data, this.$options.data());
	    },
	    close: function close() {
	      this._value = false;
	      this.resetData();
	    },
	    save: function save() {
	      var _this = this;
	
	      this.$refs["payload"].validate(function (valid) {
	        if (valid) {
	          _this.showLoader();
	          _this.changePassword(_this.payload).then(function (response) {
	            var code = response.meta.code;
	
	            if (code == 200) {
	
	              _this.$notify({
	                title: _this.$t("success"),
	                message: _this.$t("savedPasswordWithSuccess"),
	                type: 'success'
	              });
	
	              _this.close();
	              _this.updatePasswordExpired(response.data);
	              return response.data;
	            } else if (code === 400) {
	
	              _this.errors = _UtilsService2.default.buildErrorMessage(response.errors);
	
	              throw _this.errors;
	            }
	          });
	
	          _this.hideLoader();
	        } else {
	          console.log('error submit!!');
	        }
	      });
	    }
	  }),
	  created: function created() {
	    var _this2 = this;
	
	    if (this.rules) {
	
	      this.rules["currentPassword"].push({ required: true, message: this.$t('pleaseFillInTheField'), trigger: 'blur' });
	      this.rules["newPassword"].push({ required: true, message: this.$t('pleaseFillInTheField'), trigger: 'blur' });
	      this.rules["repeatNewPassword"].push({ required: true, message: this.$t('pleaseFillInTheField'), trigger: 'blur' });
	
	      this.rules["newPassword"].push({
	        validator: function validator(rules, value, callback) {
	          if (_this2.payload.newPassword && _this2.payload.newPassword == _this2.payload.currentPassword) {
	            callback(new Error(_this2.$t('newPasswordCanNotBeEqualToACurrentPassword')));
	          }
	          callback();
	        },
	        trigger: 'blur'
	      });
	
	      this.rules["newPassword"].push({
	        validator: function validator(rules, value, callback) {
	          if (_this2.payload.currentPassword && _this2.payload.currentPassword == _this2.payload.newPassword) {
	            callback(new Error(_this2.$t('newPasswordCanNotBeEqualToACurrentPassword')));
	          }
	          callback();
	        },
	        trigger: 'blur'
	      });
	
	      this.rules["repeatNewPassword"].push({
	        validator: function validator(rules, value, callback) {
	          if (_this2.payload.repeatNewPassword && _this2.payload.repeatNewPassword != _this2.payload.newPassword) {
	            callback(new Error(_this2.$t('newPasswordAndRepeatPasswordAreDifferentValues')));
	          }
	          callback();
	        },
	        trigger: 'blur'
	      });
	
	      this.rules["repeatNewPassword"].push({
	        validator: function validator(rules, value, callback) {
	          if (_this2.payload.newPassword && _this2.payload.newPassword != _this2.payload.repeatNewPassword) {
	            callback(new Error(_this2.$t('newPasswordAndRepeatPasswordAreDifferentValues')));
	          }
	          callback();
	        },
	        trigger: 'blur'
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.payload.user = this.instance;
	  }
	};

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModuleTemplate = __webpack_require__(66);
	
	var _ModuleTemplate2 = _interopRequireDefault(_ModuleTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['appendToTitle', 'subtitle'],
	  methods: {
	    resolveTitle: function resolveTitle() {
	      return this.$t('profile');
	    }
	  },
	  components: {
	    ModuleTemplate: _ModuleTemplate2.default
	  }
	};

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _SpanTrueOrFalse = __webpack_require__(826);
	
	var _SpanTrueOrFalse2 = _interopRequireDefault(_SpanTrueOrFalse);
	
	var _ChangePasswordDialogForm = __webpack_require__(809);
	
	var _ChangePasswordDialogForm2 = _interopRequireDefault(_ChangePasswordDialogForm);
	
	var _RenderImagem = __webpack_require__(137);
	
	var _RenderImagem2 = _interopRequireDefault(_RenderImagem);
	
	var _ApiService = __webpack_require__(30);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _UtilsService = __webpack_require__(9);
	
	var _UtilsService2 = _interopRequireDefault(_UtilsService);
	
	var _utils = __webpack_require__(43);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    SpanTrueOrFalse: _SpanTrueOrFalse2.default,
	    ChangePasswordDialogForm: _ChangePasswordDialogForm2.default,
	    RenderImagem: _RenderImagem2.default
	  },
	  data: function data() {
	    return {
	      instance: {
	        name: '',
	        username: '',
	        email: '',
	        phone: '',
	        enabled: ''
	      },
	      changePasswordModal: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['loggedUser', 'userLoggedRoles'])),
	  methods: {
	    showChangePasswordModal: function showChangePasswordModal() {
	      this.changePasswordModal = true;
	    },
	    getLogo: function getLogo(id) {
	      return _utils2.default.getUrlBusinessAreaImage(id);
	    }
	  },
	  mounted: function mounted() {
	
	    this.instance.name = this.loggedUser.name;
	    this.instance.username = this.loggedUser.username;
	    this.instance.email = this.loggedUser.email;
	    this.instance.phone = this.loggedUser.phone;
	    this.instance.enabled = this.loggedUser.enabled;
	
	    if (this.loggedUser.passwordExpired) {
	      this.$alert(this.$t('yourPasswordIsExpired'), this.$t('passwordExpired'), {
	        confirmButtonText: 'OK',
	        cancelButtonText: 'Cancel',
	        type: 'warning'
	      });
	    }
	  }
	};

/***/ }),
/* 462 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _brand = __webpack_require__(345);
	
	var _brand2 = _interopRequireDefault(_brand);
	
	var _menuUser = __webpack_require__(818);
	
	var _menuUser2 = _interopRequireDefault(_menuUser);
	
	var _menuApp = __webpack_require__(817);
	
	var _menuApp2 = _interopRequireDefault(_menuApp);
	
	var _vuex = __webpack_require__(3);
	
	var _HeaderUtils = __webpack_require__(87);
	
	var _HeaderUtils2 = _interopRequireDefault(_HeaderUtils);
	
	var _subMenu = __webpack_require__(819);
	
	var _subMenu2 = _interopRequireDefault(_subMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'pa-header',
	  components: { Brand: _brand2.default, MenuApp: _menuApp2.default, MenuUser: _menuUser2.default, subMenu: _subMenu2.default },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isLogged', 'loggedUser']), {
	    showBusinessLine: function showBusinessLine() {
	      if (this.$route.params.businessAreaId) {
	        return this.loggedUser.businessLines.length > 1;
	      }
	    },
	    showContracts: function showContracts() {
	      if (this.$route.params.systemId) {
	        return _.find(this.loggedUser.businessLines, { 'id': this.$route.params.businessAreaId }).contracts.length > 1;
	      }
	    },
	    contractMenuShow: function contractMenuShow() {
	      return this.$route.params.systemId;
	    }
	  })
	};

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _brand = __webpack_require__(345);
	
	var _brand2 = _interopRequireDefault(_brand);
	
	var _subMenuResponsive = __webpack_require__(820);
	
	var _subMenuResponsive2 = _interopRequireDefault(_subMenuResponsive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      meuCollapse: ''
	    };
	  },
	
	  components: {
	    Brand: _brand2.default,
	    subMenuResponsive: _subMenuResponsive2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isLogged', 'loggedUser']), {
	    showBusinessLine: function showBusinessLine() {
	      if (this.$route.params.businessAreaId) {
	        return this.loggedUser.businessLines.length > 1;
	      }
	    },
	    showContracts: function showContracts() {
	      if (this.$route.params.systemId) {
	        return _.find(this.loggedUser.businessLines, { 'id': this.$route.params.businessAreaId }).contracts.length > 1;
	      }
	    },
	    contractMenuShow: function contractMenuShow() {
	      return this.$route.params.systemId;
	    }
	  }),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['logout']), {
	    doLogout: function doLogout() {
	      this.logout();
	      this.$router.push({ path: '/auth' });
	    },
	
	    open: function open() {
	      if (this.meuCollapse == '') {
	        this.meuCollapse = 'in';
	      } else {
	        this.meuCollapse = '';
	      }
	    },
	    openNivel: function openNivel(id) {
	      var className = document.getElementById(id).parentElement.className;
	      if (className.indexOf("open") > -1) {
	        document.getElementById(id).parentElement.className = "dropdown";
	      } else {
	        document.getElementById(id).parentElement.className = "dropdown open";
	      }
	    }
	  })
	};

/***/ }),
/* 465 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    goToBusinessArea: function goToBusinessArea() {
	      var params = this.$route.params;
	      if (params.systemId) {
	        this.$router.push({
	          name: 'ModulesList',
	          params: {
	            systemId: params.systemId
	          }
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UtilsService = __webpack_require__(9);
	
	var _UtilsService2 = _interopRequireDefault(_UtilsService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	  methods: {
	    setPtBr: function setPtBr() {
	      _UtilsService2.default.localStorageSetItem("USER_LOCALE", "pt");
	      this.$i18n.locale = 'pt';
	    },
	    setEn: function setEn() {
	      _UtilsService2.default.localStorageSetItem("USER_LOCALE", "en");
	      this.$i18n.locale = 'en';
	    },
	    setEs: function setEs() {
	      _UtilsService2.default.localStorageSetItem("USER_LOCALE", "es");
	      this.$i18n.locale = 'es';
	    }
	  }
	};

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MenuNoResponsive = __webpack_require__(813);
	
	var _MenuNoResponsive2 = _interopRequireDefault(_MenuNoResponsive);
	
	var _MenuResponsive = __webpack_require__(814);
	
	var _MenuResponsive2 = _interopRequireDefault(_MenuResponsive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'main-menu',
	  components: { MenuNoResponsive: _MenuNoResponsive2.default, MenuResponsive: _MenuResponsive2.default },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['loggedUser', 'isLogged', 'authMenuMainServiceOrder', 'authMenuMainContractor', 'authMenuMainCustomer', 'authMenuMainTenant', 'authMenuMainUser']))
	};

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _flags = __webpack_require__(815);
	
	var _flags2 = _interopRequireDefault(_flags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    flags: _flags2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['loggedUser', 'isLogged'])),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['logout']), {
	    toggleUserMenu: function toggleUserMenu() {
	      this.isOpenUser = !this.isOpenUser;
	    },
	    doLogout: function doLogout() {
	      var _this = this;
	
	      this.logout().then(function () {
	
	        _this.$router.push({ path: '/auth' });
	      });
	    },
	
	    setPtBr: function setPtBr() {
	      this.$i18n.locale = 'pt';
	    },
	    setEn: function setEn() {
	      this.$i18n.locale = 'en';
	    },
	    setEs: function setEs() {
	      this.$i18n.locale = 'es';
	    }
	  })
	};

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _HeaderUtils = __webpack_require__(87);
	
	var _HeaderUtils2 = _interopRequireDefault(_HeaderUtils);
	
	var _UtilsService = __webpack_require__(9);
	
	var _UtilsService2 = _interopRequireDefault(_UtilsService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      menus: []
	    };
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userLoggedRoles'])),
	  mounted: function mounted() {
	    var _this = this;
	
	    _HeaderUtils2.default.resolveContractMenu(this.$route.params).then(function (response) {
	      _this.buildMenu(_this.userLoggedRoles, response.menu, _this.menus);
	    });
	  },
	  methods: {
	    getLabel: function getLabel(menuItem) {
	
	      var label = menuItem.labelPt;
	
	      if (this.$i18n.locale == 'es' && menuItem.labelEs) {
	        label = menuItem.labelEs;
	      } else if (this.$i18n.locale == 'en' && menuItem.labelEn) {
	        label = menuItem.labelEn;
	      }
	
	      return label;
	    },
	    buildMenu: function buildMenu(roles, menuSource, menuTarget) {
	      var _this2 = this;
	
	      menuSource.map(function (it) {
	
	        var menuItem = {
	          id: it.id,
	          labelPt: it.labelPt,
	          labelEs: it.labelEs,
	          labelEn: it.labelEn,
	          type: it.type,
	          formId: it.formId ? it.formId : null,
	          childs: [],
	          form: {
	            availableInMobile: it.form.availableInMobile,
	            availableInWeb: it.form.availableInWeb
	          }
	        };
	
	        _this2.buildMenu(roles, it.childs, menuItem.childs);
	
	        if (menuItem.type == 'FORM' && _UtilsService2.default.hasRole(roles, it.formId) && it.form.availableInWeb) {
	          menuTarget.push(menuItem);
	        } else if (menuItem.childs.length > 0) {
	          menuTarget.push(menuItem);
	        }
	      });
	    },
	    toggleUserMenu: function toggleUserMenu(menu) {
	      if (this.menuActive != menu.id) {
	        this.menuActive = menu.id;
	      } else {
	        this.menuActive = '';
	      }
	    }
	  }
	};

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _HeaderUtils = __webpack_require__(87);
	
	var _HeaderUtils2 = _interopRequireDefault(_HeaderUtils);
	
	var _UtilsService = __webpack_require__(9);
	
	var _UtilsService2 = _interopRequireDefault(_UtilsService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['meuCollapse'],
	  data: function data() {
	    return {
	      menus: []
	    };
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['userLoggedRoles'])),
	  mounted: function mounted() {
	    var _this = this;
	
	    _HeaderUtils2.default.resolveContractMenu(this.$route.params).then(function (response) {
	      _this.buildMenu(_this.userLoggedRoles, response.menu, _this.menus);
	    });
	  },
	  methods: {
	    buildMenu: function buildMenu(roles, menuSource, menuTarget) {
	      var _this2 = this;
	
	      menuSource.map(function (it) {
	
	        var menuItem = {
	          id: it.id,
	          labelPt: it.labelPt,
	          type: it.type,
	          formId: it.formId ? it.formId : null,
	          childs: [],
	          form: {
	            availableInMobile: it.form.availableInMobile,
	            availableInWeb: it.form.availableInWeb
	          }
	        };
	
	        _this2.buildMenu(roles, it.childs, menuItem.childs);
	
	        if (menuItem.type == 'FORM' && _UtilsService2.default.hasRole(roles, it.formId) && it.form.availableInWeb) {
	          menuTarget.push(menuItem);
	        } else if (menuItem.childs.length > 0) {
	          menuTarget.push(menuItem);
	        }
	      });
	    },
	    toggleUserMenu: function toggleUserMenu(menu) {
	      if (this.menuActive != menu.id) {
	        this.menuActive = menu.id;
	      } else {
	        this.menuActive = '';
	      }
	    },
	
	    openNivel: function openNivel(id) {
	      var className = document.getElementById(id).parentElement.className;
	      if (className.indexOf("open") > -1) {
	        document.getElementById(id).parentElement.className = "dropdown";
	      } else {
	        document.getElementById(id).parentElement.className = "dropdown open";
	      }
	    }
	  }
	};

/***/ }),
/* 472 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      header: true,
	      footer: true
	    };
	  },
	  mounted: function mounted() {
	    this.header = this.$slots['header'] ? true : false;
	    this.footer = this.$slots['footer'] ? true : false;
	  }
	};

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['title', 'subtitle', 'fluid'],
	  data: function data() {
	    return {};
	  },
	
	  components: {}
	};

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _directive = __webpack_require__(146);
	
	var _directive2 = _interopRequireDefault(_directive);
	
	var _options = __webpack_require__(70);
	
	var _options2 = _interopRequireDefault(_options);
	
	var _utils = __webpack_require__(147);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Money',
	  props: {
	    value: {
	      required: true,
	      type: [Number, String],
	      default: 0
	    },
	    masked: {
	      type: Boolean,
	      default: false
	    },
	    precision: {
	      type: Number,
	      default: function _default() {
	        return _options2.default.precision;
	      }
	    },
	    decimal: {
	      type: String,
	      default: function _default() {
	        return _options2.default.decimal;
	      }
	    },
	    thousands: {
	      type: String,
	      default: function _default() {
	        return _options2.default.thousands;
	      }
	    },
	    prefix: {
	      type: String,
	      default: function _default() {
	        return _options2.default.prefix;
	      }
	    },
	    suffix: {
	      type: String,
	      default: function _default() {
	        return _options2.default.suffix;
	      }
	    }
	  },
	
	  directives: { money: _directive2.default },
	
	  data: function data() {
	    return {
	      formattedValue: ''
	    };
	  },
	
	
	  watch: {
	    value: {
	      immediate: true,
	      handler: function handler(newValue, oldValue) {
	        var formatted = (0, _utils.format)(newValue, this.$props);
	        if (formatted !== this.formattedValue) {
	          this.formattedValue = formatted;
	        }
	      }
	    }
	  },
	
	  methods: {
	    change: function change(evt) {
	      this.$emit('input', this.masked ? evt.target.value : (0, _utils.unformat)(evt.target.value, this.precision));
	    }
	  }
	};

/***/ }),
/* 475 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    props: ["errors"],
	    data: function data() {
	        return {
	            messages: []
	        };
	    },
	
	    watch: {
	        'errors': function errors(val, oldVal) {
	
	            var self = this;
	            self.messages = [];
	
	            var i;
	            for (i in val) {
	                self.messages.push(val[i].message);
	            }
	        }
	    }
	};

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["value", "type"],
	  methods: {
	    formatField: function formatField() {
	      return _SgsUtils2.default.formatField(this.value, this.type);
	    },
	    validValue: function validValue() {
	      var fieldValue = this.formatField();
	
	      return fieldValue !== '' && fieldValue !== undefined && fieldValue !== null;
	    }
	  }
	};

/***/ }),
/* 477 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ["mask", "placeholder", "value", "attr"],
	  computed: {
	    _value: {
	      get: function get() {
	        return this.value;
	      },
	      set: function set(newValue) {
	        this.$emit('input', newValue.replace(/\D/g, ""));
	      }
	    }
	  },
	  methods: {
	    callBusinessRuleFocus: function callBusinessRuleFocus() {
	      if (this.attr.eventOnFocus) {
	        this.$emit('callBusinessRule', this.attr.eventOnFocus);
	      }
	    },
	    callBusinessRuleBlur: function callBusinessRuleBlur() {
	      if (this.attr.eventOnBlur) {
	        this.$emit('callBusinessRule', this.attr.eventOnBlur);
	      }
	    },
	    classToDivBeforeInput: function classToDivBeforeInput() {
	      if (this.attr.disableField) {
	        return "el-input is-disabled";
	      }
	      return "el-input";
	    }
	  }
	};

/***/ }),
/* 478 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    props: ["pagination"],
	    data: function data() {
	        return {
	            currentPage: '',
	            pagesTotal: [],
	            itemsPerPageSelected: '',
	            itemsPerPageOptions: [10, 25, 50, 100]
	        };
	    },
	
	    computed: {
	        showPreviousButton: function showPreviousButton() {
	            var self = this;
	            return self.pagination.page !== 1;
	        },
	        showNextButton: function showNextButton() {
	            var self = this;
	            return self.pagination.page !== self.pagination.totalPage;
	        },
	        totalPages: function totalPages() {
	
	            var self = this;
	            var arr = [];
	
	            if (self.pagination.totalPage > 20) {
	
	                for (var i = 1; i <= 10; i++) {
	                    arr.push(i);
	                }
	
	                for (var i = self.pagination.totalPage - 10; i <= self.pagination.totalPage; i++) {
	                    arr.push(i);
	                }
	            } else {
	
	                for (var i = 1; i <= self.pagination.totalPage; i++) {
	                    arr.push(i);
	                }
	            }
	
	            return arr;
	        }
	    },
	    watch: {
	        pagination: function pagination(val, oldVal) {
	            if (val.totalCount) {
	                var self = this;
	                self.currentPage = val.page;
	                self.itemsPerPageSelected = val.perPage;
	            }
	        }
	    },
	    methods: {
	
	        changePage: function changePage(page) {
	            var self = this;
	            if (page !== self.pagination.page) {
	                self.$emit('change-page', page);
	            }
	        },
	
	        changeItemsPerPage: function changeItemsPerPage() {
	            var self = this;
	            if (self.itemsPerPageSelected !== self.pagination.perPage) {
	                self.$emit('change-items-per-page', self.itemsPerPageSelected);
	            }
	        }
	    },
	    mounted: function mounted() {
	        var self = this;
	        if (self.pagination && self.pagination.page) {
	            self.currentPage = self.pagination.page;
	            self.itemsPerPageSelected = self.pagination.perPage;
	        }
	    }
	};

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(3);
	
	var _ApiService = __webpack_require__(30);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["label", "src", "router", "height"]
	};

/***/ }),
/* 480 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ["value"],
	  methods: {
	    resolveType: function resolveType() {
	
	      var labels = {
	        'true': this.$t('yes'),
	        'false': this.$t('no')
	      };
	
	      return labels[this.value];
	    }
	  }
	};

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _ApiService = __webpack_require__(30);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["payload", "callback"],
	  components: {},
	  data: function data() {
	    return {
	      showDialog: true,
	
	      gridData: [],
	      filter: '',
	      uriFilter: {
	        itemsPerPage: 100,
	        currentPage: 1
	      },
	      localObject: {}
	    };
	  },
	
	  watch: {
	    filter: function filter(val) {
	      if (val.length > 2 || val == "") {
	        this.load();
	      }
	    },
	    showModal: function showModal(val) {
	      if (val) {
	        this.filter = '';
	        this.load();
	      }
	    }
	  },
	  methods: {
	    closeModal: function closeModal() {
	      this.showModal = false;
	      this.$emit('autoCompleteClose');
	    },
	    selectRow: function selectRow(row) {
	      this.callback(row);
	      this.closeModal();
	    },
	    load: function load() {
	      var _this = this;
	
	      var data = this._uriFilterList;
	
	      data._ = {
	        formId: this.formIdentifier.formId,
	        fieldId: this.attr.id
	      };
	
	      var instanceConfig = this.instance && this.instance._config ? this.instance._config[this.attr.columnName] : null;
	
	      if (instanceConfig != undefined) {
	        if (instanceConfig.dependsOfSource != undefined) {
	          this.attr.dependsOfSource = instanceConfig.dependsOfSource;
	        }
	        if (instanceConfig.dependsOfTarget != undefined) {
	          this.attr.dependsOfTarget = instanceConfig.dependsOfTarget;
	        }
	      }
	
	      if (this.instance && this.attr && this.attr.dependsOfSource && this.attr.dependsOfTarget && this.instance[this.attr.dependsOfSource]) {
	
	        data._.dependsOfTarget = this.attr.dependsOfTarget;
	        data._.dependsOfQuery = this.instance[this.attr.dependsOfSource];
	      }
	
	      return _ApiService2.default.post({
	        uri: this.attr.uri,
	        data: data,
	        excludeApi: true
	      }).then(function (response) {
	        _this.gridData = response.data;
	      });
	    }
	  },
	  computed: {
	    attr: function attr() {
	      if (this.payload) {
	        return this.payload.attr;
	      }
	      return [];
	    },
	    formIdentifier: function formIdentifier() {
	      if (this.payload) {
	        return this.payload.formIdentifier;
	      }
	    },
	    instance: function instance() {
	      if (this.payload) {
	        return this.payload.instance;
	      } else {
	        return _config = {};
	      }
	    },
	    getTitle: function getTitle() {
	      return _SgsUtils2.default.getLabel({
	        attr: this.attr,
	        locale: this.$i18n.locale,
	        label: ""
	      });
	    },
	    _uriFilterList: function _uriFilterList() {
	      var _this2 = this;
	
	      var newObj = (0, _assign2.default)({}, this.uriFilter);
	
	      if (this.attr) {
	
	        var uriFilterList = this.attr.uriFilterList;
	        var uriFilterListEs = this.attr.uriFilterListEs;
	        var uriFilterListEn = this.attr.uriFilterListEn;
	
	        if (this.$i18n.locale == 'es' && uriFilterListEs.length > 0) {
	          uriFilterList = uriFilterListEs;
	        } else if (this.$i18n.locale == 'en' && uriFilterListEn.length > 0) {
	          uriFilterList = uriFilterListEn;
	        }
	
	        if (uriFilterList) {
	          uriFilterList.map(function (item) {
	            newObj[item] = _this2.filter;
	          });
	        }
	      }
	
	      return newObj;
	    },
	    _columnsToShow: function _columnsToShow() {
	
	      var list = [];
	
	      var columnsToShow = this.attr.columnsToShow;
	      var columnsToShowAttr = this.attr.columnsToShowAttr;
	
	      if (this.$i18n.locale == 'es' && this.attr.columnLabelEs) {
	        columnsToShow = this.attr.columnsToShowEs;
	        columnsToShowAttr = this.attr.columnsToShowEsAttr;
	      } else if (this.$i18n.locale == 'en' && this.attr.columnLabelEn) {
	        columnsToShow = this.attr.columnsToShowEn;
	        columnsToShowAttr = this.attr.columnsToShowEnAttr;
	      }
	
	      _.forOwn(columnsToShow, function (value, key) {
	
	        var label = key;
	
	        var itemToAdd = {
	          label: value,
	          value: key,
	          attr: columnsToShowAttr[key]
	        };
	
	        list.push(itemToAdd);
	      });
	      return list;
	    }
	  },
	  mounted: function mounted() {
	    this.load();
	  },
	  created: function created() {}
	};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	var _SgsRenderHeader = __webpack_require__(837);
	
	var _SgsRenderHeader2 = _interopRequireDefault(_SgsRenderHeader);
	
	var _SgsRenderInputText = __webpack_require__(861);
	
	var _SgsRenderInputText2 = _interopRequireDefault(_SgsRenderInputText);
	
	var _SgsRenderInputNumber = __webpack_require__(857);
	
	var _SgsRenderInputNumber2 = _interopRequireDefault(_SgsRenderInputNumber);
	
	var _SgsRenderInputDate = __webpack_require__(850);
	
	var _SgsRenderInputDate2 = _interopRequireDefault(_SgsRenderInputDate);
	
	var _SgsRenderInputDateTime = __webpack_require__(851);
	
	var _SgsRenderInputDateTime2 = _interopRequireDefault(_SgsRenderInputDateTime);
	
	var _SgsRenderInputTime = __webpack_require__(863);
	
	var _SgsRenderInputTime2 = _interopRequireDefault(_SgsRenderInputTime);
	
	var _SgsRenderInputSelect = __webpack_require__(860);
	
	var _SgsRenderInputSelect2 = _interopRequireDefault(_SgsRenderInputSelect);
	
	var _SgsRenderInputMultiSelect = __webpack_require__(856);
	
	var _SgsRenderInputMultiSelect2 = _interopRequireDefault(_SgsRenderInputMultiSelect);
	
	var _SgsRenderInputTextArea = __webpack_require__(862);
	
	var _SgsRenderInputTextArea2 = _interopRequireDefault(_SgsRenderInputTextArea);
	
	var _SgsRenderInputButtonUpload = __webpack_require__(840);
	
	var _SgsRenderInputButtonUpload2 = _interopRequireDefault(_SgsRenderInputButtonUpload);
	
	var _SgsRenderInputPassword = __webpack_require__(858);
	
	var _SgsRenderInputPassword2 = _interopRequireDefault(_SgsRenderInputPassword);
	
	var _SgsRenderInputCpf = __webpack_require__(843);
	
	var _SgsRenderInputCpf2 = _interopRequireDefault(_SgsRenderInputCpf);
	
	var _SgsRenderInputCnpj = __webpack_require__(842);
	
	var _SgsRenderInputCnpj2 = _interopRequireDefault(_SgsRenderInputCnpj);
	
	var _SgsRenderInputEmail = __webpack_require__(853);
	
	var _SgsRenderInputEmail2 = _interopRequireDefault(_SgsRenderInputEmail);
	
	var _SgsRenderInputCurrency = __webpack_require__(845);
	
	var _SgsRenderInputCurrency2 = _interopRequireDefault(_SgsRenderInputCurrency);
	
	var _SgsRenderLabelAndValue = __webpack_require__(865);
	
	var _SgsRenderLabelAndValue2 = _interopRequireDefault(_SgsRenderLabelAndValue);
	
	var _SgsRenderInputBoolean = __webpack_require__(839);
	
	var _SgsRenderInputBoolean2 = _interopRequireDefault(_SgsRenderInputBoolean);
	
	var _SgsRenderInputDataWrapper = __webpack_require__(849);
	
	var _SgsRenderInputDataWrapper2 = _interopRequireDefault(_SgsRenderInputDataWrapper);
	
	var _SgsRenderButton = __webpack_require__(828);
	
	var _SgsRenderButton2 = _interopRequireDefault(_SgsRenderButton);
	
	var _SgsRenderErrorList = __webpack_require__(68);
	
	var _SgsRenderErrorList2 = _interopRequireDefault(_SgsRenderErrorList);
	
	var _SgsRenderInputFilterText = __webpack_require__(854);
	
	var _SgsRenderInputFilterText2 = _interopRequireDefault(_SgsRenderInputFilterText);
	
	var _SgsRenderCollapse = __webpack_require__(54);
	
	var _SgsRenderCollapse2 = _interopRequireDefault(_SgsRenderCollapse);
	
	var _SgsRenderInputPhoneNumber = __webpack_require__(859);
	
	var _SgsRenderInputPhoneNumber2 = _interopRequireDefault(_SgsRenderInputPhoneNumber);
	
	var _SgsRenderImage = __webpack_require__(838);
	
	var _SgsRenderImage2 = _interopRequireDefault(_SgsRenderImage);
	
	var _SgsRenderInputHidden = __webpack_require__(855);
	
	var _SgsRenderInputHidden2 = _interopRequireDefault(_SgsRenderInputHidden);
	
	var _SgsRenderDashboard = __webpack_require__(832);
	
	var _SgsRenderDashboard2 = _interopRequireDefault(_SgsRenderDashboard);
	
	var _SgsRenderLabel = __webpack_require__(864);
	
	var _SgsRenderLabel2 = _interopRequireDefault(_SgsRenderLabel);
	
	var _SgsRenderGrid = __webpack_require__(836);
	
	var _SgsRenderGrid2 = _interopRequireDefault(_SgsRenderGrid);
	
	var _SgsRenderMap = __webpack_require__(866);
	
	var _SgsRenderMap2 = _interopRequireDefault(_SgsRenderMap);
	
	var _SgsRenderInputDealership = __webpack_require__(852);
	
	var _SgsRenderInputDealership2 = _interopRequireDefault(_SgsRenderInputDealership);
	
	var _SgsRenderInputCharges = __webpack_require__(841);
	
	var _SgsRenderInputCharges2 = _interopRequireDefault(_SgsRenderInputCharges);
	
	var _SgsRenderButtonReport = __webpack_require__(347);
	
	var _SgsRenderButtonReport2 = _interopRequireDefault(_SgsRenderButtonReport);
	
	var _SgsRenderInputCsv = __webpack_require__(844);
	
	var _SgsRenderInputCsv2 = _interopRequireDefault(_SgsRenderInputCsv);
	
	var _SgsRenderTextEditor = __webpack_require__(867);
	
	var _SgsRenderTextEditor2 = _interopRequireDefault(_SgsRenderTextEditor);
	
	var _SgsRenderFloat = __webpack_require__(835);
	
	var _SgsRenderFloat2 = _interopRequireDefault(_SgsRenderFloat);
	
	var _SgsRenderButtonForm = __webpack_require__(346);
	
	var _SgsRenderButtonForm2 = _interopRequireDefault(_SgsRenderButtonForm);
	
	var _SgsRenderButtonPrint = __webpack_require__(830);
	
	var _SgsRenderButtonPrint2 = _interopRequireDefault(_SgsRenderButtonPrint);
	
	var _SgsRenderButtonPDF = __webpack_require__(829);
	
	var _SgsRenderButtonPDF2 = _interopRequireDefault(_SgsRenderButtonPDF);
	
	var _SgsRenderCustomComponent = __webpack_require__(831);
	
	var _SgsRenderCustomComponent2 = _interopRequireDefault(_SgsRenderCustomComponent);
	
	var _SgsRenderFilterBoolean = __webpack_require__(834);
	
	var _SgsRenderFilterBoolean2 = _interopRequireDefault(_SgsRenderFilterBoolean);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["type", "attr", "fieldValue", "labelOnly", "rules", "formIdentifier", "moduleType", "instance", "attrConfig"],
	  components: {
	    SgsRenderHeader: _SgsRenderHeader2.default,
	    SgsRenderInputText: _SgsRenderInputText2.default,
	    SgsRenderInputNumber: _SgsRenderInputNumber2.default,
	    SgsRenderInputDate: _SgsRenderInputDate2.default,
	    SgsRenderInputDateTime: _SgsRenderInputDateTime2.default,
	    SgsRenderInputTime: _SgsRenderInputTime2.default,
	    SgsRenderInputSelect: _SgsRenderInputSelect2.default,
	    SgsRenderInputMultiSelect: _SgsRenderInputMultiSelect2.default,
	    SgsRenderInputTextArea: _SgsRenderInputTextArea2.default,
	    SgsRenderInputButtonUpload: _SgsRenderInputButtonUpload2.default,
	    SgsRenderInputPassword: _SgsRenderInputPassword2.default,
	    SgsRenderInputCpf: _SgsRenderInputCpf2.default,
	    SgsRenderInputCnpj: _SgsRenderInputCnpj2.default,
	    SgsRenderInputEmail: _SgsRenderInputEmail2.default,
	    SgsRenderInputCurrency: _SgsRenderInputCurrency2.default,
	    SgsRenderInputBoolean: _SgsRenderInputBoolean2.default,
	    SgsRenderLabelAndValue: _SgsRenderLabelAndValue2.default,
	    SgsRenderInputDataWrapper: _SgsRenderInputDataWrapper2.default,
	    SgsRenderButton: _SgsRenderButton2.default,
	    SgsRenderErrorList: _SgsRenderErrorList2.default,
	    SgsRenderInputFilterText: _SgsRenderInputFilterText2.default,
	    SgsRenderCollapse: _SgsRenderCollapse2.default,
	    SgsRenderInputPhoneNumber: _SgsRenderInputPhoneNumber2.default,
	    SgsRenderImage: _SgsRenderImage2.default,
	    SgsRenderInputHidden: _SgsRenderInputHidden2.default,
	    SgsRenderDashboard: _SgsRenderDashboard2.default,
	    SgsRenderLabel: _SgsRenderLabel2.default,
	    SgsRenderGrid: _SgsRenderGrid2.default,
	    SgsRenderMap: _SgsRenderMap2.default,
	    SgsRenderInputDealership: _SgsRenderInputDealership2.default,
	    SgsRenderInputCharges: _SgsRenderInputCharges2.default,
	    SgsRenderButtonReport: _SgsRenderButtonReport2.default,
	    SgsRenderInputCsv: _SgsRenderInputCsv2.default,
	    SgsRenderTextEditor: _SgsRenderTextEditor2.default,
	    SgsRenderFloat: _SgsRenderFloat2.default,
	    SgsRenderButtonForm: _SgsRenderButtonForm2.default,
	    SgsRenderButtonPrint: _SgsRenderButtonPrint2.default,
	    SgsRenderButtonPDF: _SgsRenderButtonPDF2.default,
	    SgsRenderCustomComponent: _SgsRenderCustomComponent2.default,
	    SgsRenderFilterBoolean: _SgsRenderFilterBoolean2.default
	  },
	  methods: {
	    updateField: function updateField(fieldName, fieldValue) {
	      this.$emit('input', fieldName, fieldValue);
	    },
	    actionLinkSelected: function actionLinkSelected(formId, dataRow) {
	      this.$emit('actionLinkSelected', formId, dataRow);
	    },
	    callBusinessRule: function callBusinessRule(businessRuleId) {
	      this.$emit('callBusinessRule', businessRuleId);
	    },
	    showHint: function showHint() {
	      return this.attr.hintPt != undefined && this.attr.hintPt != "";
	    },
	    getHint: function getHint() {
	      return _SgsUtils2.default.getHint({
	        attr: this.attr,
	        locale: this.$i18n.locale
	      });
	    },
	    implementedHint: function implementedHint() {
	      var listImplementeds = ['text'];
	
	      return listImplementeds.indexOf(this.type) > -1;
	    },
	    getLabel: function getLabel() {
	      return _SgsUtils2.default.getLabel({
	        attr: this.attr,
	        locale: this.$i18n.locale,
	        label: ""
	      });
	    },
	    getPlaceholder: function getPlaceholder() {
	      return _SgsUtils2.default.getPlaceholder(this.attr, this.$i18n.locale);
	    },
	    getModuleType: function getModuleType() {
	      if (this.moduleType === undefined) {
	        return 'form';
	      }
	      return this.moduleType;
	    }
	  },
	  watch: {
	    "attrConfig": function attrConfig(newVal, oldVal) {
	      var _this = this;
	
	      if (newVal != undefined && this.attr != undefined) {
	        _.forOwn(newVal, function (value, key) {
	          _this.$set(_this.attr, key, value);
	        });
	      }
	    },
	    "instance._updated": function instance_updated(newVal, oldVal) {
	
	      if (this.instance !== undefined && this.instance._config !== undefined && this.instance._config[this.attr.columnName] !== undefined) {
	        if (this.instance._config[this.attr.columnName].disableField !== undefined) {
	          this.attr.disableField = this.instance._config[this.attr.columnName].disableField;
	        }
	        if (this.instance._config[this.attr.columnName].showInForm !== undefined) {
	          this.attr.showInForm = this.instance._config[this.attr.columnName].showInForm;
	        }
	        if (this.instance._config[this.attr.columnName].showInDetails !== undefined) {
	          this.attr.showInDetails = this.instance._config[this.attr.columnName].showInDetails;
	        }
	        if (this.instance._config[this.attr.columnName].labelPt !== undefined) {
	          this.attr.labelPt = this.instance._config[this.attr.columnName].labelPt;
	        }
	        if (this.instance._config[this.attr.columnName].labelEs !== undefined) {
	          this.attr.labelEs = this.instance._config[this.attr.columnName].labelEs;
	        }
	        if (this.instance._config[this.attr.columnName].labelEn !== undefined) {
	          this.attr.labelEn = this.instance._config[this.attr.columnName].labelEn;
	        }
	        if (this.instance._config[this.attr.columnName].dependsOfSource !== undefined) {
	          this.attr.dependsOfSource = this.instance._config[this.attr.columnName].dependsOfSource;
	        }
	        if (this.instance._config[this.attr.columnName].dependsOfTarget !== undefined) {
	          this.attr.dependsOfTarget = this.instance._config[this.attr.columnName].dependsOfTarget;
	        }
	      }
	    }
	  },
	  computed: {
	    showSgsRenderGrid: function showSgsRenderGrid() {
	      if (this.attr.type === 'grid' && this.attr.showInForm !== undefined) {
	        return this.attr.showInForm;
	      }
	      return true;
	    },
	    showSgsRender: function showSgsRender() {
	
	      var ret = false;
	
	      if (this.moduleType === undefined) {
	        return true;
	      }
	
	      if (this.attr.type !== undefined) {
	
	        if (this.moduleType === 'form') {
	          if (this.attr.showInForm !== undefined && this.attr.type !== 'grid') {
	            ret = this.attr.showInForm;
	          } else {
	            ret = true;
	          }
	        } else if (this.moduleType === 'show') {
	          if (this.attr.showInDetails !== undefined) {
	
	            ret = this.attr.showInDetails;
	          } else {
	            ret = true;
	          }
	        } else if (this.moduleType === 'list') {
	          if (this.attr.type !== undefined) {
	            ret = true;
	          } else {
	            ret = false;
	          }
	        }
	      }
	
	      return ret;
	    },
	    addClass: function addClass() {
	      var myClass = "";
	      if (this.attr.hideOnPrint) {
	        myClass += "noPrint ";
	      }
	      if (this.attr.type == "buttonReport" || this.attr.type == "inputCSV" || this.attr.type == "file" || this.attr.type == "buttonForm" || this.attr.type == "buttonPrint" || this.attr.type == "buttonPDF" || this.attr.type == "button") {
	        myClass += "displayInline ";
	      }
	      return myClass;
	    }
	  }
	};

/***/ }),
/* 483 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ["attr", "fieldValue", "label"],
	  methods: {
	    callBusinessRule: function callBusinessRule() {
	      if (this.attr.eventOnClick) {
	        this.$emit('callBusinessRule', this.attr.eventOnClick);
	      }
	    }
	  },
	  computed: {
	    alingButton: function alingButton() {
	      if (this.attr.alingButton) {
	        return "marginTop25px";
	      }
	      return "";
	    }
	  }
	};

/***/ }),
/* 484 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ["formId", "label", "instance", "attr"],
	  data: function data() {
	    return {};
	  },
	
	  methods: {
	    openForm: function openForm() {
	      this.$emit('actionLinkSelected', this.formId, this.instance);
	    }
	  },
	  computed: {
	    alingButton: function alingButton() {
	      if (this.attr != undefined && this.attr.alingButton) {
	        return "marginTop25px";
	      }
	      return "";
	    },
	    resolveDisable: function resolveDisable() {
	      if (this.attr != undefined && this.attr.disableField) {
	        return attr.disableField;
	      }
	      return false;
	    }
	  }
	};

/***/ }),
/* 485 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ["attr", "label", "instance"],
	  methods: {
	    callBusinessRule: function callBusinessRule() {
	      if (this.attr.businessRule) {
	        this.$eventBus.$emit('export-pdf', this.attr.businessRule, this.instance);
	      }
	    }
	  },
	  computed: {
	    alingButton: function alingButton() {
	      if (this.attr.alingButton) {
	        return "marginTop25px";
	      }
	      return "";
	    }
	  }
	};

/***/ }),
/* 486 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ["attr", "label"],
	  methods: {
	    callPrint: function callPrint() {
	
	      window.print();
	    }
	  },
	  computed: {
	    alingButton: function alingButton() {
	      if (this.attr.alingButton) {
	        return "marginTop25px";
	      }
	      return "";
	    }
	  }
	};

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ModuleUtils = __webpack_require__(7);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	var _vuex = __webpack_require__(3);
	
	var _SgsRenderNotificationSuccess = __webpack_require__(28);
	
	var _SgsRenderNotificationSuccess2 = _interopRequireDefault(_SgsRenderNotificationSuccess);
	
	var _SgsRenderNotificationError = __webpack_require__(27);
	
	var _SgsRenderNotificationError2 = _interopRequireDefault(_SgsRenderNotificationError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "formIdentifier", "instance", "label"],
	  data: function data() {
	    return {
	      notificationError: null,
	      notificationSuccess: null
	    };
	  },
	
	  components: {
	    SgsRenderNotificationSuccess: _SgsRenderNotificationSuccess2.default,
	    SgsRenderNotificationError: _SgsRenderNotificationError2.default
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['showLoader', 'hideLoader']), {
	    callBusinessRule: function callBusinessRule() {
	      if (this.attr.eventOnClick) {
	        this.$emit('callBusinessRule', this.attr.eventOnClick);
	      }
	    },
	    returnNewFormIdentifier: function returnNewFormIdentifier(formId) {
	      var formIdentifier = (0, _assign2.default)({}, this.formIdentifier);
	      formIdentifier.formId = formId;
	
	      return formIdentifier;
	    },
	    generateReport: function generateReport() {
	      var _this = this;
	
	      this.showLoader();
	
	      _ModuleUtils2.default.moduleFormGenerateReport(this.returnNewFormIdentifier(this.attr.formId), this.instance, true).then(function (response) {
	
	        _this.hideLoader();
	
	        if (response.body) {
	          _this.notificationError = response.body.notificationError;
	          _this.notificationSuccess = response.body.notificationSuccess;
	        }
	
	        if (response.meta.code == 400) {
	
	          _.forOwn(response.body.instance, function (value, key) {
	            _this.$set(_this.instance, key, value);
	          });
	        } else if (response.meta.code == 500) {
	
	          _this.$notify({
	            title: 'Error',
	            message: _this.$t('anUnexpectedErrorOccurred') + ' ' + response.error,
	            type: 'error'
	          });
	        }
	      });
	    }
	  }),
	  computed: {
	    alingButton: function alingButton() {
	      if (this.attr.alingButton) {
	        return "marginTop25px";
	      }
	      return "";
	    }
	  }
	};

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(19);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _data$computed$props$;
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_data$computed$props$ = {
	  data: function data() {
	    return {
	      meuCollapse: "true"
	    };
	  },
	
	  computed: {
	    _rows: function _rows() {
	      if (this.attr) {
	        return this.attr.rows;
	      }
	      return [];
	    }
	  },
	  props: ["attr", "moduleType", "instance", "label"]
	}, (0, _defineProperty3.default)(_data$computed$props$, "computed", {
	  showCollapse: function showCollapse() {
	    var ret = true;
	    if (this.moduleType === 'form' || this.moduleType === undefined) {
	      if (this.attr.showInForm !== null && this.attr.showInForm !== undefined && this.attr.showInForm !== '') {
	        ret = this.attr.showInForm;
	      }
	    } else if (this.moduleType === 'show') {
	      if (this.attr.showInDetails !== null && this.attr.showInDetails !== undefined && this.attr.showInDetails !== '') {
	        ret = this.attr.showInDetails;
	      }
	    }
	
	    return ret;
	  },
	  getValue: function getValue() {
	    if (this.attr !== undefined && this.attr.open !== undefined) {
	      return this.attr.open.toString();
	    }
	    return '';
	  },
	  hideFieldOnPrint: function hideFieldOnPrint() {
	    if (this.attr.hideOnPrint) {
	      return "noPrint";
	    }
	    return "";
	  }
	}), (0, _defineProperty3.default)(_data$computed$props$, "watch", {
	  "instance._updated": function instance_updated(newVal, oldVal) {
	    if (this.instance._config[this.attr.columnName].showInForm !== undefined) {
	      this.attr.showInForm = this.instance._config[this.attr.columnName].showInForm;
	    }
	  }
	}), (0, _defineProperty3.default)(_data$computed$props$, "methods", {
	  getIcon: function getIcon() {
	    return "glyphicon glyphicon-" + this.attr.icon;
	  },
	  getName: function getName() {
	    return _SgsUtils2.default.getLabel({
	      attr: this.attr,
	      locale: this.$i18n.locale,
	      label: ""
	    });
	  }
	}), _data$computed$props$);

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(3);
	
	var _ModuleUtils = __webpack_require__(7);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "instance", "formIdentifier"],
	  data: function data() {
	    return {
	      currentView: '',
	      params: {
	        instance: null
	      }
	    };
	  },
	
	  components: {},
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['showLoader', 'hideLoader']), {
	    callBusinessRule: function callBusinessRule(instance, businessRuleId) {
	      var _this = this;
	
	      this.showLoader();
	
	      _ModuleUtils2.default.callBusinessRule(this.formIdentifier, instance, businessRuleId).then(function (response) {
	        _this.hideLoader();
	
	        _.forOwn(response.body.instance, function (value, key) {
	          _this.$set(instance, key, value);
	        });
	
	        if (response.body.notificationError != null) {
	          _this.$eventBus.$emit('notification-error', response.body.notificationError);
	        }
	
	        if (response.body.notificationSuccess != null) {
	          _this.$eventBus.$emit('notification-success', response.body.notificationSuccess);
	        }
	      });
	    }
	  }),
	  computed: {},
	  mounted: function mounted() {
	    if (this.attr.template) {
	
	      this.params.urlAttachment = _ModuleUtils2.default.resolveFormDesc(this.formIdentifier) + "/attachment";
	
	      this.params.instance = this.instance;
	      this.params.userLanguage = this.$i18n.locale;
	
	      var vueJson = eval('(' + this.attr.script + ')');
	      vueJson.template = this.attr.template;
	
	      var customDynamicComponentName = "customDynamicComponent_" + Math.floor(Math.random() * 1000 + 1);
	
	      _vue2.default.component(customDynamicComponentName, vueJson);
	      this.currentView = customDynamicComponentName;
	    }
	  }
	};

/***/ }),
/* 490 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ["attr", "fieldValue"],
	  computed: {
	    _fieldValue: function _fieldValue() {
	      if (this.fieldValue !== undefined && this.fieldValue !== '') {
	        return this.fieldValue;
	      }
	      return {};
	    },
	    showDashBoard: function showDashBoard() {
	      return this.fieldValue !== undefined && this.fieldValue !== '';
	    },
	    marginStyle: function marginStyle() {
	      return "padding-top: " + this.attr.marginTop + "px;" + "padding-bottom: " + this.attr.marginBottom + "px;" + "padding-right: " + this.attr.marginRight + "px;" + "padding-left: " + this.attr.marginLeft + "px;";
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var timer = this.attr.timer;
	    var businessRule = this.attr.businessRuleId;
	
	    if (this.attr.businessRuleId) {
	      this.$emit('callBusinessRule', businessRule);
	      if (timer) {
	        setInterval(function () {
	          _this.$emit('callBusinessRule', businessRule);
	        }, timer + "000");
	      }
	    }
	  }
	};

/***/ }),
/* 491 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ["fieldValue"],
	  data: function data() {
	    return {
	      messages: []
	    };
	  },
	
	  watch: {
	    'fieldValue': function fieldValue(val) {
	      var _this = this;
	
	      this.messages = [];
	
	      val.map(function (it) {
	        _this.messages.push(it.pt);
	      });
	    }
	  }
	};

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vuex = __webpack_require__(3);
	
	var _ModuleUtils = __webpack_require__(7);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	var _http = __webpack_require__(35);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _FormBuilderUtils = __webpack_require__(18);
	
	var _FormBuilderUtils2 = _interopRequireDefault(_FormBuilderUtils);
	
	var _AppConfigService = __webpack_require__(11);
	
	var _AppConfigService2 = _interopRequireDefault(_AppConfigService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = __webpack_require__(1);
	
	exports.default = {
	  name: 'SgsRenderFile',
	  props: ["attr", "fieldValue", "formIdentifier", "moduleType", "label", "showHint", "hintValue", "instance"],
	  data: function data() {
	    return {
	      value: [],
	      fileList: [],
	      header: {
	        Authorization: ""
	      }
	    };
	  },
	
	  watch: {
	    fieldValue: function fieldValue(val) {
	      var _this = this;
	
	      val = val ? val : "";
	      if (val !== null && !Array.isArray(val) && val.length > 0) {
	        var list = JSON.parse(val);
	        this.updateFieldValue = list;
	        this.value = list;
	        list.map(function (it) {
	          if (it.attachmentStatus !== 'REMOVE') {
	            _this.fileList.push((0, _assign2.default)({}, it));
	          }
	        });
	      }
	    },
	    formIdentifier: function formIdentifier(val) {
	      this.url = _ModuleUtils2.default.resolveFormDesc(this.formIdentifier) + "/attachment";
	    }
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['loggedUser']), {
	    updateFieldValue: {
	      get: function get() {
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        if (this.attr && this.attr.columnName) {
	          this.$emit('updateFieldValue', this.attr.columnName, newValue);
	        } else if (this.instance) {
	          this.$emit('updateFieldValue', newValue, this.instance);
	        } else {
	          this.$emit('updateFieldValue', newValue);
	        }
	      }
	    }
	  }),
	  methods: {
	    resolveUrl: function resolveUrl(hash) {
	      var url = _ModuleUtils2.default.resolveFormDesc(this.formIdentifier) + "/attachment";
	      return hash ? url + "/" + hash : url;
	    },
	    onSuccess: function onSuccess(response, file, fileList) {
	      var _this2 = this;
	
	      if (response.meta.code == 500) {
	
	        this.$notify({
	          title: 'Error',
	          message: this.$t('sgs_render_file_error_upload') + ' ' + response.error,
	          type: 'error'
	        });
	      } else {
	
	        this.value.push(response.body);
	
	        if (_.differenceBy(this.value, [{ 'attachmentStatus': 'REMOVE' }], 'attachmentStatus').length === fileList.length) {
	          this.updateFieldValue = this.value;
	          this.fileList = [];
	          this.value.map(function (it) {
	            if (it.attachmentStatus !== 'REMOVE') {
	              _this2.fileList.push((0, _assign2.default)({}, it));
	            }
	          });
	        }
	      }
	    },
	    onRemoveFile: function onRemoveFile(file, fileList) {
	
	      var hash = file.hash;
	      var attachmentStatus = file.attachmentStatus;
	
	      var positionValue = _.findIndex(this.value, { 'hash': hash });
	      var positionFileList = _.findIndex(this.fileList, { 'hash': hash });
	
	      if (attachmentStatus === 'INVALID') {
	
	        _http2.default.delete(this.resolveUrl(hash));
	        this.value.splice(positionValue, 1);
	      } else if (attachmentStatus === 'VALID') {
	
	        this.value[positionValue].attachmentStatus = "REMOVE";
	
	        var objectOnPosition = (0, _assign2.default)({}, this.value[positionValue]);
	        objectOnPosition.attachmentStatus = "REMOVE";
	
	        this.value[positionValue] = objectOnPosition;
	      }
	
	      this.fileList.splice(positionFileList, 1);
	    },
	    urlDownloadFile: function urlDownloadFile(hash) {
	      return this.resolveUrl(hash);
	    },
	    downloadFile: function downloadFile(file) {
	      window.location.href = this.urlDownloadFile(file.hash);
	    }
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    this.header["Authorization"] = "Bearer " + this.loggedUser.access_token;
	    if (this.fieldValue !== null && !Array.isArray(this.fieldValue) && this.fieldValue.length > 0) {
	      var list = JSON.parse(this.fieldValue);
	      this.updateFieldValue = list;
	      this.value = list;
	      list.map(function (it) {
	        if (it.attachmentStatus !== 'REMOVE') {
	          _this3.fileList.push((0, _assign2.default)({}, it));
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "rules", "placeholder", "label", "showHint", "hintValue"],
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        this.$emit('updateFieldValue', this.attr.columnName, newValue);
	      }
	    },
	    options: function options() {
	      return [{ value: 'YES', label: this.$t('yes') }, { value: 'NO', label: this.$t('no') }];
	    }
	  }
	};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "rules", "placeholder", "label", "showHint", "hintValue", "moduleType"],
	  data: function data() {
	    return {
	      money: {
	        decimal: this.attr.decimalSeparator,
	        thousands: this.attr.thousandsSeparator,
	        precision: this.attr.decimalDigits
	      }
	    };
	  },
	  methods: {
	    getPrefix: function getPrefix() {
	      if (this.attr != undefined) {
	        if (this.attr.prefix != undefined && this.attr.prefix != "") {
	          return " " + this.attr.prefix + " ";
	        }
	      }
	    },
	    callBusinessRuleFocus: function callBusinessRuleFocus() {
	      if (this.attr.eventOnFocus) {
	        this.$emit('callBusinessRule', this.attr.eventOnFocus);
	      }
	    },
	    callBusinessRuleBlur: function callBusinessRuleBlur() {
	      if (this.attr.eventOnBlur) {
	        this.$emit('callBusinessRule', this.attr.eventOnBlur);
	      }
	    },
	    classToDivBeforeInput: function classToDivBeforeInput() {
	      if (this.attr.disableField) {
	        return "el-input is-disabled";
	      }
	      return "el-input";
	    },
	    formatValue: function formatValue(value) {
	
	      if (value != undefined) {
	
	        var decimalSeparator = this.attr.decimalSeparator;
	        var thousandsSeparator = this.attr.thousandsSeparator;
	        var decimalDigits = this.attr.decimalDigits;
	
	        var valueSplit = value.toString().split(".");
	
	        if (decimalDigits > 0) {
	
	          var _decimalValue = "";
	
	          if (valueSplit.length > 1) {
	            _decimalValue = valueSplit[1];
	          }
	
	          _decimalValue = _decimalValue.padEnd(decimalDigits, "0");
	          value = valueSplit[0] + "." + _decimalValue;
	        } else {
	          value = valueSplit[0];
	        }
	
	        valueSplit = value.toString().split(".");
	
	        var thousandValue = valueSplit[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
	        var decimalValue = valueSplit[1].toString();
	
	        return thousandValue + decimalSeparator + decimalValue;
	      }
	    }
	  },
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	
	        if (!isNaN(this.fieldValue) && this.fieldValue != undefined) {
	          return this.fieldValue;
	        }
	
	        return 0;
	      },
	      set: function set(newValue) {
	        this.$emit('updateFieldValue', this.attr.columnName, newValue);
	      }
	    }
	  },
	  created: function created() {
	    _SgsUtils2.default.resolveRules(this.attr, this.rules);
	  }
	};

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(2);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _ModuleUtils = __webpack_require__(7);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	var _SgsRenderNotificationSuccess = __webpack_require__(28);
	
	var _SgsRenderNotificationSuccess2 = _interopRequireDefault(_SgsRenderNotificationSuccess);
	
	var _SgsRenderNotificationError = __webpack_require__(27);
	
	var _SgsRenderNotificationError2 = _interopRequireDefault(_SgsRenderNotificationError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "formIdentifier", "fieldValue", "instance"],
	  data: function data() {
	    return {
	      notificationError: null,
	      notificationSuccess: null,
	      localDataTable: []
	    };
	  },
	
	  components: {
	    SgsRenderNotificationSuccess: _SgsRenderNotificationSuccess2.default,
	    SgsRenderNotificationError: _SgsRenderNotificationError2.default
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['showLoader', 'hideLoader']), {
	    renderIcon: function renderIcon(icon) {
	      return "glyphicon glyphicon-" + icon;
	    },
	    callBusinessRule: function callBusinessRule(businessRuleId, instance) {
	      var _this = this;
	
	      this.showLoader();
	
	      _ModuleUtils2.default.callBusinessRule(this.formIdentifier, instance, businessRuleId).then(function (response) {
	
	        _this.hideLoader();
	
	        _.forOwn(response.body.instance, function (value, key) {
	          _this.$set(instance, key, value);
	        });
	
	        _this.notificationError = response.body.notificationError;
	        _this.notificationSuccess = response.body.notificationSuccess;
	      });
	    },
	    actionButton: function actionButton(button, fieldsDataRow) {
	      if (button.type === 'ACTION' || !button.type) {
	        this.callBusinessRule(button.businessRule.id, fieldsDataRow);
	      } else if (button.type === 'REPORT') {
	        this.doGenerateReport(fieldsDataRow, button.form.id);
	      } else if (button.type === 'LINK') {
	        this.$emit('actionLinkSelected', button.form.id, fieldsDataRow);
	      }
	    },
	    doGenerateReport: function doGenerateReport(fieldsDataRow, formId) {
	      var _this2 = this;
	
	      this.showLoader();
	
	      var formIdentifier = (0, _assign2.default)({}, this.formIdentifier);
	      formIdentifier.formId = formId;
	
	      _ModuleUtils2.default.moduleFormGenerateReport(formIdentifier, fieldsDataRow, true).then(function (response) {
	
	        _this2.hideLoader();
	
	        _this2.notificationError = response.body.notificationError;
	        _this2.notificationSuccess = response.body.notificationSuccess;
	
	        if (response.meta.code == 400) {
	
	          _.forOwn(response.body.instance, function (value, key) {
	            _this2.$set(_this2.instance, key, value);
	          });
	        } else if (response.meta.code == 500) {
	
	          _this2.$notify({
	            title: 'Error',
	            message: _this2.$t('anUnexpectedErrorOccurred') + ' ' + response.error,
	            type: 'error'
	          });
	        }
	      });
	    },
	    returnBackgroundColor: function returnBackgroundColor(backgroundColor) {
	      if (backgroundColor) {
	        return "background-color: " + backgroundColor + "; color: white;";
	      }
	      return "";
	    },
	    handleSelectionChange: function handleSelectionChange(val) {
	      if (val.length > 0) {
	        this.instance[this.attr.columnName + "_selected"] = val;
	      }
	    },
	
	    differenceBetweenTwoArrays: function differenceBetweenTwoArrays(array1, array2) {
	      var listToReturn = [];
	
	      array1.forEach(function (item) {
	        var itemToAddOnList = _.find(array2, { 'id': item.id });
	
	        if (itemToAddOnList === undefined) {
	          listToReturn.push(item);
	        }
	      });
	
	      return listToReturn;
	    },
	    getHeader: function getHeader(header) {
	
	      var label = header.labelPt;
	
	      if (this.$i18n.locale == 'es' && header.labelEs) {
	        label = header.labelEs;
	      } else if (this.$i18n.locale == 'en' && header.labelEn) {
	        label = header.labelEn;
	      }
	
	      return label;
	    },
	    getButtonHint: function getButtonHint(button) {
	
	      var hint = button.hintPt;
	
	      if (this.$i18n.locale == 'es' && button.hintEs) {
	        hint = button.hintEs;
	      } else if (this.$i18n.locale == 'en' && button.hintEn) {
	        hint = button.hintEn;
	      }
	
	      return hint;
	    }
	  }),
	  watch: {
	    "fieldValue": function fieldValue(newVal, oldVal) {
	
	      this.localDataTable = [];
	      this.localDataTable = newVal;
	    }
	  },
	  computed: {
	    widthIcons: function widthIcons() {
	      var sizeOfColumnActions = this.attr.actions.length * 40;
	
	      if (sizeOfColumnActions < 100) {
	        return "100px";
	      }
	
	      return sizeOfColumnActions + "px";
	    },
	    getHeaders: function getHeaders() {
	      var _this3 = this;
	
	      var ret = [];
	
	      this.attr.headers.map(function (it) {
	
	        var visible = true;
	
	        if (_this3.$i18n.locale == 'pt' && it.visibleToPt != undefined) {
	          visible = it.visibleToPt;
	        } else if (_this3.$i18n.locale == 'es' && it.visibleToEs != undefined) {
	          visible = it.visibleToEs;
	        } else if (_this3.$i18n.locale == 'en' && it.visibleToEn != undefined) {
	          visible = it.visibleToEn;
	        }
	
	        if (visible) {
	          ret.push(it);
	        }
	      });
	
	      return ret;
	    }
	  },
	  mounted: function mounted() {
	    if (this.attr.multipleSelect) {
	      this.instance[this.attr.columnName + "_selected"] = [];
	    }
	  }
	};

/***/ }),
/* 496 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ["attr", "showHint", "hintValue", "label"],
	  methods: {
	    getIcon: function getIcon() {
	      return "glyphicon glyphicon-" + this.attr.icon;
	    },
	    showHeader: function showHeader(size) {
	      if (this.attr.fontSize) {
	        return this.attr.fontSize === size;
	      } else {
	        return size === 'h4';
	      }
	    }
	  }
	};

/***/ }),
/* 497 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ["attr"],
	  computed: {
	    heightStyle: function heightStyle() {
	      return "width: 100%;" + "height: " + this.attr.height + "px;" + "margin-top: " + this.attr.marginTop + "px;" + "margin-bottom: " + this.attr.marginBottom + "px;";
	    }
	  }
	};

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "placeholder", "label", "showHint", "hintValue", "moduleType"],
	  methods: {
	    formatField: function formatField(value) {
	      return _SgsUtils2.default.formatField2({
	        value: value,
	        type: 'boolean',
	        misc: {
	          yes: this.$t("yes"),
	          no: this.$t("no")
	        }
	      });
	    }
	  },
	  watch: {
	    "updateFieldValue": function updateFieldValue(val) {
	      if (this.attr.eventOnChange) {
	        this.$emit('callBusinessRule', this.attr.eventOnChange);
	      }
	    }
	  },
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        if (this.fieldValue === undefined || this.fieldValue === null || this.fieldValue === '') {
	
	          if (this.moduleType === 'list' && this.attr && this.attr.inListHideIfNull) {
	            return this.fieldValue;
	          }
	
	          this.$emit('updateFieldValue', this.attr.columnName, 'YES');
	          return 'YES';
	        }
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        this.$emit('updateFieldValue', this.attr.columnName, newValue);
	      }
	    },
	    showInList: function showInList() {
	
	      if (this.moduleType === 'list') {
	
	        if (this.updateFieldValue != undefined) {
	          return true;
	        } else if (this.attr && !this.attr.inListHideIfNull) {
	          return true;
	        }
	      }
	
	      return false;
	    }
	  }
	};

/***/ }),
/* 499 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {};
	    },
	
	    components: {}
	};

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	var _MaskedField = __webpack_require__(67);
	
	var _MaskedField2 = _interopRequireDefault(_MaskedField);
	
	var _boletoValidator = __webpack_require__(150);
	
	var _boletoValidator2 = _interopRequireDefault(_boletoValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "rules", "label", "showHint", "hintValue", "moduleType"],
	  methods: {
	    callBusinessRule: function callBusinessRule(BusinessRuleId) {
	      this.$emit('callBusinessRule', BusinessRuleId);
	    }
	  },
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        var fieldFormatted = this.fieldValue;
	        var fieldWithMask = "";
	        if (this.fieldValue) {
	          fieldFormatted = fieldFormatted.replace(/\D/g, "");
	          if (fieldFormatted.length > 33) {
	            fieldWithMask = fieldFormatted.substring(0, 5) + "." + fieldFormatted.substring(5, 10) + " " + fieldFormatted.substring(10, 15) + "." + fieldFormatted.substring(15, 21) + " " + fieldFormatted.substring(21, 26) + "." + fieldFormatted.substring(26, 32) + " " + fieldFormatted.substring(32, 33) + " " + fieldFormatted.substring(33);
	
	            return fieldWithMask;
	          }
	        }
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        this.$emit('updateFieldValue', this.attr.columnName, newValue);
	      }
	    }
	  },
	  components: {
	    MaskedField: _MaskedField2.default
	  },
	  created: function created() {
	    var _this = this;
	
	    _SgsUtils2.default.resolveRules(this.attr, this.rules);
	    if (this.rules) {
	      this.rules[this.attr.columnName].push({
	        validator: function validator(rules, value, callback) {
	          _boletoValidator2.default.boleto(value, function (err, isValid) {
	            if (isValid || !value) {
	              callback();
	            } else {
	              callback(new Error(_this.$t("charges") + "  " + _this.$t("invalid") + "!"));
	            }
	          });
	        },
	        trigger: 'blur'
	      });
	    }
	  }
	};

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	var _MaskedField = __webpack_require__(67);
	
	var _MaskedField2 = _interopRequireDefault(_MaskedField);
	
	var _cpf_cnpj = __webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "rules", "label", "showHint", "hintValue", "moduleType"],
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        var fieldFormatted = this.fieldValue;
	
	        if (this.fieldValue) {
	          fieldFormatted = fieldFormatted.replace(/\D/g, "");
	
	          fieldFormatted = fieldFormatted.replace(/^(\d{2})(\d)/, "$1.$2");
	          fieldFormatted = fieldFormatted.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
	          fieldFormatted = fieldFormatted.replace(/\.(\d{3})(\d)/, ".$1/$2");
	          fieldFormatted = fieldFormatted.replace(/(\d{4})(\d)/, "$1-$2");
	
	          return fieldFormatted;
	        }
	
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        this.$emit('updateFieldValue', this.attr.columnName, newValue);
	      }
	    }
	  },
	  methods: {
	    callBusinessRule: function callBusinessRule(BusinessRuleId) {
	      this.$emit('callBusinessRule', BusinessRuleId);
	    }
	  },
	  components: {
	    MaskedField: _MaskedField2.default
	  },
	  created: function created() {
	    var _this = this;
	
	    _SgsUtils2.default.resolveRules(this.attr, this.rules);
	    if (this.rules) {
	      this.rules[this.attr.columnName].push({
	        validator: function validator(rules, value, callback) {
	          if (value && !_cpf_cnpj.CNPJ.isValid(value)) {
	            callback(new Error(_this.$t("cnpj") + "  " + _this.$t("invalid") + "!"));
	          }
	          callback();
	        },
	        trigger: 'blur'
	      });
	    }
	  }
	};

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	var _MaskedField = __webpack_require__(67);
	
	var _MaskedField2 = _interopRequireDefault(_MaskedField);
	
	var _cpf_cnpj = __webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "rules", "label", "showHint", "hintValue", "moduleType"],
	  methods: {
	    callBusinessRule: function callBusinessRule(BusinessRuleId) {
	      this.$emit('callBusinessRule', BusinessRuleId);
	    }
	  },
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        var fieldFormatted = this.fieldValue;
	
	        if (this.fieldValue) {
	          fieldFormatted = fieldFormatted.replace(/\D/g, "");
	
	          fieldFormatted = fieldFormatted.replace(/(\d{3})(\d)/, "$1.$2");
	          fieldFormatted = fieldFormatted.replace(/(\d{3})(\d)/, "$1.$2");
	          fieldFormatted = fieldFormatted.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
	
	          return fieldFormatted;
	        }
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        this.$emit('updateFieldValue', this.attr.columnName, newValue);
	      }
	    }
	  },
	  components: {
	    MaskedField: _MaskedField2.default
	  },
	  created: function created() {
	    var _this = this;
	
	    _SgsUtils2.default.resolveRules(this.attr, this.rules);
	    if (this.rules) {
	      this.rules[this.attr.columnName].push({
	        validator: function validator(rules, value, callback) {
	          if (value && !_cpf_cnpj.CPF.isValid(value)) {
	            callback(new Error(_this.$t("cpf") + "  " + _this.$t("invalid") + "!"));
	          }
	          callback();
	        },
	        trigger: 'blur'
	      });
	    }
	  }
	};

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "rules", "label", "showHint", "hintValue", "moduleType"],
	  data: function data() {
	    return {
	      fileName: ''
	    };
	  },
	  methods: {
	    callInputFile: function callInputFile() {
	      document.getElementById('file').click();
	    },
	    openFile: function openFile(event) {
	      var _this = this;
	
	      var input = event.target;
	      var file = input.files[0];
	
	      if (file) {
	        if (file.name.split('.').pop() === "csv") {
	
	          var reader = new FileReader();
	          reader.readAsText(file);
	          reader.onload = function () {
	            var text = reader.result;
	            _this.updateFieldValue = text;
	            _this.fileName = file.name;
	          };
	        } else {
	          this.$notify.error({
	            title: 'Error',
	            message: 'Não é possivel fazer o upload de um arquivo que não tenha a extensão ".csv"'
	          });
	          this.fileName = 'Nenhum arquivo selecionado!';
	        }
	      }
	    }
	  },
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        this.$emit('updateFieldValue', this.attr.columnName, newValue);
	      }
	    }
	  },
	  created: function created() {
	    _SgsUtils2.default.resolveRules(this.attr, this.rules);
	  }
	};

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	var _MaskedField = __webpack_require__(67);
	
	var _MaskedField2 = _interopRequireDefault(_MaskedField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "rules", "placeholder", "label", "showHint", "hintValue", "moduleType"],
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        this.$emit('updateFieldValue', this.attr.columnName, newValue);
	      }
	    }
	  },
	  methods: {
	    callBusinessRule: function callBusinessRule(BusinessRuleId) {
	      this.$emit('callBusinessRule', BusinessRuleId);
	    }
	  },
	  components: {
	    MaskedField: _MaskedField2.default
	  },
	  created: function created() {
	    _SgsUtils2.default.resolveRules(this.attr, this.rules);
	  }
	};

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _ApiService = __webpack_require__(30);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	var _ModuleUtils = __webpack_require__(7);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "value", "rules", "label", "showHint", "hintValue", "placeholder", "instance", "formIdentifier", "attrOriginal", "moduleType", "disableField"],
	  data: function data() {
	    return {
	      localValue: '',
	      localObject: {}
	    };
	  },
	
	  watch: {
	    value: function value(val) {
	      if (val) {
	        this.getValue();
	      } else {
	        this.clearField();
	      }
	    },
	
	    "localValue": function localValue(val) {
	      if (this.attr.eventOnChange) {
	        this.$emit('callBusinessRule', this.attr.eventOnChange);
	      }
	    },
	    "$i18n.locale": function $i18nLocale() {
	      this.getValue();
	    }
	  },
	  methods: {
	    openModal: function openModal() {
	      this.$eventBus.$emit('auto-complete', {
	        payload: {
	          attr: this.attr,
	          formIdentifier: this.formIdentifier,
	          instance: this.instance
	        },
	        callback: this.selectRow
	      });
	    },
	    clearField: function clearField() {
	      this.updateFieldValue = '';
	      this.localValue = '';
	    },
	    selectRow: function selectRow(row) {
	      this.updateFieldValue = row[this.attr.columnValue];
	      this.localValue = row[this.resolveColumnLabel()];
	    },
	    resolveColumnLabel: function resolveColumnLabel() {
	      var columnLabel = this.attr.columnLabel;
	
	      if (this.$i18n.locale == 'es' && this.attr.columnLabelEs) {
	        columnLabel = this.attr.columnLabelEs;
	      } else if (this.$i18n.locale == 'en' && this.attr.columnLabelEn) {
	        columnLabel = this.attr.columnLabelEn;
	      }
	
	      return columnLabel;
	    },
	    getValue: function getValue() {
	      var _this = this;
	
	      if (this.value != undefined && this.value != "") {
	        var formIdentifier = (0, _assign2.default)({}, this.formIdentifier, { formId: this.attr.formId });
	        var parentFormId = this.formIdentifier.formId;
	
	        _ModuleUtils2.default.resolveModuleDescription(formIdentifier).then(function (response) {
	
	          _this.url = _ModuleUtils2.default.resolveFormUri(formIdentifier) + "/autocompleteLoad";
	        }).then(function () {
	
	          var data = {};
	          data._ = {};
	          data._.parentFormId = parentFormId;
	          data._.parentFormFieldId = _this.attr.id;
	          data._.fieldName = _this.attr.columnValue;
	          data._.fieldId = _this.attr.columnValueFieldId;
	          data._.fieldValue = _this.value;
	          data._.formId = _this.attr.formId;
	
	          return _ApiService2.default.post({
	            uri: _this.url,
	            data: data,
	            excludeApi: true
	          }).then(function (response) {
	            if (response !== undefined) {
	              _this.localObject = response.body.instance;
	            }
	          }).then(function () {
	            if (_this.localObject !== null) {
	              _this.localValue = _this.localObject[_this.resolveColumnLabel()];
	            }
	          });
	        });
	      }
	    }
	  },
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        return this.value;
	      },
	      set: function set(newValue) {
	        if (this.attr.type == 'composition') {
	          this.$emit('input', parseInt(newValue));
	        } else {
	          this.$emit('input', newValue);
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.getValue();
	  },
	  created: function created() {
	    _SgsUtils2.default.resolveRules(this.attr, this.rules);
	  }
	};

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _SgsRenderInputData = __webpack_require__(846);
	
	var _SgsRenderInputData2 = _interopRequireDefault(_SgsRenderInputData);
	
	var _FormBuilderUtils = __webpack_require__(18);
	
	var _FormBuilderUtils2 = _interopRequireDefault(_FormBuilderUtils);
	
	var _ModuleUtils = __webpack_require__(7);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "formIdentifier", "rules", "label", "showHint", "hintValue", "placeholder", "instance", "moduleType", "disableField"],
	  data: function data() {
	    return {
	      attr_copy: ""
	    };
	  },
	
	  components: {
	    SgsRenderInputData: _SgsRenderInputData2.default
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var formIdentifier = (0, _assign2.default)({}, this.formIdentifier, { formId: this.attr.formId });
	
	    _ModuleUtils2.default.resolveModuleDescription(formIdentifier).then(function (response) {
	      var fields = response.fieldDesc.fields;
	
	      _this.attr_copy = (0, _assign2.default)({}, _this.attr);
	      _this.attr_copy.uri = _ModuleUtils2.default.resolveFormUri(formIdentifier) + "/autocomplete";
	
	      if (_this.attr_copy.uriFilterList) {
	
	        var uriFilterList = _this.attr_copy.uriFilterList.slice();
	        _this.attr_copy.uriFilterList = [];
	
	        uriFilterList.map(function (it) {
	          var field = _FormBuilderUtils2.default.findField(it, fields);
	          _this.attr_copy.uriFilterList.push(field.columnName);
	        });
	      }
	
	      if (_this.attr_copy.uriFilterListEs) {
	
	        var uriFilterListEs = _this.attr_copy.uriFilterListEs.slice();
	        _this.attr_copy.uriFilterListEs = [];
	
	        uriFilterListEs.map(function (it) {
	          var field = _FormBuilderUtils2.default.findField(it, fields);
	          _this.attr_copy.uriFilterListEs.push(field.columnName);
	        });
	      }
	
	      if (_this.attr_copy.uriFilterListEn) {
	
	        var uriFilterListEn = _this.attr_copy.uriFilterListEn.slice();
	        _this.attr_copy.uriFilterListEn = [];
	
	        uriFilterListEn.map(function (it) {
	          var field = _FormBuilderUtils2.default.findField(it, fields);
	          _this.attr_copy.uriFilterListEn.push(field.columnName);
	        });
	      }
	
	      if (_this.attr_copy.columnsToShow) {
	
	        var columnsToShow = _this.attr_copy.columnsToShow.slice();
	        _this.attr_copy.columnsToShow = {};
	        _this.attr_copy.columnsToShowAttr = {};
	
	        columnsToShow.map(function (it) {
	          var field = _FormBuilderUtils2.default.findField(it, fields);
	          _this.attr_copy.columnsToShow[field.columnName] = field.labelPt;
	          _this.attr_copy.columnsToShowAttr[field.columnName] = field;
	        });
	      }
	
	      if (_this.attr_copy.type == 'association' && _this.attr_copy.columnValue) {
	        var field = _FormBuilderUtils2.default.findField(_this.attr_copy.columnValue, fields);
	        _this.attr_copy.columnValueFieldId = _this.attr_copy.columnValue;
	        _this.attr_copy.columnValue = field.columnName;
	      }
	
	      if (_this.attr_copy.columnLabel) {
	
	        var _field = _FormBuilderUtils2.default.findField(_this.attr_copy.columnLabel, fields);
	        _this.attr_copy.columnLabel = _field.columnName;
	
	        if (_this.attr_copy.columnLabelEs) {
	
	          var fieldEs = _FormBuilderUtils2.default.findField(_this.attr_copy.columnLabelEs, fields);
	
	          if (fieldEs != undefined) {
	            _this.attr_copy.columnLabelEs = fieldEs.columnName;
	
	            if (_this.attr_copy.columnsToShowEs) {
	
	              var columnsToShowEs = _this.attr_copy.columnsToShowEs.slice();
	              _this.attr_copy.columnsToShowEs = {};
	              _this.attr_copy.columnsToShowEsAttr = {};
	
	              columnsToShowEs.map(function (it) {
	                var field = _FormBuilderUtils2.default.findField(it, fields);
	                _this.attr_copy.columnsToShowEs[field.columnName] = field.labelEs;
	                _this.attr_copy.columnsToShowEsAttr[field.columnName] = field;
	              });
	            }
	          }
	        }
	
	        if (_this.attr_copy.columnLabelEn) {
	
	          var fieldEn = _FormBuilderUtils2.default.findField(_this.attr_copy.columnLabelEn, fields);
	
	          if (fieldEn != undefined) {
	
	            _this.attr_copy.columnLabelEn = fieldEn.columnName;
	
	            if (_this.attr_copy.columnLabelEn) {
	
	              if (fieldEn != undefined) {
	
	                _this.attr_copy.columnLabelEn = fieldEn.columnName;
	
	                if (_this.attr_copy.columnsToShowEn) {
	
	                  var columnsToShowEn = _this.attr_copy.columnsToShowEn.slice();
	                  _this.attr_copy.columnsToShowEn = {};
	                  _this.attr_copy.columnsToShowEnAttr = {};
	
	                  columnsToShowEn.map(function (it) {
	                    var field = _FormBuilderUtils2.default.findField(it, fields);
	                    _this.attr_copy.columnsToShowEn[field.columnName] = field.labelEn;
	                    _this.attr_copy.columnsToShowEnAttr[field.columnName] = field;
	                  });
	                }
	              }
	            }
	          }
	        }
	      }
	    });
	  },
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        this.$emit('input', newValue);
	      }
	    }
	  },
	  methods: {
	    callBusinessRule: function callBusinessRule(BusinessRuleId) {
	      this.$emit('callBusinessRule', BusinessRuleId);
	    }
	  }
	};

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _ApiService = __webpack_require__(30);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _ModuleUtils = __webpack_require__(7);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	var _RepositoryService = __webpack_require__(24);
	
	var _RepositoryService2 = _interopRequireDefault(_RepositoryService);
	
	var _AppConfigService = __webpack_require__(11);
	
	var _AppConfigService2 = _interopRequireDefault(_AppConfigService);
	
	var _FormBuilderUtils = __webpack_require__(18);
	
	var _FormBuilderUtils2 = _interopRequireDefault(_FormBuilderUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "formIdentifier", "label", "moduleType"],
	  data: function data() {
	    return {
	      localObject: {},
	      localField: {},
	      url: ''
	    };
	  },
	  watch: {
	    fieldValue: function fieldValue(val) {
	      this.getValue();
	    },
	    "$i18n.locale": function $i18nLocale() {
	      this.getValue();
	    }
	  },
	  mounted: function mounted() {
	    this.getValue();
	  },
	  methods: {
	    getValue: function getValue() {
	      var _this = this;
	
	      this.localField = {};
	      this.localObject = {};
	
	      if (this.fieldValue != undefined && this.fieldValue != "") {
	        var formIdentifier = (0, _assign2.default)({}, this.formIdentifier, { formId: this.attr.formId });
	        var parentFormId = this.formIdentifier.formId;
	
	        _ModuleUtils2.default.resolveModuleDescription(formIdentifier).then(function (response) {
	
	          _this.url = _ModuleUtils2.default.resolveFormUri(formIdentifier) + "/autocompleteLoad";
	
	          var columnLabel = _this.attr.columnLabel;
	
	          if (_this.$i18n.locale == 'es' && _this.attr.columnLabelEs) {
	            columnLabel = _this.attr.columnLabelEs;
	          } else if (_this.$i18n.locale == 'en' && _this.attr.columnLabelEn) {
	            columnLabel = _this.attr.columnLabelEn;
	          }
	
	          _this.localField = _FormBuilderUtils2.default.findField(columnLabel, response.fieldDesc.fields);
	        }).then(function () {
	
	          var data = {};
	          data._ = {};
	          data._.parentFormId = parentFormId;
	          data._.parentFormFieldId = _this.attr.id;
	          data._.field = _this.attr.columnValue;
	          data._.fieldValue = _this.fieldValue;
	          data._.formId = _this.attr.formId;
	
	          return _ApiService2.default.post({
	            uri: _this.url,
	            data: data,
	            excludeApi: true
	          }).then(function (response) {
	            if (response !== undefined) {
	              _this.localObject = response.body.instance;
	            }
	          });
	        });
	      }
	    }
	  }
	};

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsRenderInputDataFormWrapper = __webpack_require__(847);
	
	var _SgsRenderInputDataFormWrapper2 = _interopRequireDefault(_SgsRenderInputDataFormWrapper);
	
	var _SgsRenderInputDataShowOrListWrapper = __webpack_require__(848);
	
	var _SgsRenderInputDataShowOrListWrapper2 = _interopRequireDefault(_SgsRenderInputDataShowOrListWrapper);
	
	var _FormBuilderUtils = __webpack_require__(18);
	
	var _FormBuilderUtils2 = _interopRequireDefault(_FormBuilderUtils);
	
	var _ModuleUtils = __webpack_require__(7);
	
	var _ModuleUtils2 = _interopRequireDefault(_ModuleUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "formIdentifier", "rules", "label", "showHint", "hintValue", "moduleType", "placeholder", "instance", "disableField"],
	  methods: {
	    callBusinessRule: function callBusinessRule(BusinessRuleId) {
	      this.$emit('callBusinessRule', BusinessRuleId);
	    }
	  },
	  components: {
	    SgsRenderInputDataFormWrapper: _SgsRenderInputDataFormWrapper2.default,
	    SgsRenderInputDataShowOrListWrapper: _SgsRenderInputDataShowOrListWrapper2.default
	  },
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        this.$emit('updateFieldValue', this.attr.columnName, newValue);
	      }
	    }
	  }
	};

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = __webpack_require__(1);
	
	exports.default = {
	  props: ["attr", "fieldValue", "rules", "placeholder", "label", "showHint", "hintValue", "moduleType"],
	  methods: {
	    convertDate: function convertDate(val) {
	      if (val) {
	        return moment(val).format('DD/MM/YYYY');
	      }
	      return '';
	    },
	    callBusinessRuleChange: function callBusinessRuleChange() {
	      if (this.attr.eventOnChange) {
	        this.$emit('callBusinessRule', this.attr.eventOnChange);
	      }
	    }
	  },
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        if (this.fieldValue) {
	          if (this.attr.type === 'filterDate' && Array.isArray(this.fieldValue)) {
	            var ret = [];
	            this.fieldValue.map(function (it) {
	              ret.push(new Date(it.split(" ")[0] + " 00:00:00"));
	            });
	
	            return ret;
	          }
	          return new Date(this.fieldValue + " 00:00:00");
	        }
	        return null;
	      },
	      set: function set(newValue) {
	        if (newValue) {
	          if (Array.isArray(newValue)) {
	            if (newValue[0] === null || newValue[0] === undefined || newValue[0] === '') {
	              this.$emit('updateFieldValue', this.attr.columnName, []);
	            } else {
	              var ret = [];
	
	              ret.push(moment(newValue[0]).format('YYYY-MM-DD') + " 00:00:00");
	              ret.push(moment(newValue[1]).format('YYYY-MM-DD') + " 23:59:59");
	
	              this.$emit('updateFieldValue', this.attr.columnName, ret);
	            }
	          } else {
	            this.$emit('updateFieldValue', this.attr.columnName, moment(newValue).format('YYYY-MM-DD'));
	          }
	        } else {
	          this.$emit('updateFieldValue', this.attr.columnName, newValue);
	        }
	      }
	    },
	    typeDatePicker: function typeDatePicker() {
	      if (this.attr && this.attr.dateType) {
	        return this.attr.dateType;
	      }
	      return "date";
	    }
	  },
	  created: function created() {
	    _SgsUtils2.default.resolveRules(this.attr, this.rules);
	  }
	};

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = __webpack_require__(1);
	
	exports.default = {
	  props: ["attr", "fieldValue", "rules", "placeholder", "label", "showHint", "hintValue", "moduleType"],
	  methods: {
	    convertDate: function convertDate(val) {
	      if (val) {
	        return moment(val).format('DD/MM/YYYY HH:mm');
	      }
	      return '';
	    },
	    callBusinessRuleChange: function callBusinessRuleChange() {
	      if (this.attr.eventOnChange) {
	        this.$emit('callBusinessRule', this.attr.eventOnChange);
	      }
	    }
	  },
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        if (newValue) {
	          this.$emit('updateFieldValue', this.attr.columnName, moment(newValue).format('YYYY-MM-DD HH:mm'));
	        } else {
	          this.$emit('updateFieldValue', this.attr.columnName, newValue);
	        }
	      }
	    }
	  },
	  created: function created() {
	    _SgsUtils2.default.resolveRules(this.attr, this.rules);
	  }
	};

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	var _MaskedField = __webpack_require__(67);
	
	var _MaskedField2 = _interopRequireDefault(_MaskedField);
	
	var _boletoValidator = __webpack_require__(150);
	
	var _boletoValidator2 = _interopRequireDefault(_boletoValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "rules", "label", "showHint", "hintValue", "moduleType"],
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        var fieldFormatted = this.fieldValue;
	        var fieldWithMask = "";
	        if (this.fieldValue) {
	          fieldFormatted = fieldFormatted.replace(/\D/g, "");
	          if (fieldFormatted.length > 47) {
	
	            fieldWithMask = fieldFormatted.substring(0, 11) + "-" + fieldFormatted.substring(11, 12) + " " + fieldFormatted.substring(12, 23) + "-" + fieldFormatted.substring(23, 24) + " " + fieldFormatted.substring(24, 35) + "-" + fieldFormatted.substring(35, 36) + " " + fieldFormatted.substring(36, 47) + "-" + fieldFormatted.substring(47);
	
	            return fieldWithMask;
	          }
	        }
	
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        this.$emit('updateFieldValue', this.attr.columnName, newValue);
	      }
	    }
	  },
	  methods: {
	    callBusinessRule: function callBusinessRule(BusinessRuleId) {
	      this.$emit('callBusinessRule', BusinessRuleId);
	    }
	  },
	  components: {
	    MaskedField: _MaskedField2.default
	  },
	  created: function created() {
	    var _this = this;
	
	    _SgsUtils2.default.resolveRules(this.attr, this.rules);
	    if (this.rules) {
	      this.rules[this.attr.columnName].push({
	        validator: function validator(rules, value, callback) {
	          _boletoValidator2.default.convenio(value, function (err, isValid) {
	            if (isValid || !value) {
	              callback();
	            } else {
	              callback(new Error(_this.$t("dealership") + "  " + _this.$t("invalid") + "!"));
	            }
	          });
	        },
	        trigger: 'blur'
	      });
	    }
	  }
	};

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "rules", "placeholder", "label", "showHint", "hintValue", "moduleType"],
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        this.$emit('updateFieldValue', this.attr.columnName, newValue);
	      }
	    }
	  },
	  created: function created() {
	    _SgsUtils2.default.resolveRules(this.attr, this.rules);
	  },
	
	  methods: {
	    callBusinessRuleFocus: function callBusinessRuleFocus() {
	      if (this.attr.eventOnFocus) {
	        this.$emit('callBusinessRule', this.attr.eventOnFocus);
	      }
	    },
	    callBusinessRuleBlur: function callBusinessRuleBlur() {
	      if (this.attr.eventOnBlur) {
	        this.$emit('callBusinessRule', this.attr.eventOnBlur);
	      }
	    }
	  }
	};

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "rules", "placeholder", "label"],
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        this.$emit('updateFieldValue', this.attr.columnName, newValue);
	      }
	    }
	  }
	};

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue"]
	};

/***/ }),
/* 515 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ["attr", "fieldValue"],
	  data: function data() {
	    return {
	      options: [{
	        value: 'Option1',
	        label: 'Option1'
	      }, {
	        value: 'Option2',
	        label: 'Option2'
	      }, {
	        value: 'Option3',
	        label: 'Option3'
	      }, {
	        value: 'Option4',
	        label: 'Option4'
	      }, {
	        value: 'Option5',
	        label: 'Option5'
	      }],
	      value5: ''
	    };
	  },
	
	  components: {},
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        this.$emit('updateFieldValue', this.attr.columnName, newValue);
	      }
	    }
	  }
	};

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "rules", "label", "showHint", "hintValue", "moduleType"],
	  methods: {
	    getMaxValue: function getMaxValue() {
	      if (this.attr != undefined) {
	        if (this.attr.maxValue != undefined) return this.attr.maxValue;
	      }
	    },
	
	    getMinValue: function getMinValue() {
	      if (this.attr != undefined) {
	        if (this.attr.minValue != undefined) return this.attr.minValue;
	      }
	      return 0;
	    },
	
	    getPrefix: function getPrefix() {
	      if (this.attr != undefined) {
	        if (this.attr.prefix != undefined && this.attr.prefix != "") {
	          return this.attr.prefix;
	        }
	      }
	    },
	
	    getSufix: function getSufix() {
	      if (this.attr != undefined) {
	        if (this.attr.sufix != undefined && this.attr.sufix != "") return this.attr.sufix;
	      }
	    },
	
	    showMaxValue: function showMaxValue() {
	      if (this.getMaxValue() > 0) {
	        return true;
	      }
	      return false;
	    },
	
	    callBusinessRuleFocus: function callBusinessRuleFocus() {
	      if (this.attr.eventOnFocus) {
	        this.$emit('callBusinessRule', this.attr.eventOnFocus);
	      }
	    },
	
	    callBusinessRuleBlur: function callBusinessRuleBlur() {
	      if (this.attr.eventOnBlur) {
	        this.$emit('callBusinessRule', this.attr.eventOnBlur);
	      }
	    }
	  },
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	
	        var value = this.fieldValue ? this.fieldValue : 0;
	
	        return value;
	      },
	      set: function set(newValue) {
	        this.$emit('updateFieldValue', this.attr.columnName, newValue);
	      }
	    }
	  },
	  created: function created() {
	    _SgsUtils2.default.resolveRules(this.attr, this.rules);
	  }
	};

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "rules", "placeholder", "label", "showHint", "hintValue", "moduleType"],
	  methods: {
	    getMaxSize: function getMaxSize() {
	      if (this.attr != undefined) {
	        if (this.attr.maxSize != undefined) return this.attr.maxSize;
	      }
	    },
	    getMinSize: function getMinSize() {
	      if (this.attr != undefined) {
	        if (this.attr.minSize != undefined) return this.attr.minSize;
	      }
	    },
	    callBusinessRuleFocus: function callBusinessRuleFocus() {
	      if (this.attr.eventOnFocus) {
	        this.$emit('callBusinessRule', this.attr.eventOnFocus);
	      }
	    },
	    callBusinessRuleBlur: function callBusinessRuleBlur() {
	      if (this.attr.eventOnBlur) {
	        this.$emit('callBusinessRule', this.attr.eventOnBlur);
	      }
	    }
	  },
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        this.$emit('updateFieldValue', this.attr.columnName, newValue);
	      }
	    }
	  },
	  created: function created() {
	    _SgsUtils2.default.resolveRules(this.attr, this.rules);
	  }
	};

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "rules", "placeholder", "label", "showHint", "hintValue", "moduleType"],
	  methods: {
	    getMaxSize: function getMaxSize() {
	      if (this.attr != undefined) {
	        if (this.attr.maxSize != undefined) return this.attr.maxSize;
	      }
	    },
	    getMinSize: function getMinSize() {
	      if (this.attr != undefined) {
	        if (this.attr.minSize != undefined) return this.attr.minSize;
	      }
	    },
	    callBusinessRuleFocus: function callBusinessRuleFocus() {
	      if (this.attr.eventOnFocus) {
	        this.$emit('callBusinessRule', this.attr.eventOnFocus);
	      }
	    },
	    callBusinessRuleBlur: function callBusinessRuleBlur() {
	      if (this.attr.eventOnBlur) {
	        this.$emit('callBusinessRule', this.attr.eventOnBlur);
	      }
	    }
	  },
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        this.$emit('updateFieldValue', this.attr.columnName, newValue);
	      }
	    }
	  },
	  created: function created() {
	    _SgsUtils2.default.resolveRules(this.attr, this.rules);
	  }
	};

/***/ }),
/* 519 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ["attr", "fieldValue"],
	  data: function data() {
	    return {
	      options: [{
	        value: 'Option1',
	        label: 'Option1'
	      }, {
	        value: 'Option2',
	        label: 'Option2'
	      }, {
	        value: 'Option3',
	        label: 'Option3'
	      }, {
	        value: 'Option4',
	        label: 'Option4'
	      }, {
	        value: 'Option5',
	        label: 'Option5'
	      }],
	      value: ''
	    };
	  },
	
	
	  methods: {
	    getLabel: function getLabel() {
	      if (this.attr != undefined) {
	        if (this.attr.labelPt != undefined && this.attr.labelPt != "") {
	          return this.attr.labelPt;
	        }
	      }
	      return "Label";
	    },
	    getPlaceholder: function getPlaceholder() {
	      if (this.attr != undefined) {
	        if (this.attr.placeholderPt != undefined && this.attr.placeholderPt != "") {
	          return this.attr.placeholderPt;
	        }
	      }
	      return "";
	    }
	  },
	
	  components: {},
	
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        this.$emit('updateFieldValue', this.attr.columnName, newValue);
	      }
	    }
	  }
	};

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "rules", "placeholder", "label", "showHint", "hintValue", "moduleType"],
	  methods: {
	    getPrefix: function getPrefix() {
	      if (this.attr != undefined) {
	        if (this.attr.prefix != undefined && this.attr.prefix != "") {
	          return this.attr.prefix;
	        }
	      }
	    },
	    getSufix: function getSufix() {
	      if (this.attr != undefined) {
	        if (this.attr.sufix != undefined && this.attr.sufix != "") return this.attr.sufix;
	      }
	    },
	    getMaxSize: function getMaxSize() {
	      if (this.attr != undefined) {
	        if (this.attr.maxSize != undefined) return this.attr.maxSize;
	      }
	    },
	    getMinSize: function getMinSize() {
	      if (this.attr != undefined) {
	        if (this.attr.minSize != undefined) return this.attr.minSize;
	      }
	    },
	    callBusinessRuleFocus: function callBusinessRuleFocus() {
	      if (this.attr.eventOnFocus) {
	        this.$emit('callBusinessRule', this.attr.eventOnFocus);
	      }
	    },
	    callBusinessRuleBlur: function callBusinessRuleBlur() {
	      if (this.attr.eventOnBlur) {
	        this.$emit('callBusinessRule', this.attr.eventOnBlur);
	      }
	    }
	  },
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        this.$emit('updateFieldValue', this.attr.columnName, newValue);
	      }
	    }
	  },
	  created: function created() {
	    _SgsUtils2.default.resolveRules(this.attr, this.rules);
	  }
	};

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "rules", "placeholder", "label", "showHint", "hintValue", "moduleType"],
	  methods: {
	    getMaxSize: function getMaxSize() {
	      if (this.attr != undefined) {
	        if (this.attr.maxSize != undefined) return this.attr.maxSize;
	      }
	    },
	    getMinSize: function getMinSize() {
	      if (this.attr != undefined) {
	        if (this.attr.minSize != undefined) return this.attr.minSize;
	      }
	    },
	    callBusinessRuleFocus: function callBusinessRuleFocus() {
	      if (this.attr.eventOnFocus) {
	        this.$emit('callBusinessRule', this.attr.eventOnFocus);
	      }
	    },
	    callBusinessRuleBlur: function callBusinessRuleBlur() {
	      if (this.attr.eventOnBlur) {
	        this.$emit('callBusinessRule', this.attr.eventOnBlur);
	      }
	    }
	  },
	  components: {},
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        this.$emit('updateFieldValue', this.attr.columnName, newValue);
	      }
	    }
	  },
	  created: function created() {
	    _SgsUtils2.default.resolveRules(this.attr, this.rules);
	  }
	};

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moment = __webpack_require__(1);
	
	exports.default = {
	  props: ["attr", "fieldValue", "rules", "placeholder", "label", "showHint", "hintValue", "moduleType"],
	  methods: {
	    convertDate: function convertDate(val) {
	      if (val) {
	        return moment(val).format('HH:mm');
	      }
	      return '';
	    },
	    callBusinessRuleChange: function callBusinessRuleChange() {
	      if (this.attr.eventOnChange) {
	        this.$emit('callBusinessRule', this.attr.eventOnChange);
	      }
	    }
	  },
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        var date = new Date();
	
	        if (this.fieldValue) {
	          var time = this.fieldValue.split(":");
	          return new Date(date.getFullYear(), date.getMonth(), date.getDate(), time[0], time[1]);
	        }
	
	        return '';
	      },
	      set: function set(newValue) {
	        if (newValue && newValue !== undefined && newValue !== '') {
	          this.$emit('updateFieldValue', this.attr.columnName, newValue.getHours() + ":" + newValue.getMinutes());
	        } else {
	          this.$emit('updateFieldValue', this.attr.columnName, "");
	        }
	      }
	    }
	  },
	  created: function created() {
	    _SgsUtils2.default.resolveRules(this.attr, this.rules);
	  }
	};

/***/ }),
/* 523 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ["attr", "showHint", "hintValue", "label", "fieldValue"],
	  methods: {
	    getIcon: function getIcon() {
	      return "glyphicon glyphicon-" + this.attr.icon;
	    },
	    showHeader: function showHeader(size) {
	      if (this.attr.fontSize) {
	        return this.attr.fontSize === size;
	      } else {
	        return size === 'h4';
	      }
	    }
	  },
	  computed: {
	    _label: function _label() {
	      if (this.fieldValue) {
	        return this.fieldValue;
	      }
	
	      if (this.label) {
	        return this.label;
	      }
	
	      return '';
	    }
	  }
	};

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	var _FormatField = __webpack_require__(824);
	
	var _FormatField2 = _interopRequireDefault(_FormatField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "type"],
	  components: {
	    FormatField: _FormatField2.default
	  },
	  methods: {
	    getLabel: function getLabel() {
	      if (this.attr != undefined) {
	        if (this.attr.labelPt != undefined && this.attr.labelPt != "") {
	          return this.attr.labelPt;
	        }
	      }
	      return "Label";
	    }
	  }
	};

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "rules", "label", "showHint", "hintValue", "moduleType"],
	  methods: {
	    getPrefix: function getPrefix() {
	      if (this.attr != undefined) {
	        if (this.attr.prefix != undefined && this.attr.prefix != "") {
	          return this.attr.prefix;
	        }
	      }
	    },
	    getSufix: function getSufix() {
	      if (this.attr != undefined) {
	        if (this.attr.sufix != undefined && this.attr.sufix != "") return this.attr.sufix;
	      }
	    },
	    getMaxSize: function getMaxSize() {
	      if (this.attr != undefined) {
	        if (this.attr.maxSize != undefined) return this.attr.maxSize;
	      }
	    },
	    getMinSize: function getMinSize() {
	      if (this.attr != undefined) {
	        if (this.attr.minSize != undefined) return this.attr.minSize;
	      }
	    },
	    callBusinessRuleFocus: function callBusinessRuleFocus() {
	      if (this.attr.eventOnFocus) {
	        this.$emit('callBusinessRule', this.attr.eventOnFocus);
	      }
	    },
	    callBusinessRuleBlur: function callBusinessRuleBlur() {
	      if (this.attr.eventOnBlur) {
	        this.$emit('callBusinessRule', this.attr.eventOnBlur);
	      }
	    },
	    mountPosition: function mountPosition() {
	      var objectToReturn = {
	        lat: 0,
	        lng: 0
	      };
	      var lat = this.position.lat;
	      var lng = this.position.lng;
	
	      if (lat && lng) {
	        objectToReturn.lat = parseFloat(lat);
	        objectToReturn.lng = parseFloat(lng);
	
	        this.showMap = true;
	      }
	
	      return objectToReturn;
	    }
	
	  },
	  watch: {
	    "position.lat": function positionLat(newValue) {
	      this.updateFieldValue = this.position;
	    },
	    "position.lng": function positionLng(newValue) {
	      this.updateFieldValue = this.position;
	    },
	    fieldValue: function fieldValue(val) {
	      if (typeof val === 'string' && val !== null && val !== "") {
	        this.position = JSON.parse(val);
	      }
	    },
	    position: function position(newValue, oldValue) {
	      if (newValue.lat !== "" && newValue.lng !== "") {
	        this.mountPosition();
	      }
	    }
	  },
	  data: function data() {
	    return {
	      position: {
	        lat: "",
	        lng: ""
	      },
	      showMap: false
	    };
	  },
	
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        if (typeof this.fieldValue === 'string' && this.fieldValue !== null && this.fieldValue !== "") {
	          this.position = JSON.parse(this.fieldValue);
	        }
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        this.$emit('updateFieldValue', this.attr.columnName, newValue);
	      }
	    },
	    resolveStyle: function resolveStyle() {
	      var height = 400;
	
	      if (this.attr.height) {
	        height = this.attr.height;
	      }
	
	      return "width: 100%; height: " + height + "px";
	    },
	    _position: function _position() {
	      return this.mountPosition();
	    }
	  },
	  mounted: function mounted() {
	    if (typeof this.fieldValue === 'string' && this.fieldValue !== null && this.fieldValue !== "") {
	      this.position = JSON.parse(this.fieldValue);
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    _SgsUtils2.default.resolveRules(this.attr, this.rules);
	    if (this.rules) {
	      this.rules[this.attr.columnName].push({
	        validator: function validator(rules, value, callback) {
	          if (value) {
	
	            var lat = parseFloat(value.lat);
	            var lng = parseFloat(value.lng);
	
	            if (lat && !lng || !lat && lng) {
	              callback(new Error(_this.$t('bothFieldsAreRequired')));
	            } else if (_this.attr.required && !(value.lat && value.lng)) {
	              callback(new Error(_this.$t('pleaseFillInTheField')));
	            }
	          }
	          callback();
	        },
	        trigger: 'blur'
	      });
	    }
	  }
	};

/***/ }),
/* 526 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ["value"],
	  computed: {
	    _value: {
	      get: function get() {
	        return this.value;
	      },
	      set: function set(newValue) {
	        this.$emit('input', newValue);
	      }
	    }
	  },
	  watch: {
	    '_value': function _value(newValue, oldValue) {
	      if (newValue) {
	
	        var label = newValue.pt;
	
	        if (this.$i18n.locale == 'es' && newValue.es) {
	          label = newValue.es;
	        } else if (this.$i18n.locale == 'en' && newValue.en) {
	          label = newValue.en;
	        }
	
	        if (label) {
	          this.$alert(label, this.$t('error') + "!", {
	            confirmButtonText: 'OK',
	            type: 'error'
	          });
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 527 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ["value"],
	  computed: {
	    _value: {
	      get: function get() {
	        return this.value;
	      },
	      set: function set(newValue) {
	        this.$emit('input', newValue);
	      }
	    }
	  },
	  watch: {
	    '_value': function _value(newValue) {
	      if (newValue) {
	
	        var label = newValue.pt;
	
	        if (this.$i18n.locale == 'es' && newValue.es) {
	          label = newValue.es;
	        } else if (this.$i18n.locale == 'en' && newValue.en) {
	          label = newValue.en;
	        }
	
	        if (label) {
	          this.$notify({
	            title: this.$t('success'),
	            message: label,
	            type: 'success'
	          });
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SgsUtils = __webpack_require__(4);
	
	var _SgsUtils2 = _interopRequireDefault(_SgsUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["attr", "fieldValue", "rules", "label", "showHint", "hintValue", "moduleType"],
	  data: function data() {
	    return {
	      config: {
	        placeholderText: '',
	
	        quickInsertButtons: ['embedly', 'table', 'ul', 'ol', 'hr'],
	        toolbarButtons: ['fullscreen', 'undo', 'redo', '|', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '-', 'quote', 'insertLink', 'insertTable', '|', 'specialCharacters', 'emoticons', 'insertHR', 'clearFormatting', 'selectAll', 'applyFormat', 'removeFormat', '|', 'html', 'help']
	      },
	      configDisabledEditor: {
	        placeholderText: '',
	        toolbarSticky: false,
	        toolbarButtons: ['fullscreen', 'undo', 'redo', '|', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '-', 'quote', 'insertLink', 'insertTable', '|', 'specialCharacters', 'emoticons', 'insertHR', 'clearFormatting', 'selectAll', 'applyFormat', 'removeFormat', '|', 'html', 'help'],
	        events: {
	          'froalaEditor.initialized': function froalaEditorInitialized(e, editor) {
	            editor.edit.off();
	          }
	        }
	      }
	    };
	  },
	
	  computed: {
	    updateFieldValue: {
	      get: function get() {
	        return this.fieldValue;
	      },
	      set: function set(newValue) {
	        this.$emit('updateFieldValue', this.attr.columnName, newValue);
	      }
	    }
	  },
	  created: function created() {
	    _SgsUtils2.default.resolveRules(this.attr, this.rules);
	  }
	};

/***/ }),
/* 529 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  computed: {
	    show: function show() {
	      return this.$store.state.CODECASTS_LOADER.show;
	    }
	  }
	};

/***/ }),
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 611 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 612 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 613 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 614 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 615 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 616 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 617 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 618 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 619 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 620 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 621 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 622 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 624 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 627 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 628 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 629 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 630 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 631 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 641 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 649 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 651 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 203,
		"./af.js": 203,
		"./ar": 210,
		"./ar-dz": 204,
		"./ar-dz.js": 204,
		"./ar-kw": 205,
		"./ar-kw.js": 205,
		"./ar-ly": 206,
		"./ar-ly.js": 206,
		"./ar-ma": 207,
		"./ar-ma.js": 207,
		"./ar-sa": 208,
		"./ar-sa.js": 208,
		"./ar-tn": 209,
		"./ar-tn.js": 209,
		"./ar.js": 210,
		"./az": 211,
		"./az.js": 211,
		"./be": 212,
		"./be.js": 212,
		"./bg": 213,
		"./bg.js": 213,
		"./bm": 214,
		"./bm.js": 214,
		"./bn": 216,
		"./bn-bd": 215,
		"./bn-bd.js": 215,
		"./bn.js": 216,
		"./bo": 217,
		"./bo.js": 217,
		"./br": 218,
		"./br.js": 218,
		"./bs": 219,
		"./bs.js": 219,
		"./ca": 220,
		"./ca.js": 220,
		"./cs": 221,
		"./cs.js": 221,
		"./cv": 222,
		"./cv.js": 222,
		"./cy": 223,
		"./cy.js": 223,
		"./da": 224,
		"./da.js": 224,
		"./de": 227,
		"./de-at": 225,
		"./de-at.js": 225,
		"./de-ch": 226,
		"./de-ch.js": 226,
		"./de.js": 227,
		"./dv": 228,
		"./dv.js": 228,
		"./el": 229,
		"./el.js": 229,
		"./en-au": 230,
		"./en-au.js": 230,
		"./en-ca": 231,
		"./en-ca.js": 231,
		"./en-gb": 232,
		"./en-gb.js": 232,
		"./en-ie": 233,
		"./en-ie.js": 233,
		"./en-il": 234,
		"./en-il.js": 234,
		"./en-in": 235,
		"./en-in.js": 235,
		"./en-nz": 236,
		"./en-nz.js": 236,
		"./en-sg": 237,
		"./en-sg.js": 237,
		"./eo": 238,
		"./eo.js": 238,
		"./es": 242,
		"./es-do": 239,
		"./es-do.js": 239,
		"./es-mx": 240,
		"./es-mx.js": 240,
		"./es-us": 241,
		"./es-us.js": 241,
		"./es.js": 242,
		"./et": 243,
		"./et.js": 243,
		"./eu": 244,
		"./eu.js": 244,
		"./fa": 245,
		"./fa.js": 245,
		"./fi": 246,
		"./fi.js": 246,
		"./fil": 247,
		"./fil.js": 247,
		"./fo": 248,
		"./fo.js": 248,
		"./fr": 251,
		"./fr-ca": 249,
		"./fr-ca.js": 249,
		"./fr-ch": 250,
		"./fr-ch.js": 250,
		"./fr.js": 251,
		"./fy": 252,
		"./fy.js": 252,
		"./ga": 253,
		"./ga.js": 253,
		"./gd": 254,
		"./gd.js": 254,
		"./gl": 255,
		"./gl.js": 255,
		"./gom-deva": 256,
		"./gom-deva.js": 256,
		"./gom-latn": 257,
		"./gom-latn.js": 257,
		"./gu": 258,
		"./gu.js": 258,
		"./he": 259,
		"./he.js": 259,
		"./hi": 260,
		"./hi.js": 260,
		"./hr": 261,
		"./hr.js": 261,
		"./hu": 262,
		"./hu.js": 262,
		"./hy-am": 263,
		"./hy-am.js": 263,
		"./id": 264,
		"./id.js": 264,
		"./is": 265,
		"./is.js": 265,
		"./it": 267,
		"./it-ch": 266,
		"./it-ch.js": 266,
		"./it.js": 267,
		"./ja": 268,
		"./ja.js": 268,
		"./jv": 269,
		"./jv.js": 269,
		"./ka": 270,
		"./ka.js": 270,
		"./kk": 271,
		"./kk.js": 271,
		"./km": 272,
		"./km.js": 272,
		"./kn": 273,
		"./kn.js": 273,
		"./ko": 274,
		"./ko.js": 274,
		"./ku": 275,
		"./ku.js": 275,
		"./ky": 276,
		"./ky.js": 276,
		"./lb": 277,
		"./lb.js": 277,
		"./lo": 278,
		"./lo.js": 278,
		"./lt": 279,
		"./lt.js": 279,
		"./lv": 280,
		"./lv.js": 280,
		"./me": 281,
		"./me.js": 281,
		"./mi": 282,
		"./mi.js": 282,
		"./mk": 283,
		"./mk.js": 283,
		"./ml": 284,
		"./ml.js": 284,
		"./mn": 285,
		"./mn.js": 285,
		"./mr": 286,
		"./mr.js": 286,
		"./ms": 288,
		"./ms-my": 287,
		"./ms-my.js": 287,
		"./ms.js": 288,
		"./mt": 289,
		"./mt.js": 289,
		"./my": 290,
		"./my.js": 290,
		"./nb": 291,
		"./nb.js": 291,
		"./ne": 292,
		"./ne.js": 292,
		"./nl": 294,
		"./nl-be": 293,
		"./nl-be.js": 293,
		"./nl.js": 294,
		"./nn": 295,
		"./nn.js": 295,
		"./oc-lnc": 296,
		"./oc-lnc.js": 296,
		"./pa-in": 297,
		"./pa-in.js": 297,
		"./pl": 298,
		"./pl.js": 298,
		"./pt": 300,
		"./pt-br": 299,
		"./pt-br.js": 299,
		"./pt.js": 300,
		"./ro": 301,
		"./ro.js": 301,
		"./ru": 302,
		"./ru.js": 302,
		"./sd": 303,
		"./sd.js": 303,
		"./se": 304,
		"./se.js": 304,
		"./si": 305,
		"./si.js": 305,
		"./sk": 306,
		"./sk.js": 306,
		"./sl": 307,
		"./sl.js": 307,
		"./sq": 308,
		"./sq.js": 308,
		"./sr": 310,
		"./sr-cyrl": 309,
		"./sr-cyrl.js": 309,
		"./sr.js": 310,
		"./ss": 311,
		"./ss.js": 311,
		"./sv": 312,
		"./sv.js": 312,
		"./sw": 313,
		"./sw.js": 313,
		"./ta": 314,
		"./ta.js": 314,
		"./te": 315,
		"./te.js": 315,
		"./tet": 316,
		"./tet.js": 316,
		"./tg": 317,
		"./tg.js": 317,
		"./th": 318,
		"./th.js": 318,
		"./tk": 319,
		"./tk.js": 319,
		"./tl-ph": 320,
		"./tl-ph.js": 320,
		"./tlh": 321,
		"./tlh.js": 321,
		"./tr": 322,
		"./tr.js": 322,
		"./tzl": 323,
		"./tzl.js": 323,
		"./tzm": 325,
		"./tzm-latn": 324,
		"./tzm-latn.js": 324,
		"./tzm.js": 325,
		"./ug-cn": 326,
		"./ug-cn.js": 326,
		"./uk": 327,
		"./uk.js": 327,
		"./ur": 328,
		"./ur.js": 328,
		"./uz": 330,
		"./uz-latn": 329,
		"./uz-latn.js": 329,
		"./uz.js": 330,
		"./vi": 331,
		"./vi.js": 331,
		"./x-pseudo": 332,
		"./x-pseudo.js": 332,
		"./yo": 333,
		"./yo.js": 333,
		"./zh-cn": 334,
		"./zh-cn.js": 334,
		"./zh-hk": 335,
		"./zh-hk.js": 335,
		"./zh-mo": 336,
		"./zh-mo.js": 336,
		"./zh-tw": 337,
		"./zh-tw.js": 337
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 773;


/***/ }),
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo-NOW_6.50e1185.png";

/***/ }),
/* 782 */
/***/ (function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhEAALANUAANjl+KTUGWSuZPb2KWKxVAArAGVq6fT0HajZVEWcRfz8Unu7e1OjU0N2+miwafz8SgBYABqDGl+rXwBEACaKJi9r97XiawASADuUOzly+TWSNfv7RKnA9TaKNna4doC+gEygTLnV96zG62+0b3a3O1uoW36f2Xd344+UszCQL83KpvjvNvnwOlyD6W1zqnOa+bDhQjeXFJ7SMTmkNK7dQ5XKc/bySa2sof3zUT+YQPXtRPTpHy1g9/z8WgBjAAAAACH5BAAAAAAALAAAAAAQAAsAAAaMQJ9QCClCJshJYen7OBcLj8XicAgkJUahacUqeopNIofRMC7NKwJ3ajQMK5kmBUIvCAqFCgAQZVwDAxQJFxA1eQ8tDS8cISYDBwckPxAeBA8bKBkNFRw3kTEdhSMMIDQsBjw8BjsBEREYPxMjIAkJMwM2OgcUrxEasl1ZDDQwY2QawEhLSxfOP9DRP0EAOw=="

/***/ }),
/* 783 */
/***/ (function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhEAALANUAAPxcXPpTU/X1Jfb2K/QtLfxjY+bmAP5yc/7+dvMWFv39APz8TOwAAPMAAP39bfLyE/7+Wvv7RfdLS/pERPQzM/k8PfDyQfT1O/1ra/96evdEROxoVfU7O+UAAPg2NvENDfb2MPPzGfkAAPT0H/j4NuAAAPn5PPXDsf39U/F+V+7fTu3gjfUhIezT1Pnx1vXq4ra7nezhQvj0S9/fAPLzVfTuV+xTUfxMTPK9sMDOqOCMUeSnSuvJS90AAP0AAP8AACH5BAAAAAAALAAAAAAQAAsAAAaFwJ/w5yv6RMiGksH4ZZ6ZwwGDKRQAgYCkmQF4s7fJpOKhELYKBARSU8kiERMJNBDIDGkILbVZWeR0AiMXeAgoJxstODFzdSMhhAoOCy46Ni8qgY8PkZM5PDswFo4hDw8gMyIFY2QEBCwsCQkfHwQlql9aGhocHBRmBD1KDUzFHcclJT3LQQA7"

/***/ }),
/* 784 */
/***/ (function(module, exports) {

	module.exports = "data:image/gif;base64,R0lGODlhEAALANUAAGNjtvr6+vb29fHx8fxGRvkQEP15eatjSuNjSjx6+TV0+f2Kd+np6dvb2PxUVPx4YttjSvsrK5q7/PxlZrpjSvw6Oubm5e7u7sljSgR09Z1jSvT080iB+gBMtkF9+vofHwBpu/f39uLi3/syMtVjSqG+/C9y+Ozs7KLA/GNlwPyBbO3t6gNx5QArs/2XhpGRgKysn+z+/rS0qPR0XuXl/P7KwcnJwf39Wzh3+f7+/fv/+vHx7wNv4df+/f3h3GNnxCH5BAAAAAAALAAAAAAQAAsAAAaMwJ/wl0oBjqoHYgmB/HIoXSkgoQYCoawA9kNxOJ5EAmcyTByEiouUmnoEiYspMxhcTreNrR1OKOYgaBUjEQsYAAEJAwonLCIddwwMFj0yABI4fzwgHS2DER8fCwciAQIbG3aRkxYNPi8qNWZoaRGgBbgqGg0BMVqoqTsrNBYiM0sITU0kGBQUBwca0kEAOw=="

/***/ }),
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(635)
	__webpack_require__(636)
	__webpack_require__(637)
	__webpack_require__(638)
	__webpack_require__(639)
	
	/* script */
	__vue_exports__ = __webpack_require__(439)
	
	/* template */
	var __vue_template__ = __webpack_require__(929)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(440)
	
	/* template */
	var __vue_template__ = __webpack_require__(882)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(441)
	
	/* template */
	var __vue_template__ = __webpack_require__(914)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(442)
	
	/* template */
	var __vue_template__ = __webpack_require__(931)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(444)
	
	/* template */
	var __vue_template__ = __webpack_require__(893)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(614)
	
	/* script */
	__vue_exports__ = __webpack_require__(445)
	
	/* template */
	var __vue_template__ = __webpack_require__(879)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0a5947fc"
	
	module.exports = __vue_exports__


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(446)
	
	/* template */
	var __vue_template__ = __webpack_require__(894)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(631)
	
	/* script */
	__vue_exports__ = __webpack_require__(447)
	
	/* template */
	var __vue_template__ = __webpack_require__(921)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4799f4cd"
	
	module.exports = __vue_exports__


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(612)
	
	/* script */
	__vue_exports__ = __webpack_require__(448)
	
	/* template */
	var __vue_template__ = __webpack_require__(876)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-008be568"
	
	module.exports = __vue_exports__


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(628)
	
	/* script */
	__vue_exports__ = __webpack_require__(450)
	
	/* template */
	var __vue_template__ = __webpack_require__(916)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-40848b48"
	
	module.exports = __vue_exports__


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(619)
	
	/* script */
	__vue_exports__ = __webpack_require__(452)
	
	/* template */
	var __vue_template__ = __webpack_require__(892)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(454)
	
	/* template */
	var __vue_template__ = __webpack_require__(966)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(455)
	
	/* template */
	var __vue_template__ = __webpack_require__(875)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(456)
	
	/* template */
	var __vue_template__ = __webpack_require__(898)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(457)
	
	/* template */
	var __vue_template__ = __webpack_require__(970)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(618)
	
	/* script */
	__vue_exports__ = __webpack_require__(458)
	
	/* template */
	var __vue_template__ = __webpack_require__(891)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-18f43f0e"
	
	module.exports = __vue_exports__


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(459)
	
	/* template */
	var __vue_template__ = __webpack_require__(920)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(460)
	
	/* template */
	var __vue_template__ = __webpack_require__(935)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(647)
	
	/* script */
	__vue_exports__ = __webpack_require__(461)
	
	/* template */
	var __vue_template__ = __webpack_require__(961)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c9fd1a02"
	
	module.exports = __vue_exports__


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(632)
	
	/* script */
	__vue_exports__ = __webpack_require__(462)
	
	/* template */
	var __vue_template__ = __webpack_require__(922)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-487a2e3f"
	
	module.exports = __vue_exports__


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(623)
	
	/* script */
	__vue_exports__ = __webpack_require__(463)
	
	/* template */
	var __vue_template__ = __webpack_require__(908)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(641)
	
	/* script */
	__vue_exports__ = __webpack_require__(464)
	
	/* template */
	var __vue_template__ = __webpack_require__(943)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(466)
	
	/* template */
	var __vue_template__ = __webpack_require__(903)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(467)
	
	/* template */
	var __vue_template__ = __webpack_require__(884)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(468)
	
	/* template */
	var __vue_template__ = __webpack_require__(945)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(650)
	
	/* script */
	__vue_exports__ = __webpack_require__(469)
	
	/* template */
	var __vue_template__ = __webpack_require__(968)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(470)
	
	/* template */
	var __vue_template__ = __webpack_require__(944)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(615)
	
	/* script */
	__vue_exports__ = __webpack_require__(471)
	
	/* template */
	var __vue_template__ = __webpack_require__(885)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-123dcf1e"
	
	module.exports = __vue_exports__


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(472)
	
	/* template */
	var __vue_template__ = __webpack_require__(960)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(474)
	
	/* template */
	var __vue_template__ = __webpack_require__(901)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(475)
	
	/* template */
	var __vue_template__ = __webpack_require__(962)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(476)
	
	/* template */
	var __vue_template__ = __webpack_require__(959)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(478)
	
	/* template */
	var __vue_template__ = __webpack_require__(883)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(480)
	
	/* template */
	var __vue_template__ = __webpack_require__(886)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(644)
	
	/* script */
	__vue_exports__ = __webpack_require__(481)
	
	/* template */
	var __vue_template__ = __webpack_require__(953)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-964bde9a"
	
	module.exports = __vue_exports__


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(629)
	__webpack_require__(630)
	
	/* script */
	__vue_exports__ = __webpack_require__(483)
	
	/* template */
	var __vue_template__ = __webpack_require__(919)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-46a702cc"
	
	module.exports = __vue_exports__


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(649)
	
	/* script */
	__vue_exports__ = __webpack_require__(485)
	
	/* template */
	var __vue_template__ = __webpack_require__(965)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d85afc94"
	
	module.exports = __vue_exports__


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(627)
	
	/* script */
	__vue_exports__ = __webpack_require__(486)
	
	/* template */
	var __vue_template__ = __webpack_require__(915)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3c2316f1"
	
	module.exports = __vue_exports__


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(489)
	
	/* template */
	var __vue_template__ = __webpack_require__(917)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(490)
	
	/* template */
	var __vue_template__ = __webpack_require__(971)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(626)
	
	/* script */
	__vue_exports__ = __webpack_require__(492)
	
	/* template */
	var __vue_template__ = __webpack_require__(912)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(493)
	
	/* template */
	var __vue_template__ = __webpack_require__(930)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(648)
	
	/* script */
	__vue_exports__ = __webpack_require__(494)
	
	/* template */
	var __vue_template__ = __webpack_require__(964)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d79c269c"
	
	module.exports = __vue_exports__


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(495)
	
	/* template */
	var __vue_template__ = __webpack_require__(897)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(646)
	
	/* script */
	__vue_exports__ = __webpack_require__(496)
	
	/* template */
	var __vue_template__ = __webpack_require__(958)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b1b2ceb2"
	
	module.exports = __vue_exports__


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(497)
	
	/* template */
	var __vue_template__ = __webpack_require__(918)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(498)
	
	/* template */
	var __vue_template__ = __webpack_require__(880)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(499)
	
	/* template */
	var __vue_template__ = __webpack_require__(957)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(500)
	
	/* template */
	var __vue_template__ = __webpack_require__(951)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(501)
	
	/* template */
	var __vue_template__ = __webpack_require__(940)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(502)
	
	/* template */
	var __vue_template__ = __webpack_require__(954)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(503)
	
	/* template */
	var __vue_template__ = __webpack_require__(948)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(504)
	
	/* template */
	var __vue_template__ = __webpack_require__(932)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(505)
	
	/* template */
	var __vue_template__ = __webpack_require__(910)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(633)
	
	/* script */
	__vue_exports__ = __webpack_require__(506)
	
	/* template */
	var __vue_template__ = __webpack_require__(924)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(507)
	
	/* template */
	var __vue_template__ = __webpack_require__(934)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(508)
	
	/* template */
	var __vue_template__ = __webpack_require__(887)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(625)
	
	/* script */
	__vue_exports__ = __webpack_require__(509)
	
	/* template */
	var __vue_template__ = __webpack_require__(911)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(510)
	
	/* template */
	var __vue_template__ = __webpack_require__(947)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(511)
	
	/* template */
	var __vue_template__ = __webpack_require__(933)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(512)
	
	/* template */
	var __vue_template__ = __webpack_require__(881)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(513)
	
	/* template */
	var __vue_template__ = __webpack_require__(946)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(514)
	
	/* template */
	var __vue_template__ = __webpack_require__(906)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(515)
	
	/* template */
	var __vue_template__ = __webpack_require__(923)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(516)
	
	/* template */
	var __vue_template__ = __webpack_require__(889)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(517)
	
	/* template */
	var __vue_template__ = __webpack_require__(949)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(518)
	
	/* template */
	var __vue_template__ = __webpack_require__(939)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(519)
	
	/* template */
	var __vue_template__ = __webpack_require__(937)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(520)
	
	/* template */
	var __vue_template__ = __webpack_require__(967)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(521)
	
	/* template */
	var __vue_template__ = __webpack_require__(896)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(522)
	
	/* template */
	var __vue_template__ = __webpack_require__(926)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(523)
	
	/* template */
	var __vue_template__ = __webpack_require__(899)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(624)
	
	/* script */
	__vue_exports__ = __webpack_require__(524)
	
	/* template */
	var __vue_template__ = __webpack_require__(909)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-33f2f844"
	
	module.exports = __vue_exports__


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(525)
	
	/* template */
	var __vue_template__ = __webpack_require__(963)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(528)
	
	/* template */
	var __vue_template__ = __webpack_require__(941)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(617)
	
	/* script */
	__vue_exports__ = __webpack_require__(529)
	
	/* template */
	var __vue_template__ = __webpack_require__(890)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(438)
	
	/* template */
	var __vue_template__ = __webpack_require__(925)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(530)
	
	/* template */
	var __vue_template__ = __webpack_require__(895)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(531)
	
	/* template */
	var __vue_template__ = __webpack_require__(936)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(622)
	
	/* script */
	__vue_exports__ = __webpack_require__(532)
	
	/* template */
	var __vue_template__ = __webpack_require__(905)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(533)
	
	/* template */
	var __vue_template__ = __webpack_require__(928)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(621)
	
	/* script */
	__vue_exports__ = __webpack_require__(534)
	
	/* template */
	var __vue_template__ = __webpack_require__(904)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 875 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('module-template', {
	    attrs: {
	      "title": _vm.resolveTitle(),
	      "subtitle": _vm.subtitle
	    }
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 876 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('SgsRenderNotificationSuccess', {
	    model: {
	      value: (_vm.notificationSuccess),
	      callback: function($$v) {
	        _vm.notificationSuccess = $$v
	      },
	      expression: "notificationSuccess"
	    }
	  }), _vm._v(" "), _c('SgsRenderNotificationError', {
	    model: {
	      value: (_vm.notificationError),
	      callback: function($$v) {
	        _vm.notificationError = $$v
	      },
	      expression: "notificationError"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "page-header"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12 col-md-6"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.title))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body"
	  }, [_c('SgsRenderErrorList', {
	    attrs: {
	      "fieldValue": _vm.instance.errors
	    }
	  }), _vm._v(" "), _c('el-form', {
	    ref: "instance",
	    attrs: {
	      "label-position": "top",
	      "rules": _vm.rules,
	      "model": _vm.instance
	    }
	  }, _vm._l((_vm.rowsToShow), function(row) {
	    return _c('div', {
	      staticClass: "row"
	    }, _vm._l((row.cols), function(col) {
	      return _c('div', {
	        class: 'col-xs-' + col.width + ' col-sm-' + col.width + ' col-md-' + col.width
	      }, [_vm._l((col.fields), function(field) {
	        return [(field.type != 'collapse') ? _c('SgsRender', {
	          attrs: {
	            "moduleType": "form",
	            "type": field.type,
	            "attr": field,
	            "rules": _vm.rules,
	            "fieldValue": _vm.instance[field.columnName],
	            "formIdentifier": _vm.formIdentifier,
	            "instance": _vm.instance
	          },
	          on: {
	            "input": _vm.updateField,
	            "actionLinkSelected": _vm.actionLinkSelected,
	            "callBusinessRule": _vm.callBusinessRule
	          }
	        }) : _c('SgsRenderCollapse', {
	          attrs: {
	            "attr": field,
	            "moduleType": "form"
	          }
	        }, _vm._l((field.rows), function(row) {
	          return _c('div', {
	            staticClass: "row"
	          }, _vm._l((row.cols), function(col) {
	            return _c('div', {
	              class: 'col-xs-' + col.width + ' col-sm-' + col.width + ' col-md-' + col.width
	            }, [_vm._l((col.fields), function(field) {
	              return [(field.type != 'collapse') ? _c('SgsRender', {
	                attrs: {
	                  "moduleType": "form",
	                  "type": field.type,
	                  "attr": field,
	                  "rules": _vm.rules,
	                  "fieldValue": _vm.instance[field.columnName],
	                  "formIdentifier": _vm.formIdentifier,
	                  "instance": _vm.instance
	                },
	                on: {
	                  "input": _vm.updateField,
	                  "actionLinkSelected": _vm.actionLinkSelected,
	                  "callBusinessRule": _vm.callBusinessRule
	                }
	              }) : _vm._e()]
	            })], 2)
	          }), 0)
	        }), 0)]
	      })], 2)
	    }), 0)
	  }), 0)], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 877 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    staticClass: "container-fluid"
	  }, [_c('div', {
	    staticClass: "container-fluid"
	  }, [_c('div', {
	    staticClass: "page-header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.title))])])])]), _vm._v(" "), _c('section', {
	    staticClass: "container-fluid"
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 878 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-button', {
	    class: _vm.alingButton,
	    attrs: {
	      "size": "small",
	      "type": "primary",
	      "disabled": _vm.resolveDisable
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.openForm()
	      }
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 879 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "row padding-top-50px"
	  }, _vm._l((_vm.loggedUser.businessLines), function(row) {
	    return _c('div', {
	      staticClass: "col-xs-12 col-sm-6 col-md-3 col-lg-2 padding-top-10px",
	      attrs: {
	        "offset": _vm.index > 0 ? 2 : 0
	      }
	    }, [_c('RenderImagem', {
	      attrs: {
	        "height": "height: 200px;",
	        "router": {
	          name: 'SystemsList',
	          params: {
	            businessAreaId: row.id
	          }
	        },
	        "label": row.labelPt,
	        "src": _vm.getLogo(row.id)
	      }
	    })], 1)
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 880 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), (_vm.moduleType === 'form') ? _c('el-form-item', {
	    attrs: {
	      "label": "temp",
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "block"
	  }, [_c('el-switch', {
	    attrs: {
	      "on-text": _vm.$t('yes'),
	      "off-text": _vm.$t('no'),
	      "on-color": "#13ce66",
	      "on-value": "YES",
	      "off-value": "NO",
	      "disabled": _vm.attr.disableField
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [_c('el-tag', {
	    attrs: {
	      "type": _vm.updateFieldValue == 'YES' ? 'success' : 'danger'
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.formatField(_vm.updateFieldValue)) + "\n      ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showInList) ? _c('span', [_c('el-tag', {
	    attrs: {
	      "type": _vm.updateFieldValue == 'YES' ? 'success' : 'danger'
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.formatField(_vm.updateFieldValue)) + "\n    ")])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 881 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), (_vm.moduleType === 'form') ? _c('el-form-item', {
	    attrs: {
	      "label": "temp",
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": _vm.placeholder,
	      "disabled": _vm.attr.disableField
	    },
	    on: {
	      "focus": _vm.callBusinessRuleFocus,
	      "blur": _vm.callBusinessRuleBlur
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  }, [_c('template', {
	    slot: "prepend"
	  }, [_vm._v("@")])], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("\n        " + _vm._s(_vm.updateFieldValue) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'list') ? _c('span', [_vm._v("\n    " + _vm._s(_vm.updateFieldValue) + "\n  ")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 882 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('login-template', [_c('div', {
	    staticClass: "login"
	  }, [_c('h2', {
	    staticClass: "form-header"
	  }, [_vm._v(_vm._s(_vm.$t('changePassword')))]), _vm._v(" "), _c('div', {
	    staticClass: "min-height"
	  }, [_c('bootstrap-alert-errors', {
	    attrs: {
	      "errors": _vm.errors
	    }
	  }), _vm._v(" "), (_vm.error) ? _c('div', {
	    staticClass: "alert alert-mini alert-danger"
	  }, [_vm._v("\n                " + _vm._s(_vm.error) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('form', {
	    attrs: {
	      "autocomplete": "off"
	    }
	  }, [_c('fieldset', [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('i', {
	    staticClass: "glyphicon glyphicon-user"
	  })]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.username),
	      expression: "username"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "changePasswordUsername",
	      "placeholder": _vm.$t('username'),
	      "required": "",
	      "id": "changePasswordUsername"
	    },
	    domProps: {
	      "value": (_vm.username)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.username = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('i', {
	    staticClass: "glyphicon glyphicon-lock"
	  })]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password),
	      expression: "password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "name": "changePasswordPassword",
	      "placeholder": _vm.$t('inputNewPassword'),
	      "required": "",
	      "id": "changePasswordPassword"
	    },
	    domProps: {
	      "value": (_vm.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.password = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('i', {
	    staticClass: "glyphicon glyphicon-lock"
	  })]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.repeatPassword),
	      expression: "repeatPassword"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "name": "changePasswordRepeatPassword",
	      "placeholder": _vm.$t('repeatNewPassword'),
	      "required": "",
	      "id": "changePasswordRepeatPassword"
	    },
	    domProps: {
	      "value": (_vm.repeatPassword)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.repeatPassword = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-left": "25px"
	    }
	  }, [_c('password', {
	    attrs: {
	      "strength-meter-only": true,
	      "secureLength": 2
	    },
	    model: {
	      value: (_vm.password),
	      callback: function($$v) {
	        _vm.password = $$v
	      },
	      expression: "password"
	    }
	  })], 1)]), _vm._v(" "), _c('div', [_c('el-button', {
	    staticClass: "form-btn",
	    attrs: {
	      "type": "primary",
	      "native-type": "submit",
	      "disabled": !_vm.isValidToSubmit
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.doChangePassword()
	      }
	    }
	  }, [_vm._v("\n                        " + _vm._s(_vm.$t("continue")) + "\n                    ")]), _vm._v(" "), _c('el-button', {
	    staticClass: "form-btn",
	    attrs: {
	      "type": "primary",
	      "native-type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.backToLogin()
	      }
	    }
	  }, [_vm._v("\n                        " + _vm._s(_vm.$t("cancel")) + "\n                    ")])], 1)])])])])
	},staticRenderFns: []}

/***/ }),
/* 883 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.pagination.totalCount) ? _c('div', [_c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "md": 24,
	      "xs": 24
	    }
	  }, [_c('ul', {
	    staticClass: "list-inline pull-right"
	  }, [_c('li', [_c('span', {
	    staticClass: "visible-xs-inline"
	  }, [_vm._v(_vm._s(_vm.$t("total")) + ":")]), _vm._v(" "), _c('span', {
	    staticClass: "badge"
	  }, [_vm._v(_vm._s(_vm.pagination.totalCount))]), _vm._v(" "), _c('span', {
	    staticClass: "hidden-xs"
	  }, [_vm._v(_vm._s(_vm.$t("itensFound")))])]), _vm._v(" "), _c('li', {
	    staticClass: "hidden-xs",
	    staticStyle: {
	      "width": "80px"
	    }
	  }, [_c('el-select', {
	    on: {
	      "change": function($event) {
	        return _vm.changeItemsPerPage()
	      }
	    },
	    model: {
	      value: (_vm.itemsPerPageSelected),
	      callback: function($$v) {
	        _vm.itemsPerPageSelected = $$v
	      },
	      expression: "itemsPerPageSelected"
	    }
	  }, _vm._l((_vm.itemsPerPageOptions), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "value": item
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('li', {
	    staticClass: "hidden-xs"
	  }, [_vm._v(_vm._s(_vm.$t("registersPerPage")))]), _vm._v(" "), _c('li', [_c('el-button', {
	    attrs: {
	      "size": "small",
	      "disabled": !_vm.showPreviousButton
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.changePage(_vm.pagination.page - 1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-arrow-left"
	  })])], 1), _vm._v(" "), _c('li', {
	    staticClass: "hidden-xs",
	    staticStyle: {
	      "width": "80px"
	    }
	  }, [_c('el-select', {
	    on: {
	      "change": function($event) {
	        return _vm.changePage(_vm.currentPage)
	      }
	    },
	    model: {
	      value: (_vm.currentPage),
	      callback: function($$v) {
	        _vm.currentPage = $$v
	      },
	      expression: "currentPage"
	    }
	  }, _vm._l((_vm.totalPages), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "value": item
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('li', {
	    staticClass: "hidden-xs"
	  }, [_vm._v(_vm._s(_vm.$t("ofPages", [_vm.pagination.totalPage])))]), _vm._v(" "), _c('li', {
	    staticClass: "visible-xs-inline"
	  }, [_vm._v(_vm._s(_vm.currentPage) + "/" + _vm._s(_vm.pagination.totalPage))]), _vm._v(" "), _c('li', [_c('el-button', {
	    attrs: {
	      "size": "small",
	      "disabled": !_vm.showNextButton
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.changePage(_vm.pagination.page + 1)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-arrow-right"
	  })])], 1)])])], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 884 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "noPrint"
	  }, [_c('MenuNoResponsive', {
	    staticClass: "visible-md-block visible-lg-block"
	  }), _vm._v(" "), _c('MenuResponsive', {
	    staticClass: "visible-xs-block visible-sm-block"
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 885 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ul', {
	    staticClass: "nav navbar-nav"
	  }, _vm._l((_vm.menus), function(menu) {
	    return _c('li', {
	      staticClass: "dropdown"
	    }, [_c('a', {
	      attrs: {
	        "href": "javascript:;",
	        "id": menu.id
	      },
	      on: {
	        "click": function($event) {
	          return _vm.openNivel(menu.id)
	        }
	      }
	    }, [_vm._v(_vm._s(menu.labelPt))]), _vm._v(" "), _c('ul', {
	      staticClass: "dropdown-menu"
	    }, _vm._l((menu.childs), function(row) {
	      return _c('li', {
	        staticClass: "dropdown"
	      }, [(row.type == 'NO_LINK') ? [_c('a', {
	        attrs: {
	          "href": "javascript:;",
	          "id": row.id
	        },
	        on: {
	          "click": function($event) {
	            return _vm.openNivel(row.id)
	          }
	        }
	      }, [_vm._v(_vm._s(row.labelPt))])] : [_c('router-link', {
	        attrs: {
	          "to": {
	            name: 'ModuleList',
	            params: {
	              formId: row.formId
	            }
	          },
	          "exact": ""
	        }
	      }, [_vm._v("\n              " + _vm._s(row.labelPt) + "\n            ")])], _vm._v(" "), _c('ul', {
	        staticClass: "dropdown-menu dropdown-menu-text-indent-20px"
	      }, _vm._l((row.childs), function(row2) {
	        return _c('li', {
	          staticClass: "dropdown"
	        }, [(row2.type == 'NO_LINK') ? [_c('a', {
	          attrs: {
	            "href": "javascript:;",
	            "id": row2.id
	          },
	          on: {
	            "click": function($event) {
	              return _vm.openNivel(row2.id)
	            }
	          }
	        }, [_vm._v(_vm._s(row2.labelPt))])] : [_c('router-link', {
	          attrs: {
	            "to": {
	              name: 'ModuleList',
	              params: {
	                formId: row2.formId
	              }
	            },
	            "exact": ""
	          }
	        }, [_vm._v("\n                  " + _vm._s(row2.labelPt) + "\n                ")])], _vm._v(" "), _c('ul', {
	          staticClass: "dropdown-menu dropdown-menu-text-indent-40px"
	        }, _vm._l((row2.childs), function(row3) {
	          return _c('li', {
	            staticClass: "dropdown"
	          }, [_c('router-link', {
	            attrs: {
	              "to": {
	                name: 'ModuleList',
	                params: {
	                  formId: row3.formId
	                }
	              },
	              "exact": ""
	            }
	          }, [_vm._v("\n                    " + _vm._s(row3.labelPt) + "\n                  ")])], 1)
	        }), 0)], 2)
	      }), 0)], 2)
	    }), 0)])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 886 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-tag', {
	    attrs: {
	      "type": _vm.value ? 'success' : 'danger'
	    }
	  }, [_vm._v(_vm._s(_vm.resolveType()))])], 1)
	},staticRenderFns: []}

/***/ }),
/* 887 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.moduleType === 'form') ? _c('SgsRenderInputDataFormWrapper', {
	    attrs: {
	      "attr": _vm.attr,
	      "formIdentifier": _vm.formIdentifier,
	      "fieldValue": _vm.fieldValue,
	      "moduleType": _vm.moduleType,
	      "rules": _vm.rules,
	      "showHint": _vm.showHint,
	      "label": _vm.label,
	      "hintValue": _vm.hintValue,
	      "placeholder": _vm.placeholder,
	      "instance": _vm.instance,
	      "disableField": _vm.disableField
	    },
	    on: {
	      "callBusinessRule": _vm.callBusinessRule
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  }) : _c('SgsRenderInputDataShowOrListWrapper', {
	    attrs: {
	      "attr": _vm.attr,
	      "formIdentifier": _vm.formIdentifier,
	      "fieldValue": _vm.fieldValue,
	      "label": _vm.label,
	      "moduleType": _vm.moduleType
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "navbar-header"
	  }, [(_vm.$route.params.systemId) ? _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('img', {
	    staticClass: "padding-top-10px",
	    attrs: {
	      "src": __webpack_require__(339),
	      "alt": "SGS DO BRASIL"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.goToBusinessArea()
	      }
	    }
	  })]) : _c('img', {
	    staticClass: "padding-top-10px",
	    attrs: {
	      "src": __webpack_require__(339),
	      "alt": "SGS DO BRASIL"
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 889 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), (_vm.moduleType === 'form' || _vm.attr.type === 'filterNumeric') ? _c('el-form-item', {
	    attrs: {
	      "label": "temp",
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "disabled": _vm.attr.disableField
	    },
	    on: {
	      "focus": _vm.callBusinessRuleFocus,
	      "blur": _vm.callBusinessRuleBlur
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  }, [(_vm.getPrefix()) ? _c('template', {
	    slot: "prepend"
	  }, [_vm._v(_vm._s(_vm.getPrefix()))]) : _vm._e(), _vm._v(" "), (_vm.getSufix()) ? _c('template', {
	    slot: "append"
	  }, [_vm._v(_vm._s(_vm.getSufix()))]) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("\n        " + _vm._s(_vm.updateFieldValue) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'list' && _vm.attr.type === 'numeric') ? _c('span', [_vm._v("\n    " + _vm._s(_vm.updateFieldValue) + "\n  ")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 890 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.show) ? _c('div', {
	    staticClass: "load-container"
	  }, [_c('div', {
	    staticClass: "loader"
	  })]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 891 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.businessLineContracts.length > 1) ? _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "row fundo-transparente padding-30px-margintop-50px"
	  }, _vm._l((_vm.businessLineContracts), function(row) {
	    return _c('div', {
	      staticClass: "col-xs-12 col-sm-6 col-md-3 col-lg-2 padding-top-10px",
	      attrs: {
	        "offset": _vm.index > 0 ? 2 : 0
	      }
	    }, [_c('RenderImagem', {
	      attrs: {
	        "height": "height: 200px;",
	        "router": {
	          name: 'ModulesList',
	          params: {
	            systemId: row.id,
	            systemVersion: row.version
	          }
	        },
	        "label": row.labelPt,
	        "src": _vm.getLogo(row.id)
	      }
	    })], 1)
	  }), 0)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 892 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('SgsRenderNotificationSuccess', {
	    model: {
	      value: (_vm.notificationSuccess),
	      callback: function($$v) {
	        _vm.notificationSuccess = $$v
	      },
	      expression: "notificationSuccess"
	    }
	  }), _vm._v(" "), _c('SgsRenderNotificationError', {
	    model: {
	      value: (_vm.notificationError),
	      callback: function($$v) {
	        _vm.notificationError = $$v
	      },
	      expression: "notificationError"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "page-header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body"
	  }, [_c('SgsRenderErrorList', {
	    attrs: {
	      "fieldValue": _vm.instance.errors
	    }
	  }), _vm._v(" "), _c('el-form', {
	    ref: "instance",
	    attrs: {
	      "label-position": "top",
	      "rules": _vm.rules,
	      "model": _vm.instance
	    }
	  }, [_vm._l((_vm.rowsToShow), function(row) {
	    return _c('div', {
	      staticClass: "row"
	    }, _vm._l((row.cols), function(col) {
	      return _c('div', {
	        class: 'col-xs-' + col.width + ' col-sm-' + col.width + ' col-md-' + col.width
	      }, [_vm._l((col.fields), function(field) {
	        return [(field.type != 'collapse') ? _c('SgsRender', {
	          attrs: {
	            "moduleType": "form",
	            "type": field.type,
	            "attr": field,
	            "rules": _vm.rules,
	            "fieldValue": _vm.instance[field.columnName],
	            "formIdentifier": _vm.formIdentifier,
	            "instance": _vm.instance
	          },
	          on: {
	            "input": _vm.updateField,
	            "actionLinkSelected": _vm.actionLinkSelected,
	            "callBusinessRule": _vm.callBusinessRule
	          }
	        }) : _c('SgsRenderCollapse', {
	          attrs: {
	            "attr": field,
	            "moduleType": "form"
	          }
	        }, _vm._l((field.rows), function(row) {
	          return _c('div', {
	            staticClass: "row"
	          }, _vm._l((row.cols), function(col) {
	            return _c('div', {
	              class: 'col-xs-' + col.width + ' col-sm-' + col.width + ' col-md-' + col.width
	            }, [_vm._l((col.fields), function(field) {
	              return [(field.type != 'collapse') ? _c('SgsRender', {
	                attrs: {
	                  "moduleType": "form",
	                  "type": field.type,
	                  "attr": field,
	                  "rules": _vm.rules,
	                  "fieldValue": _vm.instance[field.columnName],
	                  "formIdentifier": _vm.formIdentifier,
	                  "instance": _vm.instance
	                },
	                on: {
	                  "input": _vm.updateField,
	                  "actionLinkSelected": _vm.actionLinkSelected,
	                  "callBusinessRule": _vm.callBusinessRule
	                }
	              }) : _vm._e()]
	            })], 2)
	          }), 0)
	        }), 0)]
	      })], 2)
	    }), 0)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "size": "small"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.doGenerateReport()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n              " + _vm._s(_vm.$t("generateReport")) + "\n            ")])], 1)])], 2)], 1)]), _vm._v(" "), _c('pre', {
	    staticStyle: {
	      "display": "none"
	    }
	  }, [_vm._v(_vm._s(_vm.instance))])], 1)
	},staticRenderFns: []}

/***/ }),
/* 893 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('module-template', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 894 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('module-template', [_c('module-wrapper', {
	    attrs: {
	      "businessAreaId": _vm.businessAreaId,
	      "systemId": _vm.systemId,
	      "systemVersion": _vm.systemVersion,
	      "formId": _vm.formId
	    }
	  }), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": "SGSNow - Report Viewer",
	      "visible": _vm.exportPdfViewer,
	      "size": "full"
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.exportPdfViewer = $event
	      }
	    }
	  }, [_c('object', {
	    attrs: {
	      "data": _vm.exportPdfViewerData,
	      "type": "application/pdf",
	      "width": "100%",
	      "height": _vm.exportPdfViewerHeight
	    }
	  })]), _vm._v(" "), (_vm.showDialogForm.showDialogWithForm) ? _c('el-dialog', {
	    attrs: {
	      "visible": _vm.showDialogForm.showDialogWithForm,
	      "size": "large",
	      "id": "modal",
	      "modal": false
	    },
	    on: {
	      "update:visible": function($event) {
	        return _vm.$set(_vm.showDialogForm, "showDialogWithForm", $event)
	      }
	    }
	  }, [_c('module-template', [_c('module-wrapper', {
	    attrs: {
	      "businessAreaId": _vm.businessAreaId,
	      "systemId": _vm.systemId,
	      "systemVersion": _vm.systemVersion,
	      "formId": _vm.showDialogForm.formIdModal,
	      "parentId": _vm.showDialogForm.parentIdModal
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.autoComplete) ? _c('auto-complete', {
	    attrs: {
	      "payload": _vm.autoComplete.payload,
	      "callback": _vm.autoComplete.callback
	    },
	    on: {
	      "autoCompleteClose": _vm.autoCompleteClose
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 895 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('input', {
	    ref: "input",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.placeholder
	    },
	    domProps: {
	      "value": _vm.value
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 896 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), (_vm.moduleType === 'form') ? _c('el-form-item', {
	    attrs: {
	      "label": "temp",
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "rows": 2,
	      "type": "textarea",
	      "placeholder": _vm.placeholder,
	      "disabled": _vm.attr.disableField
	    },
	    on: {
	      "focus": _vm.callBusinessRuleFocus,
	      "blur": _vm.callBusinessRuleBlur
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("\n        " + _vm._s(_vm.updateFieldValue) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'list') ? _c('span', [_vm._v("\n    " + _vm._s(_vm.updateFieldValue) + "\n  ")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 897 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('SgsRenderNotificationSuccess', {
	    model: {
	      value: (_vm.notificationSuccess),
	      callback: function($$v) {
	        _vm.notificationSuccess = $$v
	      },
	      expression: "notificationSuccess"
	    }
	  }), _vm._v(" "), _c('SgsRenderNotificationError', {
	    model: {
	      value: (_vm.notificationError),
	      callback: function($$v) {
	        _vm.notificationError = $$v
	      },
	      expression: "notificationError"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('el-table', {
	    staticClass: "margin-bottom-15",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.localDataTable,
	      "stripe": ""
	    },
	    on: {
	      "selection-change": _vm.handleSelectionChange
	    }
	  }, [(_vm.attr.multipleSelect) ? _c('el-table-column', {
	    attrs: {
	      "type": "selection",
	      "width": "40"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.attr.actions.length > 0) ? _c('el-table-column', {
	    attrs: {
	      "label": _vm.$t('actions'),
	      "width": _vm.widthIcons
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(_vm.attr.actions.length > 0) ? _c('td', {
	          attrs: {
	            "data-th": _vm.$t('actions')
	          }
	        }, _vm._l((_vm.attr.actions), function(button) {
	          return _c('el-button', {
	            style: (_vm.returnBackgroundColor(button.backgroundColor)),
	            attrs: {
	              "size": "mini",
	              "title": _vm.getButtonHint(button)
	            },
	            on: {
	              "click": function($event) {
	                $event.preventDefault();
	                return _vm.actionButton(button, _vm.row)
	              }
	            }
	          }, [_c('i', {
	            class: _vm.renderIcon(button.icon)
	          })])
	        }), 1) : _vm._e()]
	      }
	    }], null, false, 3650089197)
	  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getHeaders), function(header) {
	    return _c('el-table-column', {
	      attrs: {
	        "label": _vm.getHeader(header),
	        "prop": header.value
	      }
	    })
	  })], 2)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 898 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div')
	},staticRenderFns: []}

/***/ }),
/* 899 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.showHeader('h1')) ? _c('h1', [(_vm.attr.icon !== '' && _vm.attr.icon !== undefined) ? _c('i', {
	    class: _vm.getIcon()
	  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm._label) + "\n  ")]) : (_vm.showHeader('h2')) ? _c('h2', [(_vm.attr.icon !== '' && _vm.attr.icon !== undefined) ? _c('i', {
	    class: _vm.getIcon()
	  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm._label) + "\n  ")]) : (_vm.showHeader('h3')) ? _c('h3', [(_vm.attr.icon !== '' && _vm.attr.icon !== undefined) ? _c('i', {
	    class: _vm.getIcon()
	  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm._label) + "\n  ")]) : (_vm.showHeader('h4')) ? _c('h4', [(_vm.attr.icon !== '' && _vm.attr.icon !== undefined) ? _c('i', {
	    class: _vm.getIcon()
	  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm._label) + "\n  ")]) : (_vm.showHeader('h5')) ? _c('h5', [(_vm.attr.icon !== '' && _vm.attr.icon !== undefined) ? _c('i', {
	    class: _vm.getIcon()
	  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm._label) + "\n  ")]) : (_vm.showHeader('h6')) ? _c('h6', [(_vm.attr.icon !== '' && _vm.attr.icon !== undefined) ? _c('i', {
	    class: _vm.getIcon()
	  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm._label) + "\n  ")]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 900 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.showSgsRender) ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showSgsRenderGrid),
	      expression: "showSgsRenderGrid"
	    }],
	    class: _vm.addClass
	  }, [(_vm.type == 'header') ? _c('SgsRenderHeader', {
	    attrs: {
	      "attr": _vm.attr,
	      "showHint": _vm.showHint(),
	      "hintValue": _vm.getHint(),
	      "label": _vm.getLabel()
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'collapse') ? _c('SgsRenderCollapse', {
	    attrs: {
	      "attr": _vm.attr,
	      "label": _vm.getLabel()
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'text' || _vm.type == 'filterText') ? _c('SgsRenderInputText', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "rules": _vm.rules ? _vm.rules : [],
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "placeholder": _vm.getPlaceholder(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType()
	    },
	    on: {
	      "updateFieldValue": _vm.updateField,
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'password') ? _c('SgsRenderInputPassword', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "rules": _vm.rules ? _vm.rules : [],
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "placeholder": _vm.getPlaceholder(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType()
	    },
	    on: {
	      "updateFieldValue": _vm.updateField,
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'numeric' || _vm.type == 'filterNumeric') ? _c('SgsRenderInputNumber', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "rules": _vm.rules ? _vm.rules : [],
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType()
	    },
	    on: {
	      "updateFieldValue": _vm.updateField,
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'date' || _vm.type == 'filterDate') ? _c('SgsRenderInputDate', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "rules": _vm.rules ? _vm.rules : [],
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "placeholder": _vm.getPlaceholder(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType()
	    },
	    on: {
	      "updateFieldValue": _vm.updateField,
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'dateTime') ? _c('SgsRenderInputDateTime', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "rules": _vm.rules ? _vm.rules : [],
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "placeholder": _vm.getPlaceholder(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType()
	    },
	    on: {
	      "updateFieldValue": _vm.updateField,
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'time') ? _c('SgsRenderInputTime', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "rules": _vm.rules ? _vm.rules : [],
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "placeholder": _vm.getPlaceholder(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType()
	    },
	    on: {
	      "updateFieldValue": _vm.updateField,
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'textArea') ? _c('SgsRenderInputTextArea', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "rules": _vm.rules ? _vm.rules : [],
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "placeholder": _vm.getPlaceholder(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType()
	    },
	    on: {
	      "updateFieldValue": _vm.updateField,
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'boolean') ? _c('SgsRenderInputBoolean', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "placeholder": _vm.getPlaceholder(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType()
	    },
	    on: {
	      "updateFieldValue": _vm.updateField,
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'cpf') ? _c('SgsRenderInputCpf', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "rules": _vm.rules ? _vm.rules : [],
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "placeholder": _vm.getPlaceholder(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType()
	    },
	    on: {
	      "updateFieldValue": _vm.updateField,
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'cnpj') ? _c('SgsRenderInputCnpj', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "rules": _vm.rules ? _vm.rules : [],
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "placeholder": _vm.getPlaceholder(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType()
	    },
	    on: {
	      "updateFieldValue": _vm.updateField,
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'email') ? _c('SgsRenderInputEmail', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "rules": _vm.rules ? _vm.rules : [],
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "placeholder": _vm.getPlaceholder(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType()
	    },
	    on: {
	      "updateFieldValue": _vm.updateField,
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'association' || _vm.type == 'composition') ? _c('SgsRenderInputDataWrapper', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "formIdentifier": _vm.formIdentifier,
	      "rules": _vm.rules ? _vm.rules : [],
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "placeholder": _vm.getPlaceholder(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType(),
	      "instance": _vm.instance,
	      "disableField": _vm.attr.disableField
	    },
	    on: {
	      "updateFieldValue": _vm.updateField,
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'phone') ? _c('SgsRenderInputPhoneNumber', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "rules": _vm.rules ? _vm.rules : [],
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "placeholder": _vm.getPlaceholder(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType()
	    },
	    on: {
	      "updateFieldValue": _vm.updateField,
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'file') ? _c('SgsRenderFile', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "placeholder": _vm.getPlaceholder(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType(),
	      "formIdentifier": _vm.formIdentifier
	    },
	    on: {
	      "updateFieldValue": _vm.updateField
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'currency') ? _c('SgsRenderInputCurrency', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "rules": _vm.rules ? _vm.rules : [],
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "placeholder": _vm.getPlaceholder(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType()
	    },
	    on: {
	      "updateFieldValue": _vm.updateField,
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'image') ? _c('SgsRenderImage', {
	    attrs: {
	      "attr": _vm.attr
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'hidden') ? _c('SgsRenderInputHidden', {
	    attrs: {
	      "attr": _vm.attr
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'dashboard') ? _c('SgsRenderDashboard', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue
	    },
	    on: {
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'label') ? _c('SgsRenderLabel', {
	    attrs: {
	      "attr": _vm.attr,
	      "showHint": _vm.showHint(),
	      "hintValue": _vm.getHint(),
	      "label": _vm.getLabel(),
	      "fieldValue": _vm.fieldValue
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'grid') ? _c('SgsRenderGrid', {
	    attrs: {
	      "attr": _vm.attr,
	      "formIdentifier": _vm.formIdentifier,
	      "instance": _vm.instance,
	      "fieldValue": _vm.fieldValue
	    },
	    on: {
	      "actionLinkSelected": _vm.actionLinkSelected
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'map') ? _c('SgsRenderMap', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "rules": _vm.rules ? _vm.rules : [],
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType()
	    },
	    on: {
	      "updateFieldValue": _vm.updateField,
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'dealership') ? _c('SgsRenderInputDealership', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "rules": _vm.rules ? _vm.rules : [],
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "placeholder": _vm.getPlaceholder(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType()
	    },
	    on: {
	      "updateFieldValue": _vm.updateField,
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'charges') ? _c('SgsRenderInputCharges', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "rules": _vm.rules ? _vm.rules : [],
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "placeholder": _vm.getPlaceholder(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType()
	    },
	    on: {
	      "updateFieldValue": _vm.updateField,
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'buttonReport') ? _c('SgsRenderButtonReport', {
	    attrs: {
	      "attr": _vm.attr,
	      "instance": _vm.instance,
	      "formIdentifier": _vm.formIdentifier,
	      "label": _vm.getLabel()
	    },
	    on: {
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'inputCSV') ? _c('SgsRenderInputCsv', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "rules": _vm.rules ? _vm.rules : [],
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType()
	    },
	    on: {
	      "updateFieldValue": _vm.updateField,
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'textEditor') ? _c('SgsRenderTextEditor', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "rules": _vm.rules ? _vm.rules : [],
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType()
	    },
	    on: {
	      "updateFieldValue": _vm.updateField,
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'float') ? _c('SgsRenderFloat', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "rules": _vm.rules ? _vm.rules : [],
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "placeholder": _vm.getPlaceholder(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType()
	    },
	    on: {
	      "updateFieldValue": _vm.updateField
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'buttonForm') ? _c('SgsRenderButtonForm', {
	    attrs: {
	      "label": _vm.getLabel(),
	      "attr": _vm.attr,
	      "formId": _vm.attr.formId,
	      "instance": _vm.instance
	    },
	    on: {
	      "actionLinkSelected": _vm.actionLinkSelected
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'buttonPrint') ? _c('SgsRenderButtonPrint', {
	    attrs: {
	      "attr": _vm.attr,
	      "label": _vm.getLabel()
	    },
	    on: {
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'buttonPDF') ? _c('SgsRenderButtonPDF', {
	    attrs: {
	      "attr": _vm.attr,
	      "label": _vm.getLabel(),
	      "instance": _vm.instance
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'filterBoolean') ? _c('SgsRenderFilterBoolean', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue,
	      "rules": _vm.rules ? _vm.rules : [],
	      "showHint": _vm.showHint(),
	      "label": _vm.getLabel(),
	      "placeholder": _vm.getPlaceholder(),
	      "hintValue": _vm.getHint(),
	      "moduleType": _vm.getModuleType()
	    },
	    on: {
	      "updateFieldValue": _vm.updateField
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'button') ? _c('SgsRenderButton', {
	    attrs: {
	      "attr": _vm.attr,
	      "label": _vm.getLabel()
	    },
	    on: {
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'errorList') ? _c('SgsRenderErrorList', {
	    attrs: {
	      "fieldValue": _vm.fieldValue
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'select') ? _c('SgsRenderInputSelect', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue
	    },
	    on: {
	      "updateFieldValue": _vm.updateField
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'multiSelect') ? _c('SgsRenderInputMultiSelect', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue
	    },
	    on: {
	      "updateFieldValue": _vm.updateField
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'upload') ? _c('SgsRenderInputButtonUpload', {
	    attrs: {
	      "attr": _vm.attr,
	      "fieldValue": _vm.fieldValue
	    },
	    on: {
	      "updateFieldValue": _vm.updateField
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.type == 'customComponent') ? _c('SgsRenderCustomComponent', {
	    attrs: {
	      "attr": _vm.attr,
	      "instance": _vm.instance,
	      "formIdentifier": _vm.formIdentifier
	    },
	    on: {
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  }) : _vm._e()], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 901 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('input', {
	    directives: [{
	      name: "money",
	      rawName: "v-money",
	      value: ({
	        precision: _vm.precision,
	        decimal: _vm.decimal,
	        thousands: _vm.thousands,
	        prefix: _vm.prefix,
	        suffix: _vm.suffix
	      }),
	      expression: "{precision, decimal, thousands, prefix, suffix}"
	    }],
	    staticClass: "v-money",
	    attrs: {
	      "type": "tel"
	    },
	    domProps: {
	      "value": _vm.formattedValue
	    },
	    on: {
	      "change": _vm.change,
	      "blur": function($event) {
	        return _vm.$emit('blur')
	      },
	      "focus": function($event) {
	        return _vm.$emit('focus')
	      }
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 902 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('SgsRenderNotificationSuccess', {
	    model: {
	      value: (_vm.notificationSuccess),
	      callback: function($$v) {
	        _vm.notificationSuccess = $$v
	      },
	      expression: "notificationSuccess"
	    }
	  }), _vm._v(" "), _c('SgsRenderNotificationError', {
	    model: {
	      value: (_vm.notificationError),
	      callback: function($$v) {
	        _vm.notificationError = $$v
	      },
	      expression: "notificationError"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "page-header"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-sm-12"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-sm-12",
	    staticStyle: {
	      "margin-top": "11px"
	    }
	  }, [_c('div', {
	    staticClass: "pull-right"
	  }, [(_vm.showCreateButton) ? _c('el-button', {
	    attrs: {
	      "size": "small",
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.create()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "glyphicon glyphicon-plus",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n            " + _vm._s(_vm.$t('newA')) + " " + _vm._s(_vm.title) + "\n          ")]) : _vm._e()], 1)])])]), _vm._v(" "), (_vm.state.filter._showFilter) ? _c('el-collapse', {
	    model: {
	      value: (_vm.collapseActiveName),
	      callback: function($$v) {
	        _vm.collapseActiveName = $$v
	      },
	      expression: "collapseActiveName"
	    }
	  }, [_c('el-collapse-item', {
	    attrs: {
	      "title": _vm.$t('filters')
	    }
	  }, [_c('div', [_c('el-form', {
	    ref: "instance",
	    attrs: {
	      "label-position": "top",
	      "rules": _vm.rules,
	      "model": _vm.state.filter
	    }
	  }, [_vm._l((_vm.filterRows), function(row, index) {
	    return _c('div', {
	      staticClass: "row"
	    }, _vm._l((row.cols), function(col, index) {
	      return _c('div', {
	        class: 'col-xs-' + col.width + ' col-sm-' + col.width + ' col-md-' + col.width
	      }, [_vm._l((col.fields), function(field, index) {
	        return [_c('SgsRender', {
	          directives: [{
	            name: "show",
	            rawName: "v-show",
	            value: (!_vm.getFilterField(field.id).hideOnFilter),
	            expression: "!getFilterField(field.id).hideOnFilter"
	          }],
	          attrs: {
	            "type": field.type,
	            "moduleType": "form",
	            "attr": _vm.getFilterField(field.id),
	            "attrConfig": _vm.getAttrConfig(_vm.state.filter, _vm.getColumnName(field.id)),
	            "rules": _vm.rules,
	            "formIdentifier": _vm.formIdentifier,
	            "fieldValue": _vm.state.filter[_vm.getColumnName(field.id)],
	            "instance": _vm.state.filter
	          },
	          on: {
	            "input": _vm.updateField,
	            "callBusinessRule": _vm.callBusinessRuleFilter
	          }
	        })]
	      })], 2)
	    }), 0)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('el-button', {
	    attrs: {
	      "size": "small",
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm._doSearch()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "glyphicon glyphicon-search",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                " + _vm._s(_vm.$t("search")) + "\n              ")])], 1)])], 2)], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.localList.length) ? _c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body"
	  }, [_c('div', {
	    staticClass: "row margin-bottom-15"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('Pagination', {
	    attrs: {
	      "pagination": _vm.pagination(_vm.state)
	    },
	    on: {
	      "change-page": _vm._setPage,
	      "change-items-per-page": _vm._setItemsPerPage
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table table-striped big-table"
	  }, [_c('colgroup', [_c('col', {
	    attrs: {
	      "width": _vm.widthIcons
	    }
	  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('thead', [_c('tr', [(_vm.showShowIcon || _vm.showEditIcon || _vm._resultActions.length > 0) ? _c('th', [_vm._v(_vm._s(_vm.$t('actions')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm._resultDesign), function(field) {
	    return _c('th', [_c('span', [_vm._v(_vm._s(_vm.getTableHeaderLabel(field.id)))])])
	  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.localList), function(fieldsDataRow) {
	    return (_vm.localList.length) ? _c('tr', [(_vm.showShowIcon || _vm.showEditIcon || _vm._resultActions.length > 0) ? _c('td', {
	      staticClass: "buttonIcon"
	    }, [(_vm.showShowIcon) ? _c('el-button', {
	      attrs: {
	        "id": 'show_' + fieldsDataRow.id,
	        "type": "primary",
	        "size": "mini"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.show(fieldsDataRow)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "glyphicon glyphicon-file"
	    })]) : _vm._e(), _vm._v(" "), (_vm.showEditIcon) ? _c('el-button', {
	      attrs: {
	        "id": 'edit_' + fieldsDataRow.id,
	        "type": "primary",
	        "size": "mini"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          return _vm.edit(fieldsDataRow)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "glyphicon glyphicon-edit"
	    })]) : _vm._e(), _vm._v(" "), _vm._l((_vm._resultActions), function(button) {
	      return (_vm._resultActions.length > 0) ? _c('el-button', {
	        style: (_vm.returnBackgroundColor(button.backgroundColor)),
	        attrs: {
	          "size": "mini",
	          "title": button.hintPt
	        },
	        on: {
	          "click": function($event) {
	            $event.preventDefault();
	            return _vm.actionButton(button, fieldsDataRow)
	          }
	        }
	      }, [_c('i', {
	        class: _vm.renderIcon(button.icon)
	      })]) : _vm._e()
	    })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm._resultDesign), function(field) {
	      return _c('td', {
	        attrs: {
	          "data-th": _vm.getFormFieldLabel(field)
	        }
	      }, [_c('SgsRender', {
	        attrs: {
	          "type": field.type,
	          "moduleType": "list",
	          "attr": field,
	          "fieldValue": fieldsDataRow[_vm.getFormField(field.id).columnName],
	          "formIdentifier": _vm.formIdentifier
	        }
	      })], 1)
	    })], 2) : _vm._e()
	  }), 0)])])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showBottomPagination(_vm.state)),
	      expression: "showBottomPagination(state)"
	    }],
	    staticClass: "row margin-top-15"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('Pagination', {
	    attrs: {
	      "pagination": _vm.pagination(_vm.state)
	    },
	    on: {
	      "change-page": _vm._setPage,
	      "change-items-per-page": _vm._setItemsPerPage
	    }
	  })], 1)])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('span', {
	    staticClass: "pull-right",
	    attrs: {
	      "id": "flags"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#",
	      "id": "br"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setPtBr()
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(782)
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "#",
	      "id": "es"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setEs()
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(783)
	    }
	  })]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "#",
	      "id": "us"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.setEn()
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(784)
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 904 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vue-street-view-pano-container"
	  }, [_c('div', {
	    ref: "vue-street-view-pano",
	    staticClass: "vue-street-view-pano"
	  }), _vm._v(" "), _vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 905 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vue-map-container"
	  }, [_c('div', {
	    ref: "vue-map",
	    staticClass: "vue-map"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "vue-map-hidden"
	  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
	},staticRenderFns: []}

/***/ }),
/* 906 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (false),
	      expression: "false"
	    }]
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Hidden",
	      "readonly": true
	    },
	    model: {
	      value: (_vm.fieldValue),
	      callback: function($$v) {
	        _vm.fieldValue = $$v
	      },
	      expression: "fieldValue"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 907 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c("div")
	},staticRenderFns: []}

/***/ }),
/* 908 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', [_c('div', {
	    staticClass: "top-header"
	  }, [_c('div', {
	    staticClass: "container-fluid"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-2 b2"
	  }, [_vm._v("\n              SGS Now\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 font-size-12px"
	  }, [_c('ul', {
	    staticClass: "menu-1"
	  }, [_c('li', {
	    staticClass: "padding-right-10px"
	  }, [_c('a', {
	    attrs: {
	      "href": "http://www.sgsgroup.com.br"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('sgsHome')))])]), _vm._v(" "), _c('li', {
	    staticClass: "border-left-1px padding-left-10px"
	  }, [_c('a', {
	    attrs: {
	      "href": "http://www.sgs.com"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('sgsAroundTheWorld')))])]), _vm._v(" "), _c('li', {
	    staticClass: "border-left-1px padding-left-10px"
	  }, [_c('a', {
	    attrs: {
	      "href": "http://www.sgs.com/en/office-directory"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('contactUs')))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-4 font-size-12px"
	  }, [_c('MenuUser')], 1)])])])])]), _vm._v(" "), _c('nav', {
	    staticClass: "navbar border-sgs"
	  }, [_c('div', {
	    staticClass: "container-fluid"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('Brand')], 1), _vm._v(" "), (_vm.isLogged) ? _c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('ul', {
	    staticClass: "menu root"
	  }, [_c('router-link', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showBusinessLine),
	      expression: "showBusinessLine"
	    }],
	    attrs: {
	      "to": {
	        name: 'BusinessAreaList'
	      },
	      "tag": "li",
	      "exact": ""
	    }
	  }, [_c('a', [_vm._v(_vm._s(_vm.$t("businessLine")))])]), _vm._v(" "), _c('router-link', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showContracts),
	      expression: "showContracts"
	    }],
	    attrs: {
	      "to": {
	        name: 'SystemsList'
	      },
	      "tag": "li",
	      "exact": ""
	    }
	  }, [_c('a', [_vm._v(_vm._s(_vm.$t("contracts")))])])], 1), _vm._v(" "), (_vm.contractMenuShow) ? _c('subMenu') : _vm._e()], 1) : _vm._e()])])])])
	},staticRenderFns: []}

/***/ }),
/* 909 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.type == 'header') ? [_c('h3', [_vm._v(_vm._s(_vm.getLabel()))])] : [_c('label', [_vm._v(_vm._s(_vm.getLabel()))]), _vm._v(" "), _c('p', [_c('FormatField', {
	    attrs: {
	      "value": _vm.fieldValue,
	      "type": _vm.type
	    }
	  })], 1)]], 2)
	},staticRenderFns: []}

/***/ }),
/* 910 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "temp",
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": _vm.placeholder,
	      "readonly": "readonly",
	      "disabled": _vm.disableField
	    },
	    model: {
	      value: (_vm.localValue),
	      callback: function($$v) {
	        _vm.localValue = $$v
	      },
	      expression: "localValue"
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "slot": "prepend",
	      "icon": "search",
	      "disabled": _vm.disableField
	    },
	    on: {
	      "click": function($event) {
	        return _vm.openModal()
	      }
	    },
	    slot: "prepend"
	  }), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "slot": "append",
	      "icon": "delete",
	      "disabled": _vm.disableField
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.clearField()
	      }
	    },
	    slot: "append"
	  })], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 911 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), (_vm.moduleType === 'form' || _vm.attr.type === 'filterDate') ? _c('el-form-item', {
	    attrs: {
	      "label": "temp",
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('el-date-picker', {
	    attrs: {
	      "format": "dd/MM/yyyy",
	      "type": _vm.typeDatePicker,
	      "placeholder": _vm.placeholder,
	      "disabled": _vm.attr.disableField
	    },
	    on: {
	      "change": _vm.callBusinessRuleChange
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [_c('span', [(_vm.convertDate(_vm.updateFieldValue)) ? _c('span', {
	    staticClass: "el-icon-date",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.convertDate(_vm.updateFieldValue)) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'list' && _vm.attr.type === 'date') ? _c('span', [(_vm.convertDate(_vm.updateFieldValue)) ? _c('span', {
	    staticClass: "el-icon-date",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.convertDate(_vm.updateFieldValue)) + "\n  ")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 912 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), (_vm.moduleType === 'form') ? _c('el-form-item', {
	    attrs: {
	      "label": "temp"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('el-upload', {
	    attrs: {
	      "headers": _vm.header,
	      "on-success": _vm.onSuccess,
	      "on-remove": _vm.onRemoveFile,
	      "file-list": _vm.fileList,
	      "action": _vm.resolveUrl(),
	      "show-file-list": true,
	      "on-preview": _vm.downloadFile,
	      "multiple": ""
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "size": "small",
	      "type": "primary",
	      "disabled": _vm.attr.disableField
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.$t("file")) + "\n      ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'custom') ? _c('div', [_c('el-upload', {
	    attrs: {
	      "headers": _vm.header,
	      "on-success": _vm.onSuccess,
	      "on-remove": _vm.onRemoveFile,
	      "file-list": _vm.fileList,
	      "action": _vm.resolveUrl(),
	      "on-preview": _vm.downloadFile,
	      "multiple": ""
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "size": "small",
	      "type": "primary"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("file")))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _vm._l((_vm.value), function(attachment) {
	    return _c('p', [_c('a', {
	      attrs: {
	        "href": _vm.urlDownloadFile(attachment.hash)
	      }
	    }, [_c('i', {
	      staticClass: "glyphicon glyphicon-cloud-download"
	    }), _vm._v("\n        " + _vm._s(attachment.name) + "\n      ")])])
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'list') ? _c('div', _vm._l((_vm.value), function(attachment) {
	    return _c('a', {
	      attrs: {
	        "href": _vm.urlDownloadFile(attachment.hash)
	      }
	    }, [_c('i', {
	      staticClass: "glyphicon glyphicon-cloud-download"
	    }), _vm._v("\n      " + _vm._s(attachment.name) + ",\n    ")])
	  }), 0) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 913 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c("div")
	},staticRenderFns: []}

/***/ }),
/* 914 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('login-template', [_c('div', {
	    staticClass: "login"
	  }, [_c('h2', {
	    staticClass: "form-header"
	  }, [_vm._v(_vm._s(_vm.$t('retrievePassword')))]), _vm._v(" "), _c('div', {
	    staticClass: "min-height"
	  }, [(_vm.error) ? _c('div', {
	    staticClass: "alert alert-mini alert-danger"
	  }, [_c('strong', [_vm._v("Error!")]), _vm._v(" " + _vm._s(_vm.error) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showForm),
	      expression: "showForm"
	    }],
	    staticClass: "min-height"
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t("enterYourUsername")))])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.showForm),
	      expression: "!showForm"
	    }],
	    staticClass: "min-height"
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t("textEmailSent")))])]), _vm._v(" "), _c('form', {
	    attrs: {
	      "autocomplete": "off"
	    }
	  }, [_c('fieldset', [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showForm),
	      expression: "showForm"
	    }],
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('i', {
	    staticClass: "glyphicon glyphicon-user"
	  })]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.username),
	      expression: "username"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "username",
	      "required": "",
	      "id": "username"
	    },
	    domProps: {
	      "value": (_vm.username)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.username = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "padding-top": "20px"
	    }
	  }, [(_vm.showForm) ? _c('el-button', {
	    staticClass: "form-btn",
	    attrs: {
	      "type": "primary",
	      "native-type": "submit",
	      "disabled": !_vm.isValidToSubmit
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.doRetrievePassword()
	      }
	    }
	  }, [_vm._v("\n                        " + _vm._s(_vm.$t("continue")) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.showForm) ? _c('el-button', {
	    staticClass: "form-btn",
	    attrs: {
	      "type": "primary",
	      "native-type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.backToLogin()
	      }
	    }
	  }, [_vm._v("\n                        " + _vm._s(_vm.$t("cancel")) + "\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.showForm) ? _c('el-button', {
	    staticClass: "form-btn",
	    attrs: {
	      "type": "primary",
	      "native-type": "submit"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.backToLogin()
	      }
	    }
	  }, [_vm._v("\n                        " + _vm._s(_vm.$t("back")) + "\n                    ")]) : _vm._e()], 1)])])])])
	},staticRenderFns: []}

/***/ }),
/* 915 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-button', {
	    class: _vm.alingButton,
	    attrs: {
	      "size": "small",
	      "type": "primary",
	      "disabled": _vm.attr.disableField
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.callPrint()
	      }
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 916 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('SgsRenderNotificationSuccess', {
	    model: {
	      value: (_vm.notificationSuccess),
	      callback: function($$v) {
	        _vm.notificationSuccess = $$v
	      },
	      expression: "notificationSuccess"
	    }
	  }), _vm._v(" "), _c('SgsRenderNotificationError', {
	    model: {
	      value: (_vm.notificationError),
	      callback: function($$v) {
	        _vm.notificationError = $$v
	      },
	      expression: "notificationError"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "page-header"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12 col-md-6"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.title))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body"
	  }, [_c('SgsRenderErrorList', {
	    attrs: {
	      "fieldValue": _vm.instance.errors
	    }
	  }), _vm._v(" "), _c('el-form', {
	    ref: "instance",
	    attrs: {
	      "label-position": "top",
	      "rules": _vm.rules,
	      "model": _vm.instance
	    }
	  }, _vm._l((_vm.rowsToShow), function(row) {
	    return _c('div', {
	      staticClass: "row"
	    }, _vm._l((row.cols), function(col) {
	      return _c('div', {
	        class: 'col-xs-' + col.width + ' col-sm-' + col.width + ' col-md-' + col.width
	      }, [_vm._l((col.fields), function(field) {
	        return [(field.type != 'collapse') ? _c('SgsRender', {
	          attrs: {
	            "moduleType": "form",
	            "type": field.type,
	            "attr": field,
	            "rules": _vm.rules,
	            "fieldValue": _vm.instance[field.columnName],
	            "formIdentifier": _vm.formIdentifier,
	            "instance": _vm.instance
	          },
	          on: {
	            "input": _vm.updateField,
	            "actionLinkSelected": _vm.actionLinkSelected,
	            "callBusinessRule": _vm.callBusinessRule
	          }
	        }) : _c('SgsRenderCollapse', {
	          attrs: {
	            "attr": field,
	            "moduleType": "form",
	            "instance": _vm.instance
	          }
	        }, _vm._l((field.rows), function(row) {
	          return _c('div', {
	            staticClass: "row"
	          }, _vm._l((row.cols), function(col) {
	            return _c('div', {
	              class: 'col-xs-' + col.width + ' col-sm-' + col.width + ' col-md-' + col.width
	            }, [_vm._l((col.fields), function(field) {
	              return [(field.type != 'collapse') ? _c('SgsRender', {
	                attrs: {
	                  "moduleType": "form",
	                  "type": field.type,
	                  "attr": field,
	                  "rules": _vm.rules,
	                  "fieldValue": _vm.instance[field.columnName],
	                  "formIdentifier": _vm.formIdentifier,
	                  "instance": _vm.instance
	                },
	                on: {
	                  "input": _vm.updateField,
	                  "actionLinkSelected": _vm.actionLinkSelected,
	                  "callBusinessRule": _vm.callBusinessRule
	                }
	              }) : _vm._e()]
	            })], 2)
	          }), 0)
	        }), 0)]
	      })], 2)
	    }), 0)
	  }), 0)], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 917 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c(_vm.currentView, {
	    tag: "component",
	    attrs: {
	      "params": _vm.params
	    },
	    on: {
	      "callBusinessRule": _vm.callBusinessRule
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 918 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('img', {
	    style: (_vm.heightStyle),
	    attrs: {
	      "src": _vm.attr.url
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 919 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "display": "inline"
	    }
	  }, [_c('el-button', {
	    class: _vm.alingButton,
	    attrs: {
	      "size": "small",
	      "type": "primary",
	      "disabled": _vm.attr.disableField
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.callBusinessRule()
	      }
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 920 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-dialog', {
	    attrs: {
	      "title": _vm.$t('changePassword'),
	      "visible": _vm._value,
	      "id": "modal"
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm._value = $event
	      },
	      "close": _vm.close
	    }
	  }, [_c('el-form', {
	    ref: "payload",
	    attrs: {
	      "label-position": "top",
	      "rules": _vm.rules,
	      "model": _vm.payload
	    }
	  }, [_c('bootstrap-alert-errors', {
	    attrs: {
	      "errors": _vm.errors
	    }
	  }), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": _vm.$t('currentPassword'),
	      "prop": "currentPassword"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "password",
	      "id": "currentPassword"
	    },
	    model: {
	      value: (_vm.payload.currentPassword),
	      callback: function($$v) {
	        _vm.$set(_vm.payload, "currentPassword", $$v)
	      },
	      expression: "payload.currentPassword"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": _vm.$t('newPassword'),
	      "prop": "newPassword"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "password",
	      "id": "newPassword"
	    },
	    model: {
	      value: (_vm.payload.newPassword),
	      callback: function($$v) {
	        _vm.$set(_vm.payload, "newPassword", $$v)
	      },
	      expression: "payload.newPassword"
	    }
	  }), _vm._v(" "), _c('password', {
	    attrs: {
	      "strength-meter-only": true,
	      "secureLength": 2
	    },
	    model: {
	      value: (_vm.payload.newPassword),
	      callback: function($$v) {
	        _vm.$set(_vm.payload, "newPassword", $$v)
	      },
	      expression: "payload.newPassword"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": _vm.$t('repeatNewPassword'),
	      "prop": "repeatNewPassword"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": "password",
	      "id": "repeatNewPassword"
	    },
	    model: {
	      value: (_vm.payload.repeatNewPassword),
	      callback: function($$v) {
	        _vm.$set(_vm.payload, "repeatNewPassword", $$v)
	      },
	      expression: "payload.repeatNewPassword"
	    }
	  })], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "size": "small",
	      "id": "close"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.close()
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t("close")) + "\n        ")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "size": "small",
	      "id": "save"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.save()
	      }
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.$t("save")) + "\n        ")])], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 921 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('SgsRenderNotificationSuccess', {
	    model: {
	      value: (_vm.notificationSuccess),
	      callback: function($$v) {
	        _vm.notificationSuccess = $$v
	      },
	      expression: "notificationSuccess"
	    }
	  }), _vm._v(" "), _c('SgsRenderNotificationError', {
	    model: {
	      value: (_vm.notificationError),
	      callback: function($$v) {
	        _vm.notificationError = $$v
	      },
	      expression: "notificationError"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "page-header"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12 col-md-6"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.title))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body"
	  }, [_c(_vm.currentView, {
	    tag: "component",
	    attrs: {
	      "params": _vm.params
	    },
	    on: {
	      "callBusinessRule": _vm.callBusinessRule,
	      "actionLinkSelected": _vm.actionLinkSelected
	    }
	  })], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 922 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "footer font-size-12px-color noPrint"
	  }, [_c('div', {
	    staticClass: "container-fluid"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-9"
	  }, [_vm._v("\n        2022 © SGS DO BRASIL. All rights reserved.\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-3"
	  }, [_c('span', {
	    staticClass: "pull-right"
	  }, [_vm._v("\n          " + _vm._s(_vm.$t('version')) + " - 1.17.03\n        ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 923 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-form-item', {
	    attrs: {
	      "label": "Label"
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "multiple": "",
	      "placeholder": _vm.$t('select')
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  }, _vm._l((_vm.options), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }), 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 924 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.attr_copy != '') ? _c('SgsRenderInputData', {
	    attrs: {
	      "attr": _vm.attr_copy,
	      "fieldValue": _vm.fieldValue,
	      "rules": _vm.rules,
	      "showHint": _vm.showHint,
	      "label": _vm.label,
	      "hintValue": _vm.hintValue,
	      "moduleType": _vm.moduleType,
	      "placeholder": _vm.placeholder,
	      "instance": _vm.instance,
	      "formIdentifier": _vm.formIdentifier,
	      "attrOriginal": _vm.attr,
	      "disableField": _vm.disableField
	    },
	    on: {
	      "callBusinessRule": _vm.callBusinessRule
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  }) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 925 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "calendar",
	    attrs: {
	      "id": "calendar"
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 926 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), (_vm.moduleType === 'form') ? _c('el-form-item', {
	    attrs: {
	      "label": "temp",
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "block"
	  }, [_c('el-time-picker', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "format": "HH:mm",
	      "placeholder": _vm.placeholder,
	      "disabled": _vm.attr.disableField
	    },
	    on: {
	      "blur": _vm.callBusinessRuleChange
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [(_vm.convertDate(_vm.updateFieldValue)) ? _c('span', {
	    staticClass: "el-icon-time",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.convertDate(_vm.updateFieldValue)) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'list') ? _c('span', [_c('span', [(_vm.convertDate(_vm.updateFieldValue)) ? _c('span', {
	    staticClass: "el-icon-time",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.convertDate(_vm.updateFieldValue)) + "\n    ")])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "meu-container"
	  }, [_c('div', {
	    staticClass: "row margin-bottom-10",
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "wrapper"
	  }, [_c('div', [_c('div', {
	    staticClass: "left"
	  }, [_vm._m(0), _vm._v(" "), _c('p', {
	    staticClass: "back-p"
	  }, [_vm._v("\n                            " + _vm._s(_vm.$t('loginDescription')) + "\n                        ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-container"
	  }, [_vm._t("default")], 2)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('img', {
	    staticClass: "img",
	    attrs: {
	      "src": __webpack_require__(781),
	      "alt": "SGS DO BRASIL"
	    }
	  })])
	}]}

/***/ }),
/* 928 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', [_c('span', {
	    domProps: {
	      "textContent": _vm._s(_vm.label)
	    }
	  }), _vm._v(" "), _c('input', {
	    ref: "input",
	    class: _vm.className,
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.placeholder
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 929 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('PageLoader'), _vm._v(" "), _c('RootHeader'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('AppFooter')], 1)
	},staticRenderFns: []}

/***/ }),
/* 930 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "temp",
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint) ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('el-select', {
	    attrs: {
	      "clearable": "",
	      "placeholder": _vm.placeholder
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  }, _vm._l((_vm.options), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }), 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 931 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('login-template', [_c('div', {
	    staticClass: "login"
	  }, [_c('h2', {
	    staticClass: "form-header"
	  }, [_vm._v(_vm._s(_vm.$t('loginPage')))]), _vm._v(" "), _c('div', {
	    staticClass: "min-height"
	  }, [(_vm.error) ? _c('div', {
	    staticClass: "alert alert-mini alert-danger"
	  }, [_c('strong', [_vm._v("Error!")]), _vm._v(" " + _vm._s(_vm.error) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('form', {
	    attrs: {
	      "autocomplete": "off"
	    }
	  }, [_c('fieldset', [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('i', {
	    staticClass: "glyphicon glyphicon-user"
	  })]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.username),
	      expression: "username"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "username",
	      "placeholder": _vm.loginPlaceholder,
	      "required": "",
	      "id": "username"
	    },
	    domProps: {
	      "value": (_vm.username)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.username = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('i', {
	    staticClass: "glyphicon glyphicon-lock"
	  })]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password),
	      expression: "password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "name": "password",
	      "placeholder": _vm.$t('password'),
	      "required": "",
	      "id": "password"
	    },
	    domProps: {
	      "value": (_vm.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.password = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "padding-top": "20px"
	    }
	  }, [_c('el-button', {
	    staticClass: "form-btn",
	    attrs: {
	      "type": "primary",
	      "native-type": "submit",
	      "disabled": !_vm.isValidToSubmit
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.doLogin()
	      }
	    }
	  }, [_vm._v("\n                        " + _vm._s(_vm.$t("loginPage")) + "\n                    ")])], 1)])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "padding-top": "30px"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        path: '/forgetPassword'
	      },
	      "tag": "a"
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t("forgotMyPassword")) + "\n            ")])], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 932 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), (_vm.moduleType === 'form') ? _c('el-form-item', {
	    attrs: {
	      "label": "temp",
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('MaskedField', {
	    attrs: {
	      "mask": '#####################,##',
	      "attr": _vm.attr
	    },
	    on: {
	      "callBusinessRule": _vm.callBusinessRule
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("\n        " + _vm._s(_vm.updateFieldValue) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'list') ? _c('span', [_vm._v("\n    " + _vm._s(_vm.updateFieldValue) + "\n  ")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 933 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), (_vm.moduleType === 'form') ? _c('el-form-item', {
	    attrs: {
	      "label": "temp",
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('MaskedField', {
	    attrs: {
	      "mask": '###########-# ###########-# ###########-# ###########-#',
	      "placeholder": '99999999999-9 99999999999-9 99999999999-9 99999999999-9',
	      "attr": _vm.attr
	    },
	    on: {
	      "callBusinessRule": _vm.callBusinessRule
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("\n        " + _vm._s(_vm.updateFieldValue) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'list') ? _c('span', [_vm._v("\n    " + _vm._s(_vm.updateFieldValue) + "\n  ")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 934 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("\n        " + _vm._s(_vm.localObject[_vm.localField.columnName]) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'list') ? _c('span', [_vm._v("\n    " + _vm._s(_vm.localObject[_vm.localField.columnName]) + "\n  ")]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 935 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('module-template', {
	    attrs: {
	      "title": _vm.resolveTitle(),
	      "subtitle": _vm.subtitle
	    }
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 936 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    ref: "flyaway"
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 937 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-form-item', {
	    attrs: {
	      "label": _vm.getLabel()
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": _vm.getPlaceholder()
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  }, _vm._l((_vm.options), function(item) {
	    return _c('el-option', {
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  }), 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 938 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.messages.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, _vm._l((_vm.messages), function(message) {
	    return _c('p', [_vm._v(_vm._s(message))])
	  }), 0) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 939 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), (_vm.moduleType === 'form') ? _c('el-form-item', {
	    attrs: {
	      "label": "temp",
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": _vm.placeholder,
	      "disabled": _vm.attr.disableField
	    },
	    on: {
	      "focus": _vm.callBusinessRuleFocus,
	      "blur": _vm.callBusinessRuleBlur
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("\n        " + _vm._s(_vm.updateFieldValue) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'list') ? _c('span', [_vm._v("\n    " + _vm._s(_vm.updateFieldValue) + "\n  ")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 940 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), (_vm.moduleType === 'form') ? _c('el-form-item', {
	    attrs: {
	      "label": "temp",
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('MaskedField', {
	    attrs: {
	      "mask": '##.###.###/####-##',
	      "placeholder": '99.999.999/9999-99',
	      "attr": _vm.attr
	    },
	    on: {
	      "callBusinessRule": _vm.callBusinessRule
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("\n        " + _vm._s(_vm.updateFieldValue) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'list') ? _c('span', [_vm._v("\n    " + _vm._s(_vm.updateFieldValue) + "\n  ")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 941 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), (_vm.moduleType === 'form' || _vm.attr.type === 'filterText') ? _c('el-form-item', {
	    attrs: {
	      "label": "temp",
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('froala', {
	    attrs: {
	      "config": _vm.config
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [_c('froala', {
	    attrs: {
	      "config": _vm.configDisabledEditor
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  })], 1)]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 942 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('div', {
	    staticClass: "meu-thumbex margin-10px-10px-30px",
	    style: (_vm.height),
	    attrs: {
	      "body-style": {
	        padding: '0px'
	      }
	    }
	  }, [_c('div', {
	    staticClass: "meu-thumbnail"
	  }, [_c('router-link', {
	    attrs: {
	      "to": _vm.router
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.src
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "margin-40-3"
	  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.label))])])])])], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 943 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', [_c('nav', {
	    staticClass: "navbar border-sgs"
	  }, [_c('div', {
	    staticClass: "navbar-header"
	  }, [(_vm.isLogged) ? _c('button', {
	    staticClass: "navbar-toggle collapsed",
	    attrs: {
	      "type": "button",
	      "id": "open"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.open()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-bar",
	    staticStyle: {
	      "background": "black"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar",
	    staticStyle: {
	      "background": "black"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar",
	    staticStyle: {
	      "background": "black"
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('a', [_c('Brand')], 1)]), _vm._v(" "), (_vm.isLogged) ? _c('div', {
	    staticClass: "collapse navbar-collapse",
	    class: _vm.meuCollapse,
	    attrs: {
	      "id": "navbar"
	    }
	  }, [_c('ul', {
	    staticClass: "nav navbar-nav"
	  }, [_c('router-link', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showBusinessLine),
	      expression: "showBusinessLine"
	    }],
	    attrs: {
	      "to": {
	        name: 'BusinessAreaList'
	      },
	      "tag": "li",
	      "exact": ""
	    }
	  }, [_c('a', [_vm._v(_vm._s(_vm.$t("businessLine")))])]), _vm._v(" "), _c('router-link', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showContracts),
	      expression: "showContracts"
	    }],
	    attrs: {
	      "to": {
	        name: 'SystemsList'
	      },
	      "tag": "li",
	      "exact": ""
	    }
	  }, [_c('a', [_vm._v(_vm._s(_vm.$t("contracts")))])])], 1), _vm._v(" "), (_vm.contractMenuShow) ? _c('subMenuResponsive', {
	    attrs: {
	      "meuCollapse": _vm.meuCollapse
	    }
	  }) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "nav navbar-nav"
	  }, [(_vm.isLogged) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.doLogout.apply(null, arguments)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t("logout")))])]) : _vm._e()])], 1) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 944 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('ul', {
	    staticClass: "menu root"
	  }, _vm._l((_vm.menus), function(menu) {
	    return _c('li', [_c('a', {
	      attrs: {
	        "href": "javascript:;"
	      }
	    }, [_vm._v(_vm._s(_vm.getLabel(menu)))]), _vm._v(" "), _c('ul', {
	      staticClass: "submenu submenu-1"
	    }, _vm._l((menu.childs), function(row) {
	      return _c('li', [(row.type == 'NO_LINK') ? [_c('a', {
	        attrs: {
	          "href": "javascript:;"
	        }
	      }, [_vm._v(_vm._s(_vm.getLabel(row)))])] : [_c('router-link', {
	        attrs: {
	          "to": {
	            name: 'ModuleList',
	            params: {
	              formId: row.formId
	            }
	          },
	          "exact": ""
	        }
	      }, [_vm._v("\n              " + _vm._s(_vm.getLabel(row)) + "\n            ")])], _vm._v(" "), _c('ul', {
	        staticClass: "submenu submenu-2"
	      }, _vm._l((row.childs), function(row2) {
	        return _c('li', [(row2.type == 'NO_LINK') ? [_c('a', {
	          attrs: {
	            "href": "javascript:;"
	          }
	        }, [_vm._v(_vm._s(_vm.getLabel(row2)))])] : [_c('router-link', {
	          attrs: {
	            "to": {
	              name: 'ModuleList',
	              params: {
	                formId: row2.formId
	              }
	            },
	            "exact": ""
	          }
	        }, [_vm._v("\n                  " + _vm._s(_vm.getLabel(row2)) + "\n                ")])], _vm._v(" "), _c('ul', {
	          staticClass: "submenu submenu-3"
	        }, _vm._l((row2.childs), function(row3) {
	          return _c('li', [(row3.type == 'NO_LINK') ? [_c('a', {
	            attrs: {
	              "href": "javascript:;"
	            }
	          }, [_vm._v(_vm._s(_vm.getLabel(row3)))])] : [_c('router-link', {
	            attrs: {
	              "to": {
	                name: 'ModuleList',
	                params: {
	                  formId: row3.formId
	                }
	              },
	              "exact": ""
	            }
	          }, [_vm._v("\n                      " + _vm._s(_vm.getLabel(row3)) + "\n                    ")])]], 2)
	        }), 0)], 2)
	      }), 0)], 2)
	    }), 0)])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 945 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c("div")
	},staticRenderFns: []}

/***/ }),
/* 946 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-form-item', {
	    attrs: {
	      "label": _vm.label,
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": _vm.placeholder
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 947 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), (_vm.moduleType === 'form') ? _c('el-form-item', {
	    attrs: {
	      "label": "temp",
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "block"
	  }, [_c('el-date-picker', {
	    attrs: {
	      "format": "dd/MM/yyyy HH:mm",
	      "type": "datetime",
	      "placeholder": _vm.placeholder,
	      "disabled": _vm.attr.disableField
	    },
	    on: {
	      "change": _vm.callBusinessRuleChange
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [(_vm.convertDate(_vm.updateFieldValue)) ? _c('span', {
	    staticClass: "el-icon-date",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.convertDate(_vm.updateFieldValue)) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'list') ? _c('span', [(_vm.convertDate(_vm.updateFieldValue)) ? _c('span', {
	    staticClass: "el-icon-date",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.convertDate(_vm.updateFieldValue)) + "\n  ")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 948 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), (_vm.moduleType === 'form' || _vm.attr.type === 'filterText') ? _c('el-form-item', {
	    attrs: {
	      "label": "temp",
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "size": "small",
	      "disabled": _vm.attr.disableField
	    },
	    on: {
	      "click": function($event) {
	        return _vm.callInputFile()
	      }
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.$t("chooseAFile")) + "\n    ")]), _vm._v(" "), _c('input', {
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "type": "file",
	      "id": "file",
	      "accept": ".csv"
	    },
	    on: {
	      "change": _vm.openFile
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fileName))])], 1) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [_c('span', [_c('pre', [_vm._v(_vm._s(_vm.updateFieldValue))])])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 949 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), (_vm.moduleType === 'form') ? _c('el-form-item', {
	    attrs: {
	      "label": "temp",
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": _vm.placeholder,
	      "type": "password",
	      "disabled": _vm.attr.disableField
	    },
	    on: {
	      "focus": _vm.callBusinessRuleFocus,
	      "blur": _vm.callBusinessRuleBlur
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("\n        " + _vm._s(_vm.updateFieldValue ? '********' : '') + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'list') ? _c('span', [_vm._v("\n    " + _vm._s(_vm.updateFieldValue ? '********' : '') + "\n  ")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 950 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "page-header"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body"
	  }, [_c('SgsRenderNotificationSuccess', {
	    model: {
	      value: (_vm.notificationSuccess),
	      callback: function($$v) {
	        _vm.notificationSuccess = $$v
	      },
	      expression: "notificationSuccess"
	    }
	  }), _vm._v(" "), _c('SgsRenderNotificationError', {
	    model: {
	      value: (_vm.notificationError),
	      callback: function($$v) {
	        _vm.notificationError = $$v
	      },
	      expression: "notificationError"
	    }
	  }), _vm._v(" "), _c('SgsRenderErrorList', {
	    attrs: {
	      "fieldValue": _vm.instance.errors
	    }
	  }), _vm._v(" "), _c('el-form', {
	    ref: "instance",
	    attrs: {
	      "label-position": "top",
	      "rules": _vm.rules,
	      "model": _vm.instance
	    }
	  }, [_vm._l((_vm.rowsToShow), function(row) {
	    return _c('div', {
	      staticClass: "row"
	    }, _vm._l((row.cols), function(col) {
	      return _c('div', {
	        class: 'col-xs-' + col.width + ' col-sm-' + col.width + ' col-md-' + col.width
	      }, [_vm._l((col.fields), function(field) {
	        return [(field.type != 'collapse') ? _c('SgsRender', {
	          attrs: {
	            "moduleType": "form",
	            "type": field.type,
	            "attr": field,
	            "rules": _vm.rules,
	            "fieldValue": _vm.instance[field.columnName],
	            "formIdentifier": _vm.formIdentifier,
	            "instance": _vm.instance
	          },
	          on: {
	            "input": _vm.updateField,
	            "actionLinkSelected": _vm.actionLinkSelected,
	            "callBusinessRule": _vm.callBusinessRule
	          }
	        }) : _c('SgsRenderCollapse', {
	          attrs: {
	            "attr": field,
	            "moduleType": "form",
	            "instance": _vm.instance
	          }
	        }, _vm._l((field.rows), function(row) {
	          return _c('div', {
	            staticClass: "row"
	          }, _vm._l((row.cols), function(col) {
	            return _c('div', {
	              class: 'col-xs-' + col.width + ' col-sm-' + col.width + ' col-md-' + col.width
	            }, [_vm._l((col.fields), function(field) {
	              return [(field.type != 'collapse') ? _c('SgsRender', {
	                attrs: {
	                  "moduleType": "form",
	                  "type": field.type,
	                  "attr": field,
	                  "rules": _vm.rules,
	                  "fieldValue": _vm.instance[field.columnName],
	                  "formIdentifier": _vm.formIdentifier,
	                  "instance": _vm.instance
	                },
	                on: {
	                  "input": _vm.updateField,
	                  "actionLinkSelected": _vm.actionLinkSelected,
	                  "callBusinessRule": _vm.callBusinessRule
	                }
	              }) : _vm._e()]
	            })], 2)
	          }), 0)
	        }), 0)]
	      })], 2)
	    }), 0)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('el-button-group', [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "size": "small"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.doSave()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-check",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n                " + _vm._s(_vm.$t("save")) + "\n              ")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "size": "small",
	      "id": "backToSearch"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.backToSearch()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-arrow-left"
	  }), _vm._v("\n                " + _vm._s(_vm.$t("backToList")) + "\n              ")]), _vm._v(" "), (_vm.id) ? _c('el-button', {
	    attrs: {
	      "size": "small",
	      "id": "backToSearch"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.backToShow()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "el-icon-arrow-left"
	  }), _vm._v("\n                " + _vm._s(_vm.$t("backToDetails")) + "\n              ")]) : _vm._e()], 1)], 1)])], 2)], 1)]), _vm._v(" "), _c('pre', {
	    staticStyle: {
	      "display": "none"
	    }
	  }, [_vm._v(_vm._s(_vm.instance))])])
	},staticRenderFns: []}

/***/ }),
/* 951 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), (_vm.moduleType === 'form') ? _c('el-form-item', {
	    attrs: {
	      "label": "temp",
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('MaskedField', {
	    attrs: {
	      "mask": '#####.##### #####.###### #####.###### # ##############',
	      "placeholder": '99999.99999 99999.999999 99999.999999 9 99999999999999',
	      "attr": _vm.attr
	    },
	    on: {
	      "callBusinessRule": _vm.callBusinessRule
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("\n        " + _vm._s(_vm.updateFieldValue) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'list') ? _c('span', [_vm._v("\n    " + _vm._s(_vm.updateFieldValue) + "\n  ")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 952 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('SgsRenderNotificationSuccess', {
	    model: {
	      value: (_vm.notificationSuccess),
	      callback: function($$v) {
	        _vm.notificationSuccess = $$v
	      },
	      expression: "notificationSuccess"
	    }
	  }), _vm._v(" "), _c('SgsRenderNotificationError', {
	    model: {
	      value: (_vm.notificationError),
	      callback: function($$v) {
	        _vm.notificationError = $$v
	      },
	      expression: "notificationError"
	    }
	  }), _vm._v(" "), _c('el-button', {
	    class: _vm.alingButton,
	    attrs: {
	      "size": "small",
	      "type": "primary",
	      "disabled": _vm.attr.disableField
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.generateReport()
	      }
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 953 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-dialog', {
	    attrs: {
	      "title": _vm.getTitle,
	      "visible": _vm.showDialog
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.showDialog = $event
	      },
	      "close": _vm.closeModal
	    }
	  }, [_c('el-row', {
	    staticClass: "margin-bottom-30"
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.filter),
	      callback: function($$v) {
	        _vm.filter = $$v
	      },
	      expression: "filter"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-table', {
	    attrs: {
	      "data": _vm.gridData,
	      "height": "300",
	      "stripe": ""
	    }
	  }, [_vm._l((_vm._columnsToShow), function(item) {
	    return _c('el-table-column', {
	      attrs: {
	        "label": item.label
	      },
	      inlineTemplate: {
	        render: function() {
	          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	            return _c('SgsRender', {
	              attrs: {
	                "type": item.attr.type,
	                "moduleType": "list",
	                "attr": item.attr,
	                "fieldValue": _vm.row[item.value],
	                "formIdentifier": _vm.formIdentifier
	              }
	            })
	          
	        },
	        staticRenderFns: []
	      }
	    })
	  }), _vm._v(" "), _c('el-table-column', {
	    inlineTemplate: {
	      render: function() {
	        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	          return _c('el-button', {
	            attrs: {
	              "size": "mini",
	              "type": "primary"
	            },
	            on: {
	              "click": function($event) {
	                $event.preventDefault();
	                return _vm.selectRow(_vm.row)
	              }
	            }
	          }, [_vm._v("\n              Selecione\n            ")])
	        
	      },
	      staticRenderFns: []
	    }
	  })], 2)], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 954 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), (_vm.moduleType === 'form') ? _c('el-form-item', {
	    attrs: {
	      "label": "temp",
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('MaskedField', {
	    attrs: {
	      "mask": '###.###.###-##',
	      "placeholder": '999.999.999-99',
	      "attr": _vm.attr
	    },
	    on: {
	      "callBusinessRule": _vm.callBusinessRule
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("\n        " + _vm._s(_vm.updateFieldValue) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'list') ? _c('span', [_vm._v("\n    " + _vm._s(_vm.updateFieldValue) + "\n  ")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 955 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "el-form-item__content"
	  }, [_c('div', {
	    class: _vm.classToDivBeforeInput()
	  }, [_c('input', {
	    directives: [{
	      name: "mask",
	      rawName: "v-mask",
	      value: (_vm.mask),
	      expression: "mask"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm._value),
	      expression: "_value"
	    }],
	    staticClass: "form-control el-input__inner",
	    attrs: {
	      "placeholder": _vm.placeholder,
	      "disabled": _vm.attr.disableField
	    },
	    domProps: {
	      "value": (_vm._value)
	    },
	    on: {
	      "focus": _vm.callBusinessRuleFocus,
	      "blur": _vm.callBusinessRuleBlur,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm._value = $event.target.value
	      }
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 956 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.showCollapse) ? _c('div', {
	    class: _vm.hideFieldOnPrint
	  }, [_c('el-collapse', {
	    staticClass: "el-collapse-01",
	    model: {
	      value: (_vm.meuCollapse),
	      callback: function($$v) {
	        _vm.meuCollapse = $$v
	      },
	      expression: "meuCollapse"
	    }
	  }, [_c('el-collapse-item', {
	    attrs: {
	      "name": _vm.getValue
	    }
	  }, [_c('template', {
	    slot: "title"
	  }, [(_vm.attr.icon !== '' && _vm.attr.icon !== undefined) ? _c('i', {
	    class: _vm.getIcon()
	  }) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.getName()) + "\n      ")]), _vm._v(" "), _c('div', [_vm._t("default")], 2)], 2)], 1)], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 957 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-form-item', {
	    attrs: {
	      "label": "Label"
	    }
	  }, [_c('el-upload')], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 958 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), (_vm.showHeader('h1')) ? _c('h1', {
	    staticClass: "bottom-border"
	  }, [(_vm.attr.icon !== '' && _vm.attr.icon !== undefined) ? _c('i', {
	    class: _vm.getIcon()
	  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.label) + "\n    "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]) : (_vm.showHeader('h2')) ? _c('h2', {
	    staticClass: "bottom-border"
	  }, [(_vm.attr.icon !== '' && _vm.attr.icon !== undefined) ? _c('i', {
	    class: _vm.getIcon()
	  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.label) + "\n    "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]) : (_vm.showHeader('h3')) ? _c('h3', {
	    staticClass: "bottom-border"
	  }, [(_vm.attr.icon !== '' && _vm.attr.icon !== undefined) ? _c('i', {
	    class: _vm.getIcon()
	  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.label) + "\n    "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]) : (_vm.showHeader('h4')) ? _c('h4', {
	    staticClass: "bottom-border"
	  }, [(_vm.attr.icon !== '' && _vm.attr.icon !== undefined) ? _c('i', {
	    class: _vm.getIcon()
	  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.label) + "\n    "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]) : (_vm.showHeader('h5')) ? _c('h5', {
	    staticClass: "bottom-border"
	  }, [(_vm.attr.icon !== '' && _vm.attr.icon !== undefined) ? _c('i', {
	    class: _vm.getIcon()
	  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.label) + "\n    "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]) : (_vm.showHeader('h6')) ? _c('h6', {
	    staticClass: "bottom-border"
	  }, [(_vm.attr.icon !== '' && _vm.attr.icon !== undefined) ? _c('i', {
	    class: _vm.getIcon()
	  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.label) + "\n    "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 959 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [(_vm.type == 'boolean' && _vm.validValue) ? _c('span', [_c('el-tag', {
	    attrs: {
	      "type": _vm.formatField() == 'Sim' ? 'success' : 'danger'
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.formatField()) + "\n    ")])], 1) : ((_vm.type == 'date' || _vm.type == 'dateTime') && _vm.validValue()) ? _c('span', [_c('i', {
	    staticClass: "el-icon-date"
	  }), _vm._v("\n    " + _vm._s(_vm.formatField()) + "\n  ")]) : (_vm.type == 'time' && _vm.validValue()) ? _c('span', [_c('i', {
	    staticClass: "el-icon-time"
	  }), _vm._v("\n    " + _vm._s(_vm.formatField()) + "\n  ")]) : _c('span', [_vm._v("\n    " + _vm._s(_vm.formatField()) + "\n  ")])])
	},staticRenderFns: []}

/***/ }),
/* 960 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-row', {
	    attrs: {
	      "gutter": 10
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.header),
	      expression: "header"
	    }],
	    staticClass: "panel-heading"
	  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
	    staticClass: "panel-body"
	  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.footer),
	      expression: "footer"
	    }],
	    staticClass: "panel-footer"
	  }, [_vm._t("footer")], 2)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 961 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('modulePanel', [_c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('user')))])])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "md": 6,
	      "xs": 24,
	      "sm": 6
	    }
	  }, [_c('div', {
	    staticClass: "icon-user text-align-center"
	  }, [_c('i', {
	    staticClass: "glyphicon glyphicon-user"
	  })])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "md": 18,
	      "xs": 24,
	      "sm": 18
	    }
	  }, [_c('p', {
	    attrs: {
	      "id": "name"
	    }
	  }, [_c('b', [_vm._v(_vm._s(_vm.$t('name') + ':'))]), _vm._v("\n                " + _vm._s(_vm.instance.name) + "\n              ")]), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "username"
	    }
	  }, [_c('b', [_vm._v(_vm._s(_vm.$t('login') + ':'))]), _vm._v("\n                " + _vm._s(_vm.instance.username) + "\n              ")]), _vm._v(" "), _c('p', {
	    attrs: {
	      "id": "phone"
	    }
	  }, [_c('b', [_vm._v(_vm._s(_vm.$t('phone') + ':'))]), _vm._v("\n                " + _vm._s(_vm.instance.phone) + "\n              ")])])], 1), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "size": "small",
	      "id": "changePassword"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.showChangePasswordModal()
	      }
	    }
	  }, [_vm._v("\n                " + _vm._s(_vm.$t("changePassword")) + "\n              ")])], 1)], 1), _vm._v(" "), (_vm.changePasswordModal) ? _c('ChangePasswordDialogForm', {
	    attrs: {
	      "instance": _vm.instance
	    },
	    model: {
	      value: (_vm.changePasswordModal),
	      callback: function($$v) {
	        _vm.changePasswordModal = $$v
	      },
	      expression: "changePasswordModal"
	    }
	  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 12
	    }
	  }, [_c('modulePanel', [_c('div', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('businessLine')))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 24
	    }
	  }, [_c('div', {
	    staticClass: "row display-initial"
	  }, _vm._l((_vm.loggedUser.businessLines), function(row) {
	    return _c('div', {
	      staticClass: "col-md-4 padding-top-10px"
	    }, [_c('RenderImagem', {
	      attrs: {
	        "height": "height: 120px;",
	        "router": {
	          name: 'SystemsList',
	          params: {
	            businessAreaId: row.id
	          }
	        },
	        "label": row.labelPt,
	        "src": _vm.getLogo(row.id)
	      }
	    })], 1)
	  }), 0)])], 1)], 1)])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 962 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.messages.length) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, _vm._l((_vm.messages), function(message) {
	    return _c('p', [_vm._v(_vm._s(message))])
	  }), 0) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 963 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), (_vm.moduleType === 'form') ? _c('el-form-item', {
	    attrs: {
	      "label": "temp",
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": _vm.$t('latitude')
	    },
	    model: {
	      value: (_vm.position.lat),
	      callback: function($$v) {
	        _vm.$set(_vm.position, "lat", $$v)
	      },
	      expression: "position.lat"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": _vm.$t('longitude')
	    },
	    model: {
	      value: (_vm.position.lng),
	      callback: function($$v) {
	        _vm.$set(_vm.position, "lng", $$v)
	      },
	      expression: "position.lng"
	    }
	  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show' && _vm.showMap) ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [_c('span', [_c('gmap-map', {
	    style: (_vm.resolveStyle),
	    attrs: {
	      "center": _vm._position,
	      "zoom": 15
	    }
	  }, [_c('gmap-marker', {
	    attrs: {
	      "position": _vm._position
	    }
	  })], 1)], 1)])]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'list' && _vm.showMap) ? _c('span', [_c('gmap-map', {
	    style: (_vm.resolveStyle),
	    attrs: {
	      "center": _vm._position,
	      "zoom": 15
	    }
	  }, [_c('gmap-marker', {
	    attrs: {
	      "position": _vm._position
	    }
	  })], 1)], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 964 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), (_vm.moduleType === 'form') ? _c('el-form-item', {
	    attrs: {
	      "label": "temp",
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "el-form-item__content"
	  }, [_c('div', {
	    class: _vm.classToDivBeforeInput()
	  }, [_c('money', {
	    staticStyle: {
	      "text-align": "right"
	    },
	    attrs: {
	      "thousands": _vm.attr.thousandsSeparator,
	      "decimal": _vm.attr.decimalSeparator,
	      "precision": _vm.attr.decimalDigits,
	      "disabled": _vm.attr.disableField
	    },
	    on: {
	      "focus": _vm.callBusinessRuleFocus,
	      "blur": _vm.callBusinessRuleBlur
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.getPrefix()) + "   " + _vm._s(_vm.formatValue(_vm.updateFieldValue)) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'list' && _vm.updateFieldValue) ? _c('span', [_vm._v("\n    " + _vm._s(_vm.getPrefix()) + "   " + _vm._s(_vm.formatValue(_vm.updateFieldValue)) + "\n  ")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 965 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-button', {
	    class: _vm.alingButton,
	    attrs: {
	      "size": "small",
	      "type": "primary",
	      "disabled": _vm.attr.disableField
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.callBusinessRule()
	      }
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 966 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "moduleWrapper"
	    }
	  }, [(_vm.moduleType == 'CRUD') ? [(_vm.moduleActive == 'list') ? _c('module-list', {
	    attrs: {
	      "fields": _vm.fields(),
	      "formIdentifier": _vm.formIdentifier(),
	      "parentId": _vm.parentId,
	      "parentColumnName": _vm.parentColumnName(),
	      "title": _vm.title,
	      "filter": _vm.moduleFilter,
	      "showCreateButton": _vm.createView,
	      "showEditIcon": _vm.editView,
	      "showShowIcon": _vm.showView,
	      "businessRulesBeforeCrudViewList": _vm.form.businessRulesBeforeCrudViewListId
	    },
	    on: {
	      "changeModuleActive": _vm.changeModuleActive,
	      "actionLinkSelected": _vm.actionLinkSelected
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.moduleActive == 'form') ? _c('module-form', {
	    attrs: {
	      "rows": _vm.rows(),
	      "fields": _vm.fields(),
	      "formIdentifier": _vm.formIdentifier(),
	      "id": _vm.moduleActiveDataId,
	      "parentId": _vm.parentId,
	      "parentColumnName": _vm.parentColumnName(),
	      "title": _vm.title,
	      "businessRulesBeforeCrudViewCreate": _vm.form.businessRulesBeforeCrudViewCreateId,
	      "businessRulesBeforeCrudViewEdit": _vm.form.businessRulesBeforeCrudViewEditId
	    },
	    on: {
	      "changeModuleActive": _vm.changeModuleActive,
	      "actionLinkSelected": _vm.actionLinkSelected
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.moduleActive == 'show') ? _c('module-show', {
	    attrs: {
	      "rows": _vm.rows(),
	      "fields": _vm.fields(),
	      "formIdentifier": _vm.formIdentifier(),
	      "id": _vm.moduleActiveDataId,
	      "parentId": _vm.parentId,
	      "parentColumnName": _vm.parentColumnName(),
	      "title": _vm.title,
	      "showEditButton": _vm.editView,
	      "showDeleteButton": _vm.deleteButton,
	      "showCreateButton": _vm.createView,
	      "businessRulesBeforeCrudViewShow": _vm.form.businessRulesBeforeCrudViewShowId
	    },
	    on: {
	      "changeModuleActive": _vm.changeModuleActive,
	      "actionLinkSelected": _vm.actionLinkSelected
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.moduleActive == 'show') ? [(_vm.moduleChild.length) ? _c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body"
	  }, [_c('el-tabs', _vm._l((_vm._moduleChild), function(child) {
	    return _c('el-tab-pane', {
	      attrs: {
	        "label": _vm.childTitle(child)
	      }
	    }, [_c('sgs-module-wrapper', {
	      attrs: {
	        "businessAreaId": _vm.formIdentifier().businessAreaId,
	        "systemId": _vm.formIdentifier().systemId,
	        "systemVersion": _vm.formIdentifier().systemVersion,
	        "formId": child.id,
	        "parentId": _vm.moduleActiveDataId
	      }
	    })], 1)
	  }), 1)], 1)]) : _vm._e()] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.moduleType == 'CUSTOM') ? [_c('module-custom', {
	    attrs: {
	      "title": _vm.title,
	      "formIdentifier": _vm.formIdentifier(),
	      "customTemplate": _vm.customTemplate,
	      "parentId": _vm.parentId
	    },
	    on: {
	      "actionLinkSelected": _vm.actionLinkSelected
	    }
	  })] : _vm._e(), _vm._v(" "), (_vm.moduleType == 'DASHBOARD') ? [_c('module-dashboard', {
	    attrs: {
	      "rows": _vm.rows(),
	      "fields": _vm.fields(),
	      "formIdentifier": _vm.formIdentifier(),
	      "parentId": _vm.parentId,
	      "title": _vm.title,
	      "businessRulesBeforeOtherView": _vm.form.businessRulesBeforeOtherViewId
	    },
	    on: {
	      "actionLinkSelected": _vm.actionLinkSelected
	    }
	  })] : _vm._e(), _vm._v(" "), (_vm.moduleType == 'REPORT') ? [_c('module-report', {
	    attrs: {
	      "rows": _vm.rows(),
	      "fields": _vm.fields(),
	      "formIdentifier": _vm.formIdentifier(),
	      "parentId": _vm.parentId,
	      "title": _vm.title,
	      "businessRulesBeforeOtherView": _vm.form.businessRulesBeforeOtherViewId
	    },
	    on: {
	      "actionLinkSelected": _vm.actionLinkSelected
	    }
	  })] : _vm._e(), _vm._v(" "), (_vm.moduleType == 'FREE') ? [_c('module-free', {
	    attrs: {
	      "rows": _vm.rows(),
	      "fields": _vm.fields(),
	      "formIdentifier": _vm.formIdentifier(),
	      "parentId": _vm.parentId,
	      "title": _vm.title,
	      "businessRulesBeforeOtherView": _vm.form.businessRulesBeforeOtherViewId
	    },
	    on: {
	      "actionLinkSelected": _vm.actionLinkSelected
	    }
	  })] : _vm._e(), _vm._v(" "), (_vm.showDialogWithForm) ? _c('el-dialog', {
	    attrs: {
	      "visible": _vm.showDialogWithForm,
	      "size": "large",
	      "id": "modal"
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.showDialogWithForm = $event
	      }
	    }
	  }, [_c('module-template', [_c('sgs-module-wrapper', {
	    attrs: {
	      "businessAreaId": _vm.formIdentifier().businessAreaId,
	      "systemId": _vm.formIdentifier().systemId,
	      "systemVersion": _vm.formIdentifier().systemVersion,
	      "formId": _vm.formIdModal,
	      "parentId": _vm.parentIdModal
	    }
	  })], 1)], 1) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 967 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-popover', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showHint),
	      expression: "showHint"
	    }],
	    ref: "popover",
	    attrs: {
	      "placement": "top-start",
	      "width": "200",
	      "trigger": "hover",
	      "content": _vm.hintValue
	    }
	  }), _vm._v(" "), (_vm.moduleType === 'form' || _vm.attr.type === 'filterText') ? _c('el-form-item', {
	    attrs: {
	      "label": "temp",
	      "prop": _vm.attr.columnName
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "label"
	    },
	    slot: "label"
	  }, [_vm._v("\n      " + _vm._s(_vm.label) + " "), (_vm.showHint && _vm.moduleType === 'form') ? _c('i', {
	    directives: [{
	      name: "popover",
	      rawName: "v-popover:popover",
	      arg: "popover"
	    }],
	    staticClass: "glyphicon glyphicon-question-sign"
	  }) : _vm._e()]), _vm._v(" "), _c('el-input', {
	    attrs: {
	      "placeholder": _vm.placeholder,
	      "disabled": _vm.attr.disableField
	    },
	    on: {
	      "focus": _vm.callBusinessRuleFocus,
	      "blur": _vm.callBusinessRuleBlur
	    },
	    model: {
	      value: (_vm.updateFieldValue),
	      callback: function($$v) {
	        _vm.updateFieldValue = $$v
	      },
	      expression: "updateFieldValue"
	    }
	  }, [(_vm.getPrefix()) ? _c('template', {
	    slot: "prepend"
	  }, [_vm._v(_vm._s(_vm.getPrefix()))]) : _vm._e(), _vm._v(" "), (_vm.getSufix()) ? _c('template', {
	    slot: "append"
	  }, [_vm._v(_vm._s(_vm.getSufix()))]) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("\n        " + _vm._s(_vm.updateFieldValue) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'list' && _vm.attr.type === 'text') ? _c('span', [_vm._v("\n    " + _vm._s(_vm.updateFieldValue) + "\n  ")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 968 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('span', {
	    staticClass: "pull-right"
	  }, [_c('ul', {
	    staticClass: "menu-1"
	  }, [_c('li', [_c('flags')], 1), _vm._v(" "), (_vm.isLogged) ? _c('li', {
	    staticClass: "border-left-padding-left-10px"
	  }, [_c('el-dropdown', [_c('span', {
	    staticClass: "el-dropdown-link"
	  }, [_c('i', {
	    staticClass: "glyphicon glyphicon-user"
	  }), _vm._v(" "), (_vm.loggedUser.username === 'admin') ? _c('b', [_vm._v(_vm._s(_vm.loggedUser.username))]) : _c('b', [_vm._v(_vm._s(_vm.loggedUser.name))]), _vm._v(" "), _c('i', {
	    staticClass: "glyphicon glyphicon-option-vertical"
	  })]), _vm._v(" "), _c('el-dropdown-menu', {
	    attrs: {
	      "slot": "dropdown"
	    },
	    slot: "dropdown"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'UserProfile'
	      },
	      "tag": "a",
	      "exact": ""
	    }
	  }, [(_vm.loggedUser.username !== 'admin') ? _c('el-dropdown-item', [_vm._v("\n                      " + _vm._s(_vm.$t("profile")) + "\n                    ")]) : _vm._e()], 1), _vm._v(" "), (_vm.loggedUser.username !== 'admin') ? _c('el-dropdown-item', {
	    attrs: {
	      "divided": ""
	    }
	  }) : _vm._e(), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.doLogout.apply(null, arguments)
	      }
	    }
	  }, [_c('el-dropdown-item', [_vm._v("\n                      " + _vm._s(_vm.$t("logout")) + "\n                    ")])], 1)], 1)], 1)], 1) : _vm._e()])])])])])
	},staticRenderFns: []}

/***/ }),
/* 969 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('SgsRenderNotificationSuccess', {
	    model: {
	      value: (_vm.notificationSuccess),
	      callback: function($$v) {
	        _vm.notificationSuccess = $$v
	      },
	      expression: "notificationSuccess"
	    }
	  }), _vm._v(" "), _c('SgsRenderNotificationError', {
	    model: {
	      value: (_vm.notificationError),
	      callback: function($$v) {
	        _vm.notificationError = $$v
	      },
	      expression: "notificationError"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "page-header"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12 col-md-6"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-12 col-md-6",
	    staticStyle: {
	      "margin-top": "11px"
	    }
	  }, [_c('div', {
	    staticClass: "pull-right"
	  }, [_c('el-button-group', [(_vm.showEditButton) ? _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "size": "small",
	      "id": "edit"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.edit()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "glyphicon glyphicon-edit",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n              " + _vm._s(_vm.$t('edit')) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showCreateButton) ? _c('el-button', {
	    attrs: {
	      "size": "small",
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.create()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "glyphicon glyphicon-plus",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n              " + _vm._s(_vm.$t('newA')) + " " + _vm._s(_vm.title) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showDeleteButton) ? _c('el-button', {
	    attrs: {
	      "type": "danger",
	      "size": "small",
	      "id": "edit"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.doDelete()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "glyphicon glyphicon-trash",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n              " + _vm._s(_vm.$t('delete')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "size": "small",
	      "id": "backToSearch"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.back()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "glyphicon glyphicon-chevron-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v("\n              " + _vm._s(_vm.$t('backToList')) + "\n            ")])], 1)], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "panel"
	  }, [_c('div', {
	    staticClass: "panel-body"
	  }, _vm._l((_vm.rowsToShow), function(row, index) {
	    return _c('div', {
	      staticClass: "row details"
	    }, _vm._l((row.cols), function(col, index) {
	      return _c('div', {
	        class: 'col-xs-' + col.width + ' col-sm-' + col.width + ' col-md-' + col.width
	      }, [_vm._l((col.fields), function(field) {
	        return [(field.type != 'collapse') ? _c('SgsRender', {
	          attrs: {
	            "moduleType": "show",
	            "type": field.type,
	            "attr": field,
	            "labelOnly": "true",
	            "fieldValue": _vm.instance[field.columnName],
	            "formIdentifier": _vm.formIdentifier,
	            "instance": _vm.instance
	          },
	          on: {
	            "callBusinessRule": _vm.callBusinessRule,
	            "actionLinkSelected": _vm.actionLinkSelected
	          }
	        }) : _c('SgsRenderCollapse', {
	          attrs: {
	            "attr": field,
	            "moduleType": "show"
	          }
	        }, _vm._l((field.rows), function(row) {
	          return _c('div', {
	            staticClass: "row"
	          }, _vm._l((row.cols), function(col) {
	            return _c('div', {
	              class: 'col-xs-' + col.width + ' col-sm-' + col.width + ' col-md-' + col.width
	            }, [_vm._l((col.fields), function(field) {
	              return [(field.type != 'collapse') ? _c('SgsRender', {
	                attrs: {
	                  "moduleType": "show",
	                  "type": field.type,
	                  "attr": field,
	                  "labelOnly": "true",
	                  "fieldValue": _vm.instance[field.columnName],
	                  "formIdentifier": _vm.formIdentifier
	                },
	                on: {
	                  "callBusinessRule": _vm.callBusinessRule,
	                  "actionLinkSelected": _vm.actionLinkSelected
	                }
	              }) : _vm._e()]
	            })], 2)
	          }), 0)
	        }), 0)]
	      })], 2)
	    }), 0)
	  }), 0)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 970 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('module-template', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),
/* 971 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.showDashBoard) ? _c('div', {
	    style: (_vm.marginStyle)
	  }, [_c('highcharts', {
	    ref: _vm.attr.id,
	    attrs: {
	      "options": _vm._fieldValue
	    }
	  })], 1) : _vm._e()
	},staticRenderFns: []}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.cb74d010ebf4905b56b0.js